(function () {
    'use strict';

    angular
        .module('app', [
            'ngAnimate',
            'ngCookies',
            'ngStorage',
            'ngSanitize',
            'ngTouch',
            'ui.router',
            'ui.bootstrap',
            'angularMoment',
            // 'oc.lazyLoad',
            'swipe',
            'ngBootstrap',
            'ngNotify',
            'truncate',
            'uiSwitch',
            'toaster',
            'ngAside',
            'vAccordion',
            'vButton',
            'oitozero.ngSweetAlert',
            'angular-notification-icons',
            'angular-ladda',
            'angularAwesomeSlider',
            'slickCarousel',
            'cfp.loadingBar',
            'ncy-angular-breadcrumb',
            'duScroll',
            'pascalprecht.translate',
            'FBAngular',
            'localytics.directives',
            'underscore',
            'smart-table',
            'mgcrea.ngStrap.timepicker',
            'minicolors',
            'ngStorage',
            'toastr',
            /* Feature modules */
            'app.auth',
            'app.dashboard',
            'app.company',
            'app.contact',
            'app.employee',
            'app.user',
            'app.industry',
            'app.inventory',
            'app.language',
            'app.planning',
            'app.yardman',
            'app.rental'
        ]);

})();

(function() {
'use strict';
    /**
     * @author Albert Brand <https://github.com/AlbertBrand/>
     * @author Sean Perkins <sean@meetmaestro.com>
     */
    angular
        .module('app')
        .factory('HttpRequestTimeoutInterceptor', HttpRequestTimeoutInterceptor);

    /** @ngInject */
    function HttpRequestTimeoutInterceptor($q, HttpPendingRequestsService) {

        var service = {
            request: request,
            responseError: responseError
        };

        function request(config) {
            config = config || {};
            if(angular.isUndefined(config.timeout) && !config.noCancelOnRouteChange) {
                config.timeout = HttpPendingRequestsService.newTimeout();
            }
            return config;
        }

        function responseError(response) {
            if(response.config.timeout.isGloballyCancelled) {
                return $q.defer().promise;
            }
            return $q.reject(response);
        }

        return service;
    }
})();
(function () {
    'use strict';
    /**
     * @author Albert Brand <https://github.com/AlbertBrand/>
     * @author Sean Perkins <sean@meetmaestro.com>
     */
    angular
        .module('app')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, HttpPendingRequestsService) {
        $rootScope.$on('$stateChangeSuccess', function (event, newUrl, oldUrl) {
            if (newUrl != oldUrl) {
                HttpPendingRequestsService.cancelAll();
            }
        });
    }

})();

(function() {
    'use strict';
    /**
     * @author Albert Brand <https://github.com/AlbertBrand/>
     * @author Sean Perkins <sean@meetmaestro.com>
     */
    angular
        .module('app')
        .config(config);

    /** @ngInject */
    function config($httpProvider) {

        $httpProvider.interceptors.push('HttpRequestTimeoutInterceptor');

    }

})();

(function() {
'use strict';
    /**
     * @author Albert Brand <https://github.com/AlbertBrand/>
     * @author Sean Perkins <sean@meetmaestro.com>
     */
    angular
        .module('app')
        .service('HttpPendingRequestsService', HttpPendingRequestsService);

    /** @ngInject */
    function HttpPendingRequestsService($q) {

        var cancelPromises = [];

        var service = {
            newTimeout: newTimeout,
            cancelAll: cancelAll
        };

        function newTimeout() {
            var cancelPromise = $q.defer();
            cancelPromises.push(cancelPromise);
            return cancelPromise.promise;
        }

        function cancelAll() {
            angular.forEach(cancelPromises, function(cancelPromise) {
                cancelPromise.promise.isGloballyCancelled = true;
                cancelPromise.resolve();
            });
            cancelPromises.length = 0;
        }

        return service;

    }

})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('yardmanStatusAside', yardmanStatusAside);

    /** @ngInject */
    function yardmanStatusAside($log, devoniteAside, toaster, API, Company, InventoryStatus, Inventory, SweetAlert, _) {

        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                yardmanStatusAside: '=?',
                visible: '=?'
            }
        };

        return directive;

        function link(scope, element, attrs) {

            var aside = {
                TEMPLATE_URL: '/app/components/yardmanStatusAside/yardmanStatusAside.html',
                UPDATE_SUCCESS_TITLE: 'Updated Inventory',
                UPDATE_SUCCESS_MESSAGE: 'You have successfully updated the inventory item: {0}.',
                FORM_ERROR_TITLE: 'Error: Missing Required Fields',
                FORM_ERROR_MESSAGE: 'Please fill out all of the required fields.',
                UPDATE_ERROR_TITLE: 'Error Updating Inventory',
                UPDATE_ERROR_MESSAGE: 'There was an issue updating the inventory item. Please contact support.'
            };

            element.bind('click', function () {
                constructor();
                devoniteAside.show();
            });

            function constructor() {
                devoniteAside.construct({
                    templateUrl: aside.TEMPLATE_URL,
                    placement: attrs.placement ? attrs.placement : 'right',
                    size: attrs.size ? attrs.size : 'md'
                }, function (vm) {
                    loadInventoryStatuses(vm);
                    loadCompanies(vm);
                    if (angular.isDefined(attrs.identity)) {
                        Inventory.get(attrs.identity).then(function(inventory) {
                            vm.inventory = angular.copy(inventory);
                            vm.form = inventory;
                        });
                    }
                });

                devoniteAside.onCancel(function() {
                    devoniteAside.destroy();
                });

                devoniteAside.onConfirm(function (deferred, vm) {
                    vm.submitted = true;
                    if (vm.asideForm.$valid) {
                        if (angular.isDefined(attrs.identity)) {
                            Inventory.updateYardman(vm.form).then(function (item) {
                                if (angular.isDefined(scope.yardmanStatusAside)) {
                                    scope.yardmanStatusAside = _.filter(scope.yardmanStatusAside, function (itemRow) {
                                        return itemRow.identity !== item.identity;
                                    });
                                    scope.yardmanStatusAside.push(item);
                                }
                                SweetAlert.success(aside.UPDATE_SUCCESS_TITLE, aside.UPDATE_SUCCESS_MESSAGE.replace('{0}', item.asset));
                                deferred.resolve();
                            }, function (response) {
                                $log.error('There was an issue updating the inventory item.', response);
                                SweetAlert.error(aside.UPDATE_ERROR_TITLE, aside.UPDATE_ERROR_MESSAGE);
                                deferred.reject(response);
                            });
                        }
                    }
                    else {
                        toaster.pop('error', aside.FORM_ERROR_TITLE, aside.FORM_ERROR_MESSAGE);
                        deferred.reject();
                    }
                    return deferred.promise;
                });
            }

            function loadInventoryStatuses(vm) {
                vm.statuses = [];
                vm.secondStatuses = [];

                var allowedStatuses = ['Picked Up', 'Staged', '1st Check', 'On Yard', 'Wash', 'Ready Line', 'Repair', 'Annual Insp', 'Hard Down'];
                API.query(InventoryStatus.api.GET + 1).then(function() {},
                function(response) {
                    $log.error('There was an issue loading statuses.', response);
                }, function(statuses) {
                    vm.statuses = vm.statuses.concat(_.filter(statuses, function(status) {
                        return status.primary === true && allowedStatuses.indexOf(status.original) !== -1;
                    }));
                    vm.secondStatuses = vm.secondStatuses.concat(_.filter(statuses, function(status) {
                        return status.primary === false && allowedStatuses.indexOf(status.original) !== -1;
                    }));
                });
            }

            function loadCompanies(vm) {
                vm.companies = [];

                API.query(Company.api.GET + 1).then(function() {},
                function(response) {
                    $log.error('There was an issue loading companies.', response);
                }, function(companies) {
                    vm.companies = vm.companies.concat(companies);
                });
            }

            scope.$on('$destroy', devoniteAside.destroy);

        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('statusAside', statusAside);

    /** @ngInject */
    function statusAside($log, devoniteAside, toaster, API, InventoryStatus, SweetAlert, _) {

        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                statusAside: '=?'
            }
        };

        return directive;

        function link(scope, element, attrs) {

            var aside = {
                TEMPLATE_URL: '/app/components/statusAside/statusAside.html',
                SAVE_SUCCESS_TITLE: 'Saved Status',
                SAVE_SUCCESS_MESSAGE: 'You have created a new status: {0}.',
                SAVE_ERROR_TITLE: 'Error Saving',
                SAVE_ERROR_MESSAGE: 'There was an issue saving the status. Please contact support.',
                UPDATE_SUCCESS_TITLE: 'Updated Status',
                UPDATE_SUCCESS_MESSAGE: 'You have successfully updated the status: {0}.',
                FORM_ERROR_TITLE: 'Error: Missing Required Fields',
                FORM_ERROR_MESSAGE: 'Please fill out all of the required fields.',
                UPDATE_ERROR_TITLE: 'Error Updating Status',
                UPDATE_ERROR_MESSAGE: 'There was an issue updating the status. Please contact support.',
                ERROR_DELETE_SYSTEM_TITLE: 'Action Not Permitted',
                ERROR_DELETE_SYSTEM_MESSAGE: 'You cannot delete system defined statuses.',
                ERROR_DELETE_404_TITLE: 'Record Not Found',
                ERROR_DELETE_404_MESSAGE: 'The record could not be located. Please refresh and try again.',
                ERROR_DELETE_TITLE: 'Error Deleting',
                ERROR_DELETE_TITLE_MESSAGE: 'There was an issue deleting the status. Please contact support.'
            };
            
            var deletePromptConfig = {
                title: 'Are you sure?',
                text: '{0} will be moved to the trash.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Delete Status',
                closeOnConfirm: true  
            };

            element.bind('click', function () {
                constructor();
                devoniteAside.show();
            });

            function constructor() {
                devoniteAside.construct({
                    templateUrl: aside.TEMPLATE_URL,
                    placement: attrs.placement ? attrs.placement : 'right',
                    size: attrs.size ? attrs.size : 'md'
                }, function (vm) {
                    vm.statusTypes = [];
                    if (angular.isDefined(attrs.identity)) {
                        InventoryStatus.get(attrs.identity).then(function (status) {
                            status.foreground = status.primary_color;
                            status.background = status.background_color;
                            vm.statusTypes = [{
                                value: 1,
                                text: 'Primary Status',
                                selected: status.primary === true,
                                disabled: status.modifiable === false
                            }, {
                                value: 0,
                                text: '2<sup>nd</sup> Status',
                                selected: status.primary === false,
                                disabled: status.modifiable === false
                            }];
                            vm.form = status;
                        });
                    }
                    else {
                        vm.statusTypes = [{
                            value: 1,
                            text: 'Primary Status',
                            selected: true
                        }, {
                            value: 0,
                            text: '2<sup>nd</sup> Status',
                            selected: false
                        }];
                    
                        vm.form = {
                            foreground: '#000',
                            background: '#ffffff'
                        };
                    }
                });

                devoniteAside.onCancel(function() {
                    devoniteAside.destroy();
                });
                
                devoniteAside.onDelete(function(deferred, vm) {
                   deletePromptConfig.text = deletePromptConfig.text.replace('{0}', vm.form.name);
                   SweetAlert.swal(deletePromptConfig, function(isConfirm) {
                        if (isConfirm) {
                            InventoryStatus.delete(vm.form.identity).then(function() {
                                scope.statusAside = _.filter(scope.statusAside, function(row) {
                                    return row.identity !== vm.form.identity;
                                });
                                SweetAlert.success('Deleted!', vm.form.name + ' has been moved to the trash.');
                                deferred.resolve();
                            }, function(response) {
                                $log.error('There was an issue deleting the status.', response);
                                if(response.status === 404) {
                                    SweetAlert.error(aside.ERROR_DELETE_404_TITLE, aside.ERROR_DELETE_404_MESSAGE);
                                }
                                else if(response.status === 403) {
                                    SweetAlert.error(aside.ERROR_DELETE_SYSTEM_TITLE, aside.ERROR_DELETE_SYSTEM_MESSAGE);
                                }
                                else {
                                    SweetAlert.error(aside.ERROR_DELETE_TITLE, aside.ERROR_DELETE_MESSAGE);
                                }
                            });
                        }
                        else {
                            deferred.reject();
                        }
                    });
                   return deferred.promise; 
                });

                devoniteAside.onConfirm(function (deferred, vm, type) {
                    vm.submitted = true;
                    if (vm.asideForm.$valid) {
                        vm.form.primary = _.find(vm.statusTypes, function(option) {
                            return option.selected && option.selected == true;
                        }).value;
                        if (angular.isDefined(attrs.identity)) {
                            InventoryStatus.update(vm.form).then(function (status) {
                                if (angular.isDefined(scope.statusAside)) {
                                    scope.statusAside = _.filter(scope.statusAside, function (statusRow) {
                                        return statusRow.identity !== status.identity;
                                    });
                                    scope.statusAside.push(status);
                                }
                                SweetAlert.success(aside.UPDATE_SUCCESS_TITLE, aside.UPDATE_SUCCESS_MESSAGE.replace('{0}', status.name));
                                deferred.resolve();
                            }, function (response) {
                                $log.error('There was an issue updating the status.', response);
                                SweetAlert.error(aside.UPDATE_ERROR_TITLE, aside.UPDATE_ERROR_MESSAGE);
                                deferred.reject(response);
                            });
                        }
                        else {
                            InventoryStatus.save(vm.form).then(function (status) {
                                if (angular.isDefined(scope.statusAside))
                                    scope.statusAside.push(status);
                                SweetAlert.success(aside.SAVE_SUCCESS_TITLE, aside.SAVE_SUCCESS_MESSAGE.replace('{0}', status.name));
                                deferred.resolve();
                            }, function (response) {
                                $log.error('There was an issue saving the status.', response);
                                SweetAlert.error(aside.SAVE_ERROR_TITLE, aside.SAVE_ERROR_MESSAGE);
                                deferred.reject(response);
                            });
                        }
                    }
                    else {
                        toaster.pop('error', aside.FORM_ERROR_TITLE, aside.FORM_ERROR_MESSAGE);
                        deferred.reject();
                    }
                    return deferred.promise;
                });
            }
            
            scope.$on('$destroy', devoniteAside.destroy);

        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('roleAside', roleAside);

    /** @ngInject */
    function roleAside($log, devoniteAside, toaster, SweetAlert, API, Page, User, Role, _) {

        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                roleAside : '=?'
            }
        };

        return directive;

        function link(scope, element, attrs) {

            var aside = {
                TEMPLATE_URL: '/app/components/roleAside/roleAside.html',
                SAVE_SUCCESS_TITLE : 'Saved Role',
                SAVE_SUCCESS_MESSAGE: 'You have created a new role: {0}.',
                UPDATE_SUCCESS_TITLE: 'Updated Role',
                UPDATE_SUCCESS_MESSAGE: 'You have successfully updated the role: {0}.',
                FORM_ERROR_TITLE: 'Error: Missing Required Fields',
                FORM_ERROR_MESSAGE: 'Please fill out all of the required fields.',
                UPDATE_ERROR_TITLE: 'Error Updating Role',
                UPDATE_ERROR_MESSAGE: 'There was an issue updating the role. Please contact support.'
            }

            element.bind('click', function() {
                constructor();
                devoniteAside.show();
            });

            function constructor() {
                devoniteAside.construct({
                    templateUrl: aside.TEMPLATE_URL,
                    placement: attrs.placement ? attrs.placement : 'right',
                    size: attrs.size ? attrs.size : 'full'
                }, function(vm) {

                    loadPages(vm);
                    loadUsers(vm);

                    if(angular.isDefined(attrs.identity)) {
                        // Employee.get(attrs.identity).then(function(employee) {
                        //     $log.debug("employee",employee);
                        //     if(angular.isDefined(employee.department) && employee.department !== null) {
                        //         employee.department = employee.department.identity;
                        //     }
                        //     if(angular.isDefined(employee.shift) && employee.shift !== null) {
                        //         employee.shift = employee.shift.identity;
                        //     }
                        //     if(angular.isDefined(employee.facility) && employee.facility !== null) {
                        //         employee.facility = employee.facility.identity;
                        //     }
                        //     if(angular.isDefined(employee.position) && employee.position !== null) {
                        //         employee.position = employee.position.identity;
                        //     }
                        //     vm.form = employee;
                        //     if(angular.isDefined(vm.form.hire_date)) {
                        //         if(!angular.isDate(vm.form.hire_date))
                        //             vm.form.hire_date = new Date(vm.form.hire_date);
                        //     }


                        // });
                    }

                });

                devoniteAside.onCancel(function() {
                    devoniteAside.destroy();
                });

                devoniteAside.onConfirm(function(deferred, vm) {
                    vm.submitted = true;
                    if(vm.asideForm.$valid) {
                        if(angular.isDefined(attrs.identity)) {
                            $log.debug('Sending...', vm.form);
                            // Employee.update(vm.form).then(function(employee) {
                            //     if(angular.isDefined(scope.roleAside)) {
                            //         scope.roleAside = _.filter(scope.roleAside, function(employeeRow) {
                            //             return employeeRow.identity !== employee.identity;
                            //         });
                            //         scope.roleAside.push(employee);
                            //     }
                            //     SweetAlert.success(aside.UPDATE_SUCCESS_TITLE, aside.UPDATE_SUCCESS_MESSAGE.replace('{0}', employee.name));
                            //     deferred.resolve();
                            // }, function(response) {
                            //     $log.error('There was an issue updating the employee.', response);
                            //     SweetAlert.error(aside.UPDATE_ERROR_TITLE, aside.UPDATE_ERROR_MESSAGE);
                            //     deferred.reject();
                            // });
                        }
                        else {
                            $log.debug('Sendig...', vm.form);
                            Role.save(vm.form).then(function(role) {
                                // if(angular.isDefined(scope.roleAside))
                                //     scope.roleAside.push(employee);
                                SweetAlert.success(aside.SAVE_SUCCESS_TITLE, aside.SAVE_SUCCESS_MESSAGE.replace('{0}', role.name));
                                deferred.resolve();
                            }, function(response) {
                                $log.error('There was an issue saving the role', response);
                                deferred.reject();
                            });
                        }
                    }
                    else {
                        toaster.pop('error', aside.FORM_ERROR_TITLE, aside.FORM_ERROR_MESSAGE);
                        deferred.reject();
                    }
                    return deferred.promise;
                });
            }

            scope.$on('$destroy', devoniteAside.destroy);

            function loadPages(vm) {
                vm.pages = [];
                API.query(Page.api.GET + 0).then(function() {
                }, function(response) {
                    $log.error('There was an issue loading the pages.', response);
                }, function(pages) {
                    vm.pages = vm.pages.concat(pages);
                    $log.debug('pages...', pages);
                });
            }

            function loadUsers(vm) {
                vm.users = [];
                User.getAll().then(function(response) {
                    vm.users = response.data;
                    $log.debug('Users...', vm.users);
                }, function(response) {
                   $log.error('There was an issue loading the users.', response);
                });
            }

        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.rental', []);

})();
(function() {
    'use strict';

    angular
        .module('app.rental')
        .directive('reservationAside', reservationAside);

    /** @ngInject */
    function reservationAside($log, $window, $filter, devoniteAside, toaster, Company, SweetAlert, Inventory, API, _) {

        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                reservationAside : '=?'
            }
        };

        return directive;


        function link(scope, element, attrs) {

            var aside = {
                TEMPLATE_URL: '/app/components/reservationAside/reservationAside.html',
                SAVE_SUCCESS_TITLE : 'Saved Reservation',
                SAVE_SUCCESS_MESSAGE: 'You have created a new reservation: {0}.',
                UPDATE_SUCCESS_TITLE: 'Updated Reservation',
                UPDATE_SUCCESS_MESSAGE: 'You have successfully updated the reservation: {0}.',
                FORM_ERROR_TITLE: 'Error: Missing Required Fields',
                FORM_ERROR_MESSAGE: 'Please fill out all of the required fields.',
                SAVE_ERROR_TITLE: 'Error Saving Reservation',
                SAVE_ERROR_MESSAGE: 'There was an issue saving the reservation. Please contact support.'
            }

            element.bind('click', function() {
                constructor();
                devoniteAside.show();
            });

            function constructor() {
                devoniteAside.construct({
                    templateUrl: aside.TEMPLATE_URL,
                    placement: attrs.placement ? attrs.placement : 'right',
                    size: attrs.size ? attrs.size : 'full'
                }, function(vm) {

                    vm.on_rent = {
                        opened: false,
                        options : {
                            formatYear: 'yyyy',
                            minDate: new Date(),
                            startingDay: 1,
                            showWeeks: false
                        },
                        format: 'MM/dd/yyyy'
                    };

                    vm.off_rent = {
                        opened: false,
                        options : {
                            formatYear: 'yyyy',
                            minDate: new Date(),
                            startingDay: 1,
                            showWeeks: false
                        },
                        format: 'MM/dd/yyyy'
                    };

                    vm.on_rent.open = function() {
                        vm.on_rent.opened = true;
                    }

                    vm.off_rent.open = function() {
                        vm.off_rent.opened = true;
                    }

                    vm.parseDate = function parseDate(date) {
                        if(angular.isUndefined(date) || date === null)
                            return '';
                        return $filter('date')(Date.parse(date), 'MM/dd/yyyy');
                    };

                    vm.loadCompany = loadCompany;
                    vm.loadContact = loadContact;

                    loadCompanies(vm);

                    if(angular.isDefined(attrs.identity)) {
                        Inventory.get(attrs.identity).then(function(item) {
                            $log.debug("item",item);
                            vm.form = item;
                            vm.form.item = item.identity;
                        });
                    }

                });

                devoniteAside.onCancel(function() {
                    devoniteAside.destroy();
                });

                devoniteAside.onConfirm(function(deferred, vm) {
                    vm.submitted = true;
                    if(vm.asideForm.$valid) {
                        if(angular.isDefined(attrs.identity)) {
                            $log.debug('Sending...', vm.form);
                            Inventory.saveReservation(vm.form).then(function(item) {
                                // SweetAlert.success(aside.SAVE_SUCCESS_TITLE, aside.SAVE_SUCCESS_MESSAGE.replace('{0}', item.item_number));
                                SweetAlert.swal({
                                    title: aside.SAVE_SUCCESS_TITLE,
                                    text: aside.SAVE_SUCCESS_MESSAGE.replace('{0}', item.item_number),
                                    type: 'success'
                                }, function() {
                                    $window.location.reload();
                                });
                                deferred.resolve();
                            }, function(response) {
                                $log.error('There was an issue saving the reservation.', response);
                                SweetAlert.error(aside.SAVE_ERROR_TITLE, aside.SAVE_ERROR_MESSAGE);
                                deferred.reject();
                            });

                        }
                    }
                    else {
                        toaster.pop('error', aside.FORM_ERROR_TITLE, aside.FORM_ERROR_MESSAGE);
                        deferred.reject();
                    }
                    return deferred.promise;
                });
            }

            function loadCompanies(vm) {
                vm.companies = [];
                API.query(Company.api.GET + 1).then(function() {}, function(response) {
                    $log.error('There was an issue loading companies.', response);
                }, function(companies) {
                   vm.companies = vm.companies.concat(companies);
                });
            }

            function loadCompany(vm) {
                var company = _.find(vm.companies, function(company) {
                    return company.identity === vm.form.company;
                });
                vm.contacts = company.contacts;
            }

            function loadContact(vm) {
                var contact = _.find(vm.contacts, function(contact) {
                    return contact.identity == vm.form.contact;
                });
                if(contact && contact.office_phone)
                    vm.form.phone = contact.office_phone;
            }

            scope.$on('$destroy', devoniteAside.destroy);


        }
    }
})();
angular.module('app').directive('perfectScrollbar', ['$parse', '$window',
function ($parse, $window) {
    var psOptions = ['wheelSpeed', 'wheelPropagation', 'minScrollbarLength', 'useBothWheelAxes', 'useKeyboard', 'suppressScrollX', 'suppressScrollY', 'scrollXMarginOffset', 'scrollYMarginOffset', 'includePadding'//, 'onScroll', 'scrollDown'
    ];

    return {
        restrict: 'EA',
        transclude: true,
        template: '<div><div ng-transclude></div></div>',
        replace: true,
        link: function ($scope, $elem, $attr) {
            var jqWindow = angular.element($window);
            var options = {};
            if (!$scope.app.isMobile) {
                for (var i = 0, l = psOptions.length; i < l; i++) {
                    var opt = psOptions[i];
                    if ($attr[opt] !== undefined) {
                        options[opt] = $parse($attr[opt])();
                    }
                }

                $scope.$evalAsync(function () {
                    $elem.perfectScrollbar(options);
                    var onScrollHandler = $parse($attr.onScroll);
                    $elem.scroll(function () {
                        var scrollTop = $elem.scrollTop();
                        var scrollHeight = $elem.prop('scrollHeight') - $elem.height();
                        $scope.$apply(function () {
                            onScrollHandler($scope, {
                                scrollTop: scrollTop,
                                scrollHeight: scrollHeight
                            });
                        });
                    });
                });

                function update(event) {
                    $scope.$evalAsync(function () {
                        if ($attr.scrollDown == 'true' && event != 'mouseenter') {
                            setTimeout(function () {
                                $($elem).scrollTop($($elem).prop("scrollHeight"));
                            }, 100);
                        }
                        $elem.perfectScrollbar('update');
                    });
                }

                // This is necessary when you don't watch anything with the scrollbar
                $elem.bind('mousemove', update);

                // Possible future improvement - check the type here and use the appropriate watch for non-arrays
                if ($attr.refreshOnChange) {
                    $scope.$watchCollection($attr.refreshOnChange, function () {
                        update();
                    });
                }

                // this is from a pull request - I am not totally sure what the original issue is but seems harmless
                if ($attr.refreshOnResize) {
                    jqWindow.on('resize', update);
                }

                $elem.bind('$destroy', function () {
                    jqWindow.off('resize', update);
                    $elem.perfectScrollbar('destroy');
                });
            }
        }
    };
}]);

(function () {
    'use strict';

    angular
        .module('app')
        .provider('Page', Page);

    /** @ngInject */
    function Page($stateProvider) {

        var pages = [];

        var stateListener = {};

        var api = {
            GET: 'pages/?page='
        };

        var service = {
            getPages: getPages,
            $get: function () {
                return {
                    setPages: setPages,
                    addPage: addPage,
                    addPages: addPages,
                    updateStateListener: updateStateListener,
                    getStateListener: getStateListener,
                    roleResolve: roleResolve,
                    hasAccess: hasAccess,
                    api: api
                }
            },
            roleResolve: roleResolve
        };

        return service;

        function updateStateListener(event, toState, toParams, fromState, fromParams) {
            stateListener = {
                event: event,
                toState: toState,
                toParams: toParams,
                fromState: fromState,
                fromParams: fromParams
            };
        }

        function getStateListener() {
            return stateListener;
        }

        /**
         * Sets all of the pages for the application
         */
        function setPages(_pages) {
            pages = _pages;
        }

        /**
         * Dynamically injects an array of pages
         */
        function addPages(pages) {
            angular.forEach(pages, function (page) {
                addPage(page);
            });
        }

        /**
         * Dynamically injects a state at runtime
         */
        function addPage(page) {
            $stateProvider.state(page.state, {
                url: page.url,
                templateUrl: page.templateUrl,
                controller: page.controller,
                controllerAs: page.controllerAs,
                title: page.name,
                ncyBreadcrumb: {
                    label: page.name
                },
                resolve: {
                    // authResolve: authResolve,
                    roleResolve: roleResolve
                }
            });
        }

        /**
         * Returns the collection of all the app pages
         */
        function getPages() {
            return pages;
        }

        /** @ngInject */
        function roleResolve($log, $state, $stateParams, authUser) {
            var user = authUser.data.user;
            if (angular.isUndefined(user)) {
                $state.go('auth.login', {}, { reload: true });
                return;
            }
            if (hasAccess(authUser.data.user, stateListener.toState.name) === false) {
                $log.error('You do not have access to:', stateListener.toState.name);
                $state.go('403', {}, { reload: true });
            }
            $log.debug('The user has access to the state:', stateListener.toState.name);
        }

        /** @ngInject */
        function hasAccess(authUser, state) {
            if(angular.isUndefined(authUser))
                return false;
            var match = false;
            angular.forEach(authUser.roles, function(role) {
               angular.forEach(role.page_permissions, function(targetPageState) {
                   if(match === true)
                        return;
                   if (state.endsWith('*'))
                        match = targetPageState.indexOf(state.replace('*', '')) !== -1;
                    else
                        match = targetPageState === state;
               });
            });
            return match;
        }

    }
})();
'use strict';
/**
  * It's like click, but when you don't click on your element.
*/
angular.module('app').directive('offClick', ['$rootScope', '$parse', function ($rootScope, $parse) {
    var id = 0;
    var listeners = {};
    // add variable to detect touch users moving..
    var touchMove = false;

    // Add event listeners to handle various events. Destop will ignore touch events
    document.addEventListener("touchmove", offClickEventHandler, true);
    document.addEventListener("touchend", offClickEventHandler, true);
    document.addEventListener('click', offClickEventHandler, true);

    function targetInFilter(target, elms) {
        if (!target || !elms) return false;
        var elmsLen = elms.length;
        for (var i = 0; i < elmsLen; ++i) {
            var currentElem = elms[i];
            var containsTarget = false;
            try {
                containsTarget = currentElem.contains(target);
            } catch (e) {
                // If the node is not an Element (e.g., an SVGElement) node.contains() throws Exception in IE,
                // see https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
                // In this case we use compareDocumentPosition() instead.
                if (typeof currentElem.compareDocumentPosition !== 'undefined') {
                    containsTarget = currentElem === target || Boolean(currentElem.compareDocumentPosition(target) & 16);
                }
            }

            if (containsTarget) {
                return true;
            }
        }
        return false;
    }

    function offClickEventHandler(event) {
        // If event is a touchmove adjust touchMove state
        if( event.type === 'touchmove' ){
            touchMove = true;
            // And end function
            return false;
        }
        // This will always fire on the touchend after the touchmove runs...
        if( touchMove ){
            // Reset touchmove to false
            touchMove = false;
            // And end function
            return false;
        }
        var target = event.target || event.srcElement;
        angular.forEach(listeners, function (listener, i) {
            if (!(listener.elm.contains(target) || targetInFilter(target, listener.offClickFilter))) {
                $rootScope.$evalAsync(function () {
                    listener.cb(listener.scope, {
                        $event: event
                    });
                });
            }

        });
    }

    return {
        restrict: 'A',
        compile: function ($element, attr) {
            var fn = $parse(attr.offClick);
            return function (scope, element) {
                var elmId = id++;
                var offClickFilter;
                var removeWatcher;

                offClickFilter = document.querySelectorAll(scope.$eval(attr.offClickFilter));

                if (attr.offClickIf) {
                    removeWatcher = $rootScope.$watch(function () {
                        return $parse(attr.offClickIf)(scope);
                    }, function (newVal) {
                        if (newVal) {
                            on();
                        } else if (!newVal) {
                            off();
                        }
                    });
                } else {
                    on();
                }

                attr.$observe('offClickFilter', function (value) {
                    offClickFilter = document.querySelectorAll(scope.$eval(value));
                });

                scope.$on('$destroy', function () {
                    off();
                    if (removeWatcher) {
                        removeWatcher();
                    }
                    element = null;
                });

                function on() {
                    listeners[elmId] = {
                        elm: element[0],
                        cb: fn,
                        scope: scope,
                        offClickFilter: offClickFilter
                    };
                }

                function off() {
                    listeners[elmId] = null;
                    delete listeners[elmId];
                }
            };
        }
    };
}]);
(function() {
    'use strict';

    angular
        .module('app')
        .directive('ngEnter', ngEnter);

    function ngEnter() {
        return function(scope, element, attrs) {
            element.bind('keydown keypress', function(event) {
                if (event.which === 13) {
                    scope.$apply(function() {
                        scope.$eval(attrs.ngEnter);
                    });
                    event.preventDefault();
                }
            });
        }
    }
})();

'use strict';
angular.module('app').directive('letterIcon', function () {
    return {
        restrict: 'AE',
        template: '<div class="letter-icon-wrapper"><span class="letter-icon">' + '{{letter}}</span></div>',
        scope: {},
        replace: true,
        link: function (scope, elem, attrs) {
            var parseColourString = function (s) {

                // Tokenise input
                var m = s.match(/^\#|^rgb\(|[\d\w]+$|\d{3}/g);

                // Other variables
                var value, values;
                var valid = true, double = false;

                // If no matches, return false
                if (!m)
                    return false;

                // If hex value
                if (m.length < 3) {
                    // Get the value
                    value = m[m.length - 1];

                    // Split into parts, either x,x,x or xx,xx,xx
                    values = value.length == 3 ? double = true && value.split('') : value.match(/../g);

                    // Convert to decimal values - if #nnn, double up on values 345 => 334455
                    values.forEach(function (v, i) {
                        values[i] = parseInt(double ? '' + v + v : v, 16);
                    });

                    // Otherwise it's rgb, get the values
                } else {
                    values = m.length == 3 ? m.slice() : m.slice(1);
                }

                // Check that each value is between 0 and 255 inclusive and return the result
                values.forEach(function (v) {
                    valid = valid ? v >= 0 && v <= 255 : false;
                });

                // If string is invalid, return false, otherwise return an array of the values
                return valid && values;
            };
            if (attrs.size && (attrs.size == 'sm' || attrs.size == 'lg')) {
                elem.addClass('size-' + attrs.size);
            }

            if (attrs.customClass) {
                if (attrs.customClass.charAt(0) === '.')
                    attrs.customClass = attrs.customClass.substr(1);
                elem.addClass(attrs.customClass);
            }

            if (attrs.border) {
                elem.addClass('border');
            }
            if (attrs.box && (attrs.box == 'round' || attrs.box == 'circle')) {
                elem.addClass('box-' + attrs.box);
            }
            if (attrs.color && (parseColourString(attrs.color) !== false || attrs.color !== 'auto')) {
                var boxColor;
                elem.removeClass(function (index, css) {
                    return (css.match(/(^|\s)letter-color-\S+/g) || []).join(' ');
                });
                boxColor = parseColourString(attrs.color);
                elem.css({
                    backgroundColor: 'rgb(' + boxColor + ')'
                });
            }
            if (attrs.colorHover && (parseColourString(attrs.colorHover) !== false || attrs.colorHover == 'auto')) {
                if (attrs.colorHover == 'auto') {
                    angular.element(elem).add(elem.closest("a")).on('mouseenter', function () {
                        elem.addClass('hover');
                    }).on('mouseleave', function () {
                        elem.removeClass('hover');
                    });
                } else {
                    var hoverColor, originalColor;
                    hoverColor = parseColourString(attrs.colorHover);
                    if (attrs.color && attrs.color !== 'auto') {
                        originalColor = attrs.color;

                    } else {
                        originalColor = elem.css("background-color");
                    }
                    angular.element(elem).add(elem.closest("a")).on('mouseenter', function () {
                        elem.css({
                            backgroundColor: 'rgb(' + hoverColor + ')'
                        });
                    }).on('mouseleave', function () {
                        elem.css({
                            backgroundColor: originalColor
                        });
                    });
                }
            }

            attrs.$observe('icon', function () {
                if (attrs.icon) {
                    elem.append('<i class="' + attrs.icon + '"></i>');
                }
            });
            attrs.$observe('data', function (val) {
                var string = val.trim(), letter = '';

                if (attrs.color && attrs.color == 'auto') {

                    elem.removeClass(function (index, css) {
                        return (css.match(/(^|\s)letter-color-\S+/g) || []).join(' ');
                    });
                    elem.addClass('letter-color-' + string.charAt(0).toLowerCase());

                }
                if (attrs.charCount && !isNaN(attrs.charCount)) {
                    var newString = string.split(/(?=[A-Z])/), count = parseInt(attrs.charCount);

                    if (count > newString.length) {
                        count = newString.length;
                    }
                    for (var i = 0; i < count; i++) {
                        letter = letter + newString[i].charAt(0);

                    }
                    scope.letter = letter.toUpperCase();
                } else {
                    scope.letter = string.charAt(0).toUpperCase();
                }
            });

        }
    };
});

(function () {
    'use strict';

    angular
        .module('app')
        .directive('inventoryLocationAside', inventoryLocationAside);

    /** @ngInject */
    function inventoryLocationAside($log, devoniteAside, toaster, API, InventoryLocation, SweetAlert, _) {

        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                inventoryLocationAside: '=?',
                visible: '=?'
            }
        };

        return directive;

        function link(scope, element, attrs) {

            var aside = {
                TEMPLATE_URL: '/app/components/inventoryLocationAside/inventoryLocationAside.html',
                SAVE_SUCCESS_TITLE: 'Saved Location',
                SAVE_SUCCESS_MESSAGE: 'You have created a new location: {0}.',
                UPDATE_SUCCESS_TITLE: 'Updated Location',
                UPDATE_SUCCESS_MESSAGE: 'You have successfully updated the location: {0}.',
                FORM_ERROR_TITLE: 'Error: Missing Required Fields',
                FORM_ERROR_MESSAGE: 'Please fill out all of the required fields.',
                UPDATE_ERROR_TITLE: 'Error Updating Location',
                UPDATE_ERROR_MESSAGE: 'There was an issue updating the location. Please contact support.',
                SAVE_ERROR_TITLE: 'Error Saving Location',
                SAVE_ERROR_MESSAGE: 'There was an issue saving the location. Please contact support.'
            };
            
            var deletePromptConfig = {
                title: 'Are you sure?',
                text: '{0} will be moved to the trash.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Delete Location',
                closeOnConfirm: true  
            };

            element.bind('click', function () {
                constructor();
                devoniteAside.show();
            });
            
            scope.$watch('visible', function(newVal) {
               if(newVal === true) {
                   constructor();
                   devoniteAside.show();
               } 
            });
            
            scope.$watch(function() {
                if(angular.isDefined(devoniteAside.getAside()))
                    return devoniteAside.getAside().closed;
                return devoniteAside.getAside();
            }, function(newVal) {
                if(angular.isDefined(newVal)) {
                    newVal.then(function(event) {
                       scope.visible = false;
                    });
                }
            });
            
            function constructor() {
                devoniteAside.construct({
                    templateUrl: aside.TEMPLATE_URL,
                    placement: attrs.placement ? attrs.placement : 'right',
                    size: attrs.size ? attrs.size : 'md'
                }, function (vm) {
                    if (angular.isDefined(attrs.identity)) {
                        InventoryLocation.get(attrs.identity).then(function(location) {
                            vm.form = location;
                        });
                    }
                });

                devoniteAside.onCancel(function() {
                    devoniteAside.destroy();
                });
                
                devoniteAside.onDelete(function(deferred, vm) {
                   deletePromptConfig.text = deletePromptConfig.text.replace('{0}', vm.form.name);
                   SweetAlert.swal(deletePromptConfig, function(isConfirm) {
                        if (isConfirm) {
                            InventoryLocation.delete(vm.form.identity).then(function() {
                                scope.inventoryLocationAside = _.filter(scope.inventoryLocationAside, function(row) {
                                    return row.identity !== vm.form.identity;
                                });
                                SweetAlert.swal('Deleted!', vm.form.name + ' has been moved to the trash.', "success");
                                deferred.resolve();
                            });
                        }
                        else {
                            deferred.reject();
                        }
                    });
                   return deferred.promise; 
                });

                devoniteAside.onConfirm(function (deferred, vm) {
                    vm.submitted = true;
                    if (vm.asideForm.$valid) {
                        if (angular.isDefined(attrs.identity)) {
                            InventoryLocation.update(vm.form).then(function (location) {
                                if (angular.isDefined(scope.inventoryLocationAside)) {
                                    scope.inventoryLocationAside = _.filter(scope.inventoryLocationAside, function (locationRow) {
                                        return locationRow.identity !== location.identity;
                                    });
                                    scope.inventoryLocationAside.push(location);
                                }
                                SweetAlert.success(aside.UPDATE_SUCCESS_TITLE, aside.UPDATE_SUCCESS_MESSAGE.replace('{0}', location.name));
                                deferred.resolve();
                            }, function (response) {
                                $log.error('There was an issue updating the inventory location.', response);
                                if(response.status === 400)
                                    vm.facilityError = response.data.error;
                                else
                                    SweetAlert.error(aside.UPDATE_ERROR_TITLE, aside.UPDATE_ERROR_MESSAGE);
                                deferred.reject(response);
                            });
                        }
                        else {
                            InventoryLocation.save(vm.form).then(function (location) {
                                if (angular.isDefined(scope.inventoryLocationAside))
                                    scope.inventoryLocationAside.push(location);
                                SweetAlert.success(aside.SAVE_SUCCESS_TITLE, aside.SAVE_SUCCESS_MESSAGE.replace('{0}', location.name));
                                deferred.resolve();
                            }, function (response) {
                                $log.error('There was an issue saving the inventory location.', response);
                                if(response.status === 400)
                                    vm.facilityError = response.data.error;
                                else
                                    SweetAlert.error(aside.SAVE_ERROR_TITLE, aside.SAVE_ERROR_MESSAGE);
                                deferred.reject(response);
                            });
                        }
                    }
                    else {
                        toaster.pop('error', aside.FORM_ERROR_TITLE, aside.FORM_ERROR_MESSAGE);
                        deferred.reject();
                    }
                    return deferred.promise;
                });
            }
            
            scope.$on('$destroy', devoniteAside.destroy);

        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('inventoryCategoryAside', inventoryCategoryAside);

    /** @ngInject */
    function inventoryCategoryAside($log, devoniteAside, toaster, API, InventoryCategory, SweetAlert, _) {

        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                inventoryCategoryAside: '=?',
                visible: '=?'
            }
        };

        return directive;

        function link(scope, element, attrs) {

            var aside = {
                TEMPLATE_URL: '/app/components/inventoryCategoryAside/inventoryCategoryAside.html',
                SAVE_SUCCESS_TITLE: 'Saved Category',
                SAVE_SUCCESS_MESSAGE: 'You have created a new category: {0}.',
                UPDATE_SUCCESS_TITLE: 'Updated Category',
                UPDATE_SUCCESS_MESSAGE: 'You have successfully updated the category: {0}.',
                FORM_ERROR_TITLE: 'Error: Missing Required Fields',
                FORM_ERROR_MESSAGE: 'Please fill out all of the required fields.',
                UPDATE_ERROR_TITLE: 'Error Updating Category',
                UPDATE_ERROR_MESSAGE: 'There was an issue updating the category. Please contact support.',
                SAVE_ERROR_TITLE: 'Error Saving Category',
                SAVE_ERROR_MESSAGE: 'There was an issue saving the category. Please contact support.'
            };
            
            var deletePromptConfig = {
                title: 'Are you sure?',
                text: '{0} will be moved to the trash.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Delete Category',
                closeOnConfirm: true  
            };

            element.bind('click', function () {
                constructor();
                devoniteAside.show();
            });
            
            scope.$watch('visible', function(newVal) {
               if(newVal === true) {
                   constructor();
                   devoniteAside.show();
               } 
            });
            
            scope.$watch(function() {
                if(angular.isDefined(devoniteAside.getAside()))
                    return devoniteAside.getAside().closed;
                return devoniteAside.getAside();
            }, function(newVal) {
                if(angular.isDefined(newVal)) {
                    newVal.then(function(event) {
                       scope.visible = false;
                    });
                }
            });
            
            function constructor() {
                devoniteAside.construct({
                    templateUrl: aside.TEMPLATE_URL,
                    placement: attrs.placement ? attrs.placement : 'right',
                    size: attrs.size ? attrs.size : 'sm'
                }, function (vm) {
                    if (angular.isDefined(attrs.identity)) {
                        InventoryCategory.get(attrs.identity).then(function(location) {
                            vm.form = location;
                        });
                    }
                });

                devoniteAside.onCancel(function() {
                    devoniteAside.destroy();
                });
                
                devoniteAside.onDelete(function(deferred, vm) {
                   deletePromptConfig.text = deletePromptConfig.text.replace('{0}', vm.form.name);
                   SweetAlert.swal(deletePromptConfig, function(isConfirm) {
                        if (isConfirm) {
                            InventoryCategory.delete(vm.form.identity).then(function() {
                                scope.inventoryCategoryAside = _.filter(scope.inventoryCategoryAside, function(row) {
                                    return row.identity !== vm.form.identity;
                                });
                                SweetAlert.swal('Deleted!', vm.form.name + ' has been moved to the trash.', "success");
                                deferred.resolve();
                            });
                        }
                        else {
                            deferred.reject();
                        }
                    });
                   return deferred.promise; 
                });

                devoniteAside.onConfirm(function (deferred, vm) {
                    vm.submitted = true;
                    if (vm.asideForm.$valid) {
                        if (angular.isDefined(attrs.identity)) {
                            InventoryCategory.update(vm.form).then(function (category) {
                                if (angular.isDefined(scope.inventoryCategoryAside)) {
                                    scope.inventoryCategoryAside = _.filter(scope.inventoryCategoryAside, function (categoryRow) {
                                        return categoryRow.identity !== category.identity;
                                    });
                                    scope.inventoryCategoryAside.push(category);
                                }
                                SweetAlert.success(aside.UPDATE_SUCCESS_TITLE, aside.UPDATE_SUCCESS_MESSAGE.replace('{0}', category.name));
                                deferred.resolve();
                            }, function (response) {
                                $log.error('There was an issue updating the category.', response);
                                SweetAlert.error(aside.UPDATE_ERROR_TITLE, aside.UPDATE_ERROR_MESSAGE);
                                deferred.reject(response);
                            });
                        }
                        else {
                            InventoryCategory.save(vm.form).then(function (category) {
                                if (angular.isDefined(scope.inventoryCategoryAside))
                                    scope.inventoryCategoryAside.push(category);
                                SweetAlert.success(aside.SAVE_SUCCESS_TITLE, aside.SAVE_SUCCESS_MESSAGE.replace('{0}', category.name));
                                deferred.resolve();
                            }, function (response) {
                                $log.error('There was an issue saving the category.', response);
                                SweetAlert.error(aside.SAVE_ERROR_TITLE, aside.SAVE_ERROR_MESSAGE);
                                deferred.reject(response);
                            });
                        }
                    }
                    else {
                        toaster.pop('error', aside.FORM_ERROR_TITLE, aside.FORM_ERROR_MESSAGE);
                        deferred.reject();
                    }
                    return deferred.promise;
                });
            }
            
            scope.$on('$destroy', devoniteAside.destroy);

        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('inventoryAside', inventoryAside);

    /** @ngInject */
    function inventoryAside($log, devoniteAside, toaster, API, Inventory, InventoryLocation, InventoryStatus, InventoryCategory, SweetAlert, _, $sessionStorage) {

        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                inventoryAside: '=?',
                visible: '=?'
            }
        };

        return directive;

        function link(scope, element, attrs) {

            scope.$storage = $sessionStorage;

            var aside = {
                TEMPLATE_URL: '/app/components/inventoryAside/inventoryAside.html',
                SAVE_SUCCESS_TITLE: 'Saved Item',
                SAVE_SUCCESS_MESSAGE: 'You have created a new item: {0}.',
                UPDATE_SUCCESS_TITLE: 'Updated Item',
                UPDATE_SUCCESS_MESSAGE: 'You have successfully updated the item: {0}.',
                FORM_ERROR_TITLE: 'Error: Missing Required Fields',
                FORM_ERROR_MESSAGE: 'Please fill out all of the required fields.',
                UPDATE_ERROR_TITLE: 'Error Updating Item',
                UPDATE_ERROR_MESSAGE: 'There was an issue updating the item. Please contact support.',
                SAVE_ERROR_TITLE: 'Error Saving Item',
                SAVE_ERROR_MESSAGE: 'There was an issue saving the item. Please contact support.'
            };

            var deletePromptConfig = {
                title: 'Are you sure?',
                text: '{0} will be moved to the trash.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Delete Classification',
                closeOnConfirm: true
            };

            element.bind('click', function () {
                constructor();
                devoniteAside.show();
            });

            scope.$watch('visible', function(newVal) {
               if(newVal === true) {
                   constructor();
                   devoniteAside.show();
               }
            });

            scope.$watch(function() {
                if(angular.isDefined(devoniteAside.getAside()))
                    return devoniteAside.getAside().closed;
                return devoniteAside.getAside();
            }, function(newVal) {
                if(angular.isDefined(newVal)) {
                    newVal.then(function(event) {
                       scope.visible = false;
                    });
                }
            });

            scope.displayLocationAside = displayLocationAside;

            function displayLocationAside() {
                scope.$storage.inventoryAside = devoniteAside.getScope().form;
            }

            function constructor() {

                devoniteAside.registerAction({
                    name: 'displayLocationAside',
                    action: displayLocationAside
                });

                devoniteAside.construct({
                    templateUrl: aside.TEMPLATE_URL,
                    placement: attrs.placement ? attrs.placement : 'right',
                    size: attrs.size ? attrs.size : 'md'
                }, function (vm) {

                    vm.date_fleet = {
                        opened: false,
                        options : {
                            formatYear: 'yyyy',
                            startingDay: 1,
                            showWeeks: false
                        },
                        format: 'MM/dd/yyyy',
                    };

                    vm.date_fleet.open = function() {
                        vm.date_fleet.opened = true;
                    }

                    vm.manu_year = {
                        opened: false,
                        options : {
                            formatYear: 'yyyy',
                            minMode: 'month',
                            startingDay: 1,
                            showWeeks: false
                        },
                        format: 'MM/yyyy',
                    };

                    vm.manu_year.open = function() {
                        vm.manu_year.opened = true;
                    }

                    loadInventoryStatuses(vm);
                    loadInventoryLocations(vm);
                    loadInventoryCategories(vm);

                    if (angular.isDefined(attrs.identity)) {
                        Inventory.get(attrs.identity).then(function(inventory) {
                            if(angular.isDefined(inventory.status) && inventory.status !== null)
                                inventory.status = inventory.status.identity;
                            if(angular.isDefined(inventory.second_status) && inventory.second_status !== null)
                                inventory.sec_status = inventory.second_status.identity;
                            if(angular.isDefined(inventory.category) && inventory.category !== null)
                                inventory.category = inventory.category.identity;
                            if(angular.isDefined(inventory.location) && inventory.location != null)
                                inventory.location = inventory.location.identity;
                            if(angular.isDefined(inventory.date_in_fleet))
                                inventory.fleet = new Date(Date.parse(inventory.date_in_fleet));
                            if(angular.isDefined(inventory.year_manufactured))
                                inventory.manuYear = new Date(Date.parse(inventory.year_manufactured));
                            vm.form = inventory;
                        });
                    }
                });

                devoniteAside.onCancel(function() {
                    devoniteAside.destroy();
                });

                devoniteAside.onDelete(function(deferred, vm) {
                   deletePromptConfig.text = deletePromptConfig.text.replace('{0}', vm.form.name);
                   SweetAlert.swal(deletePromptConfig, function(isConfirm) {
                        if (isConfirm) {
                            Inventory.delete(vm.form.identity).then(function() {
                                scope.inventoryAside = _.filter(scope.inventoryAside, function(row) {
                                    return row.identity !== vm.form.identity;
                                });
                                SweetAlert.swal('Deleted!', vm.form.name + ' has been moved to the trash.', "success");
                                deferred.resolve();
                            });
                        }
                        else {
                            deferred.reject();
                        }
                    });
                   return deferred.promise;
                });

                devoniteAside.onConfirm(function (deferred, vm) {
                    vm.submitted = true;
                    if (vm.asideForm.$valid) {
                        if (angular.isDefined(attrs.identity)) {
                            if(angular.isString(vm.form.fleet))
                                vm.form.fleet = new Date(Date.parse(vm.form.fleet));
                            if(angular.isString(vm.form.manuYear))
                                vm.form.manuYear = new Date(Date.parse(vm.form.manuYear));
                            Inventory.update(vm.form).then(function (inventory) {
                                if (angular.isDefined(scope.inventoryAside)) {
                                    scope.inventoryAside = _.filter(scope.inventoryAside, function (inventoryRow) {
                                        return inventoryRow.identity !== inventory.identity;
                                    });
                                    scope.inventoryAside.push(inventory);
                                }
                                SweetAlert.success(aside.UPDATE_SUCCESS_TITLE, aside.UPDATE_SUCCESS_MESSAGE.replace('{0}', inventory.asset));
                                deferred.resolve();
                            }, function (response) {
                                $log.error('There was an issue updating the item.', response);
                                SweetAlert.error(aside.UPDATE_ERROR_TITLE, aside.UPDATE_ERROR_MESSAGE);
                                deferred.reject(response);
                            });
                        }
                        else {
                            Inventory.save(vm.form).then(function (inventory) {
                                if (angular.isDefined(scope.inventoryAside))
                                    scope.inventoryAside.push(inventory);
                                SweetAlert.success(aside.SAVE_SUCCESS_TITLE, aside.SAVE_SUCCESS_MESSAGE.replace('{0}', inventory.asset));
                                deferred.resolve();
                            }, function (response) {
                                $log.error('There was an issue saving the item.', response);
                                SweetAlert.error(aside.SAVE_ERROR_TITLE, aside.SAVE_ERROR_MESSAGE);
                                deferred.reject(response);
                            });
                        }
                    }
                    else {
                        toaster.pop('error', aside.FORM_ERROR_TITLE, aside.FORM_ERROR_MESSAGE);
                        deferred.reject();
                    }
                    return deferred.promise;
                });
            }

            function loadInventoryStatuses(vm) {
                vm.statuses = [];
                vm.secondStatuses = [];

                API.query(InventoryStatus.api.GET + 1).then(function() {},
                function(response) {
                    $log.error('There was an issue loading inventory statuses.', response);
                }, function(statuses) {
                    vm.statuses = vm.statuses.concat(_.filter(statuses, function(status) {
                        return status.primary === true;
                    }));
                    vm.secondStatuses = vm.secondStatuses.concat(_.filter(statuses, function(status) {
                        return status.primary === false;
                    }));
                });
            }

            function loadInventoryLocations(vm) {
                vm.locations = [];

                API.query(InventoryLocation.api.GET + 1).then(function() {},
                function(response) {
                    $log.error('There was an issue loading inventory locations.', response);
                }, function(locations) {
                    vm.locations = vm.locations.concat(locations);
                });
            }

            function loadInventoryCategories(vm) {
                vm.categories = [];

                API.query(InventoryCategory.api.GET + 1).then(function() {},
                function(response) {
                    $log.error('There was an issue loading inventory categories.', response);
                }, function(categories) {
                    vm.categories = vm.categories.concat(categories);
                });
            }

            scope.$on('$destroy', devoniteAside.destroy);

        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('insightPlaceholder', InsightPlaceholder);

    /** @ngInject */
    function InsightPlaceholder() {

        var directive = {
            bindToController: true,
            controller: InsightPlaceholderController,
            controllerAs: 'vm',
            templateUrl: '/app/components/insightPlaceholder/insightPlaceholder.html',
            link: link,
            restrict: 'A',
            scope: {
                options : '=insightPlaceholder',
                collection: '=?collection'
            }
        };
        return directive;

        function link(scope, element, attrs) {

        }
    }
    /* @ngInject */
    function InsightPlaceholderController ($log, $scope) {

        var vm = this;

        vm.clickButton = clickButton;
        vm.isVisible = isVisible;

        function clickButton() {
            if(angular.isDefined(vm.options.button_action)) {
                vm.options.button_action();
            }
        }

        function isVisible() {
            if(angular.isDefined(vm.collection)) {
                return vm.collection.length === 0;
            }
            else {
                if(angular.isFunction(vm.options.collection)) {
                    return vm.options.collection().length === 0;
                }
                else {
                    return vm.options.collection.length === 0;
                }
            }
        }

    }
})();
(function () {
    'use strict';
    
    angular
        .module('app')
        .directive('ctFullheight', ctFullheight);

    /**
     * Make element 100% height of browser window.
     * @ngInject
     * @param  {[type]} $window    [description]
     * @param  {[type]} $rootScope [description]
     * @param  {[type]} $timeout   [description]
     * @return {[type]}            [description]
     */
    function ctFullheight($window, $rootScope, $timeout) {
        var directive = {
            restrict: 'AE',
            scope: {
                ctFullheightIf: '&'
            },
            link: linkFunc
        };
        return directive;

        function linkFunc(scope, elem, attrs) {
            var $document = $(document);
            var exclusionItems;
            var exclusionHeight;
            var setHeight = true;
            var page;

            scope.initializeWindowSize = function () {
                $timeout(function () {
                    exclusionHeight = 0;
                    if (attrs.ctFullheightIf) {
                        scope.$watch(scope.ctFullheightIf, function (newVal, oldVal) {
                            if (newVal && !oldVal) {
                                setHeight = true;
                            } else if (!newVal) {
                                $(elem).css('height', 'auto');
                                setHeight = false;
                            }
                        });
                    }

                    if (attrs.ctFullheightExclusion) {
                        var exclusionItems = attrs.ctFullheightExclusion.split(',');
                        angular.forEach(exclusionItems, function (_element) {
                            exclusionHeight = exclusionHeight + $(_element).outerHeight(true);
                        });
                    }
                    if (attrs.ctFullheight == 'window') {
                        page = $window;
                    } else {
                        page = $document;
                    }

                    scope.$watch(function () {
                        scope.__height = page.height();
                    });
                    if (setHeight) {
                        $(elem).css('height', 'auto');
                        if (page.innerHeight() < $window.innerHeight()) {
                            page = $window;
                        }
                        $(elem).css('height', page.innerHeight() - exclusionHeight);
                    }
                }, 300);
            };

            scope.initializeWindowSize();
            scope.$watch('__height', function () {
                scope.initializeWindowSize();
            });
            $window.on('resize', function () {
                scope.initializeWindowSize();
            });
        }
    }
});

(function() {
    'use strict';

    angular
        .module('app')
        .directive('formGroup', formGroup);

    /** @ngInject */
    function formGroup() {

        var directive = {
            restrict: 'C',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, elem) {
            var input = elem.find('input')[0];
            if(input && input.attributes && input.attributes.required) {
                elem.find('label').append('<span class="req">*</span>');
            }
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('employeePositionAside', employeePositionAside);

    /** @ngInject */
    function employeePositionAside($log, devoniteAside, toaster, API, EmployeePosition, SweetAlert, _) {

        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                employeePositionAside: '=?',
                visible: '=?'
            }
        };

        return directive;

        function link(scope, element, attrs) {

            var aside = {
                TEMPLATE_URL: '/app/components/employeePositionAside/employeePositionAside.html',
                SAVE_SUCCESS_TITLE: 'Saved Position',
                SAVE_SUCCESS_MESSAGE: 'You have created a new position: {0}.',
                UPDATE_SUCCESS_TITLE: 'Updated Position',
                UPDATE_SUCCESS_MESSAGE: 'You have successfully updated the position: {0}.',
                FORM_ERROR_TITLE: 'Error: Missing Required Fields',
                FORM_ERROR_MESSAGE: 'Please fill out all of the required fields.',
                UPDATE_ERROR_TITLE: 'Error Updating Position',
                UPDATE_ERROR_MESSAGE: 'There was an issue updating the position. Please contact support.',
                SAVE_ERROR_TITLE: 'Error Saving Position',
                SAVE_ERROR_MESSAGE: 'There was an issue saving the position. Please contact support.'
            };

            var deletePromptConfig = {
                title: 'Are you sure?',
                text: '{0} will be moved to the trash.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Delete Position',
                closeOnConfirm: true
            };

            element.bind('click', function () {
                constructor();
                devoniteAside.show();
            });

            scope.$watch('visible', function(newVal) {
               if(newVal === true) {
                   constructor();
                   devoniteAside.show();
               }
            });

            scope.$watch(function() {
                if(angular.isDefined(devoniteAside.getAside()))
                    return devoniteAside.getAside().closed;
                return devoniteAside.getAside();
            }, function(newVal) {
                if(angular.isDefined(newVal)) {
                    newVal.then(function(event) {
                       scope.visible = false;
                    });
                }
            });

            function constructor() {
                devoniteAside.construct({
                    templateUrl: aside.TEMPLATE_URL,
                    placement: attrs.placement ? attrs.placement : 'right',
                    size: attrs.size ? attrs.size : 'sm'
                }, function (vm) {
                    if (angular.isDefined(attrs.identity)) {
                        EmployeePosition.get(attrs.identity).then(function(position) {
                            vm.form = position;
                        });
                    }
                });

                devoniteAside.onCancel(function() {
                    devoniteAside.destroy();
                });

                devoniteAside.onDelete(function(deferred, vm) {
                   deletePromptConfig.text = deletePromptConfig.text.replace('{0}', vm.form.name);
                   SweetAlert.swal(deletePromptConfig, function(isConfirm) {
                        if (isConfirm) {
                            EmployeePosition.delete(vm.form.identity).then(function() {
                                scope.employeePositionAside = _.filter(scope.employeePositionAside, function(row) {
                                    return row.identity !== vm.form.identity;
                                });
                                SweetAlert.swal('Deleted!', vm.form.name + ' has been moved to the trash.', "success");
                                deferred.resolve();
                            });
                        }
                        else {
                            deferred.reject();
                        }
                    });
                   return deferred.promise;
                });

                devoniteAside.onConfirm(function (deferred, vm) {
                    vm.submitted = true;
                    if (vm.asideForm.$valid) {
                        if (angular.isDefined(attrs.identity)) {
                            EmployeePosition.update(vm.form).then(function (position) {
                                if (angular.isDefined(scope.employeePositionAside)) {
                                    scope.employeePositionAside = _.filter(scope.employeePositionAside, function (positionRow) {
                                        return positionRow.identity !== position.identity;
                                    });
                                    scope.employeePositionAside.push(position);
                                }
                                SweetAlert.success(aside.UPDATE_SUCCESS_TITLE, aside.UPDATE_SUCCESS_MESSAGE.replace('{0}', position.name));
                                deferred.resolve();
                            }, function (response) {
                                $log.error('There was an issue updating the employee position.', response);
                                SweetAlert.error(aside.UPDATE_ERROR_TITLE, aside.UPDATE_ERROR_MESSAGE);
                                deferred.reject(response);
                            });
                        }
                        else {
                            EmployeePosition.save(vm.form).then(function (position) {
                                if (angular.isDefined(scope.employeePositionAside))
                                    scope.employeePositionAside.push(position);
                                SweetAlert.success(aside.SAVE_SUCCESS_TITLE, aside.SAVE_SUCCESS_MESSAGE.replace('{0}', position.name));
                                deferred.resolve();
                            }, function (response) {
                                $log.error('There was an issue saving the employee position.', response);
                                SweetAlert.error(aside.SAVE_ERROR_TITLE, aside.SAVE_ERROR_MESSAGE);
                                deferred.reject(response);
                            });
                        }
                    }
                    else {
                        toaster.pop('error', aside.FORM_ERROR_TITLE, aside.FORM_ERROR_MESSAGE);
                        deferred.reject();
                    }
                    return deferred.promise;
                });
            }

            scope.$on('$destroy', devoniteAside.destroy);

        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('employeeDepartmentAside', employeeDepartmentAside);

    /** @ngInject */
    function employeeDepartmentAside($log, devoniteAside, toaster, API, EmployeeDepartment, SweetAlert, _) {

        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                employeeDepartmentAside: '=?',
                visible: '=?'
            }
        };

        return directive;

        function link(scope, element, attrs) {

            var aside = {
                TEMPLATE_URL: '/app/components/employeeDepartmentAside/employeeDepartmentAside.html',
                SAVE_SUCCESS_TITLE: 'Saved Department',
                SAVE_SUCCESS_MESSAGE: 'You have created a new department: {0}.',
                UPDATE_SUCCESS_TITLE: 'Updated Department',
                UPDATE_SUCCESS_MESSAGE: 'You have successfully updated the department: {0}.',
                FORM_ERROR_TITLE: 'Error: Missing Required Fields',
                FORM_ERROR_MESSAGE: 'Please fill out all of the required fields.',
                UPDATE_ERROR_TITLE: 'Error Updating Department',
                UPDATE_ERROR_MESSAGE: 'There was an issue updating the department. Please contact support.',
                SAVE_ERROR_TITLE: 'Error Saving Department',
                SAVE_ERROR_MESSAGE: 'There was an issue saving the department. Please contact support.'
            };
            
            var deletePromptConfig = {
                title: 'Are you sure?',
                text: '{0} will be moved to the trash.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Delete Department',
                closeOnConfirm: true  
            };

            element.bind('click', function () {
                constructor();
                devoniteAside.show();
            });
            
            scope.$watch('visible', function(newVal) {
               if(newVal === true) {
                   constructor();
                   devoniteAside.show();
               } 
            });
            
            scope.$watch(function() {
                if(angular.isDefined(devoniteAside.getAside()))
                    return devoniteAside.getAside().closed;
                return devoniteAside.getAside();
            }, function(newVal) {
                if(angular.isDefined(newVal)) {
                    newVal.then(function(event) {
                       scope.visible = false;
                    });
                }
            });
            
            function constructor() {
                devoniteAside.construct({
                    templateUrl: aside.TEMPLATE_URL,
                    placement: attrs.placement ? attrs.placement : 'right',
                    size: attrs.size ? attrs.size : 'sm'
                }, function (vm) {
                    if (angular.isDefined(attrs.identity)) {
                        EmployeeDepartment.get(attrs.identity).then(function(department) {
                            vm.form = department;
                        });
                    }
                });

                devoniteAside.onCancel(function() {
                    devoniteAside.destroy();
                });
                
                devoniteAside.onDelete(function(deferred, vm) {
                   deletePromptConfig.text = deletePromptConfig.text.replace('{0}', vm.form.name);
                   SweetAlert.swal(deletePromptConfig, function(isConfirm) {
                        if (isConfirm) {
                            EmployeeDepartment.delete(vm.form.identity).then(function() {
                                scope.employeeDepartmentAside = _.filter(scope.employeeDepartmentAside, function(row) {
                                    return row.identity !== vm.form.identity;
                                });
                                SweetAlert.swal('Deleted!', vm.form.name + ' has been moved to the trash.', "success");
                                deferred.resolve();
                            });
                        }
                        else {
                            deferred.reject();
                        }
                    });
                   return deferred.promise; 
                });

                devoniteAside.onConfirm(function (deferred, vm) {
                    vm.submitted = true;
                    if (vm.asideForm.$valid) {
                        if (angular.isDefined(attrs.identity)) {
                            EmployeeDepartment.update(vm.form).then(function (department) {
                                if (angular.isDefined(scope.employeeDepartmentAside)) {
                                    scope.employeeDepartmentAside = _.filter(scope.employeeDepartmentAside, function (departmentRow) {
                                        return departmentRow.identity !== department.identity;
                                    });
                                    scope.employeeDepartmentAside.push(department);
                                }
                                SweetAlert.success(aside.UPDATE_SUCCESS_TITLE, aside.UPDATE_SUCCESS_MESSAGE.replace('{0}', department.name));
                                deferred.resolve();
                            }, function (response) {
                                $log.error('There was an issue updating the employee department.', response);
                                SweetAlert.error(aside.UPDATE_ERROR_TITLE, aside.UPDATE_ERROR_MESSAGE);
                                deferred.reject(response);
                            });
                        }
                        else {
                            EmployeeDepartment.save(vm.form).then(function (department) {
                                if (angular.isDefined(scope.employeeDepartmentAside))
                                    scope.employeeDepartmentAside.push(department);
                                SweetAlert.success(aside.SAVE_SUCCESS_TITLE, aside.SAVE_SUCCESS_MESSAGE.replace('{0}', department.name));
                                deferred.resolve();
                            }, function (response) {
                                $log.error('There was an issue saving the employee department.', response);
                                SweetAlert.error(aside.SAVE_ERROR_TITLE, aside.SAVE_ERROR_MESSAGE);
                                deferred.reject(response);
                            });
                        }
                    }
                    else {
                        toaster.pop('error', aside.FORM_ERROR_TITLE, aside.FORM_ERROR_MESSAGE);
                        deferred.reject();
                    }
                    return deferred.promise;
                });
            }
            
            scope.$on('$destroy', devoniteAside.destroy);

        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.employee', []);

})();

(function() {
    'use strict';

    angular
        .module('app.employee')
        .directive('employeeAside', employeeAside);

    /** @ngInject */
    function employeeAside($log, devoniteAside, toaster, Employee, SweetAlert, EmployeeShift, EmployeePosition, EmployeeDepartment, InventoryLocation, API, _) {

        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                employeeAside : '=?'
            }
        };

        return directive;


        function link(scope, element, attrs) {

            var aside = {
                TEMPLATE_URL: '/app/components/employeeAside/employeeAside.html',
                SAVE_SUCCESS_TITLE : 'Saved Employee',
                SAVE_SUCCESS_MESSAGE: 'You have created a new employee: {0}.',
                UPDATE_SUCCESS_TITLE: 'Updated Employee',
                UPDATE_SUCCESS_MESSAGE: 'You have successfully updated the employee: {0}.',
                FORM_ERROR_TITLE: 'Error: Missing Required Fields',
                FORM_ERROR_MESSAGE: 'Please fill out all of the required fields.',
                SAVE_ERROR_EMAIL_TITLE: 'Email Address Taken',
                SAVE_ERROR_EMAIL_MESSAGE: 'The email address is already registered to another user.',
                UPDATE_ERROR_TITLE: 'Error Updating Employee',
                UPDATE_ERROR_MESSAGE: 'There was an issue updating the employee. Please contact support.'
            }

            element.bind('click', function() {
                constructor();
                devoniteAside.show();
            });

            function constructor() {
                devoniteAside.construct({
                    templateUrl: aside.TEMPLATE_URL,
                    placement: attrs.placement ? attrs.placement : 'right',
                    size: attrs.size ? attrs.size : 'md'
                }, function(vm) {
                    vm.hire_date = {
                        opened: false,
                        options : {
                            formatYear: 'yyyy',
                            startingDay: 1,
                            showWeeks: false
                        },
                        format: 'MM/dd/yyyy'
                    };

                    vm.toggle = true;

                    vm.$watch('toggle', function(){
                        vm.toggleText = vm.toggle ? 'Create Role' : 'Cancel';
                    })

                    vm.shiftToggle = true;

                    vm.$watch('shiftToggle', function(){
                        vm.shiftText = vm.shiftToggle ? 'Create Shift' : 'Cancel';
                    })

                    vm.hire_date.open = function() {
                        vm.hire_date.opened = true;
                    }

                    loadEmployeeDepartments(vm);
                    loadEmployeeShifts(vm);
                    loadEmployeePositions(vm);
                    loadInventoryLocations(vm);

                    if(angular.isDefined(attrs.identity)) {
                        Employee.get(attrs.identity).then(function(employee) {
                            $log.debug("employee",employee);
                            if(angular.isDefined(employee.department) && employee.department !== null) {
                                employee.department = employee.department.identity;
                            }
                            if(angular.isDefined(employee.shift) && employee.shift !== null) {
                                employee.shift = employee.shift.identity;
                            }
                            if(angular.isDefined(employee.facility) && employee.facility !== null) {
                                employee.facility = employee.facility.identity;
                            }
                            if(angular.isDefined(employee.position) && employee.position !== null) {
                                employee.position = employee.position.identity;
                            }
                            vm.form = employee;
                            if(angular.isDefined(vm.form.hire_date)) {
                                if(!angular.isDate(vm.form.hire_date))
                                    vm.form.hire_date = new Date(vm.form.hire_date);
                            }


                        });
                    }

                });

                devoniteAside.onCancel(function() {
                    devoniteAside.destroy();
                });

                devoniteAside.onConfirm(function(deferred, vm) {
                    vm.submitted = true;
                    if(vm.asideForm.$valid) {
                        if(angular.isDefined(attrs.identity)) {
                            $log.debug('Sending...', vm.form);
                            Employee.update(vm.form).then(function(employee) {
                                if(angular.isDefined(scope.employeeAside)) {
                                    scope.employeeAside = _.filter(scope.employeeAside, function(employeeRow) {
                                        return employeeRow.identity !== employee.identity;
                                    });
                                    scope.employeeAside.push(employee);
                                }
                                SweetAlert.success(aside.UPDATE_SUCCESS_TITLE, aside.UPDATE_SUCCESS_MESSAGE.replace('{0}', employee.name));
                                deferred.resolve();
                            }, function(response) {
                                $log.error('There was an issue updating the employee.', response);
                                SweetAlert.error(aside.UPDATE_ERROR_TITLE, aside.UPDATE_ERROR_MESSAGE);
                                deferred.reject();
                            });
                        }
                        else {
                            Employee.save(vm.form).then(function(employee) {
                                if(angular.isDefined(scope.employeeAside))
                                    scope.employeeAside.push(employee);
                                SweetAlert.success(aside.SAVE_SUCCESS_TITLE, aside.SAVE_SUCCESS_MESSAGE.replace('{0}', employee.name));
                                deferred.resolve();
                        }, function(response) {
                                if(response.data.message === 'EMAIL_TAKEN') {
                                    SweetAlert.error(aside.SAVE_ERROR_EMAIL_TITLE, aside.SAVE_ERROR_EMAIL_MESSAGE);
                                    deferred.reject();
                                }
                            });
                        }
                    }
                    else {
                        toaster.pop('error', aside.FORM_ERROR_TITLE, aside.FORM_ERROR_MESSAGE);
                        deferred.reject();
                    }
                    return deferred.promise;
                });
            }

            function loadEmployeeDepartments(vm) {
                vm.departments = [];
                API.query(EmployeeDepartment.api.GET + 1).then(function() {}, function(response) {
                    $log.error('There was an issue loading the employee departments', response);
                }, function(departments) {
                    vm.departments = vm.departments.concat(departments);
                });
            }

            function loadEmployeeShifts(vm) {
                vm.shifts = [];
                API.query(EmployeeShift.api.GET + 1).then(function() {}, function(response) {
                    $log.error('There was an issue loading the employee shifts', response);
                }, function(shifts) {
                    vm.shifts = vm.shifts.concat(shifts);
                });
            }

            function loadEmployeePositions(vm) {
                vm.positions = [];
                API.query(EmployeePosition.api.GET + 1).then(function() {}, function(response) {
                    $log.error('There was an issue loading the employee positions', response);
                }, function(positions) {
                    vm.positions = vm.positions.concat(positions);
                });
            }

            function loadInventoryLocations(vm) {
                vm.locations = [];
                API.query(InventoryLocation.api.GET + 1).then(function() {}, function(response) {
                    $log.error('There was an issue loading the inventory locations', response);
                }, function(locations) {
                    vm.locations = vm.locations.concat(locations);
                });
            }

            scope.$on('$destroy', devoniteAside.destroy);


        }
    }
})();
(function() {
'use strict';

    angular
        .module('app')
        .factory('devoniteAside', devoniteAside);

    /** @ngInject */
    function devoniteAside($aside, $http, $templateCache, $q) {
        
        var aside;
        
        var service = {
            construct:construct,
            show: showAside,
            onConfirm: onConfirm,
            onCancel: onCancel,
            onDelete: onDelete,
            destroy: destroy,
            getAside: getAside,
            registerAction: registerAction,
            getScope: getScope
        };
        
        return service;
        
        var confirmEvent, cancelEvent, deleteEvent, options, scopeInstance, scopeInheritence;
        var customActions = [];

        ////////////////
        
        function construct(config, scopeInstancePointer) { 
            options = {
                backdrop: true,
                controller: devoniteAsideController
            };
            
            angular.extend(options, config);
            
            if(angular.isUndefined($templateCache.get(config.templateUrl))) {
                $http.get(config.templateUrl, {cache:$templateCache});
            }
            
            if(angular.isDefined(scopeInstancePointer))
                scopeInstance = scopeInstancePointer;
            
        }
        
        function onConfirm(callback) {
            confirmEvent = callback;
        }
        
        function onCancel(callback) {
            cancelEvent = callback;
        }
        
        function onDelete(callback) {
            deleteEvent = callback;
        }
        
        function showAside() {
            aside = $aside.open(options);
        }
        
        function getAside() {
            return aside;
        }
        
        function registerAction(action) {
            if(angular.isUndefined(customActions))
                customActions = [];
            customActions.push(action);
        }
        
        function getScope() {
            return scopeInheritence;
        }
        
        function devoniteAsideController($log, $scope, $uibModalInstance) {
            
            if(angular.isDefined(scopeInstance)) {
                scopeInstance($scope);
            }
            
            angular.forEach(customActions, function(customAction) {
                $scope[customAction.name] = customAction.action;
            });
            
            $scope.ok = confirmAside;
            $scope['delete'] = deleteAside;
            $scope.cancel = cancelAside;
            
            scopeInheritence = $scope;
            
            function confirmAside(event, type) {
                if(angular.isDefined(confirmEvent)) {
                    confirmEvent($q.defer(), $scope, type).then(function() {
                        $uibModalInstance.close();
                        event.stopPropagation();
                    });
                }
                else {
                    $uibModalInstance.close();
                    event.stopPropagation();
                }
            }
            
            function cancelAside(event) {
                if(angular.isDefined(cancelEvent))
                    cancelEvent($scope);
                $uibModalInstance.dismiss();
                event.stopPropagation();
            }
            
            function deleteAside(event) {
                if(angular.isDefined(deleteEvent)) {
                    deleteEvent($q.defer(), $scope).then(function() {
                        $uibModalInstance.dismiss();
                        event.stopPropagation();
                    });
                }
                else {
                    $uibModalInstance.dismiss();
                    event.stopPropagation();
                }   
            }
        }
        
        function destroy() {
            options = {};
            confirmEvent = undefined;
            cancelEvent = undefined;
            customActions = [];
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.contact', []);

})();
(function () {
    'use strict';

    angular
        .module('app.contact')
        .directive('contactAside', contactAside);

    /** @ngInject */
    function contactAside($log, devoniteAside, toaster, API, Contact, Company, SweetAlert, _) {

        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                contactAside: '=?'
            }
        };

        return directive;

        function link(scope, element, attrs) {

            var aside = {
                TEMPLATE_URL: '/app/components/contactAside/contactAside.html',
                SAVE_SUCCESS_TITLE: 'Saved Contact',
                SAVE_SUCCESS_MESSAGE: 'You have created a new contact: {0}.',
                UPDATE_SUCCESS_TITLE: 'Updated Contact',
                UPDATE_SUCCESS_MESSAGE: 'You have successfully updated the contact: {0}.',
                FORM_ERROR_TITLE: 'Error: Missing Required Fields',
                FORM_ERROR_MESSAGE: 'Please fill out all of the required fields.',
                SAVE_ERROR_EMAIL_TITLE: 'Email Address Taken',
                SAVE_ERROR_EMAIL_MESSAGE: 'The email address is already registered to another user.',
                UPDATE_ERROR_TITLE: 'Error Updating Contact',
                UPDATE_ERROR_MESSAGE: 'There was an issue updating the contact. Please contact support.'
            }

            element.bind('click', function () {
                constructor();
                devoniteAside.show();
            });

            function constructor() {
                devoniteAside.construct({
                    templateUrl: aside.TEMPLATE_URL,
                    placement: attrs.placement ? attrs.placement : 'right',
                    size: attrs.size ? attrs.size : 'md'
                }, function (vm) {

                    vm.companies = [];

                    API.query(Company.api.GET + 1).then(function() {},
                    function(response) {
                        $log.error('There was an issue loading companies.', response);
                    }, function(companies) {
                       vm.companies = vm.companies.concat(companies);
                    });

                    if (angular.isDefined(attrs.identity)) {
                        Contact.get(attrs.identity).then(function (contact) {
                            if(angular.isDefined(contact.company) )
                                contact.company = contact.company.identity;
                            vm.form = contact;
                        });
                    }

                });

                devoniteAside.onCancel(function() {
                    devoniteAside.destroy();
                });

                devoniteAside.onConfirm(function (deferred, vm) {
                    vm.submitted = true;
                    if (vm.asideForm.$valid) {
                        if (angular.isDefined(attrs.identity)) {
                            Contact.update(vm.form).then(function (contact) {
                                if (angular.isDefined(scope.contactAside)) {
                                    scope.contactAside = _.filter(scope.contactAside, function (contactRow) {
                                        return contactRow.identity !== contact.identity;
                                    });
                                    scope.contactAside.push(contact);
                                }
                                SweetAlert.success(aside.UPDATE_SUCCESS_TITLE, aside.UPDATE_SUCCESS_MESSAGE.replace('{0}', contact.name));
                                deferred.resolve();
                            }, function (response) {
                                $log.error('There was an issue updating the contact.', response);
                                SweetAlert.error(aside.UPDATE_ERROR_TITLE, aside.UPDATE_ERROR_MESSAGE);
                                deferred.reject();
                            });
                        }
                        else {
                            Contact.save(vm.form).then(function (contact) {
                                if (angular.isDefined(scope.contactAside))
                                    scope.contactAside.push(contact);
                                SweetAlert.success(aside.SAVE_SUCCESS_TITLE, aside.SAVE_SUCCESS_MESSAGE.replace('{0}', contact.name));
                                deferred.resolve();
                            }, function() {
                                deferred.reject();
                            });
                        }
                    }
                    else {
                        toaster.pop('error', aside.FORM_ERROR_TITLE, aside.FORM_ERROR_MESSAGE);
                        deferred.reject();
                    }
                    return deferred.promise;
                });
            }

            scope.$on('$destroy', devoniteAside.destroy);

        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.rental')
        .directive('confirmationAside', confirmationAside);

    /** @ngInject */
    function confirmationAside($log, $window, $filter, devoniteAside, toaster, Confirmation, Company, SweetAlert, Inventory, API, _) {

        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                confirmationAside : '=?'
            }
        };

        return directive;


        function link(scope, element, attrs) {

            var aside = {
                TEMPLATE_URL: '/app/components/confirmationAside/confirmationAside.html',
                SAVE_SUCCESS_TITLE : 'Saved Confirmation',
                SAVE_SUCCESS_MESSAGE: 'You have created a new confirmation: {0}.',
                UPDATE_SUCCESS_TITLE: 'Updated Confirmation',
                UPDATE_SUCCESS_MESSAGE: 'You have successfully updated the confirmation: {0}.',
                FORM_ERROR_TITLE: 'Error: Missing Required Fields',
                FORM_ERROR_MESSAGE: 'Please fill out all of the required fields.',
                SAVE_ERROR_TITLE: 'Error Saving Confirmation',
                SAVE_ERROR_MESSAGE: 'There was an issue saving the confirmation. Please contact support.'
            }

            element.bind('click', function() {
                constructor();
                devoniteAside.show();
            });

            function constructor() {
                devoniteAside.construct({
                    templateUrl: aside.TEMPLATE_URL,
                    placement: attrs.placement ? attrs.placement : 'right',
                    size: attrs.size ? attrs.size : 'full'
                }, function(vm) {

                    vm.on_rent = {
                        opened: false,
                        options : {
                            formatYear: 'yyyy',
                            minDate: new Date(),
                            startingDay: 1,
                            showWeeks: false
                        },
                        format: 'MM/dd/yyyy'
                    };

                    vm.off_rent = {
                        opened: false,
                        options : {
                            formatYear: 'yyyy',
                            minDate: new Date(),
                            startingDay: 1,
                            showWeeks: false
                        },
                        format: 'MM/dd/yyyy'
                    };

                    vm.on_rent.open = function() {
                        vm.on_rent.opened = true;
                    }

                    vm.off_rent.open = function() {
                        vm.off_rent.opened = true;
                    }

                    vm.parseDate = function parseDate(date) {
                        if(angular.isUndefined(date) || date === null)
                            return '';
                        return $filter('date')(Date.parse(date), 'MM/dd/yyyy');
                    };

                    vm.loadCompany = loadCompany;
                    vm.loadContact = loadContact;

                    loadCompanies(vm);

                    if(angular.isDefined(attrs.identity)) {
                        Inventory.get(attrs.identity).then(function(item) {
                            $log.debug("item",item);
                            vm.form = item;
                            vm.form.item = item.identity;
                        });
                    }

                });

                devoniteAside.onCancel(function() {
                    devoniteAside.destroy();
                });

                devoniteAside.onConfirm(function(deferred, vm) {
                    vm.submitted = true;
                    if(vm.asideForm.$valid) {
                        if(angular.isDefined(attrs.identity)) {
                            $log.debug('Sending...', vm.form);
                            Confirmation.save(vm.form).then(function(item) {
                                // SweetAlert.success(aside.SAVE_SUCCESS_TITLE, aside.SAVE_SUCCESS_MESSAGE.replace('{0}', item.item_number));
                                SweetAlert.swal({
                                    title: aside.SAVE_SUCCESS_TITLE,
                                    text: aside.SAVE_SUCCESS_MESSAGE.replace('{0}', item.item_number),
                                    type: 'success'
                                }, function() {
                                    $window.location.reload();
                                });
                                deferred.resolve();
                            }, function(response) {
                                $log.error('There was an issue saving the confirmation.', response);
                                SweetAlert.error(aside.SAVE_ERROR_TITLE, aside.SAVE_ERROR_MESSAGE);
                                deferred.reject();
                            });

                        }
                    }
                    else {
                        toaster.pop('error', aside.FORM_ERROR_TITLE, aside.FORM_ERROR_MESSAGE);
                        deferred.reject();
                    }
                    return deferred.promise;
                });
            }

            function loadCompanies(vm) {
                vm.companies = [];
                API.query(Company.api.GET + 1).then(function() {}, function(response) {
                    $log.error('There was an issue loading companies.', response);
                }, function(companies) {
                   vm.companies = vm.companies.concat(companies);
                });
            }

            function loadCompany(vm) {
                var company = _.find(vm.companies, function(company) {
                    return company.identity === vm.form.company;
                });
                vm.contacts = company.contacts;
            }

            function loadContact(vm) {
                var contact = _.find(vm.contacts, function(contact) {
                    return contact.identity == vm.form.contact;
                });
                if(contact && contact.office_phone)
                    vm.form.phone = contact.office_phone;
            }

            scope.$on('$destroy', devoniteAside.destroy);


        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('companyClassificationAside', companyClassificationAside);

    /** @ngInject */
    function companyClassificationAside($log, devoniteAside, toaster, API, CompanyClassification, SweetAlert, _) {

        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                companyClassificationAside: '=?',
                visible: '=?'
            }
        };

        return directive;

        function link(scope, element, attrs) {

            var aside = {
                TEMPLATE_URL: '/app/components/companyClassificationAside/companyClassificationAside.html',
                SAVE_SUCCESS_TITLE: 'Saved Classification',
                SAVE_SUCCESS_MESSAGE: 'You have created a new classification: {0}.',
                UPDATE_SUCCESS_TITLE: 'Updated Classification',
                UPDATE_SUCCESS_MESSAGE: 'You have successfully updated the classification: {0}.',
                FORM_ERROR_TITLE: 'Error: Missing Required Fields',
                FORM_ERROR_MESSAGE: 'Please fill out all of the required fields.',
                UPDATE_ERROR_TITLE: 'Error Updating Classification',
                UPDATE_ERROR_MESSAGE: 'There was an issue updating the classification. Please contact support.',
                SAVE_ERROR_TITLE: 'Error Saving Classification',
                SAVE_ERROR_MESSAGE: 'There was an issue saving the classification. Please contact support.'
            };
            
            var deletePromptConfig = {
                title: 'Are you sure?',
                text: '{0} will be moved to the trash.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Delete Classification',
                closeOnConfirm: true  
            };

            element.bind('click', function () {
                constructor();
                devoniteAside.show();
            });
            
            scope.$watch('visible', function(newVal) {
               if(newVal === true) {
                   constructor();
                   devoniteAside.show();
               } 
            });
            
            scope.$watch(function() {
                if(angular.isDefined(devoniteAside.getAside()))
                    return devoniteAside.getAside().closed;
                return devoniteAside.getAside();
            }, function(newVal) {
                if(angular.isDefined(newVal)) {
                    newVal.then(function(event) {
                       scope.visible = false;
                    });
                }
            });
            
            function constructor() {
                devoniteAside.construct({
                    templateUrl: aside.TEMPLATE_URL,
                    placement: attrs.placement ? attrs.placement : 'right',
                    size: attrs.size ? attrs.size : 'sm'
                }, function (vm) {
                    if (angular.isDefined(attrs.identity)) {
                        CompanyClassification.get(attrs.identity).then(function(location) {
                            vm.form = location;
                        });
                    }
                });

                devoniteAside.onCancel(function() {
                    devoniteAside.destroy();
                });
                
                devoniteAside.onDelete(function(deferred, vm) {
                   deletePromptConfig.text = deletePromptConfig.text.replace('{0}', vm.form.name);
                   SweetAlert.swal(deletePromptConfig, function(isConfirm) {
                        if (isConfirm) {
                            CompanyClassification.delete(vm.form.identity).then(function() {
                                scope.companyClassificationAside = _.filter(scope.companyClassificationAside, function(row) {
                                    return row.identity !== vm.form.identity;
                                });
                                SweetAlert.swal('Deleted!', vm.form.name + ' has been moved to the trash.', "success");
                                deferred.resolve();
                            });
                        }
                        else {
                            deferred.reject();
                        }
                    });
                   return deferred.promise; 
                });

                devoniteAside.onConfirm(function (deferred, vm) {
                    vm.submitted = true;
                    if (vm.asideForm.$valid) {
                        if (angular.isDefined(attrs.identity)) {
                            CompanyClassification.update(vm.form).then(function (classification) {
                                if (angular.isDefined(scope.companyClassificationAside)) {
                                    scope.companyClassificationAside = _.filter(scope.companyClassificationAside, function (classificationRow) {
                                        return classificationRow.identity !== classification.identity;
                                    });
                                    scope.companyClassificationAside.push(classification);
                                }
                                SweetAlert.success(aside.UPDATE_SUCCESS_TITLE, aside.UPDATE_SUCCESS_MESSAGE.replace('{0}', classification.name));
                                deferred.resolve();
                            }, function (response) {
                                $log.error('There was an issue updating the classification.', response);
                                SweetAlert.error(aside.UPDATE_ERROR_TITLE, aside.UPDATE_ERROR_MESSAGE);
                                deferred.reject(response);
                            });
                        }
                        else {
                            CompanyClassification.save(vm.form).then(function (classification) {
                                if (angular.isDefined(scope.companyClassificationAside))
                                    scope.companyClassificationAside.push(classification);
                                SweetAlert.success(aside.SAVE_SUCCESS_TITLE, aside.SAVE_SUCCESS_MESSAGE.replace('{0}', classification.name));
                                deferred.resolve();
                            }, function (response) {
                                $log.error('There was an issue saving the classification.', response);
                                SweetAlert.error(aside.SAVE_ERROR_TITLE, aside.SAVE_ERROR_MESSAGE);
                                deferred.reject(response);
                            });
                        }
                    }
                    else {
                        toaster.pop('error', aside.FORM_ERROR_TITLE, aside.FORM_ERROR_MESSAGE);
                        deferred.reject();
                    }
                    return deferred.promise;
                });
            }
            
            scope.$on('$destroy', devoniteAside.destroy);

        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('companyAside', companyAside);

    /** @ngInject */
    function companyAside($log, devoniteAside, toaster, API, Company, CompanyClassification, Industry, Employee, SweetAlert, ngNotify, $state, _) {

        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                companyAside: '=?'
            }
        };

        return directive;

        function link(scope, element, attrs) {

            var aside = {
                TEMPLATE_URL: '/app/components/companyAside/companyAside.html',
                SAVE_SUCCESS_TITLE: 'Saved Company',
                SAVE_SUCCESS_MESSAGE: 'You have created a new company: {0}.',
                UPDATE_SUCCESS_TITLE: 'Updated Company',
                UPDATE_SUCCESS_MESSAGE: 'You have successfully updated the company: {0}.',
                FORM_ERROR_TITLE: 'Error: Missing Required Fields',
                FORM_ERROR_MESSAGE: 'Please fill out all of the required fields.',
                UPDATE_ERROR_TITLE: 'Error Updating Company',
                UPDATE_ERROR_MESSAGE: 'There was an issue updating the company. Please contact support.'
            };
            
            var deletePromptConfig = {
                title: 'Are you sure?',
                text: '{0} will be moved to the trash.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Delete Company',
                closeOnConfirm: true  
            };

            element.bind('click', function () {
                constructor();
                devoniteAside.show();
            });

            function constructor() {
                devoniteAside.construct({
                    templateUrl: aside.TEMPLATE_URL,
                    placement: attrs.placement ? attrs.placement : 'right',
                    size: attrs.size ? attrs.size : 'full'
                }, function (vm) {
                    
                    loadAssignedUsers(vm);
                    loadClassifications(vm);
                    loadIndustries(vm);
                    loadCompanies(vm);

                    if (angular.isDefined(attrs.identity)) {
                        Company.get(attrs.identity).then(function (company) {
                            vm.company = company;
                            if(angular.isDefined(company.industry) && company.industry !== null)
                                company.industry = company.industry.identity;
                            if(angular.isDefined(company.assigned_user) && company.assigned_user !== null)
                                company.assigned_user = company.assigned_user.identity;
                            if(angular.isDefined(company.classification) && company.classification !== null)
                                company.classification = company.classification.identity;
                            if(angular.isDefined(company.parent_company) && company.parent_company !== null)
                                company.parent_company = company.parent_company.identity;
                            vm.form = company;
                        });
                    }
                    else {
                        vm.form = {
                            billing_country : 'United States',//TODO load from a company config
                            parent_check: true,
                            country_check: true
                        };
                    }

                });

                devoniteAside.onCancel(function() {
                    devoniteAside.destroy();
                });
                
                devoniteAside.onDelete(function(deferred, vm) {
                   deletePromptConfig.text = deletePromptConfig.text.replace('{0}', vm.form.name);
                   SweetAlert.swal(deletePromptConfig, function(isConfirm) {
                        if (isConfirm) {
                            Company.delete(vm.form.identity).then(function() {
                                scope.companyAside = _.filter(scope.companyAside, function(row) {
                                    return row.identity !== vm.form.identity;
                                });
                                SweetAlert.swal('Deleted!', vm.form.name + ' has been moved to the trash.', "success");
                                deferred.resolve();
                            });
                        }
                        else {
                            deferred.reject();
                        }
                    });
                   return deferred.promise; 
                });

                devoniteAside.onConfirm(function (deferred, vm, type) {
                    vm.submitted = true;
                    if (vm.asideForm.$valid) {
                        if (angular.isDefined(attrs.identity)) {
                            Company.update(vm.form).then(function (company) {
                                if (angular.isDefined(scope.companyAside)) {
                                    scope.companyAside = _.filter(scope.companyAside, function (companyRow) {
                                        return companyRow.identity !== company.identity;
                                    });
                                    scope.companyAside.push(company);
                                }
                                if(angular.isUndefined(type))
                                    SweetAlert.success(aside.UPDATE_SUCCESS_TITLE, aside.UPDATE_SUCCESS_MESSAGE.replace('{0}', company.name));
                                else if(type === 'ADD_NEW') {
                                    vm.form = {
                                        billing_country : 'United States',//TODO load from a company config
                                        parent_check: true,
                                        country_check: true
                                    };
                                    deferred.reject();
                                }
                                else if(type === 'SELECT_ASSET') {
                                    ngNotify.set('You are selecting equipment/inventory items for <strong>'+vm.company.name+'</strong>.', {
                                        type: 'info',
                                        sticky:true,
                                        html:true
                                    });
                                    $log.debug('Test', vm.company);
                                    $state.go('app.inventory.search', {company:vm.company.identity});
                                }
                                deferred.resolve();
                            }, function (response) {
                                $log.error('There was an issue updating the company.', response);
                                SweetAlert.error(aside.UPDATE_ERROR_TITLE, aside.UPDATE_ERROR_MESSAGE);
                                deferred.reject(response);
                            });
                        }
                        else {
                            Company.save(vm.form).then(function (company) {
                                if (angular.isDefined(scope.companyAside))
                                    scope.companyAside.push(company);
                                if(angular.isUndefined(type)) {
                                    SweetAlert.success(aside.SAVE_SUCCESS_TITLE, aside.SAVE_SUCCESS_MESSAGE.replace('{0}', company.name));
                                    deferred.resolve();
                                }
                                else if(type === 'ADD_NEW') {
                                    vm.form = {
                                        billing_country : 'United States',//TODO load from a company config
                                        parent_check: true,
                                        country_check: true
                                    };
                                    deferred.reject();
                                }
                                else if(type === 'SELECT_ASSET') {
                                    ngNotify.set('You are selecting equipment/inventory items for <strong>'+vm.company.name+'</strong>.', {
                                        type: 'info',
                                        sticky:true,
                                        html:true
                                    });
                                    $state.go('app.inventory.search', {company:vm.company});
                                }
                            }, function (response) {
                                deferred.reject(response);
                            });
                        }
                    }
                    else {
                        toaster.pop('error', aside.FORM_ERROR_TITLE, aside.FORM_ERROR_MESSAGE);
                        deferred.reject();
                    }
                    return deferred.promise;
                });
            }
            
            function loadAssignedUsers(vm) {
                vm.users = [];
                    
                API.query(Employee.api.GET + 1).then(function() {},
                function(response) {
                    $log.error('There was an issue loading users.', response);
                }, function(users) {
                    vm.users = vm.users.concat(users); 
                });
            }
            
            function loadClassifications(vm) {
                vm.classifications = [];
                    
                API.query(CompanyClassification.api.GET + 1).then(function() {},
                function(response) {
                    $log.error('There was an issue loading classifications.', response);
                }, function(classifications) {
                    vm.classifications = vm.classifications.concat(classifications); 
                });
            }
            
            function loadIndustries(vm) {
                vm.industries = [];
                    
                API.query(Industry.api.GET + 1).then(function() {},
                function(response) {
                    $log.error('There was an issue loading industries.', response);
                }, function(industries) {
                    vm.industries = vm.industries.concat(industries); 
                });
            }
            
            function loadCompanies(vm) {
                vm.companies = [];
                    
                API.query(Company.api.GET + 1).then(function() {},
                function(response) {
                    $log.error('There was an issue loading companies.', response);
                }, function(companies) {
                    vm.companies = vm.companies.concat(companies); 
                });
            }

            scope.$on('$destroy', devoniteAside.destroy);

        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('btnToggle', btnToggle);

    /** @ngInject */
    function btnToggle($log, $compile, _) {

        var directive = {
            restrict: 'AE',
            templateUrl: '/app/components/btnToggle/btnToggle.html',
            scope: {
                options: '='
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, elem, attrs) {
            
            if(angular.isDefined(scope.options)) {
                scope.selected = scope.options[0];
                setOptions();
            }

            scope.$watch('options', function(newVal, oldVal) {
               if(angular.isDefined(newVal) && newVal.length !== 0) {
                   scope.selected = newVal[0];
                   setOptions();
               } 
            });

            scope.selectItem = selectItem;
            scope.isSelected = isSelected;

            function setOptions() {
                if(attrs.justified)
                    scope.justified = true;
                if(attrs.selectedClass)
                    scope.selectedClass = attrs.selectedClass;
                else
                    scope.selectedClass = 'btn-primary';
                scope.selected = _.find(scope.options, function(option) {
                    return option.selected && option.selected == true;
                });
                if(!scope.selected) {
                    if(scope.options.length > 0) {
                        scope.selected = scope.options[0].selected == true ? scope.options[0].value : '';
                    }
                }
                else
                    scope.selected = scope.selected.value;
            }

            function selectItem(selectedItem) {
                if(selectedItem.disabled === true)
                    return;
                scope.selected = selectedItem.value;
                angular.forEach(scope.options, function(option) {
                    option.selected = false;
                });
                selectedItem.selected = true;
            }

            function isSelected(option) {
                return scope.selected == option.value;
            }
        }


    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .factory('API', API);

    /** @ngInject */
    function API($log, $http, $state, $q, $location) {

        var host;

        var service = {
            getRequest: getRequest,
            get: getRequest,
            postRequest: postRequest,
            putRequest: putRequest,
            deleteRequest: deleteRequest,
            query: queryRequest
        };

        initAPIHost();

        return service;

        function initAPIHost() {
            if($location.port() === 3000 || $location.port() === 3002) {
                host = 'http://insightflow/api/';
            }
            else {
                host = 'http://insightflow.devonite.com/core/api/';
            }
        }

        function syncToken() {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        }

        function queryRequest(url) {

            syncToken();

            var deferred = $q.defer();

            var queryNext = function(requestURL) {

                if(requestURL.indexOf('/?page=') !== -1)
                    requestURL = requestURL.replace('/?page=', '?page=');

                $http.get(requestURL).then(function(response) {

                    var responseData = response.data;
                    var pagination = responseData.meta.pagination;

                    deferred.notify(responseData.data);

                    if(angular.isDefined(pagination.links.next))
                        queryNext(pagination.links.next);
                    else
                        deferred.resolve();
                }, function(response) {
                    $log.error('Pagination ('+requestURL+')', response);
                    if(response.status === 401 || response.status === -1) {
                        $state.go('auth.login');
                        return;
                    }
                    deferred.reject(response);
                });
            };

            queryNext(host + url);

            return deferred.promise;
        }

        function getRequest(url) {
            syncToken();
            var deferred = $q.defer();
            $http.get(host + url).then(function(response) {
                deferred.resolve(response);
            }, function(response) {
                if (response.status === 401 || response.status === -1) {
                    $state.go('auth.login');
                    deferred.reject(response);
                    return;
                }
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function postRequest(url, payload) {
            syncToken();
            return $http.post(host + url, payload);
        }

        function putRequest(url, payload) {
            syncToken();
            return $http.put(host + url, payload);
        }

        function deleteRequest(url) {
            syncToken();
            return $http.delete(host + url);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('smart-table')
        .filter('smartTableFilter', smartTableFilter);

    /** @ngInject */
    function smartTableFilter(_) {
        return function (array, expression) {
            var expression = angular.copy(expression);
            return _.filter(array, function (object) {
                if (angular.isUndefined(expression.$)) {
                    var searchTerms = _.keys(expression);
                    return _.filter(searchTerms, function(searchTerm) {
                        var value = object[searchTerm];
                        if(angular.isString(value)) {
                            return value.toLowerCase().indexOf(expression[searchTerm].toLowerCase()) !== -1;
                        }
                        if (angular.isNumber(value)) {
                            var dateValue = new Date(value);
                            if (isNaN(dateValue))
                                return value.toString().indexOf(expression[searchTerm].toLowerCase()) !== -1;
                            else 
                                return dateValue.toString().toLowerCase().indexOf(expression[searchTerm].replace(/,/g, '').toLowerCase()) !== -1;
                        }
                        return false;
                    }).length === searchTerms.length;
                }
                else {
                    var values = _.values(object);
                    return _.find(values, function (value) {
                        if (angular.isUndefined(expression.$)) {
                            return true;
                        }
                        if (angular.isArray(value))
                            value = value.join(', ');
                        if (angular.isString(value))
                            return value.toLowerCase().indexOf(expression.$.toLowerCase()) !== -1;
                        if (angular.isNumber(value)) {
                            var dateValue = Date.parse(value);
                            if (isNaN(dateValue))
                                return value.toString().indexOf(expression.$.toLowerCase()) !== -1;
                            else
                                return dateValue.toString().indexOf(expression.$.toLowerCase()) !== -1;
                        }
                        return false;
                    });
                }
            });
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('app.yardman', []);

})();
(function() {
    'use strict';

    angular
        .module('app.yardman')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {

        $stateProvider

            .state('app.yardman', {
                url: '/yardman',
                templateUrl: '/app/yardman/yardman.html',
                controller: 'YardmanController',
                controllerAs: 'vm',
                title: 'Yardman',
                ncyBreadcrumb: {
                    label: 'Yardman'
                },
                resolve: {
                    /** @ngInject */
                    yardmanResolve: function(Inventory) {
                        return Inventory.getYardman();
                    }
                }
            });

    }

})();

(function() {
'use strict';

    angular
        .module('app.yardman')
        .controller('YardmanController', YardmanController);

    /** @ngInject */
    function YardmanController($log, yardmanResolve, API, Inventory, InventoryStatus, InventoryLocation) {
        var tblState;

        var vm = this;

        // Collection of status options
        vm.statuses = [];
        vm.secondStatuses = [];
        // Collection of inventory locations
        vm.locations = [];
        // Collection of inventory items
        vm.items = [].concat(yardmanResolve.data);
        vm.displayedItems = [].concat(vm.items);

        vm.filter = {
            asset : '',
            location: '',
            statuses: [],
            secondStatuses: []
        }
        vm.filteredItems = [];

        vm.filterPipe = filterPipe;
        vm.filterItems = filterItems;

        vm.placeholder = {
            collection: vm.items,
            title: 'No Inventory',
            message: 'There are currently no inventory items to confirm.',
        };

        constructor();

        function constructor() {
            if(yardmanResolve.meta.pagination.current_page < yardmanResolve.meta.pagination.total_pages) {
                API.query(Inventory.api.YARDMAN + (yardmanResolve.meta.pagination.current_page + 1)).then(function() {

                }, function(response) {
                    $log.error('There was an issue loading the inventory items.', response);
                }, function(items) {
                    vm.items = vm.items.concat(items);
                    vm.displayedItems = [].concat(vm.items);
                    vm.filteredItems = [].concat(vm.items);
                    filterPipe(tblState);
                });
            }
            else {
                vm.filteredItems = [].concat(vm.items);
                filterPipe(tblState);
            }
            loadInventoryLocations();
            loadInventoryStatuses();
        }

        function loadInventoryStatuses() {
            var allowedStatuses = ['Confirm', 'Ready for Delivery', 'Picked Up', '1st Check', 'Delivery Scheduled', 'Pick up Scheduled', 'On Yard'];
            API.query(InventoryStatus.api.GET + 1).then(function() {},
            function(response) {
                $log.error('There was an issue loading inventory statuses.', response);
            }, function(statuses) {
               vm.statuses = vm.statuses.concat(_.filter(statuses, function(status) {
                    return status.primary === true && allowedStatuses.indexOf(status.original) !== -1;
               }));
               vm.secondStatuses = vm.secondStatuses.concat(_.filter(statuses, function(status) {
                   return status.primary === false && allowedStatuses.indexOf(status.original) !== -1;
               }));
            });
        }

        function loadInventoryLocations() {
            API.query(InventoryLocation.api.GET + 1).then(function() {},
            function(response) {
                $log.error('There was an issue loading inventory locations.', response);
            }, function(locations) {
               vm.locations = vm.locations.concat(locations);
            });
        }

        function filterPipe(tableState) {
            tblState = tableState;
            if (tableState) {
                var pagination = tableState.pagination;
                var start = pagination.start || 0;
                var number = pagination.number || 10;
                var searchTerm = tableState.search.predicateObject || '';
                tableState.pagination.numberOfPages = Math.ceil(Object.keys(vm.filteredItems).length / 10);
                vm.displayedItems = vm.filteredItems.slice(start, start + number);
            }
            else {
                tblState = {
                    pagination : {
                        number: 10,
                        numberOfPages: 0,
                        start: 0,
                        totalItemCount: 0
                    },
                    search: {},
                    sort: {}
                };
                filterPipe(tblState);
            }
        }

        function filterItems() {
            vm.filteredItems = [].concat(vm.items);
            vm.filteredItems = _.filter(vm.filteredItems, function(item) {
                if(vm.filter.asset) {
                    if(item.asset.toLowerCase().indexOf(vm.filter.asset.toLowerCase()) === -1)
                        return false;
                }
                if(vm.filter.statuses && vm.filter.statuses.length > 0) {
                    if(!item.status || vm.filter.statuses.indexOf(item.status.original) === -1)
                        return false;
                }
                if(vm.filter.secondStatuses && vm.filter.secondStatuses.length > 0 ) {
                    if(!item.secondStatus || vm.filter.secondStatuses.indexOf(item.secondStatus.original) === -1)
                        return false;
                }
                if(vm.filter.locations && vm.filter.locations.length > 0) {
                    if(item.location === null || vm.filter.locations.indexOf(item.location.identity) === -1)
                        return false;
                }
                return true;
            });
            vm.filterPipe(tblState);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.user', []);

})();
(function() {
    'use strict';

    angular
        .module('app.user')
        .factory('User', User);

    /** @ngInject */
    function User($log, $q, API) {

        var factory = {
            getAll: getAll,
            getDeleted: getAllDeleted,
            get: get,
            save: save,
            update: update,
            'delete': deleteRequest
        };

        return factory;

        function getAllDeleted() {
            var deferred = $q.defer();
            API.getRequest('companies/deleted').then(function(response) {
                deferred.resolve(response.data);

            }, function(response) {
                $log.error('[Companies] getAllDeleted()', response);
                deferred.resolve();
            });
            return deferred.promise;
        }

        function getAll() {
            var deferred = $q.defer();
            API.getRequest('users').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[User] getAll()', response);
                deferred.resolve();
            });
            return deferred.promise;
        }

        function get(identity) {
            var deferred = $q.defer();
            API.getRequest('users?identity=' + identity).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[User] get()', response);
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

        function save(payload) {
            var deferred = $q.defer();
            API.postRequest('users', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[User] save()', response);
                deferred.resolve();
            });
            return deferred.promise;
        }

        function update(payload) {
            var deferred = $q.defer();
            API.putRequest('users', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[User] update()', response);
                deferred.resolve();
            });
            return deferred.promise;
        }

        function deleteRequest(identity) {
            var deferred = $q.defer();
            API.deleteRequest('users?identity='+identity).then(function(response) {
                deferred.resolve(response);
            }, function(response) {
                $log.error('[User] delete()', response);
                deferred.resolve();
            });
            return deferred.promise;
        }

    }

})();
(function() {
    'use strict';

    angular.module('app')
        .factory('Role', Role);

    /** @ngInject */
    function Role($log, $q, API) {
        
        var api = {
            GET: '/roles/?page='
        };

        var factory = {
            getAll: getAll,
            getDeleted: getAllDeleted,
            get: get,
            save: save,
            update: update,
            'delete': deleteRequest,
            api: api
        };

        return factory;

        function getAllDeleted() {
            var deferred = $q.defer();
            API.getRequest('roles/deleted').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function getAll() {
            var deferred = $q.defer();
            API.getRequest('roles').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function get(identity) {
            var deferred = $q.defer();
            API.getRequest('roles?identity=' + identity).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function save(payload) {
            var deferred = $q.defer();
            API.postRequest('roles', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function update(payload) {
            var deferred = $q.defer();
            API.putRequest('roles', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function deleteRequest(identity) {
            var deferred = $q.defer();
            API.deleteRequest('roles?identity='+identity).then(function(response) {
                deferred.resolve(response);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

    }

})();
(function() {
    'use strict';

    angular.module('app')
        .controller('UserRoleSettingsController', UserRoleSettingsController);

    /** @ngInject */
    function UserRoleSettingsController(roleResolve, API, Role, $log) {

        var vm = this;
        vm.asideRole = false;
        vm.roles = [].concat(roleResolve.data);
        vm.displayedRoles = [].concat(vm.roles);
        
        vm.placeholder = {
            collection: vm.roles,
            title: 'No Roles',
            message: 'There are currently no user roles.',
            button_text: 'Create 1<sup>st</sup> Role',
            button_action: function() {
                vm.asideRole = true;
            }
        };
        
        constructor();
        
        function constructor() {
            if(roleResolve.meta.pagination.current_page < roleResolve.meta.pagination.total_pages) {
                API.query(Role.api.GET + (roleResolve.meta.pagination.current_page + 1)).then(function() {
                }, function(response) {
                    $log.error('There was an issue loading the user roles.', response);
                }, function(roles) {
                    vm.roles = vm.roles.concat(roles);
                    vm.displayedRoles = [].concat(vm.roles);
                });
            }
        }
        
    }
})();
(function() {
    'use strict';

    angular.module('app')
        .controller('StatusOptionSettingsController', StatusOptionSettingsController);

    /** @ngInject */
    function StatusOptionSettingsController(InventoryStatus, $aside, $log, SweetAlert, _, statusResolve) {

        var vm = this;
        vm.asideStatus = false;
        vm.statuses = [].concat(statusResolve.data);
        vm.displayedStatuses = [].concat(vm.statuses);

        vm.showCreateStatus = showCreateStatus;
        vm.showEditStatus = showEditStatus;
        
        vm.placeholder = {
            collection: vm.statuses,
            title: 'No Statuses',
            message: 'There are currently no statuses.',
            button_text: 'Create 1<sup>st</sup> Status',
            button_action: function() {
                $log.debug('Called!');
                vm.asideStatus = true;
            }
        };
        
        constructor();
        
        function constructor() {
            if(statusResolve.meta.pagination.current_page < statusResolve.meta.pagination.total_pages) {
                API.query(InventoryStatus.api.GET + (statusResolve.meta.pagination.current_page + 1)).then(function() {
                }, function(response) {
                    $log.error('There was an issue loading the inventory statuses.', response);
                }, function(statuses) {
                    vm.statuses = vm.statuses.concat(statuses);
                    vm.displayedStatuses = [].concat(vm.statuses);
                });
            }
        }

        function showCreateStatus() {
            var createStatusInstance = $aside.open({
                templateUrl: 'asideStatus.html',
                placement: 'right',
                size: 'sm',
                backdrop: true,
                controller: function ($scope, $uibModalInstance) {

                    $scope.statusTypes = [{
                        value: 1,
                        text: 'Primary Status',
                        selected: true
                    }, {
                        value: 0,
                        text: '2<sup>nd</sup> Status'
                    }];

                    $scope.form = {
                        primary : true
                    };

                    $scope.ok = function (e) {
                        $scope.submitted = true;
                        if($scope.statusForm.$valid) {
                            $uibModalInstance.close();
                            e.stopPropagation();
                            $scope.form.primary = _.find($scope.statusTypes, function(option) {
                                return option.selected && option.selected == true;
                            }).value;
                            saveStatus($scope.form);
                        }
                    };

                    $scope.cancel = function (e) {
                        $scope.form = '';
                        $uibModalInstance.dismiss();
                        e.stopPropagation();
                    };
                },
            });
        }

        function showEditStatus(status) {
            var editStatusInstance = $aside.open({
                templateUrl: 'asideStatus.html',
                placement: 'right',
                size: 'sm',
                backdrop: true,
                controller: function ($scope, $uibModalInstance) {

                    $scope.statusTypes = [{
                        value: 1,
                        text: 'Primary Status',
                        selected: status.primary !== 0
                    }, {
                        value: 0,
                        text: '2<sup>nd</sup> Status',
                        selected: status.primary === 0
                    }];

                    $scope.form = {
                        identity: status.identity,
                        primary : status.primary,
                        background : status.background_color,
                        foreground: status.primary_color,
                        name: status.name
                    };

                    $scope.ok = function (e) {
                        $scope.submitted = true;
                        if($scope.statusForm.$valid) {
                            $uibModalInstance.close();
                            e.stopPropagation();
                            $scope.form.primary = _.find($scope.statusTypes, function(option) {
                                return option.selected && option.selected == true;
                            }).value;
                            updateStatus(status, $scope.form);
                        }
                    };
                    $scope.cancel = function (e) {
                        $scope.form = '';
                        $uibModalInstance.dismiss();
                        e.stopPropagation();
                    };
                },
            });
        }

        function saveStatus(form) {
            InventoryStatus.save(form).then(function(status) {
                vm.statuses.push(status);
                vm.displayedStatuses.push(status);
                SweetAlert.swal('Saved Status', 'You have created a new status: ' + status.name + '.', 'success');
            });
        }

        function updateStatus(oldStatus, form) {
            InventoryStatus.update(form).then(function(status) {
                vm.statuses.splice(vm.statuses.indexOf(oldStatus), 1);
                vm.displayedStatuses.splice(vm.displayedStatuses.indexOf(oldStatus), 1);
                vm.statuses.push(status);
                vm.displayedStatuses.push(status);
                SweetAlert.swal('Updated Status', 'You have updated the status: ' + status.name + '.', 'success');
            });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider, PageProvider) {

        $urlRouterProvider.otherwise('/app/dashboard');

        $stateProvider
            .state('app.settings', {
                url: '/settings',
                abstract: true,
                template: '<ui-view />',
                resolve: {
                    roleResolve: PageProvider.roleResolve
                }
            })
            .state('app.settings.companies', {
                url: '/companies',
                templateUrl: '/app/settings/company-settings.html',
                controller: 'CompanySettingsController',
                controllerAs: 'vm',
                title: 'Company',
                ncyBreadcrumb: {
                    label: 'Company'
                },
                resolve: {
                    /** @ngInject */
                    companyResolve: function(Company) {
                        return Company.getAll();
                    }
                }
            })
            .state('app.settings.contacts', {
                url: '/contact',
                templateUrl: '/app/settings/contact-settings.html',
                controller: 'ContactSettingsController',
                controllerAs: 'vm',
                title: 'Contact',
                ncyBreadcrumb: {
                    label: 'Contact'
                },
                resolve: {
                    /** @ngInject */
                    contactResolve: function(Contact) {
                        return Contact.getAll();
                    }
                }
            })
            .state('app.settings.employees', {
                url: '/employees',
                templateUrl: '/app/settings/employee-settings.html',
                controller: 'EmployeeSettingsController',
                controllerAs: 'vm',
                title: 'Employees',
                ncyBreadcrumb: {
                    label: 'Employees'
                },
                resolve: {
                    /** @ngInject */
                    employeesResolve: function(Employee) {
                        return Employee.getAll();
                    }
                }
            })
            .state('app.settings.inventory', {
                url: '/inventory',
                templateUrl: '/app/settings/inventory-settings.html',
                controller: 'InventorySettingsController',
                controllerAs: 'vm',
                title: 'Inventory',
                ncyBreadcrumb: {
                    label: 'Inventory'
                },
                resolve: {
                    /** @ngInject */
                    inventoryResolve: function(Inventory) {
                        return Inventory.getAll();
                    }
                }
            })
            .state('app.settings.status-options', {
                url: '/statuses',
                templateUrl: '/app/settings/status-option-settings.html',
                controller: 'StatusOptionSettingsController',
                controllerAs: 'vm',
                title: 'Status Options',
                ncyBreadcrumb: {
                    label: 'Status Options'
                },
                resolve: {
                    /** @ngInject */
                    statusResolve: function(InventoryStatus) {
                        return InventoryStatus.getAll();
                    }
                }
            })
            .state('app.settings.inventory-locations', {
                url: '/locations',
                templateUrl: '/app/settings/inventory-location-settings.html',
                controller: 'InventoryLocationSettingsController',
                controllerAs: 'vm',
                title: 'Inventory Locations',
                ncyBreadcrumb: {
                    label: 'Inventory Locations'
                },
                resolve: {
                    /** @ngInject */
                    locationResolve: function(InventoryLocation) {
                        return InventoryLocation.getAll();
                    }
                }
            })
            .state('app.settings.company-classifications', {
                url: '/classifications',
                templateUrl: '/app/settings/company-classification-settings.html',
                controller: 'CompanyClassificationSettingsController',
                controllerAs: 'vm',
                title: 'Company Classifications',
                ncyBreadcrumb: {
                    label: 'Company Classifications'
                },
                resolve: {
                    /** @ngInject */
                    classificationResolve: function(CompanyClassification) {
                        return CompanyClassification.getAll();
                    }
                }
            })
            .state('app.settings.employee-departments', {
                url: '/departments',
                templateUrl: '/app/settings/employee-department-settings.html',
                controller: 'EmployeeDepartmentSettingsController',
                controllerAs: 'vm',
                title: 'Employee Departments',
                ncyBreadcrumb: {
                    label: 'Employee Departments'
                },
                resolve: {
                    /** @ngInject */
                    departmentResolve: function(EmployeeDepartment) {
                        return EmployeeDepartment.getAll();
                    }
                }
            })
            .state('app.settings.employee-positions', {
                url: '/positions',
                templateUrl: '/app/settings/employee-position-settings.html',
                controller: 'EmployeePositionSettingsController',
                controllerAs: 'vm',
                title: 'Employee Positions',
                ncyBreadcrumb: {
                    label: 'Employee Positions'
                },
                resolve: {
                    /** @ngInject */
                    positionResolve: function(EmployeePosition) {
                        return EmployeePosition.getAll();
                    }
                }
            })
            .state('app.settings.roles', {
                url: '/roles',
                templateUrl: '/app/settings/user-role-settings.html',
                controller: 'UserRoleSettingsController',
                controllerAs: 'vm',
                title: 'User Roles',
                ncyBreadcrumb: {
                    label: 'User Roles'
                },
                resolve: {
                    /** @ngInject */
                    roleResolve: function(Role) {
                        return Role.getAll();
                    }
                }
            })
            .state('app.settings.inventory-categories', {
                url: '/inventory-categories',
                templateUrl: '/app/settings/inventory-category-settings.html',
                controller: 'InventoryCategorySettingsController',
                controllerAs: 'vm',
                title: 'Inventory Categories',
                ncyBreadcrumb: {
                    label: 'Inventory Categories',
                },
                resolve: {
                    /** @ngInject */
                    categoryResolve: function(InventoryCategory) {
                        return InventoryCategory.getAll();
                    }
                }
            });

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('InventorySettingsController', InventorySettingsController);

    /** @ngInject */
    function InventorySettingsController(Inventory, InventoryStatus, InventoryLocation, $scope, $aside, $log, _, SweetAlert, inventoryResolve, API) {

        var vm = this;

        vm.asideInventory = false;
        // The collection of all the items
        vm.items = [].concat(inventoryResolve.data);
        // The collection of displayed items
        vm.displayedItems = [].concat(vm.items);
        // The collection of filtered items
        vm.filteredItems = [].concat(vm.items);
        
        vm.safeCollection = [].concat(vm.items);
        
        vm.filter = {};

        // The primary statuses collection
        vm.statuses = [];
        // The secondary statuses collection
        vm.secondStatuses = [];
        // The inventory location collection
        vm.locations = [];

        vm.displayedDeleted = [];
        vm.deletedItems = [];

        vm.createItem = createItem;
        vm.saveItem = saveItem;
        vm.showEditItem = showEditItem;
        vm.deleteItemPrompt = deleteItemPrompt;
        vm.restoreItemPrompt = restoreItemPrompt;
        vm.filterPipe = filterPipe;
        vm.filterItems = filterItems;

        loadTrashedInventory();

        vm.placeholder = {
            collection: vm.items,
            title: 'No Inventory',
            message: 'There are currently no inventory items.',
            button_text: 'Create 1<sup>st</sup> Item',
            button_action: function () {
                vm.asideInventory = true;
            }
        };

        constructor();

        function constructor() {
            if (inventoryResolve.meta.pagination.current_page < inventoryResolve.meta.pagination.total_pages) {
                API.query(Inventory.api.GET + (inventoryResolve.meta.pagination.current_page + 1)).then(function () {
                }, function (response) {
                    $log.error('There was an issue loading the inventory items.', response);
                }, function (items) {
                    vm.items = vm.items.concat(items);
                    vm.displayedItems = [].concat(vm.items);
                    vm.filteredItems = [].concat(vm.items);
                    vm.safeCollection = vm.safeCollection.concat(items);
                    filterItems();
                });
            }
            else {
                filterItems();
            }
            loadInventoryStatuses();
            loadInventoryLocations();
        }

        function loadInventoryStatuses() {
            API.query(InventoryStatus.api.GET + 1).then(function () { },
                function (response) {
                    $log.error('There was an issue loading the inventory statuses.', response);
                }, function (statuses) {
                    vm.statuses = vm.statuses.concat(_.filter(statuses, function (status) {
                        return status.primary === true;
                    }));
                    vm.secondStatuses = vm.secondStatuses.concat(_.filter(statuses, function (status) {
                        return status.primary === false;
                    }));
                });
        }
        
        function loadInventoryLocations() {
            API.query(InventoryLocation.api.GET + 1).then(function() {}, 
            function(response) {
                $log.error('There was an issue loading the inventory locations.', response);
            }, function(locations) {
                vm.locations = vm.locations.concat(locations);
            });
        }

        function loadTrashedInventory() {
            Inventory.getDeleted().then(function (items) {
                vm.deletedItems = items;
                vm.displayedDeleted = [].concat(items);
            });
        }

        function filterPipe(tableState) {
            if (tableState) {
                var pagination = tableState.pagination;
                var start = pagination.start || 0;
                var number = pagination.number || 10;
                var searchTerm = tableState.search.predicateObject || '';
                tableState.pagination.numberOfPages = Math.ceil(Object.keys(vm.items).length / 10);
                vm.displayedItems = vm.items.slice(start, start + number);
            }
        }
        
        function filterItems() {
            vm.items = _.filter(vm.safeCollection, function(item) {
                if(vm.filter.asset) {
                    if(item.asset.toLowerCase().indexOf(vm.filter.asset.toLowerCase()) === -1)
                        return false;
                }
                if(vm.filter.category) {
                    if(item.category.name.toLowerCase().indexOf(vm.filter.category.toLowerCase()) === -1)
                        return false;
                }
                if(vm.filter.description) {
                    if(item.description === null || item.description.toLowerCase().indexOf(vm.filter.description.toLowerCase()) === -1)
                        return false;
                }
                if(vm.filter.statuses && vm.filter.statuses.length > 0) {
                    if(!item.status || vm.filter.statuses.indexOf(item.status.original) === -1)
                        return false;
                }
                if(vm.filter.secondStatuses && vm.filter.secondStatuses.length > 0 ) {
                    if(!item.secondStatus || vm.filter.secondStatuses.indexOf(item.secondStatus.original) === -1)
                        return false;
                }
                if(vm.filter.locations && vm.filter.locations.length > 0) {
                    if(!item.location || vm.filter.locations.indexOf(item.location.identity) === -1)
                        return false;
                }
                return true;
            });
        }
        
        function createItem() {
            $aside.open({
                templateUrl: 'asideContent.html',
                placement: 'right',
                size: 'md',
                backdrop: true,
                controller: function ($scope, $uibModalInstance) {
                    $scope.statuses = vm.statuses;
                    $scope.secondStatuses = vm.secondStatuses;
                    $scope.categories = vm.categories;
                    $scope.locations = vm.locations;
                    $scope.showLocationFields = false;

                    $scope.date_fleet = {
                        opened: false,
                        options: {
                            formatYear: 'yyyy',
                            minDate: new Date(),
                            startingDay: 1,
                            showWeeks: false
                        },
                        format: 'MM/dd/yyyy',
                    };

                    $scope.date_fleet.open = function () {
                        $scope.date_fleet.opened = true;
                    }

                    $scope.manu_year = {
                        opened: false,
                        options: {
                            formatYear: 'yyyy',
                            minDate: new Date(),
                            minMode: 'month',
                            startingDay: 1,
                            showWeeks: false
                        },
                        format: 'MM/yyyy',
                    };

                    $scope.manu_year.open = function () {
                        $scope.manu_year.opened = true;
                    }

                    $scope.showCreateLocation = function () {
                        $scope.showLocationFields = true;
                    }

                    $scope.ok = function (e) {
                        $uibModalInstance.close();
                        e.stopPropagation();
                        saveItem($scope.form);
                    };
                    $scope.cancel = function (e) {
                        $uibModalInstance.dismiss();
                        e.stopPropagation();
                    };
                }
            });
        }

        function saveItem(form) {
            Inventory.save(form).then(function (item) {
                $log.debug('item', item);
                vm.items.push(item)
                SweetAlert.swal("Saved Product", item.asset + ' has been loaded into the system.', "success");
            });
        }

        function showEditItem(item) {
            $aside.open({
                templateUrl: 'asideContent.html',
                placement: 'right',
                size: 'md',
                backdrop: true,
                controller: function ($scope, $uibModalInstance) {

                    $scope.form = angular.copy(item);
                    if (item.second_status)
                        $scope.form.sec_status = item.second_status.identity;
                    if (item.status)
                        $scope.form.status = item.status.identity;
                    if (item.location)
                        $scope.form.location = item.location.identity;

                    $scope.form.fleet = Date.parse(item.date_in_fleet);
                    $scope.form.manuYear = Date.parse(item.year_manufactured);

                    $scope.statuses = vm.statuses;
                    $scope.secondStatuses = vm.secondStatuses;
                    $scope.categories = vm.categories;
                    $scope.locations = vm.locations;
                    $scope.showLocationFields = false;

                    $scope.date_fleet = {
                        opened: false,
                        options: {
                            formatYear: 'yyyy',
                            minDate: new Date(),
                            startingDay: 1,
                            showWeeks: false
                        },
                        format: 'MM/dd/yyyy',
                    };

                    $scope.date_fleet.open = function () {
                        $scope.date_fleet.opened = true;
                    }

                    $scope.manu_year = {
                        opened: false,
                        options: {
                            formatYear: 'yyyy',
                            minDate: new Date(),
                            minMode: 'month',
                            startingDay: 1,
                            showWeeks: false
                        },
                        format: 'MM/yyyy',
                    };

                    $scope.manu_year.open = function () {
                        $scope.manu_year.opened = true;
                    }

                    $scope.showCreateLocation = function () {
                        $scope.showLocationFields = true;
                    }

                    $scope.ok = function (e) {
                        $uibModalInstance.close();
                        e.stopPropagation();
                        updateItem(item, $scope.form);
                    };
                    $scope.cancel = function (e) {
                        $uibModalInstance.dismiss();
                        e.stopPropagation();
                    };
                }
            });
        }

        function updateItem(oldItem, form) {
            $log.debug('Form', form);
            Inventory.update(form).then(function (item) {
                $log.debug('item', item);

                vm.items = _.filter(vm.items, function (i) {
                    return i.identity !== oldItem.identity;
                });
                vm.items.push(item);
                SweetAlert.swal("Updated Product", item.asset + ' has been updated.', "success");
            });
        }

        function deleteItemPrompt(item) {
            SweetAlert.swal({
                title: 'Are you sure?',
                text: item.asset + ' will be moved to the trash bin.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes, remove it.',
                closeOnConfirm: true,
            },
                function (isConfirm) {
                    if (isConfirm) {
                        Inventory.delete(item.identity).then(function (response) {
                            vm.items.splice(vm.items.indexOf(item), 1);
                            vm.deletedItems.push(item);
                            SweetAlert.swal("Deleted!", item.asset + ' has been moved to the trash.', "success");
                        });
                    }
                });
        }

        function restoreItemPrompt(item) {
            SweetAlert.swal({
                title: 'Are you sure?',
                text: item.asset + ' will be available in the system.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes, restore it.',
                closeOnConfirm: true,
            },
                function (isConfirm) {
                    if (isConfirm) {
                        Inventory.restore(item.identity).then(function (response) {
                            vm.deletedItems.splice(vm.deletedItems.indexOf(item), 1);
                            vm.items.push(item);
                            SweetAlert.swal("Restored!", item.asset + ' has been moved to the active items.', "success");
                        });
                    }
                });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .controller('InventoryLocationSettingsController', InventoryLocationSettingsController);

    /** @ngInject */
    function InventoryLocationSettingsController($log, InventoryLocation, locationResolve) {

        var vm = this;
        
        vm.asideLocation = false;
        
        vm.locations = [].concat(locationResolve.data);
        vm.displayedLocations = [].concat(vm.locations);
        
        vm.placeholder = {
            collection: getCollection(),
            title: 'No Locations',
            message: 'There are currently no inventory locations.',
            button_text: 'Create 1<sup>st</sup> Location',
            button_action: function() {
                vm.asideLocation = true;
            }
        }
        
        function getCollection() {
            return vm.locations;
        }
        
        constructor();
        
        function constructor() {
            if(locationResolve.meta.pagination.current_page < locationResolve.meta.pagination.total_pages) {
                API.query(InventoryLocation.api.GET + (locationResolve.meta.pagination.current_page + 1)).then(function() {
                }, function(response) {
                    $log.error('There was an issue loading the inventory locations.', response);
                }, function(locations) {
                    vm.locations = vm.locations.concat(locations);
                    vm.displayedLocations = [].concat(vm.locations);
                });
            }
        }
        
    }
})();
(function() {
'use strict';

    angular
        .module('app')
        .controller('InventoryCategorySettingsController', InventoryCategorySettingsController);

    function InventoryCategorySettingsController($log, categoryResolve, API, InventoryCategory) {
        
         var vm = this;
        
        vm.asideCategory = false;
        
        vm.categories = [].concat(categoryResolve.data);
        vm.displayedCategories = [].concat(vm.categories);
        
        vm.placeholder = {
            collection: getCollection(),
            title: 'No Categories',
            message: 'There are currently no inventory categories.',
            button_text: 'Create 1<sup>st</sup> Category',
            button_action: function() {
                vm.asideCategory = true;
            }
        }
        
        function getCollection() {
            return vm.categories;
        }
        
        constructor();
        
        function constructor() {
            if(categoryResolve.meta.pagination.current_page < categoryResolve.meta.pagination.total_pages) {
                API.query(InventoryCategory.api.GET + (categoryResolve.meta.pagination.current_page + 1)).then(function() {
                }, function(response) {
                    $log.error('There was an issue loading the inventory categories.', response);
                }, function(categories) {
                    vm.categories = vm.categories.concat(categories);
                    vm.displayedCategories = [].concat(vm.categories);
                });
            }
        }
        
    }
    
})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('EmployeeSettingsController', EmployeeSettingsController);

    /** @ngInject */
    function EmployeeSettingsController($log, API, Employee, employeesResolve) {

        var vm = this; 
        
        vm.asideEmployee = false;
        
        vm.employees = [].concat(employeesResolve.data);
        vm.displayedEmployees = [].concat(vm.employees);
        
         vm.placeholder = {
            collection: vm.employees,
            title: 'No Employees',
            message: 'There are currently no employees.',
            button_text: 'Create 1<sup>st</sup> Employee',
            button_action: function() {
                vm.asideEmployee = true;
            }
        }
        
        constructor();
        
        function constructor() {
            $log.debug('Employees...', vm.employees);
            if(employeesResolve.meta.pagination.current_page < employeesResolve.meta.pagination.total_pages) {
                API.query(Employee.api.GET + (employeesResolve.meta.pagination.current_page + 1)).then(function() {
                }, function(response) {
                    $log.error('There was an issue loading the employees.', response);
                }, function(employees) {
                    vm.employees = vm.employees.concat(employees);
                    vm.displayedEmployees = [].concat(vm.employees);
                });
            }
        }
       
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('EmployeePositionSettingsController', EmployeePositionSettingsController);

    /** @ngInject */
    function EmployeePositionSettingsController($log, API, EmployeePosition, positionResolve) {

        var vm = this;

        vm.positionAside = false;

        vm.positions = [].concat(positionResolve.data);
        vm.displayedPositions = [].concat(vm.positions);

        $log.debug('positions', vm.positions);

        vm.placeholder = {
            collection: vm.positions,
            title: 'No Positions',
            message: 'There are currently no employee positions.',
            button_text: 'Create 1<sup>st</sup> Position',
            button_action: function() {
                vm.positionAside = true;
            }
        };

        constructor();

        function constructor() {
            if(positionResolve.meta.pagination.current_page < positionResolve.meta.pagination.total_pages) {
                API.query(EmployeePosition.api.GET + (positionResolve.meta.pagination.current_page + 1)).then(function() {
                }, function(response) {
                    $log.error('There was an issue loading employee positions.', response);
                }, function(positions) {
                    vm.positions = vm.positions.concat(positions);
                    vm.displayedPositions = [].concat(vm.positions);
                });
            }
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('EmployeeDepartmentSettingsController', EmployeeDepartmentSettingsController);

    /** @ngInject */
    function EmployeeDepartmentSettingsController($log, API, EmployeeDepartment, $aside, $scope, SweetAlert, departmentResolve) {

        var vm = this; 
        
        vm.departmentAside = false;
        
        vm.departments = [].concat(departmentResolve.data);
        vm.displayedDepartments = [].concat(vm.departments);
        
        $log.debug('Departments', vm.departments);
        
        vm.placeholder = {
            collection: vm.departments,
            title: 'No Departments',
            message: 'There are currently no departments.',
            button_text: 'Create 1<sup>st</sup> Department',
            button_action: function() {
                vm.departmentAside = true;
            }
        };
        
        constructor();
        
        function constructor() {
            if(departmentResolve.meta.pagination.current_page < departmentResolve.meta.pagination.total_pages) {
                API.query(EmployeeDepartment.api.GET + (departmentResolve.meta.pagination.current_page + 1)).then(function() {
                }, function(response) {
                    $log.error('There was an issue loading employee departments.', response);
                }, function(departments) {
                    vm.departments = vm.departments.concat(departments);
                    vm.displayedDepartments = [].concat(vm.departments);
                });
            }
        }
       
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('ContactSettingsController', ContactSettingsController);

    /** @ngInject */
    function ContactSettingsController($log, API, Contact, contactResolve) {
        
        var vm = this;
        
        vm.asideContact = false;
        
        vm.contacts = [].concat(contactResolve.data);
        vm.displayedContacts = [].concat(vm.contacts);
        
        constructor();
        
        vm.placeholder = {
            collection: vm.contacts,
            title: 'No Contacts',
            message: 'There are currently no contacts.',
            button_text: 'Create 1<sup>st</sup> Contact',
            button_action: function() {
                vm.asideContact = true;
            }
        };
        
        function constructor() {
            if(contactResolve.meta.pagination.current_page < contactResolve.meta.pagination.total_pages) {
                API.query(Contact.api.GET + (contactResolve.meta.pagination.current_page + 1)).then(function() {
                    
                }, function(response) {
                    $log.error('There was an issue loading contacts.', response);
                }, function(contacts) {
                    vm.contacts = vm.contacts.concat(contacts);
                    vm.displayedContacts = [].concat(vm.contacts);
                });
            }
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('CompanySettingsController', CompanySettingsController);

    /** @ngInject */
    function CompanySettingsController($log, Company, API, companyResolve) {
        
        var vm = this;

        vm.companies = [].concat(companyResolve.data);
        vm.displayedCompanies = [].concat(vm.companies);

        vm.deletedCompanies = [];
        vm.displayedDeleted = [];
        
        vm.loadDeletedCompanies = loadDeletedCompanies;

        vm.company = Company;
        
        vm.placeholder = {
            collection: vm.companies,
            title: 'No Companies',
            message: 'There are currently no companies.',
            button_text: 'Create 1<sup>st</sup> Company',
            button_action: function() {
                $log.debug('Called!');
            }
        };
        
        constructor();
        
        function constructor() {
            loadRemainingCompanies();
            loadDeletedCompanies();
        }

        function loadRemainingCompanies() {
            if(companyResolve.meta.pagination.current_page < companyResolve.meta.pagination.total_pages) {
                API.query(Company.api.GET  + (companyResolve.meta.pagination.current_page + 1)).then(function() {
                    // $scope.$broadcast('loadedCompanies', vm.companies);
                },
                function(response) {
                    $log.error('There was an issue loading companies.', response);
                }, function(companies) {
                    vm.companies = vm.companies.concat(companies); 
                    vm.displayedCompanies = [].concat(vm.companies);
                });
            }
            else {
                // $scope.$broadcast('loadedCompanies', vm.companies);
            }
        }

        function loadDeletedCompanies() {
            Company.getDeleted().then(function(companies) {
                vm.deletedCompanies = companies;
                vm.displayedDeleted = [].concat(vm.deletedCompanies);
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .controller('CompanyClassificationSettingsController', CompanyClassificationSettingsController);

    /** @ngInject */
    function CompanyClassificationSettingsController($log, $aside, SweetAlert, CompanyClassification, classificationResolve) {
        
        var vm = this;
        
        vm.asideClassification = false;
        
        vm.classifications = [].concat(classificationResolve.data);
        vm.displayedClassifications = [].concat(vm.classifications);

        vm.showCreateClassification = showCreateClassification;
        vm.showUpdateClassification = showUpdateClassification;
        
        vm.placeholder = {
            collection: vm.classifications,
            title: 'No Classifications',
            message: 'There are currently no company classifications.',
            button_text: 'Create 1<sup>st</sup> Classification',
            button_action: function() {
                vm.asideClassification = true;
            }
        }
        
        constructor();
        
        function constructor() {
            if(classificationResolve.meta.pagination.current_page < classificationResolve.meta.pagination.total_pages) {
                API.query(CompanyClassification.api.GET + (classificationResolve.meta.pagination.current_page + 1)).then(function() {
                }, function(response) {
                    $log.error('There was an issue loading the company classifications.', response);
                }, function(classifications) {
                    vm.classifications = vm.classifications.concat(classifications);
                    vm.displayedClassifications = [].concat(vm.classifications);
                });
            }
        }

        function showCreateClassification() {
            $aside.open({
                templateUrl: 'asideClassification.html',
                placement: 'right',
                size: 'sm',
                backdrop: true,
                controller: function ($scope, $uibModalInstance) {

                    $scope.ok = function (e) {
                        $scope.submitted = true;
                        if($scope.classificationForm.$valid) {
                            $uibModalInstance.close();
                            e.stopPropagation();
                            saveClassification($scope.form);
                        }
                    };
                    $scope.cancel = function (e) {
                        $scope.form = '';
                        $uibModalInstance.dismiss();
                        e.stopPropagation();
                    };
                }
            });
        }

         function showUpdateClassification(classification) {
            $aside.open({
                templateUrl: 'asideClassification.html',
                placement: 'right',
                size: 'sm',
                backdrop: true,
                controller: function ($scope, $uibModalInstance) {

                    $scope.form = {
                        identity: classification.identity,
                        name: classification.name
                    };

                    $scope.ok = function (e) {
                        $scope.submitted = true;
                        if($scope.classificationForm.$valid) {
                            $uibModalInstance.close();
                            e.stopPropagation();
                            updateClassification(classification, $scope.form);
                        }
                    };
                    $scope.cancel = function (e) {
                        $scope.form = '';
                        $uibModalInstance.dismiss();
                        e.stopPropagation();
                    };
                }
            });
        }

        function saveClassification(form) {
            CompanyClassification.save(form).then(function(classification) {
                vm.classifications.push(classification);
                vm.displayedClassifications.push(classification);
                SweetAlert.swal('Saved Classification', 'You have created a new classification: ' + classification.name + '.', 'success');
            });
        }

        function updateClassification(oldClassification, form) {
             CompanyClassification.update(form).then(function(classification) {
                vm.classifications.splice(vm.classifications.indexOf(oldClassification), 1);
                vm.displayedClassifications.splice(vm.displayedClassifications.indexOf(oldClassification), 1);
                vm.classifications.push(classification);
                vm.displayedClassifications.push(classification);
                SweetAlert.swal('Updated Contact', 'You have updated the classification: ' + classification.name + '.', 'success');
            });
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('app.rental')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {

        $stateProvider

            .state('app.rental', {
                url: '/rental',
                templateUrl: '/app/rental/rental.html',
                controller: 'RentalController',
                controllerAs: 'vm',
                title: 'Rental',
                ncyBreadcrumb: {
                    label: 'Rental'
                },
                resolve: {
                    /** @ngInject */
                    rentalResolve: function(Inventory) {
                        return Inventory.getAll();
                    }
                }
            });

    }

})();

(function() {
'use strict';

    angular
        .module('app.rental')
        .controller('RentalController', RentalController);

    /** @ngInject */
    function RentalController($log, rentalResolve, API, Inventory, InventoryStatus, InventoryLocation, Confirmation) {
        var tblState;

        var vm = this;

        // Collection of status options
        vm.statuses = [];
        vm.secondStatuses = [];
        // Collection of inventory locations
        vm.locations = [];
        // Collection of inventory items
        vm.items = [].concat(rentalResolve.data);
        vm.displayedItems = [].concat(vm.items);

        vm.rentalButtons = [{
            text: 'Reservations',
            value: 'Reservations',
            selected: true
        }, {
            text: 'Confirmations',
            value: 'Confirmations',
            selected: false
        }];

        vm.filter = {
            asset : '',
            location: '',
            statuses: [],
            secondStatuses: []
        }
        vm.filteredItems = [];

        vm.filterPipe = filterPipe;
        vm.filterItems = filterItems;

        vm.toDate = toDate;

        vm.placeholder = {
            collection: vm.items,
            title: 'No Inventory',
            message: 'There are currently no inventory items to confirm.',
        };

        vm.filters = [];

        vm.availableFilters = [
            'Fixed Asset #',
            'Description',
            'Inventory Location',
            'Status',
            'Secondary Status',
            'Expected On Rent Date',
            // 'Expected from Workshop'
            'Actual Off Rent Date',
            'Customer',
            'City',
            'Zip Code'
        ];

        vm.activeFilter = vm.availableFilters[0];

        vm.applyFilter = applyFilter;
        vm.removeFilter = removeFilter;

        function applyFilter() {
            if(angular.isUndefined(vm.newFilter) || vm.newFilter.length === 0) {
                toastr.warning('Please enter a valid filter value.', 'Warning');
                return;
            }
            var text = vm.newFilter;
            switch(vm.activeFilter) {
                case 'Customer':
                    text = _.find(vm.companies, function(company) {
                        return company.identity === text;
                    }).name;
                    break;
                case 'Inventory Location':
                    text = _.find(vm.locations, function(location) {
                        return location.identity === text;
                    }).name;
                    break;
                case 'Status':
                    text = _.find(vm.statuses, function(status) {
                        return status.identity === text;
                    }).name;
                    break;
                case 'Secondary Status':
                    text = _.find(vm.secondStatuses, function(status) {
                        return status.identity === text;
                    }).name;
                    break;
            }
            vm.filters.push({
                type: vm.activeFilter,
                text: text,
                value: vm.newFilter
            });
            vm.newFilter = undefined;
            vm.activeFilter = undefined;
            filterItems();
        }

        function removeFilter(deleteFilter) {
            vm.filters = _.filter(vm.filters, function(filter) {
                return filter !== deleteFilter;
            });
            filterItems();
        }
















        constructor();

        function constructor() {
            if(rentalResolve.meta.pagination.current_page < rentalResolve.meta.pagination.total_pages) {
                API.query(Inventory.api.PLANNING + (rentalResolve.meta.pagination.current_page + 1)).then(function() {

                }, function(response) {
                    $log.error('There was an issue loading the inventory items.', response);
                }, function(items) {
                    vm.items = vm.items.concat(items);
                    vm.displayedItems = [].concat(vm.items);
                    vm.filteredItems = [].concat(vm.items);
                    filterPipe(tblState);
                });
            }
            else {
                vm.filteredItems = [].concat(vm.items);
                filterPipe(tblState);
            }
            $log.debug('vm.items', vm.items);
            loadConfirmations();
            loadInventoryLocations();
            loadInventoryStatuses();
        }

        function loadConfirmations() {
            Confirmation.getAll().then(function(response) {
                $log.debug('Response back...', response)
            }, function(response) {
                $log.error('There was an issue loading the confirmations.', response);
            });
        }

        function toDate(dateString) {
            var value = Date.parse(dateString);
            if(isNaN(value))
                return undefined;
            return value;
        }

        function loadInventoryStatuses() {
            API.query(InventoryStatus.api.GET + 1).then(function() {},
            function(response) {
                $log.error('There was an issue loading inventory statuses.', response);
            }, function(statuses) {
               vm.statuses = vm.statuses.concat(_.filter(statuses, function(status) {
                    return status.primary === true;
               }));
               vm.secondStatuses = vm.secondStatuses.concat(_.filter(statuses, function(status) {
                   return status.primary === false;
               }));
            });
        }

        function loadInventoryLocations() {
            API.query(InventoryLocation.api.GET + 1).then(function() {},
            function(response) {
                $log.error('There was an issue loading inventory locations.', response);
            }, function(locations) {
               vm.locations = vm.locations.concat(locations);
            });
        }

        function filterPipe(tableState) {
            tblState = tableState;
            if (tableState) {
                var pagination = tableState.pagination;
                var start = pagination.start || 0;
                var number = pagination.number || 10;
                var searchTerm = tableState.search.predicateObject || '';
                tableState.pagination.numberOfPages = Math.ceil(Object.keys(vm.filteredItems).length / 10);
                vm.displayedItems = vm.filteredItems.slice(start, start + number);
            }
            else {
                tblState = {
                    pagination : {
                        number: 10,
                        numberOfPages: 0,
                        start: 0,
                        totalItemCount: 0
                    },
                    search: {},
                    sort: {}
                };
                filterPipe(tblState);
            }
        }

        function filterItems() {
            vm.filteredItems = [].concat(vm.items);
            vm.filteredItems = _.filter(vm.filteredItems, function(item) {
                var hasMatch = true;
                angular.forEach(vm.filters, function(filter) {
                    switch(filter.type) {
                        case 'Fixed Asset #':
                            if(item.asset.toLowerCase().indexOf(filter.value.toLowerCase()) === -1)
                                hasMatch = false;
                            break;
                        case 'Description':
                            if(item.description.toLowerCase().indexOf(filter.value.toLowerCase()) === -1)
                                hasMatch = false;
                            break;
                        case 'Inventory Location':
                            if(item.location === null || item.location.identity !== filter.value)
                                hasMatch = false;
                            break;
                        case 'City':
                            if(item.next_reservation.site_city.toLowerCase().indexOf(filter.value.toLowerCase()) === -1)
                                hasMatch = false;
                            break;
                        case 'Zip Code':
                            if(item.next_reservation.site_postal.toLowerCase().indexOf(filter.value.toLowerCase()) === -1)
                                hasMatch = false;
                            break;
                        case 'Customer':
                            if(item.next_reservation.company === null || item.next_reservation.company.identity !== filter.value)
                                hasMatch = false;
                            break;
                        case 'Status':
                            if(item.status === null || item.status.identity !== filter.value)
                                hasMatch = false;
                            break;
                        case 'Secondary Status':
                            if(item.second_status === null || item.second_status.identity !== filter.value)
                                hasMatch = false;
                            break;
                        case 'Expected On Rent Date':
                            var expectedOnRent = $filter('date')(toDate(item.next_reservation.expected_on_rent), 'MM/dd/yyyy');
                            if(angular.isUndefined(item.next_reservation.expected_on_rent) || expectedOnRent.indexOf(filter.value) === -1)
                                hasMatch = false;
                            break;
                        case 'Actual Off Rent Date':
                            var expectedOffRent = $filter('date')(toDate(item.next_reservation.expected_off_rent), 'MM/dd/yyyy');
                            if(angular.isUndefined(item.next_reservation.expected_off_rent)  || expectedOffRent.indexOf(filter.value) === -1)
                                hasMatch = false;
                            break;
                    }
                });
                return hasMatch;
            });
            vm.filterPipe(tblState);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.planning', []);

})();
(function() {
    'use strict';

    angular
        .module('app.planning')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {

        $stateProvider

            .state('app.planning', {
                url: '/planning',
                templateUrl: '/app/planning/planning.html',
                controller: 'PlanningController',
                controllerAs: 'vm',
                title: 'Planning',
                ncyBreadcrumb: {
                    label: 'Planning'
                },
                resolve: {
                    /** @ngInject */
                    planningResolve: function(Inventory) {
                        return Inventory.getPlanning();
                    }
                }
            });

    }

})();

(function() {
'use strict';

    angular
        .module('app.planning')
        .controller('PlanningController', PlanningController);

    /** @ngInject */
    function PlanningController($log, $state, $filter, toastr, planningResolve, API, User, Company, Confirmation, Inventory, InventoryStatus, InventoryLocation, Reservation) {
        var tblState;

        var vm = this;

        vm.filters = [];
        vm.selected = [];
        vm.statuses = [];
        vm.locations = [];

        vm.reservations = [].concat(_.filter(planningResolve.data.data, function(item) {
            return item.next_reservation && item.next_reservation !== null;
        }));
        vm.displayedReservations = [].concat(vm.reservations);
        vm.filteredItems = [];

        vm.availableFilters = [
            'Fixed Asset #',
            'Description',
            'Inventory Location',
            'Status',
            'Expected On Rent Date',
            // 'Expected from Workshop'
            'Actual Off Rent Date',
            'Customer',
            'City',
            'Zip Code'
        ];

        vm.placeholder = {
            collection: function() {
                return vm.reservations;
            },
            title: 'No Reservations',
            message: 'There are currently no items to confirm.',
        };

        vm.filterPipe = filterPipe;
        vm.filterItems = filterItems;
        vm.toDate = toDate;
        vm.selectRow = selectRow;
        vm.assignDriver = assignDriver;
        vm.applyFilter = applyFilter;
        vm.removeFilter = removeFilter;

        constructor();

        function constructor() {
            vm.filteredItems = [].concat(vm.reservations);
            filterPipe(tblState);
            loadInventoryLocations();
            loadInventoryStatuses();
            loadDrivers();
            loadCompanies();
        }

        function applyFilter() {
            if(angular.isUndefined(vm.newFilter) || vm.newFilter.length === 0) {
                toastr.warning('Please enter a valid filter value.', 'Warning');
                return;
            }
            var text = vm.newFilter;
            switch(vm.activeFilter) {
                case 'Customer':
                    text = _.find(vm.companies, function(company) {
                        return company.identity === text;
                    }).name;
                    break;
                case 'Inventory Location':
                    text = _.find(vm.locations, function(location) {
                        return location.identity === text;
                    }).name;
                    break;
                case 'Status':
                    text = _.find(vm.statuses, function(status) {
                        return status.identity === text;
                    }).name;
                    break;
            }
            vm.filters.push({
                type: vm.activeFilter,
                text: text,
                value: vm.newFilter
            });
            vm.newFilter = undefined;
            vm.activeFilter = undefined;
            filterItems();
        }

        function removeFilter(deleteFilter) {
            vm.filters = _.filter(vm.filters, function(filter) {
                return filter !== deleteFilter;
            });
            filterItems();
        }

        function toDate(dateString) {
            var value = Date.parse(dateString);
            if(isNaN(value))
                return undefined;
            return value;
        }

        function loadDrivers() {
            vm.drivers = [];
            User.getAll().then(function(response) {
                vm.drivers = response.data;
                $log.debug('loaded users.', vm.drivers);
            }, function(response) {
               $log.error('There was an issue loading the users.', response);
            });
        }

        function loadCompanies() {
            vm.companies = [];
            API.query(Company.api.GET + 0).then(function() {},
            function(response) {
                $log.error('There was an issue loading companies.', response);
            }, function(companies) {
                vm.companies = vm.companies.concat(companies);
            });
        }

        function loadInventoryStatuses() {
            var allowedStatuses = ['Confirm', 'Ready for Delivery', 'Picked Up', '1st Check', 'Delivery Scheduled', 'Pick up Scheduled', 'On Yard'];
            API.query(InventoryStatus.api.GET + 1).then(function() {},
            function(response) {
                $log.error('There was an issue loading inventory statuses.', response);
            }, function(statuses) {
               vm.statuses = vm.statuses.concat(_.filter(statuses, function(status) {
                    return status.primary === true && allowedStatuses.indexOf(status.original) !== -1;
               }));
            });
        }

        function loadInventoryLocations() {
            API.query(InventoryLocation.api.GET + 1).then(function() {},
            function(response) {
                $log.error('There was an issue loading inventory locations.', response);
            }, function(locations) {
               vm.locations = vm.locations.concat(locations);
            });
        }

        function filterPipe(tableState) {
            tblState = tableState;
            if (tableState) {
                var pagination = tableState.pagination;
                var start = pagination.start || 0;
                var number = pagination.number || 10;
                var searchTerm = tableState.search.predicateObject || '';
                tableState.pagination.numberOfPages = Math.ceil(Object.keys(vm.filteredItems).length / 10);
                vm.displayedItems = vm.filteredItems.slice(start, start + number);
            }
            else {
                tblState = {
                    pagination : {
                        number: 10,
                        numberOfPages: 0,
                        start: 0,
                        totalItemCount: 0
                    },
                    search: {},
                    sort: {}
                };
                filterPipe(tblState);
            }
        }

        function filterItems() {
            $log.debug('vm.reservations', vm.reservations);
            vm.filteredItems = [].concat(vm.reservations);
            vm.filteredItems = _.filter(vm.filteredItems, function(item) {
                var hasMatch = true;
                angular.forEach(vm.filters, function(filter) {
                    switch(filter.type) {
                        case 'Fixed Asset #':
                            if(item.asset.toLowerCase().indexOf(filter.value.toLowerCase()) === -1)
                                hasMatch = false;
                            break;
                        case 'Description':
                            if(item.description.toLowerCase().indexOf(filter.value.toLowerCase()) === -1)
                                hasMatch = false;
                            break;
                        case 'Inventory Location':
                            if(item.location === null || item.location.identity !== filter.value)
                                hasMatch = false;
                            break;
                        case 'City':
                            if(item.next_reservation.site_city.toLowerCase().indexOf(filter.value.toLowerCase()) === -1)
                                hasMatch = false;
                            break;
                        case 'Zip Code':
                            if(item.next_reservation.site_postal.toLowerCase().indexOf(filter.value.toLowerCase()) === -1)
                                hasMatch = false;
                            break;
                        case 'Customer':
                            if(item.next_reservation.company === null || item.next_reservation.company.identity !== filter.value)
                                hasMatch = false;
                            break;
                        case 'Status':
                            if(item.status === null || item.status.identity !== filter.value)
                                hasMatch = false;
                            break;
                        case 'Expected On Rent Date':
                            var expectedOnRent = $filter('date')(toDate(item.next_reservation.expected_on_rent), 'MM/dd/yyyy');
                            if(angular.isUndefined(item.next_reservation.expected_on_rent) || expectedOnRent.indexOf(filter.value) === -1)
                                hasMatch = false;
                            break;
                        case 'Actual Off Rent Date':
                            var expectedOffRent = $filter('date')(toDate(item.next_reservation.expected_off_rent), 'MM/dd/yyyy');
                            if(angular.isUndefined(item.next_reservation.expected_off_rent)  || expectedOffRent.indexOf(filter.value) === -1)
                                hasMatch = false;
                            break;
                    }
                });
                return hasMatch;
            });
            vm.filterPipe(tblState);
        }

        /**
         * Selects or Deselects an item in the table
         *
         * @param value The value to add or remove
         */
        function selectRow(value) {
            if(vm.selected.indexOf(value) !== -1)
                vm.selected.splice(vm.selected.indexOf(value));
            else
                vm.selected.push(value);
        }

        /**
         * Assigns a driver to the selected inventory items
         */
        function assignDriver() {
            if(angular.isUndefined(vm.driver)) {
                toastr.warning('You need to select a driver to assign.', 'Warning: Select a Driver');
                return;
            }
            if(vm.selected.length < 1) {
                toastr.warning('You need to select items from the table to assign a driver to.', 'Warning: Select Items');
                return;
            }
            angular.forEach(vm.selected, function(item) {
                Confirmation.assignDriver(item, vm.driver).then(function(response) {
                    toastr.success('Successfully assigned the driver to the selected items', 'Saved Driver');
                    $state.go('app.planning', {}, {reload:true});
                }, function(response) {
                    $log.error('There was an issue assigning the driver', response);
                    toastr.error('There was an issue assigning the driver. Please contact support.', 'Error');
                });
            });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.inventory', ['app.language']);

})();
(function() {
    'use strict';

    angular
        .module('app.inventory')
        .factory('Reservation', Reservation);

    /** @ngInject */
    function Reservation($log, $q, API) {

        var factory = {
            getAll: getAll,
            save: save,
            update: update,
            updateMultiple: updateMultiple,
            remove: remove,
            getPage: getPage
        };

        return factory;

        function getPage(page) {
            return API.getRequest('reservations/?page=' + page);
        }

        function getAll() {
            var deferred = $q.defer();
            API.getRequest('reservations').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function save(payload) {
            var deferred = $q.defer();
            API.postRequest('reservations', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function update(payload) {
            var deferred = $q.defer();
            API.putRequest('reservations', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function updateMultiple(payload) {
            var deferred = $q.defer();
            API.putRequest('reservations/multiple', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function remove(identity) {
            var deferred = $q.defer();
            API.deleteRequest('reservations?identity=' + identity).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
               deferred.reject(response);
            });
            return deferred.promise;
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .factory('Inventory', Inventory);

    /** @ngInject */
    function Inventory($log, $q, API) {

        var api = {
            GET: 'inventory/?page=',
            YARDMAN: 'inventory/yardman/?page=',
            PLANNING: 'inventory/planning/?page='
        };

        var factory = {
            getAll: getAll,
            getYardman: getYardman,
            getPlanning: getPlanning,
            getDeleted: getAllDeleted,
            get: get,
            save: save,
            saveReservation: saveReservation,
            update: update,
            updateStatus: updateStatus,
            updateYardman: updateYardman,
            restore: restore,
            'delete': deleteRequest,
            api: api,
            // new
            getPage: getPage
        };

        return factory;

        function getPage(page) {
            return API.getRequest('inventory/?page=' + page);
        }

        function getAllDeleted() {
            var deferred = $q.defer();
            API.getRequest('inventory/trash').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function getAll() {
            var deferred = $q.defer();
            API.getRequest('inventory').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function getYardman() {
            var deferred = $q.defer();
            API.getRequest('inventory/yardman').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function getPlanning() {
            return API.getRequest('inventory/planning');
        }

        function get(identity) {
            var deferred = $q.defer();
            API.getRequest('inventory?identity=' + identity).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function save(payload) {
            var deferred = $q.defer();
            API.postRequest('inventory', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function saveReservation(payload) {
            var deferred = $q.defer();
            API.postRequest('inventory/rental-reservation', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function update(payload) {
            var deferred = $q.defer();
            API.putRequest('inventory', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function updateStatus(payload) {
            var deferred = $q.defer();
            API.putRequest('inventory/update-status', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function updateYardman(payload) {
            var deferred = $q.defer();
            API.putRequest('inventory/yard-man', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function restore(identity) {
            var deferred = $q.defer();
            API.putRequest('inventory/restore?identity='+identity).then(function(response) {
                deferred.resolve(response);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function deleteRequest(identity) {
            var deferred = $q.defer();
            API.deleteRequest('inventory?identity='+identity).then(function(response) {
                deferred.resolve(response);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('app.inventory')
        .factory('Confirmation', Confirmation);

    /** @ngInject */
    function Confirmation($log, $q, API) {

        var factory = {
            save: save,
            getAll: getAll,
            updateStatus: updateStatus,
            assignDriver: assignDriver
        };

        return factory;

        function getAll() {
            return API.getRequest('confirmations');
        }

        function updateStatus(payload) {
            var deferred = $q.defer();
            API.putRequest('confirmations/status', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function save(payload) {
            var deferred = $q.defer();
            API.postRequest('confirmations', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        /**
         * Assigns a driver to a confirmation
         *
         * @param confirmation The confirmation identity
         * @param driver The driver identity to assign
         */
        function assignDriver(confirmation, driver) {
            return API.postRequest('confirmations/assign-driver', {
                identity: confirmation,
                driver: driver
            });
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {

        $stateProvider

            .state('app.mechanic', {
                url: '/mechanic',
                templateUrl: '/app/mechanic/mechanic-view.html',
                controller: 'MechanicViewController',
                controllerAs: 'vm',
                title: 'Mechanic View',
                ncyBreadcrumb: {
                    label: 'Mechanic View'
                },
                resolve: {
                    /** @ngInject */
                    inventoryResolve: function(Inventory) {
                        return Inventory.getAll();
                    }
                }
            });

    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .factory('Mechanic', Mechanic);

    /** @ngInject */
    function Mechanic($log, $q, API) {
        
        var api = {
            GET: 'service/?page='
        };

        var factory = {
            getAll: getAll,
            get: get,
            save: save,
            update: update,
            api: api
        };

        return factory;

        function getAll() {
            var deferred = $q.defer();
            API.getRequest('service').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function get(identity) {
            var deferred = $q.defer();
            API.getRequest('service?identity=' + identity).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response.data);
            });
            return deferred.promise;
        }

        function save(payload) {
            var deferred = $q.defer();
            API.postRequest('service', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function update(payload) {
            var deferred = $q.defer();
            API.putRequest('service', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function deleteRequest(identity) {
            var deferred = $q.defer();
            API.deleteRequest('service?identity='+identity).then(function(response) {
                deferred.resolve(response);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

    }

})();
(function() {
'use strict';

    angular
        .module('app')
        .controller('MechanicViewController', MechanicViewController);

    /** @ngInject */
    function MechanicViewController($log, inventoryResolve, API, Inventory, InventoryStatus, InventoryLocation, _, $filter) {
        
        var vm = this;
        
        var tblState;
        
        // The collection of inventory items
        vm.items = [].concat(inventoryResolve.data);
        // The collection of displayed inventory items
        vm.displayedItems = [].concat(vm.items);
        // The collection of filtered items
        vm.filteredItems = [];
        // The collection of status options
        vm.statuses = [];
        // The collection of 2nd status options
        vm.secondStatuses = [];
        // The collection of inventory locations
        vm.locations = [];
        
        vm.filter = {};
        
        vm.placeholder = {
            collection: vm.items,
            title: 'No Inventory',
            message: 'There are currently no inventory items.',
        };
        
        vm.filterItems = filterItems;
        vm.filterPipe = filterPipe;
        vm.parseDate = parseDate;
        
        constructor();
        
        function constructor() {
            $log.debug('Items...', vm.items);
            if(inventoryResolve.meta.pagination.current_page < inventoryResolve.meta.pagination.total_pages) {
                API.query(Inventory.api.GET + (inventoryResolve.meta.pagination.current_page + 1)).then(function() {
                    
                }, function(response) {
                    $log.error('There was an issue loading the inventory records.', response);
                }, function(items) {
                    vm.items = vm.items.concat(items);
                    vm.displayedItems = [].concat(vm.items);
                    vm.filteredItems = [].concat(vm.items);
                    filterPipe(tblState);
                });
            }
            else {
                vm.filteredItems = [].concat(vm.items);
                filterPipe(tblState);
            }
            loadInventoryStatuses();
            loadInventoryLocations();
        }
        
        function loadInventoryStatuses() {
            API.query(InventoryStatus.api.GET + 1).then(function() {}, 
            function(response) {
                $log.error('There was an issue loading the inventory statuses.', response);
            }, function(statuses) {
                vm.statuses = vm.statuses.concat(_.filter(statuses, function(status) {
                    return status.primary === true;
                }));
                vm.secondStatuses = vm.secondStatuses.concat(_.filter(statuses, function(status) {
                    return status.primary === false;
                }));
            });
        }
        
        function loadInventoryLocations() {
            API.query(InventoryLocation.api.GET + 1).then(function() {}, 
            function(response) {
                $log.error('There was an issue loading the inventory locations.', response);
            }, function(locations) {
                vm.locations = vm.locations.concat(locations);
            });
        }
        
        function filterItems() {
            vm.filteredItems = [].concat(vm.items);
            vm.filteredItems = _.filter(vm.filteredItems, function(item) {
                if(angular.isDefined(vm.filter.asset)) {
                    if(item.asset.toLowerCase().indexOf(vm.filter.asset.toLowerCase()) === -1)
                        return false;
                }
                if(vm.filter.statuses && vm.filter.statuses.length > 0) {
                    if(!item.status || vm.filter.statuses.indexOf(item.status.original) === -1)
                        return false;
                }
                if(vm.filter.secondStatuses && vm.filter.secondStatuses.length > 0 ) {
                    if(!secondStatus || vm.filter.secondStatuses.indexOf(secondStatus.original) === -1)
                        return false;
                }
                if(vm.filter.locations && vm.filter.locations.length > 0) {
                    if(!location || vm.filter.locations.indexOf(location.identity) === -1)
                        return false;
                }
                if(vm.filter.workshop) {
                    if(angular.isDefined(expected_workshop)) {
                        if(parseDate(expected_workshop).toLowerCase().indexOf(vm.filter.workshop.toLowerCase()) === -1)
                            return false;
                    }
                }
                if(vm.filter.reservation) {
                    if(parseDate(item.next_reservation_date).toLowerCase().indexOf(vm.filter.reservation.toLowerCase()) === -1)
                        return false;
                }
                if(vm.filter.inspection) {
                    if(parseDate(service.item.next_inspection_date).toLowerCase().indexOf(vm.filter.inspection.toLowerCase()) === -1)
                        return false;
                }
                return true;
            });
            vm.filterPipe(tblState);
        }

        function filterPipe(tableState) {
            tblState = tableState;
            if (tableState) {
                var pagination = tableState.pagination;
                var start = pagination.start || 0;
                var number = pagination.number || 10;
                var searchTerm = tableState.search.predicateObject || '';
                tableState.pagination.numberOfPages = Math.ceil(Object.keys(vm.filteredItems).length / 10);
                vm.displayedItems = vm.filteredItems.slice(start, start + number);
            }
            else {
                tblState = {
                    pagination : {
                        number: 10,
                        numberOfPages: 0,
                        start: 0,
                        totalItemCount: 0
                    },
                    search: {},
                    sort: {}
                };
                filterPipe(tblState);
            }
        }
        
        function parseDate(date) {
            var date = Date.parse(date);
            if(angular.isUndefined(date) || date === null || isNaN(date))
                return '';
            return $filter('date')(date, 'MMMM dd, yyyy');
        }
        
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($rootScope, $scope, $state, $swipe, $translate, $localStorage, $window, $document, $timeout, cfpLoadingBar, Fullscreen, Auth, $log) {
        var vm = this;

        // Loading bar transition
        // -----------------------------------
        var $win = $($window),
            $body = $('body');

        $scope.horizontalNavbarCollapsed = true;
        $scope.menuInit = function(value) {
            $scope.horizontalNavbarCollapsed = value;
        };
        $scope.menuToggle = function(value) {
            $scope.horizontalNavbarCollapsed = !$scope.horizontalNavbarCollapsed;
        };

        vm.goBack = function() {
            $log.debug('[MainCtrl] goBack()', $rootScope.previousState);
            if ($rootScope.previousState && $rootScope.previousState.name && $rootScope.previousState.name.trim().length > 0) {
                $state.go($rootScope.previousState.name, $rootScope.previousState.params);
                return;
            } else {
                var parentState = $state.$current.parent.self.name;
                if (parentState && parentState.trim().length > 0) {
                    $state.go(parentState);
                    return;
                }
                $state.go('app.dashboard');
            }
        }

        $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
            //start loading bar on stateChangeStart
            cfpLoadingBar.start();
            $scope.horizontalNavbarCollapsed = true;
            if (toState.name == "app.pagelayouts.boxedpage") {
                $body.addClass("app-boxed-page");
            } else {
                $body.removeClass("app-boxed-page");
            }
        });
        $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
            $scope.horizontalNavbarCollapsed = true;
            //stop loading bar on stateChangeSuccess
            event.targetScope.$watch("$viewContentLoaded", function() {
                cfpLoadingBar.complete();
            });

            // scroll top the page on change state
            $('#app .main-content').css({
                position: 'relative',
                top: 'auto'
            });

            $('footer').show();

            window.scrollTo(0, 0);

            if (angular.element('.email-reader').length) {
                angular.element('.email-reader').animate({
                    scrollTop: 0
                }, 0);
            }

            $rootScope.previousState = {
                name: fromState.name,
                params: fromParams
            }

            // Save the route title
            $rootScope.currTitle = $state.current.title;

        });

        // State not found
        $rootScope.$on('$stateNotFound', function(event, unfoundState, fromState, fromParams) {
            //$rootScope.loading = false;
            console.log(unfoundState.to);
            // "lazy.state"
            console.log(unfoundState.toParams);
            // {a:1, b:2}
            console.log(unfoundState.options);
            // {inherit:false} + default options
        });

        $rootScope.pageTitle = function() {
            return $rootScope.app.name + ' - ' + ($rootScope.currTitle || $rootScope.app.description);
        };
        var defaultlayout = $scope.app.defaultLayout;
        // save settings to local storage
        if (angular.isDefined($localStorage.lay)) {
            $scope.app.layout = angular.copy($localStorage.lay);

        }

        $scope.resetLayout = function() {
            $scope.loading_reset = true;
            // start loading
            $timeout(function() {
                delete $localStorage.lay;
                $scope.app.layout = angular.copy($rootScope.app.defaultLayout);
                $scope.loading_reset = false;
                // stop loading
            }, 500);

        };
        $scope.saveLayout = function() {
            $scope.loading_save = true;
            // start loading
            $timeout(function() {
                $localStorage.lay = angular.copy($scope.app.layout);
                $scope.loading_save = false;
                // stop loading
            }, 500);

        };
        $scope.setLayout = function() {

            $scope.app.layout.isNavbarFixed = false;
            $scope.app.layout.isSidebarClosed = false;
            $scope.app.layout.isSidebarFixed = false;
            $scope.app.layout.isFooterFixed = false;
            $scope.app.layout.isBoxedPage = false;

        };

        //global function to scroll page up
        $scope.toTheTop = function() {

            $document.scrollTopAnimated(0, 600);

        };

        // angular translate
        // ----------------------
        $scope.language = {
            // Handles language dropdown
            listIsOpen: false,
            // list of available languages
            available: {
                'en': 'English',
                'it_IT': 'Italiano',
                'de_DE': 'Deutsch'
            },
            // display always the current ui language
            init: function() {
                var proposedLanguage = $translate.proposedLanguage() || $translate.use();
                var preferredLanguage = $translate.preferredLanguage();
                // we know we have set a preferred one in app.config
                $scope.language.selected = $scope.language.available[(proposedLanguage || preferredLanguage)];
            },
            set: function(localeId, ev) {
                $translate.use(localeId);
                $scope.language.selected = $scope.language.available[localeId];
                $scope.language.listIsOpen = !$scope.language.listIsOpen;
            }
        };

        $scope.language.init();

        // Fullscreen
        $scope.isFullscreen = false;
        $scope.goFullscreen = function() {
            $scope.isFullscreen = !$scope.isFullscreen;
            if (Fullscreen.isEnabled()) {
                Fullscreen.cancel();
            } else {
                Fullscreen.all();
            }

            // Set Fullscreen to a specific element (bad practice)
            // Fullscreen.enable( document.getElementById('img') )

        };

        // Function that find the exact height and width of the viewport in a cross-browser way
        var viewport = function() {
            var e = window,
                a = 'inner';
            if (!('innerWidth' in window)) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return {
                width: e[a + 'Width'],
                height: e[a + 'Height']
            };
        };
        // function that adds information in a scope of the height and width of the page
        $scope.getWindowDimensions = function() {
            return {
                'h': viewport().height,
                'w': viewport().width
            };
        };
        // Detect when window is resized and set some variables
        $scope.$watch($scope.getWindowDimensions, function(newValue, oldValue) {
            $scope.windowHeight = newValue.h;
            $scope.windowWidth = newValue.w;

            if (newValue.w >= 992) {
                $scope.isLargeDevice = true;
            } else {
                $scope.isLargeDevice = false;
            }
            if (newValue.w < 992) {
                $scope.isSmallDevice = true;
            } else {
                $scope.isSmallDevice = false;
            }
            if (newValue.w <= 768) {
                $scope.isMobileDevice = true;
            } else {
                $scope.isMobileDevice = false;
            }
        }, true);
        // Apply on resize
        $win.on('resize', function() {

            $scope.$apply();
            if ($scope.isLargeDevice) {
                $('#app .main-content').css({
                    position: 'relative',
                    top: 'auto',
                    width: 'auto'
                });
                $('footer').show();
            }
        });

        if(sessionStorage.getItem('token') && !$rootScope.user) {
            Auth.getAuthUser().then(function(response) {
                if(!response) {
                    sessionStorage.removeItem('token');
                    $state.go('auth.login');
                }
                else {
                    $rootScope.user = response.user;
                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app.language', []);

})();
(function() {
    'use strict';

    angular
        .module('app.language')
        .factory('Language', Language);

        /** @ngInject */
        function Language($q, $log, API) {

            var factory = {
                getAll: getAll
            };

            return factory;

            function getAll() {
                var deferred = $q.defer();
                API.getRequest('languages').then(function(response) {
                    deferred.resolve(response.data);
                }, function(response) {
                    $log.error('[Language] getAll()', response);
                    deferred.resolve();
                });
                return deferred.promise;
            }

        }
})();
(function() {
    'use strict';

    angular
        .module('app.inventory')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {

        $stateProvider
        
            .state('app.inventory', {
                url: '/inventory',
                abstract: true,
                template: '<ui-view/>'
            })

            .state('app.inventory.search', {
                url: '/search',
                templateUrl: '/app/inventory/inventory-search.html',
                controller: 'InventorySearchController',
                controllerAs: 'vm',
                title: 'Primary Status Search',
                ncyBreadcrumb: {
                    label: 'Primary Status Search'
                },
                params: {
                    company: null
                },
                resolve: {
                    /** @ngInject */
                    inventoryResolve: function(Inventory) {
                        return Inventory.getAll();
                    }
                }
            })

            .state('app.inventory.reservation', {
                url: '/{identity}/reservation',
                templateUrl: '/app/inventory/inventory-reservation.html',
                controller: 'InventoryReservationController',
                controllerAs: 'vm',
                title: 'Reservation Form',
                ncyBreadcrumb: {
                    label: 'Reservation Form'
                },
                params: {
                    company: null
                }
            })

            .state('app.inventory.confirmation', {
                url: '/confirmation',
                templateUrl: '/app/inventory/inventory-confirmation.html',
                controller: 'InventoryConfirmationController',
                controllerAs: 'vm',
                title: 'Confirmation Form',
                ncyBreadcrumb: {
                    label: 'Confirmation Form'
                },
                params: {
                    selectedItem: null,
                    company: null
                }
            })

            .state('app.inventory.service', {
                url: '/{identity}/service',
                templateUrl: '/app/inventory/inventory-service.html',
                controller: 'InventoryServiceController',
                controllerAs: 'vm',
                title: 'Mechanic Asset View',
                ncyBreadcrumb: {
                    label: 'Mechanic Asset View'
                }
            })

            .state('app.inventory.multiple', {
                url: '/multiple',
                templateUrl: '/app/inventory/inventory-multiple.html',
                controller: 'InventoryMultipleController',
                controllerAs: 'vm',
                title: 'Multiple View',
                ncyBreadcrumb: {
                    label: 'Multiple View'
                }
            });

    }

})();

(function() {
    'use strict';

    angular.module('app.inventory')
        .controller('InventoryStatusController', InventoryStatusController);

    /** @ngInject */
    function InventoryStatusController(InventoryStatus, $aside, $log, SweetAlert, _) {

        var vm = this;

        vm.statuses = [];
        vm.displayedStatuses = [];

        vm.showCreateStatus = showCreateStatus;
        vm.showEditStatus = showEditStatus;

        loadInventoryStatuses();

        function loadInventoryStatuses() {
            InventoryStatus.getAll().then(function(statuses) {
                vm.statuses = _.sortBy(statuses, 'created_at').reverse();
                vm.displayedStatuses = [].concat(vm.statuses);
            });
        }

        function showCreateStatus() {
            var createStatusInstance = $aside.open({
                templateUrl: 'asideStatus.html',
                placement: 'right',
                size: 'sm',
                backdrop: true,
                controller: function ($scope, $uibModalInstance) {

                    $scope.statusTypes = [{
                        value: 1,
                        text: 'Primary Status',
                        selected: true
                    }, {
                        value: 0,
                        text: '2<sup>nd</sup> Status'
                    }];

                    $scope.form = {
                        primary : true
                    };

                    $scope.ok = function (e) {
                        $scope.submitted = true;
                        if($scope.statusForm.$valid) {
                            $uibModalInstance.close();
                            e.stopPropagation();
                            $scope.form.primary = _.find($scope.statusTypes, function(option) {
                                return option.selected && option.selected == true;
                            }).value;
                            saveStatus($scope.form);
                        }
                    };

                    $scope.cancel = function (e) {
                        $scope.form = '';
                        $uibModalInstance.dismiss();
                        e.stopPropagation();
                    };
                },
            });
        }

        function showEditStatus(status) {
            var editStatusInstance = $aside.open({
                templateUrl: 'asideStatus.html',
                placement: 'right',
                size: 'sm',
                backdrop: true,
                controller: function ($scope, $uibModalInstance) {

                    $scope.statusTypes = [{
                        value: 1,
                        text: 'Primary Status',
                        selected: status.primary !== 0
                    }, {
                        value: 0,
                        text: '2<sup>nd</sup> Status',
                        selected: status.primary === 0
                    }];

                    $scope.form = {
                        identity: status.identity,
                        primary : status.primary,
                        background : status.background_color,
                        foreground: status.primary_color,
                        name: status.name
                    };

                    $scope.ok = function (e) {
                        $scope.submitted = true;
                        if($scope.statusForm.$valid) {
                            $uibModalInstance.close();
                            e.stopPropagation();
                            $scope.form.primary = _.find($scope.statusTypes, function(option) {
                                return option.selected && option.selected == true;
                            }).value;
                            updateStatus(status, $scope.form);
                        }
                    };
                    $scope.cancel = function (e) {
                        $scope.form = '';
                        $uibModalInstance.dismiss();
                        e.stopPropagation();
                    };
                },
            });
        }

        function saveStatus(form) {
            InventoryStatus.save(form).then(function(status) {
                vm.statuses.push(status);
                vm.displayedStatuses.push(status);
                SweetAlert.swal('Saved Status', 'You have created a new status: ' + status.name + '.', 'success');
            });
        }

        function updateStatus(oldStatus, form) {
            InventoryStatus.update(form).then(function(status) {
                vm.statuses.splice(vm.statuses.indexOf(oldStatus), 1);
                vm.displayedStatuses.splice(vm.displayedStatuses.indexOf(oldStatus), 1);
                vm.statuses.push(status);
                vm.displayedStatuses.push(status);
                SweetAlert.swal('Updated Status', 'You have updated the status: ' + status.name + '.', 'success');
            });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.inventory')
        .factory('InventoryStatus', InventoryStatus);

    /** @ngInject */
    function InventoryStatus($log, $q, API) {

        var api = {
            GET: 'inventory/statuses/?page='
        };
        
        var factory = {
            getAll: getAll,
            getDeleted: getAllDeleted,
            get: get,
            save: save,
            update: update,
            'delete': deleteRequest,
            api: api
        };

        return factory;

        function getAllDeleted() {
            var deferred = $q.defer();
            API.getRequest('inventory/trash').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function getAll() {
            var deferred = $q.defer();
            API.getRequest('inventory/statuses').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function get(identity) {
            var deferred = $q.defer();
            API.getRequest('inventory/statuses?identity=' + identity).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function save(payload) {
            var deferred = $q.defer();
            API.postRequest('inventory/statuses', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function update(payload) {
            var deferred = $q.defer();
            API.putRequest('inventory/statuses', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function deleteRequest(identity) {
            var deferred = $q.defer();
            API.deleteRequest('inventory/statuses?identity='+identity).then(function(response) {
                deferred.resolve(response);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('app.inventory')
        .factory('InventoryService', InventoryService);

    /** @ngInject */
    function InventoryService($log, $q, API) {

        var factory = {
            getAll: getAll,
            getDeleted: getAllDeleted,
            get: get,
            getItem: getItem,
            save: save,
            update: update,
            'delete': deleteRequest
        };

        return factory;

        function getAllDeleted() {
            var deferred = $q.defer();
            API.getRequest('inventory/trash').then(function(response) {
                deferred.resolve(response.data);

            }, function(response) {
                $log.error('[InventoryService] getAllDeleted()', response);
                deferred.resolve();
            });
            return deferred.promise;
        }

        function getAll() {
            var deferred = $q.defer();
            API.getRequest('service').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[InventoryService] getAll()', response);
                deferred.resolve();
            });
            return deferred.promise;
        }

        function get(identity) {
            var deferred = $q.defer();
            API.getRequest('service?identity=' + identity).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[InventoryService] get()', response);
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

         function getItem(identity) {
            var deferred = $q.defer();
            API.getRequest('service/item?identity=' + identity).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[InventoryService] getItem()', response);
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

        function save(payload) {
            var deferred = $q.defer();
            API.postRequest('service', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[InventoryService] save()', response);
                deferred.resolve();
            });
            return deferred.promise;
        }

        function update(payload) {
            var deferred = $q.defer();
            API.putRequest('service', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[Industry] update()', response);
                deferred.resolve();
            });
            return deferred.promise;
        }

        function deleteRequest(identity) {
            var deferred = $q.defer();
            API.deleteRequest('inventory/statuses?identity='+identity).then(function(response) {
                deferred.resolve(response);
            }, function(response) {
                $log.error('[InventoryService] delete()', response);
                deferred.resolve();
            });
            return deferred.promise;
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('app.inventory')
        .controller('InventoryServiceController', InventoryServiceController);

    /** @ngInject */
    function InventoryServiceController($log, Inventory, InventoryStatus, InventoryService, $aside, $state, $stateParams, ngNotify, SweetAlert, API, _) {
        var vm = this;

        vm.showServiceAsset = showServiceAsset;
        
        // The collection of primary statuses
        vm.statuses = [];
        // The collection of secondary statuses
        vm.secondStatuses = [];

        loadInventory();
        loadInventoryStatuses();

        function loadInventory() {
            Inventory.get($stateParams.identity).then(function(item) {
                if (!item) {
                    ngNotify.set('Invalid inventory record to view. Please try again.', {
                        type: 'error',
                        duration: 3000
                    });
                    $state.go('app.inventory.search');
                    return;
                }
                $log.debug('Item', item);
                vm.item = item;
                $log.debug('Item', vm.item);
                constructFormData();
                buildOrders();
            });
        }

        function loadInventoryStatuses() {
            API.query(InventoryStatus.api.GET).then(function() {},
            function(response) {
                $log.error('There was an issue loading the inventory statuses.', response);
            }, function(statuses) {
                vm.statuses = vm.statuses.concat(_.filter(statuses, function(status) {
                    return status.primary === true;
                }));
                vm.secondStatuses = vm.secondStatuses.concat(_.filter(statuses, function(status) {
                    return status.primary === false;
                }))
            });
        }

        function constructFormData() {
            vm.form = {
                serial: vm.item.serial,
                asset: vm.item.asset,
                description: vm.item.description
            };
        }

        function buildOrders() {
            vm.orders = [];
            angular.forEach(vm.item.reservations, function(reservation) {
                if(angular.isDefined(reservation.confirmation) && reservation.confirmation !== null) {
                    var startTime = Date.parse(reservation.confirmation.expected_on_rent);
                    var endTime = Date.parse(reservation.confirmation.expected_off_rent);
                    var duration = endTime - startTime;
                    reservation.rental_days = (duration / 86400000);
                    vm.orders.push(reservation);
                }
            });
            vm.displayedOrders = [].concat(vm.orders);
        }

        function showServiceAsset() {
            $aside.open({
                templateUrl: 'asideService.html',
                placement: 'right',
                size: 'full',
                backdrop: true,
                controller: function($scope, $uibModalInstance) {

                    $log.debug('Item', vm.item);

                    $scope.item = vm.item;

                    $scope.formatDate = formatDate;

                    function formatDate(dateString) {
                        return new Date(dateString);
                    }


                    $scope.form = {
                        serial: vm.item.serial,
                        asset: vm.item.asset,
                        description: vm.item.description,
                        availablePercent: '',
                        inspectionDate: '',
                        item: vm.item.identity
                    };

                    $scope.startService = startService;
                    $scope.endService = endService;


                    function startService() {
                        $scope.form.start_time = new Date();

                        InventoryService.save($scope.form).then(function(response) {
                            $scope.form.identity = response;
                        });
                    }

                    function endService() {
                        $scope.form.end_time = new Date();

                        $state.go('app.mechanic', {}, {reload:true});
                        InventoryService.update($scope.form).then(function(response) {
                            $log.debug('called', response);
                            $uibModalInstance.close();
                            SweetAlert.swal('Ended Service', 'The service record and item have been updated.', 'success');
                        });
                    }

                    $scope.secondStatuses = vm.secondStatuses;
                    $scope.serviceStatus = [{
                        text: 'Ready Line',
                        value: 'Ready Line'
                    }, {
                        text: 'Repair',
                        value: 'Repair'
                    }, {
                        text: 'Hard Down',
                        value: 'Hard Down'
                    }, {
                        text: 'Annual Insp.',
                        value: 'Annual Insp'
                    }];

                    $scope.inspection_date = {
                        opened: false,
                        options: {
                            formatYear: 'yyyy',
                            minDate: new Date(),
                            startingDay: 1,
                            showWeeks: false
                        },
                        format: 'MM/dd/yyyy'
                    };

                    $scope.inspection_date.open = function() {
                        $scope.inspection_date.opened = true;
                    }

                    $scope.expected_workshop = {
                        opened: false,
                        options: {
                            formatYear: 'yyyy',
                            minDate: new Date(),
                            startingDay: 1,
                            showWeeks: false
                        },
                        format: 'MM/dd/yyyy'
                    };

                    $scope.expected_workshop.open = function() {
                        $scope.expected_workshop.opened = true;
                    }

                    $scope.cancel = function(e) {
                        $uibModalInstance.dismiss();
                        e.stopPropagation();
                    };
                }
            });
        }
    }

})();

(function() {
    'use strict';
    angular
        .module('app.inventory')
        .controller('InventorySearchController', InventorySearchController);

    /** @ngInject */
    function InventorySearchController($scope, $log, _, $state, $aside, $stateParams, Inventory, InventoryStatus, InventoryLocation, SweetAlert, API, inventoryResolve) {

        var vm = this;
        
        vm.asideInventory = false;
        // Collection of status options
        vm.statuses = [];
        vm.secondStatuses = [];
        // Collection of inventory locations
        vm.locations = [];
        // Collection of inventory items
        vm.items = [].concat(inventoryResolve.data);
        vm.displayedItems = [].concat(vm.items);
        
        vm.placeholder = {
            collection: vm.items,
            title: 'No Inventory',
            message: 'There are currently no inventory items.',
            button_text: 'Create 1<sup>st</sup> Item',
            button_action: function() {
                vm.asideInventory = true;
            }
        };
        
        $log.debug('Items...', vm.items);
        
        var messages = {
            MISSING_ITEMS: {
                RESERVATION : {
                    title: 'No Items Selected',
                    message: 'You must select an inventory item to create a reservation.'
                },
                CONFIRMATION: {
                    title: 'No Items Selected',
                    message: 'You must select an inventory item to create a confirmation.'
                },
                SERVICE: {
                    title: 'No Items Selected',
                    message: 'You must select an item to start a service.'
                }
            },
            REQUIREMENTS: {
                CONFIRMATION: {
                    title: 'Warning',
                    message: 'You can only create a confirmation for items that are \'{0}\'.'
                }
            }
        };

        vm.form = {
            selectedItem : ''
        };
        vm.filter = {
            asset : '',
            location: '',
            statuses: [],
            secondStatuses: []
        }
        vm.filteredItems = [];

        vm.selectRow = selectRow;
        vm.filterPipe = filterPipe;
        vm.filterItems = filterItems;
        vm.confirmation = confirmation;
        vm.reservation = reservation;
        vm.service = service;
        vm.getRecord = getRecord;
        vm.showUpdateItem = showUpdateItem;

        checkForSelectedCompany();
        loadInventoryStatuses();
        loadInventoryLocations();

        function checkForSelectedCompany() {
            if($stateParams.company) {
                vm.form.selectedCompany = $stateParams.company;
            }
        }
        
        constructor();
        
        function constructor() {
            if(inventoryResolve.meta.pagination.current_page < inventoryResolve.meta.pagination.total_pages) {
                API.query(Inventory.api.GET + (inventoryResolve.meta.pagination.current_page + 1)).then(function() {
                    
                }, function(response) {
                    $log.error('There was an issue loading the inventory items.', response);
                }, function(items) {
                    vm.items = vm.items.concat(items);
                    vm.displayedItems = [].concat(vm.items);
                    vm.filteredItems = [].concat(vm.items);
                    filterPipe(tblState);
                });
            }
            else {
                vm.filteredItems = [].concat(vm.items);
                filterPipe(tblState);
            }
        }

        function loadInventoryStatuses() {
            API.query(InventoryStatus.api.GET + 1).then(function() {}, 
            function(response) {
                $log.error('There was an issue loading inventory statuses.', response);
            }, function(statuses) {
               vm.statuses = vm.statuses.concat(_.filter(statuses, function(status) {
                    return status.primary === true;
               }));
               vm.secondStatuses = vm.secondStatuses.concat(_.filter(statuses, function(status) {
                   return status.primary === false;
               }));
            });
        }

        function loadInventoryLocations() {
            API.query(InventoryLocation.api.GET + 1).then(function() {},
            function(response) {
                $log.error('There was an issue loading inventory locations.', response);
            }, function(locations) {
               vm.locations = vm.locations.concat(locations); 
            });
        }

        function selectRow(identity) {
            vm.form.selectedItem = identity;
        }

        function showUpdateItem(item) {
            $aside.open({
                templateUrl: 'asideInventoryItem.html',
                placement: 'right',
                size: 'md',
                backdrop: true,
                controller: function ($scope, $uibModalInstance) {

                    $scope.form = {
                        identity: item.identity,
                        asset: item.asset,
                        description: item.description
                    };

                    $scope.options = [{
                        value: 'Picked Up',
                        text: 'Picked Up',
                        selected: item.status.original == 'Picked Up'
                    }, {
                        value: 'Delivery',
                        text: 'Delivery',
                        selected: item.status.original == 'Delivery'
                    }, {
                        value: 'Off Rent',
                        text: 'Off Rent',
                        selected: item.status.original == 'Off Rent'
                    }, {
                        value: 'On Rent',
                        text: 'On Rent',
                        selected: item.status.original == 'On Rent'
                    }];

                    $scope.ok = function (e) {
                        $uibModalInstance.close();
                        e.stopPropagation();
                        $scope.form.status = _.find($scope.options, function(option) {
                            return option.selected && option.selected == true;
                        }).value;
                        updateInventoryItem(item, $scope.form);
                    };
                    $scope.cancel = function (e) {
                        $uibModalInstance.dismiss();
                        e.stopPropagation();
                    };
                }
            });
        }

        function updateInventoryItem(oldItem, form) {
            $log.debug('Update item', form);
            Inventory.updateStatus(form).then(function(item) {
                $log.debug('Item Response', item);
                vm.items.splice(vm.items.indexOf(oldItem), 1);
                vm.displayedItems.splice(vm.displayedItems.indexOf(oldItem), 1);
                vm.items.push(item);
                vm.displayedItems.push(item);
                SweetAlert.swal('Updated Item', 'You have updated the status to: ' + item.status.name + '.', 'success');
            });
        }

        var tblState;

        function filterPipe(tableState) {
            tblState = tableState;
            if (tableState) {
                var pagination = tableState.pagination;
                var start = pagination.start || 0;
                var number = pagination.number || 10;
                var searchTerm = tableState.search.predicateObject || '';
                tableState.pagination.numberOfPages = Math.ceil(Object.keys(vm.filteredItems).length / 10);
                vm.displayedItems = vm.filteredItems.slice(start, start + number);
            }
            else {
                tblState = {
                    pagination : {
                        number: 10,
                        numberOfPages: 0,
                        start: 0,
                        totalItemCount: 0
                    },
                    search: {},
                    sort: {}
                };
                filterPipe(tblState);
            }
        }

        function filterItems() {
            vm.filteredItems = [].concat(vm.items);
            vm.filteredItems = _.filter(vm.filteredItems, function(item) {
                if(vm.filter.asset) {
                    if(item.asset.toLowerCase().indexOf(vm.filter.asset.toLowerCase()) === -1)
                        return false;
                }
                if(vm.filter.statuses && vm.filter.statuses.length > 0) {
                    if(!item.status || vm.filter.statuses.indexOf(item.status.original) === -1)
                        return false;
                }
                if(vm.filter.secondStatuses && vm.filter.secondStatuses.length > 0 ) {
                    if(!item.secondStatus || vm.filter.secondStatuses.indexOf(item.secondStatus.original) === -1)
                        return false;
                }
                if(vm.filter.locations && vm.filter.locations.length > 0) {
                    if(item.location === null || vm.filter.locations.indexOf(item.location.identity) === -1)
                        return false;
                }
                return true;
            });
            vm.filterPipe(tblState);
        }

        function getRecord(item) {
            if(item.reservation)
                return item.reservation;
            else {
                if(item.reservations.length > 0) {
                    var currentTime = new Date();
                    var reservation = _.find(item.reservations, function(reservation) {
                        reservation.expected_on_rent = new Date(reservation.expected_on_rent);
                        reservation.expected_off_rent = new Date(reservation.expected_off_rent);
                        return (currentTime <= reservation.expected_off_rent && currentTime >= reservation.expected_on_rent);
                    });
                    if(!reservation) {
                        var reservation = _.sortBy(item.reservations, 'created_at').reverse();
                        return reservation[0];
                    }
                    if(reservation.company)
                        item.reservation = reservation;
                }
                else {
                    item.reservation = 'None';
                }
            }
            return item.reservation;
        }

        function reservation() {
            $log.debug('Form', vm.form.selectedItem);
            if(vm.form.selectedItem === '') {
                SweetAlert.swal(messages.MISSING_ITEMS.RESERVATION.title, messages.MISSING_ITEMS.RESERVATION.message);
                return;
            }
            var identity = angular.copy(vm.form.selectedItem);
            vm.form.selectedItem = '';
            $state.go('app.inventory.reservation', {
                identity: identity,
                company: vm.form.selectedCompany
            });

        }

        function confirmation() {
            if(vm.form.selectedItem === '') {
                SweetAlert.warning(messages.MISSING_ITEMS.CONFIRMATION.title, messages.MISSING_ITEMS.CONFIRMATION.message);
                return;
            }

            var item = _.find(vm.items, function(item) {
                return item.identity === vm.form.selectedItem;
            });

            if(item.status && item.status.original.toLowerCase() === 'ready line') {
                 $state.go('app.inventory.confirmation', {
                    selectedItem: vm.form.selectedItem,
                    company: vm.form.selectedCompany
                });
            }
            else {
                SweetAlert.warning(messages.REQUIREMENTS.CONFIRMATION.title, messages.REQUIREMENTS.CONFIRMATION.message.replace('{0}', _.find(vm.statuses, function(status) {
                    return status.original === 'Ready Line'
                }).name));
            }
        }

        function service() {
            if(vm.form.selectedItem === '') {
                SweetAlert.warning(messages.MISSING_ITEMS.SERVICE.title, messages.MISSING_ITEMS.SERVICE.message);
                return;
            }
            $state.go('app.inventory.service', {identity:vm.form.selectedItem});
        }

    }
})();
(function() {
    'use strict';
    angular
        .module('app.inventory')
        .controller('InventoryReservationController', InventoryReservationController);

        /** @ngInject */
        function InventoryReservationController($log, $window, $scope, $state, $filter, $stateParams, ngNotify, API, Company, Inventory, Reservation, _, $aside, SweetAlert) {

            var vm = this;

            vm.companies = [];
            vm.reservations = [];
            vm.displayedReservations = [].concat(vm.reservations);

            vm.messages = {
                SAVE_SUCCESS: {
                    title: 'Saved!',
                    message: 'You have created a new reservation #{0}.'
                },
                SAVE_ERROR: {
                    title: 'Error!',
                    message: 'There was an issue saving the reservation. Please contact support.'
                },
                SAVE_CONFIRM: {
                    title: 'Are you sure?',
                    message: 'There is a reservation that already exists for this time period. Do you want to create another reservation?'
                },
                UPDATE_SUCCESS: {
                    title: 'Updated!',
                    message: 'You have updated reservation #{0}.'
                },
                UPDATE_ERROR: {
                    title: 'Error!',
                    message: 'There was an issue updating the reservation. Please contact support.'
                }
            };

            if($stateParams.company) {
                ngNotify.dismiss();
            }

            vm.form = {
                item: $stateParams.identity,
                company: $stateParams.company
            };

            vm.on_rent = {
                opened: false,
                options : {
                    formatYear: 'yyyy',
                    minDate: new Date(),
                    startingDay: 1,
                    showWeeks: false
                },
                format: 'MM/dd/yyyy'
            };

            vm.off_rent = {
                opened: false,
                options : {
                    formatYear: 'yyyy',
                    minDate: new Date(),
                    startingDay: 1,
                    showWeeks: false
                },
                format: 'MM/dd/yyyy'
            };

            vm.on_rent.open = function() {
                vm.on_rent.opened = true;
            }

            vm.off_rent.open = function() {
                vm.off_rent.opened = true;
            }

            vm.saveReservation = saveReservation;
            vm.loadCompany = loadCompany;
            vm.loadContact = loadContact;
            vm.loadAddress = loadAddress;
            vm.expandComments = expandComments;
            vm.showUpdateReservation = showUpdateReservation;
            vm.parseDate = parseDate;

            function constructor() {
                loadInventory();
                loadCompanies();
            }

            constructor();

            function parseDate(date) {
                if(angular.isUndefined(date) || date === null)
                    return '';
                return $filter('date')(Date.parse(date), 'MM/dd/yyyy');
            }

            function saveReservation() {
                vm.submitted = true;

                if(vm.reservationForm.$valid) {
                    var hasConflict = _.find(vm.reservations, function(record) {
                        $log.debug('record', record);
                        var startTime = Date.parse(record.expected_on_rent);
                        var endTime = Date.parse(record.expected_off_rent);
                        var onRent =  Date.parse(vm.form.expected_on_rent);
                        var offRent = Date.parse(vm.form.expected_off_rent);

                        if(onRent <= endTime && onRent >= startTime)
                            return true;
                        if(offRent <= endTime && offRent >= startTime)
                            return true;

                        $log.debug('Check [S] ' + startTime + ', [E] ' + endTime + ' against [S] ' + onRent + ', [E] ' + endTime);
                        return false;
                    });

                    if(hasConflict) {
                        SweetAlert.swal({
                            title: vm.messages.SAVE_CONFIRM.title,
                            text: vm.messages.SAVE_CONFIRM.message,
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#DD6B55',
                            confirmButtonText: 'Yes, save anyways.',
                            closeOnConfirm: true
                        },
                        function(isConfirm) {
                            if (isConfirm) {
                                save();
                            }
                        });
                    }
                    else {
                        save();
                    }
                }
            }

            function save() {
                Reservation.save(vm.form).then(function(record) {
                    SweetAlert.success(vm.messages.SAVE_SUCCESS.title, vm.messages.SAVE_SUCCESS.message.replace('{0}', record.item_number));
                    $state.go('app.inventory.search', {}, {reload:true});
                }, function(response) {
                    SweetAlert.error(vm.messages.SAVE_ERROR.title, vm.messages.SAVE_ERROR.message);
                    $log.error('There was an issue saving the reservation.', response);
                });
            }

            function loadInventory() {
                Inventory.get($stateParams.identity).then(function(item) {
                    if(!item) {
                        ngNotify.set('Invalid inventory record to view. Please try again.', {
                            type: 'error',
                            duration: 3000
                        });
                        $state.go('app.inventory.search');
                        return;
                    }
                    vm.item = item;
                    vm.reservations = _.filter(vm.item.reservations);
                    $log.debug('Reservations', vm.reservations);
                    vm.displayedReservations = [].concat(vm.reservations);
                    loadPastSiteAddresses();
                });
            }


            function loadCompanies() {
                API.query(Company.api.GET + 1).then(function() {}, function(response) {
                    $log.error('There was an issue loading companies.', response);
                }, function(companies) {
                   vm.companies = vm.companies.concat(companies);
                });
            }

            function loadCompany() {
                var company = _.find(vm.companies, function(company) {
                    return company.identity === vm.form.company;
                });
                vm.contacts = company.contacts;
            }

            function loadContact() {
                var contact = _.find(vm.contacts, function(contact) {
                    return contact.identity == vm.form.contact;
                });
                if(contact && contact.office_phone)
                    vm.form.phone = contact.office_phone;
            }

            function loadPastSiteAddresses() {
                vm.addresses = [];
                if(vm.item.records) {
                    angular.forEach(vm.item.records, function(record) {
                        vm.addresses.push({
                            site_address: record.site_address,
                            site_city: record.site_city,
                            site_state: record.site_state,
                            site_postal: record.site_postal,
                            site_country: record.site_country
                        });
                    });
                }
                $log.debug('Existing Addresses', vm.addresses);
            }

            function loadAddress() {
                vm.form.site_address = vm.form.address.site_address;
                vm.form.site_city = vm.form.address.site_city;
                vm.form.site_state = vm.form.address.site_state;
                vm.form.site_postal = vm.form.address.site_postal;
            }

            function expandComments() {
                $aside.open({
                    templateUrl: 'asideComments.html',
                    placement: 'left',
                    size: 'full',
                    backdrop: true,
                    controller: function ($scope, $uibModalInstance) {
                        $scope.ok = function (e) {
                            $uibModalInstance.close();
                            e.stopPropagation();
                            saveComments($scope.comments);
                        };
                        $scope.cancel = function (e) {
                            $uibModalInstance.dismiss();
                            e.stopPropagation();
                        };
                    }
                });
            }

            function saveComments(comments) {
                vm.form.comments = comments;
            }

            function showUpdateReservation(item) {
                $aside.open({
                    templateUrl: 'asideReservation.html',
                    placement: 'right',
                    size: 'md',
                    backdrop: true,
                    controller: function ($scope, $uibModalInstance) {

                        $scope.companies = vm.companies;

                        $scope.form = {
                            identity: item.identity,
                            company : item.company.identity,
                            item : item.item.identity,
                            site_address : item.site_address,
                            site_city : item.site_city,
                            site_state : item.site_state,
                            site_postal: item.site_postal,
                            expected_on_rent : Date.parse(item.expected_on_rent),
                            expected_off_rent : Date.parse(item.expected_off_rent)
                        };

                        loadAsideCompany(function() {
                            $scope.form.contact = item.contact.identity;
                            loadAsideContact();
                        });

                        $scope.loadCompany = loadAsideCompany;
                        $scope.loadContact = loadAsideContact;

                        $scope.on_rent = {
                            opened: false,
                            options : {
                                formatYear: 'yyyy',
                                minDate: new Date(),
                                startingDay: 1,
                                showWeeks: false
                            },
                            format: 'MM/dd/yyyy'
                        };

                        $scope.off_rent = {
                            opened: false,
                            options : {
                                formatYear: 'yyyy',
                                minDate: new Date(),
                                startingDay: 1,
                                showWeeks: false
                            },
                            format: 'MM/dd/yyyy'
                        };

                        $scope.on_rent.open = function() {
                            $scope.on_rent.opened = true;
                        }

                        $scope.off_rent.open = function() {
                            $scope.off_rent.opened = true;
                        }

                        function loadAsideCompany(callback) {
                            var company = _.find($scope.companies, function(company) {
                                return company.identity === $scope.form.company;
                            });
                            $scope.contacts = company.contacts;
                            if(callback)
                                callback();
                        }

                        function loadAsideContact(callback) {
                            var contact = _.find($scope.contacts, function(contact) {
                                return contact.identity == $scope.form.contact;
                            });
                            if(contact && contact.office_phone)
                                $scope.form.phone = contact.office_phone;
                            if(callback)
                                callback();
                        }

                        $scope.ok = function (e) {
                            $uibModalInstance.close();
                            e.stopPropagation();
                            updateReservation(item, $scope.form);
                        };
                        $scope.cancel = function (e) {
                            $uibModalInstance.dismiss();
                            e.stopPropagation();
                        };

                        $scope['delete'] = function(e) {
                            Reservation.remove($scope.form.identity).then(function(response) {
                                $uibModalInstance.dismiss();
                                e.stopPropagation();
                                $window.location.reload();
                            }, function(response) {
                                $log.error('There was an issue deleting the reservation', response);
                                SweetAlert.error('There was an issue deleting the reservation.', 'Error');
                            });
                            console.log('called...');
                        };
                    }
                });
            }

            function updateReservation(item, form) {
                Reservation.update(form).then(function(record) {
                    vm.reservations.splice(vm.reservations.indexOf(item));
                    vm.reservations.push(record);
                    SweetAlert.success(vm.messages.UPDATE_SUCCESS.title, vm.messages.UPDATE_SUCCESS.message.replace('{0}', record.item_number));
                }, function(response) {
                    $log.error('There was an issue updating the reservation.', response);
                    SweetAlert.error(vm.messages.SAVE_ERROR.title, vm.messages.SAVE_ERROR.message);
                });
            }

        }
})();
(function() {
    'use strict';

    angular
        .module('app.inventory')
        .controller('InventoryMultipleController', InventoryMultipleController);

    /** @ngInject */
    function InventoryMultipleController($log, InventoryStatus, Employee, Reservation, SweetAlert, $state, _) {

        var vm = this;

        vm.filteredItems = [];

        vm.form = {};

        vm.updateSelected = {};

        vm.filterTypes = [{
            value: 'Reservation',
            text: 'Reservations'
        }, {
            value: 'Confirmation',
            text: 'Confirmations'
        }];

        vm.on_rent = {
            opened: false,
            options : {
                formatYear: 'yyyy',
                startingDay: 1,
                showWeeks: false
            },
            format: 'MM/dd/yyyy'
        };

        vm.off_rent = {
            opened: false,
            options : {
                formatYear: 'yyyy',
                startingDay: 1,
                showWeeks: false
            },
            format: 'MM/dd/yyyy'
        };

        vm.on_rent.open = function() {
            vm.on_rent.opened = true;
        }

        vm.off_rent.open = function() {
            vm.off_rent.opened = true;
        }

        vm.filterPipe = filterPipe;
        vm.filterItems = filterItems;
        vm.getRecord = getRecord;
        vm.formatDate = formatDate;
        vm.saveChanges = saveChanges;

        loadInventoryStatuses();
        loadReservations();
        loadEmployees();

        function formatDate(dateString) {
            return new Date(dateString);
        }

        function loadReservations() {
            Reservation.getAll().then(function(reservations) {
                vm.reservations = reservations;
                vm.displayedReservations = [].concat(vm.reservations);
                filterPipe(tblState);
            });
        }

        function loadEmployees() {
            Employee.getAll().then(function(employees) {
                vm.employees = _.filter(employees, function(employee) {
                    return employee.external == true && employee.logistics == true;
                });

            });
        }

        function loadInventoryStatuses() {
            InventoryStatus.getAll().then(function(statuses) {
                vm.statuses = _.sortBy(statuses, 'created_at').reverse();
                vm.displayedStatuses = [].concat(vm.statuses);
            });
        }

        function saveChanges() {
            $log.debug('vm.updateSelected', Object.keys(vm.updateSelected));
            Reservation.updateMultiple({
                    identities: Object.keys(vm.updateSelected),
                    chauffer: vm.form.chauffer
                }).then(function() {
                SweetAlert.swal("Saved!", 'You have successfully updated multiple records.', "success");
                $state.go($state.current, {}, {reload: true});
            });
        }

        var tblState;

        function filterPipe(tableState) {
            tblState = tableState;
            if (tableState) {
                var pagination = tableState.pagination;
                var start = pagination.start || 0;
                var number = pagination.number || 10;
                // var searchTerm = tableState.search.predicateObject || '';
                tableState.pagination.numberOfPages = Math.ceil(Object.keys(vm.filteredItems).length / 10);
                vm.displayedItems = vm.filteredItems.slice(start, start + number);
            }
            else {
                tblState = {
                    pagination : {
                        number: 10,
                        numberOfPages: 0,
                        start: 0,
                        totalItemCount: 0
                    },
                    search: {},
                    sort: {}
                };
                filterPipe(tblState);
            }
        }

        function filterItems() {
            vm.itemType = _.find(vm.filterTypes, function(option) {
                return option.selected && option.selected == true;
            });
            vm.filteredItems = [].concat(vm.reservations);
            vm.filteredItems = _.filter(vm.filteredItems, function(reservation) {
                if(vm.itemType) {
                    var type = vm.itemType.value;
                    if(type == 'Reservation') {
                        if(reservation.confirmation)
                            return false;
                    }
                    if(type == 'Confirmation') {
                        if(!reservation.confirmation)
                            return false;
                    }
                }
                if(vm.form.statuses && vm.form.statuses.length > 0) {
                    if(!reservation.item.status || vm.form.statuses.indexOf(reservation.item.status.identity) === -1)
                        return false;
                }
                if(vm.form.expected_off_rent) {
                    var filterOffRent = formatDate(vm.form.expected_off_rent).toUTCString();
                    filterOffRent = Date.parse(filterOffRent.split(' ').slice(0, 4).join(' '));

                    var offRent = formatDate(reservation.expected_off_rent).toUTCString();
                    offRent = Date.parse(offRent.split(' ').slice(0, 4).join(' '));

                    if(offRent > filterOffRent)
                        return false;
                }
                if(vm.form.expected_on_rent) {
                    var filterOnRent = formatDate(vm.form.expected_on_rent).toUTCString();
                    filterOnRent = Date.parse(filterOnRent.split(' ').slice(0, 4).join(' '));

                    var onRent = formatDate(reservation.expected_on_rent).toUTCString();
                    onRent = Date.parse(onRent.split(' ').slice(0, 4).join(' '));

                    if(onRent > filterOnRent)
                        return false;
                }
                return true;
            });
            vm.filterPipe();
        }

        function getRecord(item) {
            if(item.reservation)
                return item.reservation;
            else {
                if(item.reservations.length > 0) {
                    var currentTime = new Date();
                    var reservation = _.find(item.reservations, function(reservation) {
                        reservation.expected_on_rent = new Date(reservation.expected_on_rent);
                        reservation.expected_off_rent = new Date(reservation.expected_off_rent);
                        return (currentTime <= reservation.expected_off_rent && currentTime >= reservation.expected_on_rent);
                    });
                    if(!reservation) {
                        reservation = _.sortBy(item.reservations, 'created_at').reverse();
                        return reservation[0];
                    }
                    if(reservation.company)
                        item.reservation = reservation;
                }
                else {
                    item.reservation = 'None';
                }
            }
            return item.reservation;
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('app.inventory')
        .factory('InventoryLocation', InventoryLocation);

    /** @ngInject */
    function InventoryLocation($log, $q, API) {

        var api = {
            GET: 'inventory/locations/?page='
        };
        
        var factory = {
            getAll: getAll,
            getDeleted: getAllDeleted,
            get: get,
            save: save,
            update: update,
            'delete': deleteRequest,
            api: api
        };

        return factory;

        function getAllDeleted() {
            var deferred = $q.defer();
            API.getRequest('inventory/trash').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function getAll() {
            var deferred = $q.defer();
            API.getRequest('inventory/locations').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function get(identity) {
            var deferred = $q.defer();
            API.getRequest('inventory/locations?identity=' + identity).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function save(payload) {
            var deferred = $q.defer();
            API.postRequest('inventory/locations', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function update(payload) {
            var deferred = $q.defer();
            API.putRequest('inventory/locations', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function deleteRequest(identity) {
            var deferred = $q.defer();
            API.deleteRequest('inventory/locations?identity='+identity).then(function(response) {
                deferred.resolve(response);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('app.inventory')
        .controller('InventoryConfirmationController', InventoryConfirmationController);

    /** @ngInject */
    function InventoryConfirmationController($log, $scope, $state, $stateParams, $filter, Inventory, Confirmation, API, Company, $aside, ngNotify, SweetAlert, _) {

        var vm = this;
        
        // The collection of companies
        vm.companies = [];

        if($stateParams.company) {
            ngNotify.dismiss();
        }

        vm.submitted = false;
        vm.reservations = [];

        vm.form = {
            selectedItem : '',
            company: $stateParams.company
        };

        vm.saveConfirmation = saveConfirmation;
        vm.expandComments = expandComments;
        vm.loadCompany = loadCompany;
        vm.loadContact = loadContact;
        vm.loadAddress = loadAddress;
        vm.loadReservation = loadReservation;

        vm.on_rent = {
            opened: false,
            options : {
                formatYear: 'yyyy',
                minDate: new Date(),
                startingDay: 1,
                showWeeks: false
            },
            format: 'MM/dd/yyyy'
        };

        vm.off_rent = {
            opened: false,
            options : {
                formatYear: 'yyyy',
                minDate: new Date(),
                startingDay: 1,
                showWeeks: false
            },
            format: 'MM/dd/yyyy'
        };

        vm.on_rent.open = function() {
            vm.on_rent.opened = true;
        }

        vm.off_rent.open = function() {
            vm.off_rent.opened = true;
        }

        setSelectedItems();
        
        function constructor() {
            loadCompanies();
        }
        
        constructor();
        
        function setSelectedItems() {
            if(!$stateParams.selectedItem) {
                $state.go('app.inventory.search', {}, {reload:true});
                return;
            }
            vm.form.item = $stateParams.selectedItem;

            Inventory.get(vm.form.item).then(function(item) {
                $log.debug('Loaded Item', item);
                vm.reservations = vm.reservations.concat(item.reservations);
                loadPastSiteAddresses(item);
            });

            $log.debug('Reserv For Table', vm.reservations);
            vm.displayedReservations = [].concat(vm.reservations);
        }

        function saveConfirmation() {
            // TODO Form Validation?
            Confirmation.save(vm.form).then(function(record) {
                $log.debug('Record', record);
                if(record) {
                    SweetAlert.swal("Saved!", 'You have created new confirmation #' + record.item_number +'.', "success");
                    $state.go('app.inventory.search', {}, {reload:true});
                }
                else {
                    SweetAlert.swal("Error!", 'There was an issue saving the confirmation. Please contact support.', "error");
                }
            });
        }

        function loadCompanies() {
            API.query(Company.api.GET + 1).then(function() {}, function(response) {
                $log.error('There was an issue loading companies.', response);
            }, function(companies) {
                vm.companies = vm.companies.concat(companies); 
            });
        }

        function loadCompany() {
            $log.debug('Selected identity: ', vm.form.company);
            var company = _.find(vm.companies, function(company) {
                return company.identity === vm.form.company;
            });
            $log.debug('Selected Company: ', company);
            vm.contacts = company.contacts;
        }

        function loadContact() {
            var contact = _.find(vm.contacts, function(contact) {
                return contact.identity == vm.form.contact;
            });
            if(contact && contact.office_phone)
                vm.form.phone = contact.office_phone;
        }

        function loadReservation(reservation) {
            $log.debug('Reservation', reservation);
            vm.form.company = reservation.company.identity;
            vm.form.contact = reservation.contact.identity;
            vm.form.site_address = reservation.site_address;
            vm.form.site_city = reservation.site_city;
            vm.form.site_state = reservation.site_state;
            vm.form.site_postal = reservation.site_postal;
            vm.form.expected_on_rent = Date.parse(reservation.expected_on_rent);
            vm.form.expected_off_rent = Date.parse(reservation.expected_off_rent);
            vm.form.delivery_request_time = reservation.delivery_request_time;
            vm.form.comments = reservation.comments;
            vm.contacts = reservation.company.contacts;
            loadContact();
            $log.debug('Set Form:', vm.form);
        }

        function loadPastSiteAddresses(item) {
            vm.addresses = [];
            if(item.records) {
                angular.forEach(item.records, function(record) {
                    vm.addresses.push({
                        site_address: record.site_address,
                        site_city: record.site_city,
                        site_state: record.site_state,
                        site_postal: record.site_postal,
                        site_country: record.site_country
                    });
                });
            }
            $log.debug('Existing Addresses', vm.addresses);
        }

        function loadAddress() {
            vm.form.site_address = vm.form.address.site_address;
            vm.form.site_city = vm.form.address.site_city;
            vm.form.site_state = vm.form.address.site_state;
            vm.form.site_postal = vm.form.address.site_postal;
        }

        function expandComments() {
            $aside.open({
                templateUrl: 'asideComments.html',
                placement: 'left',
                size: 'full',
                backdrop: true,
                controller: function ($scope, $uibModalInstance) {
                    $scope.ok = function (e) {
                        $uibModalInstance.close();
                        e.stopPropagation();
                        saveComments($scope.comments);
                    };
                    $scope.cancel = function (e) {
                        $uibModalInstance.dismiss();
                        e.stopPropagation();
                    };
                }
            });
        }

        function saveComments(comments) {
            vm.form.comments = comments;
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.inventory')
        .factory('InventoryCategory', InventoryCategory);

    /** @ngInject */
    function InventoryCategory($log, $q, API) {

        var api = {
            GET: 'inventory/categories/?page='
        };
        
        var factory = {
            getAll: getAll,
            get: get,
            save: save,
            update: update,
            'delete': deleteRequest,
            api: api
        };

        return factory;

        function getAll() {
            var deferred = $q.defer();
            API.getRequest('inventory/categories').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function get(identity) {
            var deferred = $q.defer();
            API.getRequest('inventory/categories?identity=' + identity).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function save(payload) {
            var deferred = $q.defer();
            API.postRequest('inventory/categories', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function update(payload) {
            var deferred = $q.defer();
            API.putRequest('inventory/categories', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function deleteRequest(identity) {
            var deferred = $q.defer();
            API.deleteRequest('inventory/categories?identity='+identity).then(function(response) {
                deferred.resolve(response);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('app.industry', []);

})();
(function() {
    'use strict';

    angular
        .module('app.industry')
        .factory('Industry', Industry);

    /** @ngInject */
    function Industry($log, $q, API) {
        
        var api = {
            GET: 'industries/?page='
        };

        var factory = {
            getAll: getAll,
            // getDeleted: getAllDeleted,
            // get: get,
            // save: save,
            // update: update,
            // 'delete': deleteRequest,
            api: api
        };

        return factory;

        // function getAllDeleted() {
        //     var deferred = $q.defer();
        //     API.getRequest('companies/deleted').then(function(response) {
        //         $log.debug('[Industry] getAllDeleted()', response);
        //         deferred.resolve(response.data);

        //     }, function(response) {
        //         $log.error('[Industry] getAllDeleted()', response);
        //         deferred.resolve();
        //     });
        //     return deferred.promise;
        // }

        function getAll() {
            var deferred = $q.defer();
            API.getRequest('industries').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        // function get(identity) {
        //     var deferred = $q.defer();
        //     API.getRequest('users?identity=' + identity).then(function(response) {
        //         $log.debug('[Industry] get()', response);
        //         deferred.resolve(response.data);
        //     }, function(response) {
        //         $log.error('[Industry] get()', response);
        //         deferred.resolve(response.data);
        //     });
        //     return deferred.promise;
        // }

        // function save(payload) {
        //     var deferred = $q.defer();
        //     API.postRequest('companies', payload).then(function(response) {
        //         $log.debug('[Industry] save()', response);
        //         deferred.resolve(response.data);
        //     }, function(response) {
        //         $log.error('[Industry] save()', response);
        //         deferred.resolve();
        //     });
        //     return deferred.promise;
        // }

        // function update(payload) {
        //     var deferred = $q.defer();
        //     API.putRequest('users', payload).then(function(response) {
        //         $log.debug('[Industry] update()', response);
        //         deferred.resolve(response);
        //     }, function(response) {
        //         $log.error('[Industry] update()', response);
        //         deferred.resolve();
        //     });
        //     return deferred.promise;
        // }

        // function deleteRequest(identity) {
        //     var deferred = $q.defer();
        //     API.deleteRequest('users?identity='+identity).then(function(response) {
        //         $log.debug('[Industry] delete()', response);
        //         deferred.resolve(response);
        //     }, function(response) {
        //         $log.error('[Industry] delete()', response);
        //         deferred.resolve();
        //     });
        //     return deferred.promise;
        // }

    }

})();
(function() {
    'use strict';

    angular.module('app.employee')
        .factory('Employee', Employee);

    /** @ngInject */
    function Employee($log, $q, API) {
        
        var api = {
            GET: 'users/?page='
        };

        var factory = {
            getAll: getAll,
            get: get,
            save: save,
            update: update,
            api: api
        };

        return factory;
        
        function getAll() {
            var deferred = $q.defer();
            API.getRequest('users').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[User] getAll()', response);
                deferred.resolve();
            });
            return deferred.promise;
        }

        function get(identity) {
            var deferred = $q.defer();
            API.getRequest('users?identity=' + identity).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[Employees] get()', response);
                deferred.reject(response.data);
            });
            return deferred.promise;
        }

        function save(payload) {
            var deferred = $q.defer();
            API.postRequest('users', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function update(payload) {
            var deferred = $q.defer();
            API.putRequest('users', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[Users] update()', response);
                deferred.reject(response);
            });
            return deferred.promise;
        }

    }

})();
(function() {
    'use strict';

    angular.module('app')
        .factory('EmployeeShift', EmployeeShift);

    /** @ngInject */
    function EmployeeShift($log, $q, API) {
        
        var api = {
             GET: 'users/shifts/?page='
        };

        var factory = {
            getAll: getAll,
            get: get,
            save: save,
            update: update,
            'delete': deleteRequest,
            api: api
        };

        return factory;

        function getAll() {
            var deferred = $q.defer();
            API.getRequest('users/shifts').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function get(identity) {
            var deferred = $q.defer();
            API.getRequest('users/shifts?identity=' + identity).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function save(payload) {
            var deferred = $q.defer();
            API.postRequest('users/shifts', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function update(payload) {
            var deferred = $q.defer();
            API.putRequest('users/shifts', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function deleteRequest(identity) {
            var deferred = $q.defer();
            API.deleteRequest('users/shifts?identity='+identity).then(function(response) {
                deferred.resolve(response);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

    }

})();
(function() {
    'use strict';

    angular.module('app.employee')
        .factory('EmployeeRole', EmployeeRole);

    /** @ngInject */
    function EmployeeRole($log, $q, API) {

        var factory = {
            getAll: getAll,
            getDeleted: getAllDeleted,
            get: get,
            save: save,
            update: update,
            'delete': deleteRequest
        };

        return factory;

        function getAllDeleted() {
            var deferred = $q.defer();
            API.getRequest('employees/roles/deleted').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function getAll() {
            var deferred = $q.defer();
            API.getRequest('employees/roles').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function get(identity) {
            var deferred = $q.defer();
            API.getRequest('employees/roles?identity=' + identity).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function save(payload) {
            var deferred = $q.defer();
            API.postRequest('employees/roles', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function update(payload) {
            var deferred = $q.defer();
            API.putRequest('employees/roles', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function deleteRequest(identity) {
            var deferred = $q.defer();
            API.deleteRequest('employees/roles?identity='+identity).then(function(response) {
                deferred.resolve(response);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

    }

})();
(function() {
    'use strict';

    angular.module('app.employee')
        .factory('EmployeePosition', EmployeePosition);

    /** @ngInject */
    function EmployeePosition($log, $q, API) {

        var api = {
            GET: 'users/positions/?page='
        };

        var factory = {
            getAll: getAll,
            get: get,
            save: save,
            update: update,
            'delete': deleteRequest,
            api: api
        };

        return factory;

        function getAll() {
            var deferred = $q.defer();
            API.getRequest('users/positions').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function get(identity) {
            var deferred = $q.defer();
            API.getRequest('users/positions?identity=' + identity).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function save(payload) {
            var deferred = $q.defer();
            API.postRequest('users/positions', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function update(payload) {
            var deferred = $q.defer();
            API.putRequest('users/positions', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function deleteRequest(identity) {
            var deferred = $q.defer();
            API.deleteRequest('users/positions?identity='+identity).then(function(response) {
                deferred.resolve(response);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

    }

})();
(function() {
    'use strict';

    angular.module('app.employee')
        .factory('EmployeeDepartment', EmployeeDepartment);

    /** @ngInject */
    function EmployeeDepartment($log, $q, API) {
        
        var api = {
            GET: 'users/departments/?page='
        };

        var factory = {
            getAll: getAll,
            get: get,
            save: save,
            update: update,
            'delete': deleteRequest,
            api: api
        };

        return factory;

        function getAll() {
            var deferred = $q.defer();
            API.getRequest('users/departments').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function get(identity) {
            var deferred = $q.defer();
            API.getRequest('users/departments?identity=' + identity).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function save(payload) {
            var deferred = $q.defer();
            API.postRequest('users/departments', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function update(payload) {
            var deferred = $q.defer();
            API.putRequest('users/departments', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function deleteRequest(identity) {
            var deferred = $q.defer();
            API.deleteRequest('users/departments?identity='+identity).then(function(response) {
                deferred.resolve(response);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('app.dashboard', []);

})();

(function() {
    'use strict';

    angular
        .module('app.dashboard')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {

        $stateProvider

            .state('app.dashboard', {
                url: '/dashboard',
                templateUrl: '/app/dashboard/dashboard.html',
                controller: 'DashboardController',
                controllerAs: 'vm',
                title: 'Dashboard',
                ncyBreadcrumb: {
                    label: 'Dashboard'
                },
                resolve: {
                    /** @ngInject */
                    statsResolve: function(Dashboard) {
                        return Dashboard.getStats();
                    }
                }
            });

    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .factory('Dashboard', Dashboard);

    /** @ngInject */
    function Dashboard($log, $q, API) {

        var factory = {
            getStats: getStats
        };

        return factory;

        function getStats() {
            var deferred = $q.defer();
            API.getRequest('dashboard').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController(Dashboard, statsResolve, $log) {
        
        var vm = this;
        
        vm.stats = statsResolve;
        vm.computePercent = computePercent;
        
        function computePercent(last, now) {
            var percent = (now - last) / last * 100;
            if(!isFinite(percent) && !isNaN(percent))
                return '∞';
            if(isNaN(percent))
                return '—';
            return percent + '%';
        }
        
    }

})();

(function() {
    'use strict';

    angular.module('app.contact')
        .factory('Contact', Contact);

    /** @ngInject */
    function Contact($log, $q, API) {
        
        var api = {
            GET: 'contacts/?page='
        };

        var factory = {
            getAll: getAll,
            getDeleted: getAllDeleted,
            get: get,
            save: save,
            update: update,
            'delete': deleteRequest,
            api: api
        };

        return factory;

        function getAllDeleted() {
            var deferred = $q.defer();
            API.getRequest('contacts/deleted').then(function(response) {
                deferred.resolve(response.data);

            }, function(response) {
                $log.error('[Contacts] getAllDeleted()', response);
                deferred.resolve();
            });
            return deferred.promise;
        }
        
        function getAll() {
            var deferred = $q.defer();
            API.getRequest('contacts').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[Contacts] getAll()', response);
                deferred.reject(response);
            });
            return deferred.promise;
        }
        
        

        function get(identity) {
            var deferred = $q.defer();
            API.getRequest('contacts?identity=' + identity).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[Contacts] get()', response);
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function save(payload) {
            var deferred = $q.defer();
            API.postRequest('contacts', payload).then(function(response) {
                $log.debug('[Contacts] save()', response);
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[Contacts] save()', response);
                deferred.resolve();
            });
            return deferred.promise;
        }

        function update(payload) {
            var deferred = $q.defer();
            API.putRequest('contacts', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[Contacts] update()', response);
                deferred.resolve();
            });
            return deferred.promise;
        }

        function deleteRequest(identity) {
            var deferred = $q.defer();
            API.deleteRequest('contacts?identity='+identity).then(function(response) {
                deferred.resolve(response);
            }, function(response) {
                $log.error('[Contacts] delete()', response);
                deferred.resolve();
            });
            return deferred.promise;
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('app.company', []);

})();
(function() {
    'use strict';

    angular
        .module('app.company')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {

        $stateProvider

            .state('app.company', {
                url: '/company',
                template: '<ui-view/>',
                title: 'Company',
                ncyBreadcrumb: {
                    label: 'Company'
                }
            })

            .state('app.company.search', {
                url: '/search',
                templateUrl: '/app/companies/company-search.html',
                controller: 'CompanySearchController',
                controllerAs: 'vm',
                title: 'Customer Search',
                ncyBreadcrumb: {
                    label: 'Customer Search'
                },
                resolve: {
                    /** @ngInject */
                    companyResolve: function(Company) {
                        return Company.getAll();
                    }
                }
            });
            
    }

})();

(function() {
    'use strict';

    angular
        .module('app.company')
        .factory('Company', Company);

    /** @ngInject */
    function Company($log, $q, API) {
        
        var api = {
            GET: 'companies/?page='
        };

        var factory = {
            // API Functions
            getAll: getAll,
            getDeleted: getAllDeleted,
            get: get,
            save: save,
            update: update,
            'delete': deleteRequest,
            api: api
        };

        return factory;

        function getAllDeleted() {
            var deferred = $q.defer();
            API.getRequest('companies/deleted').then(function(response) {
                deferred.resolve(response.data);

            }, function(response) {
                $log.error('[Companies] getAllDeleted()', response);
                deferred.reject();
            });
            return deferred.promise;
        }

        function getAll() {
            var deferred = $q.defer();
            API.getRequest('companies').then(function(response) {
                deferred.resolve(response.data);

            }, function(response) {
                $log.error('[Companies] getAll()', response);
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function get(identity) {
            var deferred = $q.defer();
            API.getRequest('companies?identity=' + identity).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[Companies] get()', response);
                deferred.reject(response.data);
            });
            return deferred.promise;
        }

        function save(payload) {
            var deferred = $q.defer();
            API.postRequest('companies', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[Companies] save()', response);
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function update(payload) {
            var deferred = $q.defer();
            API.putRequest('companies', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[Companies] update()', response);
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function deleteRequest(identity) {
            var deferred = $q.defer();
            API.deleteRequest('companies?identity='+identity).then(function(response) {
                deferred.resolve(response);
            }, function(response) {
                $log.error('[Companies] delete()', response);
                deferred.reject();
            });
            return deferred.promise;
        }



    }

})();
(function() {
    'use strict';

    angular.module('app')
        .factory('CompanyStatus', CompanyStatus);

    /** @ngInject */
    function CompanyStatus($log, $q, API) {

        var api = {
            GET: 'companies/statuses/?page='
        };

        var factory = {
            getAll: getAll,
            get: get,
            save: save,
            update: update,
            'delete': deleteRequest,
            api: api
        };

        return factory;

        function getAll() {
            var deferred = $q.defer();
            API.getRequest('companies/statuses').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function get(identity) {
            var deferred = $q.defer();
            API.getRequest('companies/statuses?identity=' + identity).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function save(payload) {
            var deferred = $q.defer();
            API.postRequest('companies/statuses', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function update(payload) {
            var deferred = $q.defer();
            API.putRequest('companies/statuses', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function deleteRequest(identity) {
            var deferred = $q.defer();
            API.deleteRequest('companies/statuses?identity='+identity).then(function(response) {
                deferred.resolve(response);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

    }

})();
(function() {
    'use strict';

    angular.module('app.company')
        .controller('CompanySearchController', CompanySearchController);

    /** @ngInject */
    function CompanySearchController($log, $scope, $state, $aside, ngNotify, _, $filter, SweetAlert, Inventory, Confirmation, Reservation, API, companyResolve, CompanyClassification, Company) {

        var vm = this;

        vm.confirmationAside = false;
        vm.reservationAside = false;

        vm.companies = [].concat(companyResolve.data);
        vm.classifications = [];

        vm.confirmations = [];
        vm.reservations = [];

        vm.confirmationPlaceholder = {
            collection: vm.confirmations,
            title: 'No Confirmations',
            message: 'There are currently no confirmations.',
            // button_text: 'Create 1<sup>st</sup> Confirmation',
            // button_action: function() {
            //     vm.confirmationAside = true;
            // }
        };

        vm.reservationPlaceholder = {
            collection: function() {
                return vm.confirmations
            },
            title: 'No Reservations',
            message: 'There are currently no reservations.',
            // button_text: 'Create 1<sup>st</sup> Reservation',
            // button_action: function() {
            //     vm.reservationAside = true;
            // }
        };

        vm.loadCompany = loadCompany;
        vm.customerSince = customerSince;
        vm.selectEquipment = selectEquipment;
        vm.showUpdateReservation = showUpdateReservation;
        vm.showUpdateConfirmation = showUpdateConfirmation;
        vm.formatDate = formatDate;

        constructor();

        function constructor() {
            loadRemainingCompanies();
            loadClassifications();
        }

        function loadRemainingCompanies() {
            if(companyResolve.meta.pagination.current_page < companyResolve.meta.pagination.total_pages) {
                API.query(Company.api.GET  + (companyResolve.meta.pagination.current_page + 1)).then(function() {},
                function(response) {
                    $log.error('There was an issue loading companies.', response);
                }, function(companies) {
                    vm.companies = vm.companies.concat(companies);
                });
            }
        }

        function loadClassifications() {
            API.query(CompanyClassification.api.GET + 1).then(function() {},
            function(response) {
                $log.error('There was an issue loading company classifications.', response);
            }, function(classifications) {
               vm.classifications = vm.classifications.concat(classifications);
            });
        }

        function loadCompany() {
            vm.company = _.find(vm.companies, function(company) {
                return company.identity === vm.form.company;
            });
            vm.reservations = _.filter(vm.company.reservations, function(reservation) {
                return !reservation.confirmation;
            });
            vm.displayedReservations = [].concat(vm.reservations);
            vm.confirmations = _.filter(vm.company.reservations, function(reservation) {
                return reservation.confirmation;
            });
            vm.displayedConfirmations = [].concat(vm.confirmations);

            vm.fuelLogs = vm.company.fuel_logs;
            vm.displayedFuelLogs = [].concat(vm.fuelLogs);

            $log.debug('Reservations', vm.reservations);
            $log.debug('Confirmations', vm.confirmations);
            $log.debug('Company', vm.company);
        }

        function formatDate(dateString) {
            return new Date(dateString);
        }

        function customerSince() {
            if(!vm.company)
                return '';
            return $filter('date')(vm.company.created_at, 'MMMM d, yyyy');
        }

        function selectEquipment() {
            ngNotify.set('You are selecting equipment/inventory items for <strong>'+vm.company.name+'</strong>.', {
                type: 'info',
                sticky:true,
                html:true
            });
            $state.go('app.inventory.search', {company:vm.form.company});
        }

        function showUpdateReservation(reservation) {
            $log.debug('ITEM', reservation);
            $aside.open({
                templateUrl: 'asideReservation.html',
                placement: 'right',
                size: 'md',
                backdrop: true,
                controller: function ($scope, $uibModalInstance) {

                    $scope.companies = vm.companies;

                    $scope.status = reservation.item.status.name;

                    $log.debug('Scope Status', $scope.status);

                    $scope.form = {
                        identity: reservation.identity,
                        company : reservation.company.identity,
                        item : reservation.item.identity,
                        site_address : reservation.site_address,
                        site_city : reservation.site_city,
                        site_state : reservation.site_state,
                        site_postal: reservation.site_postal,
                        expected_on_rent : new Date(reservation.expected_on_rent),
                        expected_off_rent : new Date(reservation.expected_off_rent)
                    };

                    loadAsideCompany(function() {
                        $scope.form.contact = reservation.contact.identity;
                        loadAsideContact();
                    });

                    $scope.loadCompany = loadAsideCompany;
                    $scope.loadContact = loadAsideContact;

                    $scope.on_rent = {
                        opened: false,
                        options : {
                            formatYear: 'yyyy',
                            minDate: new Date(),
                            startingDay: 1,
                            showWeeks: false
                        },
                        format: 'MM/dd/yyyy'
                    };

                    $scope.off_rent = {
                        opened: false,
                        options : {
                            formatYear: 'yyyy',
                            minDate: new Date(),
                            startingDay: 1,
                            showWeeks: false
                        },
                        format: 'MM/dd/yyyy'
                    };

                    $scope.on_rent.open = function() {
                        $scope.on_rent.opened = true;
                    }

                    $scope.off_rent.open = function() {
                        $scope.off_rent.opened = true;
                    }

                    function loadAsideCompany(callback) {
                        var company = _.find($scope.companies, function(company) {
                            return company.identity === $scope.form.company;
                        });
                        $scope.contacts = company.contacts;
                        if(callback)
                            callback();
                    }

                    function loadAsideContact(callback) {
                        var contact = _.find($scope.contacts, function(contact) {
                            return contact.identity == $scope.form.contact;
                        });
                        if(contact && contact.office_phone)
                            $scope.form.phone = contact.office_phone;
                        if(callback)
                            callback();
                    }

                    $scope.confirm = function(e) {
                        SweetAlert.swal({
                            title: 'Are you sure?',
                            text: 'Do you want to confirm this reservation?',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#58B957',
                            confirmButtonText: 'Yes',
                            closeOnConfirm: true
                        },
                        function(isConfirm) {
                            if (isConfirm) {
                                $uibModalInstance.close();
                                e.stopPropagation();
                                $scope.form.confirmation = true;
                                confirmReservation(reservation, $scope.form);
                            }
                        });
                    }
                    $scope.ok = function (e) {
                        $uibModalInstance.close();
                        e.stopPropagation();
                        updateReservation(reservation, $scope.form);
                    };
                    $scope.cancel = function (e) {
                        $uibModalInstance.dismiss();
                        e.stopPropagation();
                    };
                }
            });
        }

        function updateReservation(item, form) {
            Reservation.update(form).then(function(record) {
                vm.reservations.splice(vm.reservations.indexOf(item));
                vm.reservations.push(record);
                vm.displayedReservations.splice(vm.displayedReservations.indexOf(item));
                vm.displayedReservations.push(record);
                if(record) {
                    SweetAlert.swal("Updated!", 'You have updated reservation #' + record.item_number + '.', "success");
                }
                else {
                    SweetAlert.swal("Error!", 'There was an issue updating the reservation. Please contact support.', "error");
                }
            });
        }

        function confirmReservation(item, form) {
            Reservation.update(form).then(function(record) {
                vm.reservations.splice(vm.reservations.indexOf(item));
                vm.reservations.push(record);
                vm.displayedReservations.splice(vm.displayedReservations.indexOf(item));
                vm.displayedReservations.push(record);
                if(record) {
                    SweetAlert.swal("Confirmed!", 'You have confirmed reservation #' + record.item_number + '.', "success");
                }
                else {
                    SweetAlert.swal("Error!", 'There was an issue confirming the reservation. Please contact support.', "error");
                }
            });
        }

        function showUpdateConfirmation(reservation) {
            $aside.open({
                templateUrl: 'asideConfirmation.html',
                placement: 'right',
                size: 'sm',
                backdrop: true,
                controller: function ($scope, $uibModalInstance) {

                    $scope.options = [{
                        text: 'Off Rent',
                        value: 'Off Rent',
                        selected: reservation.item.status.name == 'Off Rent' ? true : false
                    }, {
                        text: 'Delivered',
                        value: 'Delivered',
                        selected: reservation.item.status.name == 'On Rent' ? true : false
                    }];

                    $scope.form = {
                        identity: reservation.identity,
                        asset : reservation.item.asset,
                        description : reservation.item.description
                    };
                    $scope.ok = function (e) {
                        $uibModalInstance.close();
                        e.stopPropagation();
                        $scope.form.status = _.find($scope.options, function(option) {
                            return option.selected && option.selected == true;
                        }).value;
                        updateConfirmation($scope.form);
                    };
                    $scope.cancel = function (e) {
                        $uibModalInstance.dismiss();
                        e.stopPropagation();
                    };
                }
            });
        }

        function updateConfirmation(form) {
            $log.debug('Sending', form);
            Confirmation.updateStatus(form).then(function(record) {
                $log.debug('Record', record);
                if(record) {
                    SweetAlert.swal("Updated!", 'You have updated confirmation #' + record.item_number + '.', "success");
                }
                else {
                    SweetAlert.swal("Error!", 'There was an issue updating the confirmation. Please contact support.', "error");
                }
            });
        }
    }

})();

(function() {
    'use strict';

    angular.module('app.company')
        .factory('CompanyClassification', CompanyClassification);

    /** @ngInject */
    function CompanyClassification($log, $q, API) {
        
        var api = {
            GET: 'companies/classifications/?page='
        };

        var factory = {
            getAll: getAll,
            getDeleted: getAllDeleted,
            get: get,
            save: save,
            update: update,
            'delete': deleteRequest,
            api: api
        };

        return factory;

        function getAllDeleted() {
            var deferred = $q.defer();
            API.getRequest('companies/classifications/deleted').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function getAll() {
            var deferred = $q.defer();
            API.getRequest('companies/classifications').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function get(identity) {
            var deferred = $q.defer();
            API.getRequest('companies/classifications?identity=' + identity).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function save(payload) {
            var deferred = $q.defer();
            API.postRequest('companies/classifications', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function update(payload) {
            var deferred = $q.defer();
            API.putRequest('companies/classifications', payload).then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function deleteRequest(identity) {
            var deferred = $q.defer();
            API.deleteRequest('companies/classifications?identity='+identity).then(function(response) {
                deferred.resolve(response);
            }, function(response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('app.auth', []);

})();

(function() {
    'use strict';

    angular
        .module('app.auth')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($log, SweetAlert, Auth, $rootScope, $state) {
        var vm = this;

        vm.submitted = false;
        vm.login = login;
        vm.form = {
            email: '',
            password: ''
        };

        function login() {
            vm.submitted = true;
            if(vm.loginForm.$valid) {
                Auth.attemptLogin(vm.form).then(function(response) {
                    sessionStorage.setItem('token', response.token);
                    Auth.getAuthUser().then(function(response) {
                        $rootScope.user = response.user;
                        $state.go('app.dashboard');
                    });
                }, function(response) {
                    if(response.status === 401) {
                        if (response.data.attempts==5){
                         SweetAlert.swal({
                            title: "Account Locked",
                            text: "You are out of attempts. This account has been locked for 15 minutes.",
                            type: "error",
                            confirmButtonColor: "#007AFF"
                         });
                        }
                        else {
                         SweetAlert.swal({
                            title: "Invalid Credentials",
                            text: "You have used attempt "+response.data.attempts+" of 5.",
                            type: "error",
                            confirmButtonColor: "#007AFF"
                         });
                        }
                    }
                    if(response.status === 423) {
                         SweetAlert.swal({
                            title: "Account Locked",
                            text: "This account has been locked for 15 minutes.",
                            type: "error",
                            confirmButtonColor: "#007AFF"
                        });
                    }
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app.auth')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {

        $stateProvider

            .state('auth', {
                url: '/auth',
                template: '<ui-view/>',
                abstract: true
            })

            .state('auth.login', {
                url: '/login',
                templateUrl: '/app/auth/login.html',
                controller: 'LoginController',
                controllerAs: 'vm'
            })

            .state('auth.logout', {
                url: '/logout',
                controller: function($state) {
                    sessionStorage.removeItem('token');
                    $state.go('auth.login');
                },
                controllerAs: 'vm'
            });

    }

})();

(function() {
    'use strict';

    angular.module('app.auth')
        .factory('Auth', Auth);

    /** @ngInject */
    function Auth($log, $q, API) {

        var factory = {
            getAuthUser: getAuthUser,
            attemptLogin: attemptLogin
        };

        return factory;

        function getAuthUser() {
            var deferred = $q.defer();
            API.getRequest('authenticate/user').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('Error loading authorized user.', response);
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function attemptLogin(payload) {
            var deferred = $q.defer();
            API.postRequest('authenticate/auth', payload).then(function(response) {
                $log.debug('[Auth] attemptLogin()', response);
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[Auth] attemptLogin()', response);
                deferred.reject(response);
            });
            return deferred.promise;
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .run(runBlock);

    /** @ngInject */
    function runBlock($log, $rootScope, $state, $stateParams, Page) {

        // Set some reference to access them from any scope
        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;

        // GLOBAL APP SCOPE
        // set below basic information
        $rootScope.app = {
            name: 'InsightFlow', // name of your project
            author: 'GDC Total Business Solutions', // author's name or company name
            description: '', // brief description
            version: '1.6.0', // current version
            year: ((new Date()).getFullYear()), // automatic current year (for copyright information)
            isMobile: (function() { // true if the browser is a mobile device
                var check = false;
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    check = true;
                }
                return check;
            })(),
            defaultLayout: {
                isNavbarFixed: true, //true if you want to initialize the template with fixed header
                isSidebarFixed: true, // true if you want to initialize the template with fixed sidebar
                isSidebarClosed: false, // true if you want to initialize the template with closed sidebar
                isFooterFixed: false, // true if you want to initialize the template with fixed footer
                isBoxedPage: false, // true if you want to initialize the template with boxed layout
                theme: 'lyt4-theme-1', // indicate the theme chosen for your project
                logo: 'assets/images/logo.png', // relative path of the project logo
                logoCollapsed: 'assets/images/logo-collapsed.png' // relative path of the collapsed logo
            },
            layout: ''
        };
        $rootScope.app.layout = angular.copy($rootScope.app.defaultLayout);

        $rootScope.$on('$stateChangeStart', stateChangeListener);

        $rootScope.hasAccess = hasAccess;

        function stateChangeListener(event, toState, toParams, fromState, fromParams) {
            Page.updateStateListener(event, toState, toParams, fromState, fromParams);
        }

        function hasAccess(state) {
            return Page.hasAccess($rootScope.user, state);
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider, PageProvider) {
        
        $urlRouterProvider.otherwise('/app/dashboard');

        $stateProvider
            .state('app', {
                url: '/app',
                abstract: true,
                templateUrl: '/app/main/main.html',
                resolve: {
                    authUser : authUserResolve,
                    roleResolve: PageProvider.roleResolve
                }
            })
            .state('403', {
                url: '/403',
                templateUrl: '/app/auth/403.html'
            });
            
            
       /** @ngInject */
       function authUserResolve(API) {
           return API.get('authenticate/user');
       }

    }

})();

/* global */
(function() {
    'use strict';

    angular
        .module('app')
        .constant('APP_MEDIAQUERY', {
            'desktopXL': 1200,
            'desktop': 992,
            'tablet': 768,
            'mobile': 480
        });

})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(translationConfig)
        .config(localStorageConfig)
        .config(cfgLoadingBarConfig)
        .config(breadcrumbConfig);

    /** @ngInject */
    function translationConfig($logProvider, $translateProvider) {
        // Enable log
        $logProvider.debugEnabled(true);

        // prefix and suffix information  is required to specify a pattern
        // You can simply use the static-files loader with this pattern:
        $translateProvider.useStaticFilesLoader({
            prefix: 'assets/i18n/',
            suffix: '.json'
        });

        // Since you've now registered more then one translation table, angular-translate has to know which one to use.
        // This is where preferredLanguage(langKey) comes in.
        $translateProvider.preferredLanguage('en');

        // Store the language in the local storage
        $translateProvider.useLocalStorage();

        // Enable sanitize
        $translateProvider.useSanitizeValueStrategy('sanitize');

    }

    function localStorageConfig($localStorageProvider) {
        $localStorageProvider.setKeyPrefix('InsightFlow');
    }

    function cfgLoadingBarConfig(cfpLoadingBarProvider) {
        cfpLoadingBarProvider.includeBar = true;
        cfpLoadingBarProvider.includeSpinner = false;
    }

    function breadcrumbConfig($breadcrumbProvider) {
        $breadcrumbProvider.setOptions({
            template: '<ul class="breadcrumb"><li><a ui-sref="app.dashboard"><i class="fa fa-home margin-right-5 text-large text-dark"></i>Home</a></li><li ng-repeat="step in steps">{{step.ncyBreadcrumbLabel}}</li></ul>'
        });
    }
    
     angular
        .module('smart-table')
        .run(smartTableConfig);

    /**
     * Injects a custom pagination template, overriding smart table's default template
     * @ngInject
     * @param  {[type]} $templateCache [description]
     */
    function smartTableConfig($templateCache) {
        $templateCache.put('template/smart-table/pagination.html', [
            '<div class="pagination core--table--footer" ng-if="pages.length >= 2">',
                '<ul class="pagination">',
                    '<li ng-class="{ active: currentPage == 1 }">',
                        '<a ng-click="selectPage(1)">',
                            '<span aria-hidden="true">1</span>',
                        '</a>',
                    '</li>',
                    '<li>',
                        '<a ng-click="selectPage(currentPage-1)" aria-label="Previous" ng-if="currentPage != 1 && numPages > 4">',
                            '<span aria-hidden="true">&larr;</span>',
                        '</a>',
                    '</li>',
                    '<li ng-repeat="page in pages" ng-class="{ active: page == currentPage }" ng-if="page != 1 && page != numPages">',
                        '<a ng-click="selectPage(page)">{{ page }}</a>',
                    '</li>',
                    '<li>',
                        '<a ng-click="selectPage(currentPage+1)" ng-if="currentPage != numPages && numPages > 4">',
                            '<span aria-hidden="true">&rarr;</span>',
                        '</a>',
                    '</li>',
                    '<li ng-class="{ active: currentPage == pages.length }">',
                        '<a href="" ng-click="selectPage(numPages)" aria-label="Last">',
                            '<span aria-hidden="true">{{ numPages }}</span>',
                        '</a>',
                    '</li>',
                '</ul>',
            '</div>'
        ].join(''));
    }

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("/app/auth/403.html","<div class=\"page-error\"><div class=\"error-number text-red\">403</div><h1 class=\"text-red\">Access Denied</h1><div class=\"error-details top-spacer-1\"><h4>Please contact your administrator to receive access to this page.</h4><button type=\"button\" ui-sref=\"auth.login\" class=\"btn btn-danger\">Return to Login</button></div></div>");
$templateCache.put("/app/auth/login.html","<div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><div class=\"login-container\"><div class=\"text-center\"><div class=\"logo\"><img ng-src=\"{{app.layout.logo}}\" alt=\"{{app.name}}\" width=\"200px\"></div><p class=\"text-extra-large top-spacer-1\">Login to access your InsightFlow account.</p></div><form name=\"vm.loginForm\" ng-submit=\"vm.login()\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{\'has-error\' : vm.submitted && vm.loginForm.email.$invalid}\"><label class=\"control-label\">Email</label> <input type=\"text\" class=\"input-lg form-control\" ng-model=\"vm.form.email\" name=\"email\" required=\"\" placeholder=\"Email Address\" ng-enter=\"vm.login()\"><div class=\"help-block\" ng-if=\"vm.submitted && vm.loginForm.email.$invalid\"><p class=\"text-danger\">Please enter a valid email address.</p></div></div><div class=\"form-group\" ng-class=\"{\'has-error\' : vm.submitted && vm.loginForm.email.$invalid}\"><label class=\"control-label\">Password</label> <input type=\"password\" class=\"input-lg form-control\" ng-model=\"vm.form.password\" name=\"password\" required=\"\" placeholder=\"Password\" ng-enter=\"vm.login()\"><div class=\"help-block\" ng-if=\"vm.submitted && vm.loginForm.password.$invalid\"><p class=\"text-danger\">Please enter a password.</p></div></div><div class=\"form-group\"><button type=\"button\" ng-click=\"vm.login()\" class=\"btn btn-success btn-lg btn-block\">Log in</button></div></form></div><p class=\"text-center top-spacer-1\">&copy; {{app.year}} <span class=\"text-bold text-uppercase\">{{ app.author }}</span>. <span translate=\"footer.copyright.MESSAGE\">All rights reserved</span></p></div></div>");
$templateCache.put("/app/companies/company-search.html","<div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"companies.search.title\">Customer Search</h4><span class=\"mainDescription\" translate=\"companies.search.description\">Quickly search and find customer information. You can create a new order or reservation, once a customer has been selected.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div class=\"container-fluid container-fullw\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"text-right margin-bottom-10\"><a company-aside=\"vm.companies\" class=\"btn btn-primary\">Create Company</a></div><uib-tabset class=\"tabbable\"><uib-tab heading=\"Customer Details\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">Company Name</label><select class=\"form-control\" chosen=\"\" ng-change=\"vm.loadCompany()\" data-placeholder=\"Select a company\" ng-model=\"vm.form.company\" no-results-text=\"\'There are no companies.\'\" ng-options=\"company.identity as company.name for company in vm.companies\"><option value=\"\"></option></select></div><div class=\"form-group\"><label class=\"control-label\">Customer Number</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Enter a customer number\" ng-model=\"vm.form.company\" no-results-text=\"\'There are no companies.\'\" ng-options=\"company.identity as company.customer_number for company in vm.companies\"><option value=\"\"></option></select></div><div class=\"form-group\"><label class=\"control-label\">Classifications</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select a company classification\" ng-model=\"vm.form.classification\" no-results-text=\"\'There are no company classifications.\'\" ng-options=\"classification.identity as classification.name for classification in vm.classifications\"><option value=\"\"></option></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">Billing Address</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.company.billing_address\" readonly=\"\" disabled=\"\"></div><div class=\"form-group\"><label class=\"control-label\">City</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.company.billing_city\" readonly=\"\" disabled=\"\"></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\">State</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.company.billing_state\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\">Zip Code</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.company.billing_postal\" readonly=\"\" disabled=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><label class=\"control-label\">Country</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.company.billing_country\" readonly=\"\" disabled=\"\"></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">Billing Contact Name</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.billing\" readonly=\"\" disabled=\"\"></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\">Email</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.billing\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\">Phone #</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.billing\" readonly=\"\" disabled=\"\"></div></div></div><div class=\"form-group\"><label class=\"control-label\">Customer Since</label> <input type=\"text\" class=\"form-control\" value=\"{{ vm.customerSince() }}\" readonly=\"\" disabled=\"\"></div><div class=\"text-right\" ng-show=\"vm.company\"><a company-aside=\"vm.companies\" identity=\"{{ ::vm.company.identity }}\" type=\"button\" class=\"btn btn-success\">Edit</a> <a ng-click=\"vm.selectEquipment()\" type=\"button\" class=\"btn btn-primary\">Select Equipment / Inventory Items</a></div></div></div></uib-tab><uib-tab heading=\"Order Details\" ng-show=\"vm.form.company\"><div class=\"row mt-10\"><div class=\"col-md-3 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\"># of current orders</label> <input type=\"text\" class=\"form-control\" disabled=\"\" readonly=\"\"></div><div class=\"form-group\"><label class=\"control-label\"># of orders YTD</label> <input type=\"text\" class=\"form-control\" disabled=\"\" readonly=\"\"></div><div class=\"form-group\"><label class=\"control-label\">Date of last order</label> <input type=\"text\" class=\"form-control\" disabled=\"\" readonly=\"\"></div></div><div class=\"col-md-3 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Days rented YTD</label> <input type=\"text\" class=\"form-control\" disabled=\"\" readonly=\"\"></div><div class=\"form-group\"><label class=\"control-label\">Average Rental Period</label> <input type=\"text\" class=\"form-control\" disabled=\"\" readonly=\"\"></div><div class=\"form-group\"><label class=\"control-label\">Customer downtime</label> <input type=\"text\" class=\"form-control\" disabled=\"\" readonly=\"\"></div></div><div class=\"col-md-3 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Top Products</label> <input type=\"text\" class=\"form-control\" disabled=\"\" readonly=\"\"></div><div class=\"form-group\"><label class=\"control-label\"></label> <input type=\"text\" class=\"form-control\" disabled=\"\" readonly=\"\"></div><div class=\"form-group\"><label class=\"control-label\"></label> <input type=\"text\" class=\"form-control\" disabled=\"\" readonly=\"\"></div></div><div class=\"col-md-3 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Credit Limit</label> <input type=\"text\" class=\"form-control\" disabled=\"\" readonly=\"\"></div><div class=\"form-group\"><label class=\"control-label\">Current Balance</label> <input type=\"text\" class=\"form-control\" disabled=\"\" readonly=\"\"></div></div></div><hr><div insight-placeholder=\"vm.confirmationPlaceholder\" ng-show=\"vm.confirmations.length < 1\"></div><div st-table=\"vm.displayedConfirmations\" st-safe-src=\"vm.confirmations\" ng-show=\"vm.confirmations.length > 0\"><table class=\"table table-hover\"><thead><tr><th st-sort-default=\"true\" st-skip-natural=\"true\" st-sort=\"item_number\">Customer Order #</th><th st-skip-natural=\"true\" st-sort=\"item.description\">Item Description</th><th st-skip-natural=\"true\" st-sort=\"\">Work Height (F)</th><th st-skip-natural=\"true\" st-sort=\"exected_on_rent\">On Rent Date</th><th st-skip-natural=\"true\" st-sort=\"exected_off_rent\">Off Rent Date</th><th st-skip-natural=\"true\" st-sort=\"site_address\">Location</th><th st-skip-natural=\"true\" st-sort=\"site_city\">City</th><th st-skip-natural=\"true\" st-sort=\"site_state\">State</th><th st-skip-natural=\"true\" st-sort=\"site_postal\">Zip Code</th><th st-skip-natural=\"true\" st-sort=\"contact.name\">On-Site Contact</th><th st-skip-natural=\"true\" st-sort=\"contact.office_phone\">Contact #</th></tr></thead><tbody><tr ng-if=\"!vm.displayedConfirmations && !vm.confirmations\"><td class=\"text-center\" colspan=\"12\">You need to select a company to load confirmations.</td></tr><tr ng-if=\"vm.displayedConfirmations.length == 0 && vm.confirmations.length > 0\"><td class=\"text-center\" colspan=\"12\">There are no orders that match your search criteria.</td></tr><tr ng-repeat=\"reservation in vm.displayedConfirmations\"><td>#{{ ::reservation.item_number }}</td><td>{{ ::reservation.item.description }}</td><td></td><td>{{ vm.formatDate(reservation.expected_on_rent) | date : \'MM/dd/yyyy\' }}</td><td>{{ vm.formatDate(reservation.expected_off_rent) | date : \'MM/dd/yyyy\' }}</td><td>{{ ::reservation.site_address }}</td><td>{{ ::reservation.site_city }}</td><td>{{ ::reservation.site_state }}</td><td>{{ ::reservation.site_postal }}</td><td>{{ ::reservation.contact.name }}</td><td>{{ ::reservation.contact.office_phone }}</td><td class=\"center\"><div class=\"visible-md visible-lg hidden-sm hidden-xs\"><a ng-click=\"vm.showUpdateConfirmation(reservation)\" class=\"btn btn-transparent btn-xs tooltips\" tooltip-placement=\"top\" uib-tooltip=\"Edit\"><i class=\"fa fa-pencil fa fa-white\"></i></a></div><div class=\"visible-xs visible-sm hidden-md hidden-lg\"><div class=\"btn-group dropdown\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-o btn-sm dropdown-toggle\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i>&nbsp;<span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right dropdown-light\" role=\"menu\"><li><a>Edit</a></li></ul></div></div></td></tr></tbody><tfoot ng-show=\"vm.displayedConfirmations.length > 9\"><tr><td colspan=\"12\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></uib-tab><uib-tab heading=\"Reservation Details\" ng-show=\"vm.form.company\"><div insight-placeholder=\"vm.reservationPlaceholder\" ng-show=\"vm.reservations.length < 1\"></div><div st-table=\"vm.displayedReservations\" st-safe-src=\"vm.reservations\" ng-show=\"vm.reservations.length > 0\"><table class=\"table table-hover\"><thead><tr><th st-sort-default=\"true\" st-skip-natural=\"true\" st-sort=\"item_number\">Customer Order #</th><th st-skip-natural=\"true\" st-sort=\"item.description\">Item Description</th><th st-skip-natural=\"true\" st-sort=\"\">Work Height (F)</th><th st-skip-natural=\"true\" st-sort=\"exected_on_rent\">On Rent Date</th><th st-skip-natural=\"true\" st-sort=\"exected_off_rent\">Off Rent Date</th><th st-skip-natural=\"true\" st-sort=\"site_address\">Location</th><th st-skip-natural=\"true\" st-sort=\"site_city\">City</th><th st-skip-natural=\"true\" st-sort=\"site_state\">State</th><th st-skip-natural=\"true\" st-sort=\"site_postal\">Zip Code</th><th st-skip-natural=\"true\" st-sort=\"contact.name\">On-Site Contact</th><th st-skip-natural=\"true\" st-sort=\"contact.office_phone\">Contact #</th><th></th></tr></thead><tbody><tr ng-if=\"vm.displayedReservations.length == 0 && vm.reservations.length > 0\"><td class=\"text-center\" colspan=\"12\">There are no reservations that match your search criteria.</td></tr><tr ng-repeat=\"reservation in vm.displayedReservations\"><td>#{{ ::reservation.item_number }}</td><td>{{ ::reservation.item.description }}</td><td></td><td>{{ vm.formatDate(reservation.expected_on_rent) | date : \'MM/dd/yyyy\' }}</td><td>{{ vm.formatDate(reservation.expected_off_rent) | date : \'MM/dd/yyyy\' }}</td><td>{{ ::reservation.site_address }}</td><td>{{ ::reservation.site_city }}</td><td>{{ ::reservation.site_state }}</td><td>{{ ::reservation.site_postal }}</td><td>{{ ::reservation.contact.name }}</td><td>{{ ::reservation.contact.office_phone }}</td><td class=\"center\"><div class=\"visible-md visible-lg hidden-sm hidden-xs\"><a ng-click=\"vm.showUpdateReservation(reservation)\" class=\"btn btn-transparent btn-xs tooltips\" tooltip-placement=\"top\" uib-tooltip=\"Edit\"><i class=\"fa fa-pencil fa fa-white\"></i></a></div><div class=\"visible-xs visible-sm hidden-md hidden-lg\"><div class=\"btn-group dropdown\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-o btn-sm dropdown-toggle\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i>&nbsp;<span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right dropdown-light\" role=\"menu\"><li><a>Edit</a></li></ul></div></div></td></tr></tbody><tfoot ng-show=\"vm.displayedReservations.length > 9\"><tr><td colspan=\"12\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></uib-tab><uib-tab heading=\"Fuel Logs\" ng-show=\"vm.form.company\"><div st-table=\"vm.displayedFuelLogs\" st-safe-src=\"vm.fuelLogs\"><table class=\"table table-hover\"><thead><tr><th st-sort-default=\"true\" st-skip-natural=\"true\" st-sort=\"created_at\">Created At</th><th st-skip-natural=\"true\" st-sort=\"amount\">Amount</th><th>Comments</th><th st-skip-natural=\"true\" st-sort=\"\">Created By</th><th></th></tr></thead><tbody><tr ng-if=\"vm.displayedFuelLogs.length == 0 && vm.fuelLogs.length > 0\"><td class=\"text-center\" colspan=\"4\">There are no fuel logs that match your search criteria.</td></tr><tr ng-if=\"vm.fuelLogs.length === 0\"><td class=\"text-center\" colspan=\"4\">There are currently no fuel logs for this company.</td></tr><tr ng-repeat=\"log in vm.displayedFuelLogs\"><td>{{ log.created_at | date: \'MM/dd/yyyy\' }}</td><td>{{ ::log.amount }}</td><td>{{ ::log.comments }}</td><td>{{ ::log.created_by.name }}</td><td class=\"center\"></td></tr></tbody><tfoot ng-show=\"vm.displayedReservations.length > 9\"><tr><td colspan=\"4\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></uib-tab></uib-tabset></div></div></div><ng-include src=\"\'/app/inventory/inventory-reservation.aside.html\'\"></ng-include><ng-include src=\"\'/app/inventory/inventory-confirmation.aside.html\'\"></ng-include>");
$templateCache.put("/app/dashboard/dashboard.html","<div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"dashboard.WELCOME\" translate-values=\"{ appName: app.name }\">WELCOME TO CLIP-TWO</h4><span class=\"mainDescription\">overview &amp; stats</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div class=\"container-fluid container-fullw padding-bottom-10 ng-scope\"><div class=\"row no-margin\"><div class=\"col-lg-3 col-md-6 no-padding\"><div class=\"panel panel-azure height-300 no-radius no-border\"><div class=\"panel-heading padding-5 padding-bottom-0\"><span class=\"triangle-top-right text-white pull-right\"></span></div><div class=\"panel-body no-padding\"><div class=\"block text-dark text-center\"><span class=\"counter text-bold text-white ng-scope\" count-to=\"{{ vm.stats.reservations.this_week }}\" value=\"0\" duration=\"1\" filter=\"number\">{{ vm.stats.reservations.this_week }}</span><h4 class=\"text-uppercase text-white no-margin\">RESERVATIONS THIS WEEK</h4><span class=\"line-separator line-sm text-white\"></span><p><span class=\"text-white-transparent\">Last Week:</span><span class=\"label background-light text-bold text-dark\">{{ vm.computePercent(vm.stats.reservations.last_week, vm.stats.reservations.this_week) }}</span></p></div></div></div></div><div class=\"col-lg-3 col-md-6 no-padding\"><div class=\"panel panel-purple height-300 no-radius no-border\"><div class=\"panel-heading padding-5 padding-bottom-0\"><span class=\"triangle-top-right text-white pull-right\"></span></div><div class=\"panel-body no-padding\"><div class=\"block text-dark text-center\"><span class=\"counter text-bold text-white ng-scope\" count-to=\"{{ vm.stats.reservations.this_month }}\" value=\"0\" duration=\"1\" filter=\"number\">{{ vm.stats.reservations.this_month }}</span><h4 class=\"text-uppercase text-white no-margin\">RESERVATIONS THIS MONTH</h4><span class=\"line-separator line-sm text-white\"></span><p class=\"no-margin\"><span class=\"text-white-transparent\">Last Month:</span><span class=\"label background-light text-bold text-dark\">{{ vm.computePercent(vm.stats.reservations.last_month, vm.stats.reservations.this_month) }}</span></p></div></div></div></div><div class=\"col-lg-3 col-md-6 no-padding\"><div class=\"panel panel-green height-300 no-radius no-border\"><div class=\"panel-heading padding-5 padding-bottom-0\"><span class=\"triangle-top-right text-white pull-right\"></span></div><div class=\"panel-body no-padding\"><div class=\"block text-dark text-center\"><span class=\"counter text-bold text-white ng-scope\" count-to=\"{{ ::vm.stats.confirmations.this_week }}\" value=\"0\" duration=\"1\" filter=\"number\">{{ ::vm.stats.confirmations.this_week }}</span><h4 class=\"text-uppercase text-white no-margin\">CONFIRMATIONS THIS WEEK</h4><span class=\"line-separator line-sm text-white\"></span><p><span class=\"text-white-transparent\">Last Month:</span><span class=\"label background-light text-bold text-dark\">{{ vm.computePercent(vm.stats.confirmations.last_week, vm.stats.confirmations.this_week) }}</span></p></div></div></div></div><div class=\"col-lg-3 col-md-6 no-padding\"><div class=\"panel panel-orange height-300 no-radius no-border\"><div class=\"panel-heading padding-5 padding-bottom-0\"><span class=\"triangle-top-right text-white pull-right\"></span></div><div class=\"panel-body no-padding\"><div class=\"block text-dark text-center\"><span class=\"counter text-bold text-white ng-scope\" count-to=\"{{ vm.stats.confirmations.this_month }}\" value=\"0\" duration=\"1\" filter=\"number\">{{ vm.stats.confirmations.this_month }}</span><h4 class=\"text-uppercase text-white no-margin\">CONFIRMATIONS THIS MONTH</h4><span class=\"line-separator line-sm text-white\"></span><p><span class=\"text-white-transparent\">Last Month:</span><span class=\"label background-light text-bold text-dark\">{{ vm.computePercent(vm.stats.confirmations.last_month, vm.stats.confirmations.this_month) }}</span></p></div></div></div></div></div></div>");
$templateCache.put("/app/inventory/inventory-confirmation.aside.html","<script type=\"text/ng-template\" id=\"asideConfirmation.html\"><div class=\"modal-header\"> <h3 class=\"modal-title\">Update Confirmation <a ng-click=\"cancel($event)\" class=\"pull-right\"><span class=\"fa fa-close\"></span></a></h3> </div> <div class=\"modal-body\"> <form class=\"updateConfirmationForm\" novalidate> <div class=\"row\"> <div class=\"col-md-12\"> <div class=\"form-group\"> <label class=\"control-label\">Fixed Asset #</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.asset\" readonly disabled /> </div> </div> </div> <div class=\"row\"> <div class=\"col-md-12\"> <div class=\"form-group\"> <label class=\"control-label\">Item Description</label> <textarea class=\"form-control\" ng-model=\"form.description\" rows=\"3\" readonly disabled></textarea> </div> </div> </div> <div class=\"row\"> <div class=\"col-md-12\"> <label class=\"control-label\">Update Status:</label> <btn-toggle options=\"options\" justified=\"true\"></btn-toggle> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Save</button> </div></script>");
$templateCache.put("/app/inventory/inventory-confirmation.html","<div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"inventory.confirmation.title\">Confirmation Form</h4><span class=\"mainDescription\" translate=\"inventory.confirmation.description\">Create a new ceservation for an inventory item.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div class=\"container-fluid container-fullw\"><form name=\"vm.reservationForm\" ng-submit=\"vm.saveConfirmation()\" novalidate=\"\"><div class=\"row margin-bottom-15\"><div class=\"col-md-12 text-right\"><button type=\"button\" ng-click=\"main.goBack()\" class=\"btn btn-default\">Return</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.saveConfirmation()\">Save</button></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"panel panel-white\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Fixed Asset #</label> <input type=\"text\" class=\"form-control\" value=\"{{ ::vm.item.asset }}\" placeholder=\"Fixed Asset #\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Confirmation Customer</label><select class=\"form-control\" chosen=\"\" ng-change=\"vm.loadCompany()\" data-placeholder=\"Select a customer\" ng-model=\"vm.form.company\" no-results-text=\"\'There are no companies.\'\" ng-options=\"company.identity as company.name for company in vm.companies\"><option value=\"\"></option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Expected On Rent Date</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{vm.on_rent.format}}\" ng-model=\"vm.form.expected_on_rent\" is-open=\"vm.on_rent.opened\" datepicker-options=\"vm.on_rent.options\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.on_rent.open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Expected Off Rent Date</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{vm.off_rent.format}}\" ng-model=\"vm.form.expected_off_rent\" is-open=\"vm.off_rent.opened\" datepicker-options=\"vm.off_rent.options\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.off_rent.open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Contact Name</label><select class=\"form-control\" chosen=\"\" ng-change=\"vm.loadContact()\" data-placeholder=\"Select a contact\" ng-model=\"vm.form.contact\" no-results-text=\"\'There are no contacts.\'\" ng-options=\"contact.identity as contact.name for contact in vm.contacts\"><option value=\"\"></option></select></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Contact Number</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.phone\" placeholder=\"Contact #\"></div></div></div><div class=\"row\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Item Description</label> <input type=\"text\" class=\"form-control\" value=\"{{ ::vm.item.description }}\" placeholder=\"Item Description\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Location</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.site_address\" placeholder=\"Street Address\"></div></div><div class=\"col-md-1 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">City</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.site_city\" placeholder=\"City\"></div></div><div class=\"col-md-1 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">State</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.site_state\" placeholder=\"State\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Zip Code</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.site_postal\" placeholder=\"Zip Code\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Delivery Time</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.delivery_request_time\" name=\"deliveryTime\" bs-timepicker=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Comments</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.comments\" ng-click=\"vm.expandComments();\" placeholder=\"Comments\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\">Choose an existing address:</label><select class=\"form-control\" chosen=\"\" ng-change=\"vm.loadAddress()\" data-placeholder=\"Select an existing site address...\" ng-model=\"vm.form.address\" no-results-text=\"\'There are no existing site addresses.\'\" ng-options=\"address as address.site_address+\' \'+address.site_city+\', \'+address.site_state+\' \'+address.site_postal for address in vm.addresses\"><option value=\"\"></option></select></div></div></div><hr><h4>Existing Reservations</h4><p>Select an existing reservation to confirm the information.</p><div class=\"row\"><div class=\"col-md-12\" st-table=\"vm.displayedReservations\" st-safe-src=\"vm.reservations\"><table class=\"table table-hover\"><thead><tr><th></th><th>Customer Name</th><th>Expected On-Rent</th><th>Expected Off-Rent</th><th>Location</th><th>City</th><th>State</th><th>Zip Code</th><th>Contact Name</th><th>Contact #</th><th>Last Edit</th></tr></thead><tbody><tr ng-if=\"vm.displayedReservations.length == 0 && vm.reservations.length == 0\"><td class=\"text-center\" colspan=\"11\">There are no past reservations for this item.</td></tr><tr ng-if=\"vm.displayedReservations.length == 0 && vm.reservations.length > 0\"><td class=\"text-center\" colspan=\"11\">There are no reservations that match your search criteria.</td></tr><tr ng-repeat=\"item in vm.displayedReservations\"><td><div class=\"radio clip-radio radio-primary\"><input id=\"{{ ::item.identity }}\" type=\"radio\" name=\"reservation\" ng-click=\"vm.loadReservation(item)\"> <label for=\"{{ ::item.identity }}\"></label></div></td><td>{{ ::item.company.name }}</td><td>{{ ::item.reservation.expected_on_rent | date : \'MM/dd/yyyy\' }}</td><td>{{ ::item.reservation.expected_off_rent | date : \'MM/dd/yyyy\' }}</td><td>{{ ::item.site_address }}</td><td>{{ ::item.site_city }}</td><td>{{ ::item.site_state }}</td><td>{{ ::item.site_postal }}</td><td>{{ ::item.contact.name }}</td><td>{{ ::item.contact.office_phone }}</td><td>{{ ::item.updated_by }}</td></tr></tbody><tfoot ng-show=\"vm.displayedReservations.length > 9\"><tr><td colspan=\"11\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div></div></form></div><script type=\"text/ng-template\" id=\"asideComments.html\"><div class=\"modal-header\"> <h3 class=\"modal-title\">Comments <a ng-click=\"cancel($event)\" class=\"pull-right\"><span class=\"fa fa-close\"></span></a></h3> </div> <div class=\"modal-body padding-0\"> <form class=\"commentForm\" novalidate> <textarea class=\"form-control height-max clear-style\" ng-model=\"comments\" autofocus placeholder=\"Enter comments here\"></textarea> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Save</button> </div></script>");
$templateCache.put("/app/inventory/inventory-item.aside.html","<script type=\"text/ng-template\" id=\"asideInventoryItem.html\"><div class=\"modal-header\"> <h3 class=\"modal-title\">Update Inventory Item <a ng-click=\"cancel($event)\" class=\"pull-right\"><span class=\"fa fa-close\"></span></a></h3> </div> <div class=\"modal-body\"> <form class=\"updateInventoryItemForm\" novalidate> <div class=\"row\"> <div class=\"col-md-12\"> <div class=\"form-group\"> <label class=\"control-label\">Fixed Asset #</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.asset\" readonly disabled /> </div> </div> </div> <div class=\"row\"> <div class=\"col-md-12\"> <div class=\"form-group\"> <label class=\"control-label\">Item Description</label> <textarea class=\"form-control\" ng-model=\"form.description\" rows=\"3\" readonly disabled></textarea> </div> </div> </div> <div class=\"row\"> <div class=\"col-md-12\"> <label class=\"control-label\">Update Status:</label> <btn-toggle options=\"options\" justified=\"true\"></btn-toggle> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Save</button> </div></script>");
$templateCache.put("/app/inventory/inventory-multiple.html","<div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"inventory.multiple.title\">Multiple View</h4><span class=\"mainDescription\" translate=\"inventory.multiple.description\">Quickly create update items to a confirmation or ready for delivery.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div class=\"container-fluid container-fullw\"><div class=\"row margin-bottom-15\"><div class=\"col-md-2\"><label class=\"control-label\">Status(es)</label><select class=\"form-control\" chosen=\"\" multiple=\"\" data-placeholder=\"Select statuses\" ng-change=\"vm.filterItems()\" ng-model=\"vm.form.statuses\" no-results-text=\"\'There are no statuses.\'\" ng-options=\"status.identity as status.name for status in vm.statuses\"></select></div><div class=\"col-md-2\"><label class=\"control-label\">On Rent Date</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"expected_on_rent\" uib-datepicker-popup=\"{{vm.on_rent.format}}\" ng-model=\"vm.form.expected_on_rent\" is-open=\"vm.on_rent.opened\" datepicker-options=\"vm.on_rent.options\" close-text=\"Close\" ng-change=\"vm.filterItems()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.on_rent.open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-2\"><label class=\"control-label\">Off Rent Date</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"expected_off_rent\" uib-datepicker-popup=\"{{vm.off_rent.format}}\" ng-model=\"vm.form.expected_off_rent\" is-open=\"vm.off_rent.opened\" datepicker-options=\"vm.off_rent.options\" close-text=\"Close\" ng-change=\"vm.filterItems()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.off_rent.open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-2\"><label class=\"control-label\">Chauffer</label><select class=\"form-control\" chosen=\"\" multiple=\"\" data-placeholder=\"Select chauffer\" ng-model=\"vm.form.chauffer\" no-results-text=\"\'There are no chauffers.\'\" ng-options=\"employee.identity as employee.name for employee in vm.employees\"></select></div><div class=\"col-md-2\" style=\"padding-right:0;\"><label class=\"control-label\">Filter By</label><btn-toggle options=\"vm.filterTypes\" justified=\"true\" ng-click=\"vm.filterItems()\"></btn-toggle></div><div class=\"col-md-2 text-right padding-top-20\"><a class=\"btn btn-wide btn-blue\" ng-click=\"vm.saveChanges()\">Save Changes</a></div></div><div class=\"panel panel-white\"><div class=\"panel-body\"><div class=\"col-md-12\" st-table=\"vm.filteredItems\" st-safe-src=\"vm.reservations\" st-pipe=\"vm.filterPipe()\"><table class=\"table table-hover\"><thead><tr><th></th><th>Status</th><th>Asset #</th><th>Item Description</th><th>Customer Name</th><th>Expected On-Rent</th><th>Expected Off-Rent</th><th>Location</th><th>City</th><th>State</th><th>Zip Code</th><th>Contact Name</th><th>Contact #</th><th>Requested Delivery Time</th><th>Reservation Comments</th><th>Chauffer Assigned</th><th>Additional Comments</th></tr></thead><tbody><tr ng-if=\"vm.filteredItems.length == 0 && vm.reservations.length == 0\"><td class=\"text-center\" colspan=\"17\">There are no past reservations for this item.</td></tr><tr ng-if=\"vm.filteredItems.length == 0 && vm.reservations.length > 0\"><td class=\"text-center\" colspan=\"17\">There are no reservations that match your search criteria.</td></tr><tr ng-repeat=\"reservation in vm.filteredItems\"><td><div class=\"checkbox clip-check check-primary\"><input type=\"checkbox\" ng-model=\"vm.updateSelected[reservation.identity]\" id=\"{{reservation.identity}}\" value=\"true\"> <label for=\"{{reservation.identity}}\"></label></div></td><td>{{ ::reservation.item.status.name }}</td><td>{{ ::reservation.item.asset }}</td><td>{{ ::reservation.item.description }}</td><td>{{ ::reservation.company.name }}</td><td>{{ vm.formatDate(reservation.expected_on_rent) | date : \'MM/dd/yyyy\' }}</td><td>{{ vm.formatDate(reservation.expected_off_rent) | date : \'MM/dd/yyyy\' }}</td><td>{{ ::reservation.site_address }}</td><td>{{ ::reservation.site_city }}</td><td>{{ ::reservation.site_state }}</td><td>{{ ::reservation.site_postal }}</td><td>{{ ::reservation.contact.name }}</td><td>{{ ::reservation.contact.office_phone }}</td><td></td><td></td><td>{{ ::reservation.confirmation.logistic.name }}</td><td></td></tr></tbody><tfoot ng-show=\"vm.filteredItems.length > 9\"><tr><td colspan=\"17\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("/app/inventory/inventory-reservation.aside.html","<script type=\"text/ng-template\" id=\"asideReservation.html\"><div class=\"modal-header\"> <h3 class=\"modal-title\">Update Reservation <a ng-click=\"cancel($event)\" class=\"pull-right\"><span class=\"fa fa-close\"></span></a></h3> </div> <div class=\"modal-body\"> <form class=\"updateReservationForm\" novalidate> <div class=\"row\"> <div class=\"col-md-12 col-xs-12\"> <div class=\"form-group\"> <label class=\"control-label\">Customer</label> <select class=\"form-control\" chosen ng-change=\"loadCompany()\" data-placeholder=\"Select a customer\" ng-model=\"form.company\" no-results-text=\"\'There are no companies.\'\" ng-options=\"company.identity as company.name for company in companies\"> </select> </div> </div> </div> <div class=\"row\"> <div class=\"col-md-6 col-xs-12\"> <div class=\"form-group\"> <label class=\"control-label\">Contact</label> <select class=\"form-control\" chosen ng-change=\"loadContact()\" data-placeholder=\"Select a contact\" ng-model=\"form.contact\" no-results-text=\"\'There are no contacts.\'\" ng-options=\"contact.identity as contact.name for contact in contacts\"> </select> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"form-group\"> <label class=\"control-label\">Contact #</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.phone\" placeholder=\"Contact #\" /> </div> </div> </div> <div class=\"row\"> <div class=\"col-md-6 col-xs-12\"> <div class=\"form-group\"> <label class=\"control-label\">Expected On-Rent</label> <div class=\"input-group\"> <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{on_rent.format}}\" ng-model=\"form.expected_on_rent\" is-open=\"on_rent.opened\" datepicker-options=\"on_rent.options\" close-text=\"Close\" /> <span class=\"input-group-btn\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"on_rent.open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button> </span> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"form-group\"> <label class=\"control-label\">Expected Off-Rent</label> <div class=\"input-group\"> <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{off_rent.format}}\" ng-model=\"form.expected_off_rent\" is-open=\"off_rent.opened\" datepicker-options=\"off_rent.options\" close-text=\"Close\" /> <span class=\"input-group-btn\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"off_rent.open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button> </span> </div> </div> </div> </div> <div class=\"form-group\"> <label class=\"control-label\">Site Address</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.site_address\" placeholder=\"Site Address\" /> </div> <div class=\"row\"> <div class=\"col-md-6 col-xs-12\"> <div class=\"form-group\"> <label class=\"control-label\">Site City</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.site_city\" placeholder=\"City\" /> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"form-group\"> <label class=\"control-label\">Site State</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.site_state\" placeholder=\"State\" /> </div> </div> </div> <div class=\"form-group\"> <label class=\"control-label\">Site Zip Code</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.site_postal\" placeholder=\"Zip Code\" /> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> <button class=\"btn btn-danger\" ng-click=\"delete($event)\" ng-if=\"form.identity\">Delete</button> <button class=\"btn btn-success\" ng-click=\"confirm($event)\" ng-if=\"status == \'Ready Line\'\">Confirmation</button> <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Save</button> </div></script>");
$templateCache.put("/app/inventory/inventory-reservation.html","<div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"inventory.reservation.title\">Reservation Form</h4><span class=\"mainDescription\" translate=\"inventory.reservation.description\">Create a new reservation for an inventory item.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div class=\"container-fluid container-fullw\"><form name=\"vm.reservationForm\" ng-submit=\"vm.saveReservation()\" novalidate=\"\"><div class=\"row margin-bottom-15\"><div class=\"col-md-12 text-right\"><button type=\"button\" ng-click=\"main.goBack()\" class=\"btn btn-default\">Return</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.saveReservation()\">Save</button></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"panel panel-white\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Fixed Asset #</label> <input type=\"text\" class=\"form-control\" value=\"{{ ::vm.item.asset }}\" placeholder=\"Fixed Asset #\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : vm.submitted && vm.reservationForm.company.$invalid}\"><label class=\"control-label\">Reservation Customer<span class=\"req\">*</span></label><select class=\"form-control\" chosen=\"\" ng-change=\"vm.loadCompany()\" data-placeholder=\"Select a customer\" ng-model=\"vm.form.company\" no-results-text=\"\'There are no companies.\'\" ng-options=\"company.identity as company.name for company in vm.companies\" name=\"company\" required=\"\"><option value=\"\"></option></select><span class=\"help-block text-danger\" ng-show=\"vm.submitted && vm.reservationForm.company.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> You must select a company to create a reservation.</span></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : vm.submitted && vm.reservationForm.expected_on_rent.$invalid}\"><label class=\"control-label\">Expected On Rent Date</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"expected_on_rent\" uib-datepicker-popup=\"{{vm.on_rent.format}}\" ng-model=\"vm.form.expected_on_rent\" is-open=\"vm.on_rent.opened\" datepicker-options=\"vm.on_rent.options\" close-text=\"Close\" required=\"\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.on_rent.open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><span class=\"help-block text-danger\" ng-show=\"vm.submitted && vm.reservationForm.expected_on_rent.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> You must enter an expected on rent date for a reservation.</span></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Expected Off Rent Date</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{vm.off_rent.format}}\" ng-model=\"vm.form.expected_off_rent\" is-open=\"vm.off_rent.opened\" datepicker-options=\"vm.off_rent.options\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.off_rent.open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : vm.submitted && vm.reservationForm.contact.$invalid}\"><label class=\"control-label\">Contact Name<span class=\"req\">*</span></label><select class=\"form-control\" chosen=\"\" ng-change=\"vm.loadContact()\" data-placeholder=\"Select a contact\" ng-model=\"vm.form.contact\" no-results-text=\"\'There are no contacts.\'\" ng-options=\"contact.identity as contact.name for contact in vm.contacts\" name=\"contact\" required=\"\"><option value=\"\"></option></select><span class=\"help-block text-danger\" ng-show=\"vm.submitted && vm.reservationForm.contact.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> You must select a contact to create a reservation.</span></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Contact Number</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.phone\" placeholder=\"Contact #\"></div></div></div><div class=\"row\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Item Description</label> <input type=\"text\" class=\"form-control\" value=\"{{ ::vm.item.description }}\" placeholder=\"Item Description\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Location</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.site_address\" placeholder=\"Street Address\"></div></div><div class=\"col-md-1 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">City</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.site_city\" placeholder=\"City\"></div></div><div class=\"col-md-1 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">State</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.site_state\" placeholder=\"State\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Zip Code</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.site_postal\" placeholder=\"Zip Code\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Delivery Time</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.delivery_request_time\" name=\"deliveryTime\" bs-timepicker=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Comments</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.comments\" ng-click=\"vm.expandComments();\" placeholder=\"Comments\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\">Choose an existing address:</label><select class=\"form-control\" chosen=\"\" ng-change=\"vm.loadAddress()\" data-placeholder=\"Select an existing site address...\" ng-model=\"vm.form.address\" no-results-text=\"\'There are no existing site addresses.\'\" ng-options=\"address as address.site_address+\' \'+address.site_city+\', \'+address.site_state+\' \'+address.site_postal for address in vm.addresses\"><option value=\"\" <=\"\" option=\"\"></option></select></div></div></div><div class=\"row\"><div class=\"col-md-12\" st-table=\"vm.displayedReservations\" st-safe-src=\"vm.reservations\"><table class=\"table table-hover\"><thead><tr><th>Customer Name</th><th>Expected On-Rent</th><th>Expected Off-Rent</th><th>Location</th><th>City</th><th>State</th><th>Zip Code</th><th>Contact Name</th><th>Contact #</th><th>Last Edit</th><th></th></tr></thead><tbody><tr ng-if=\"vm.displayedReservations.length == 0 && vm.reservations.length == 0\"><td class=\"text-center\" colspan=\"10\">There are no past reservations for this item.</td></tr><tr ng-if=\"vm.displayedReservations.length == 0 && vm.reservations.length > 0\"><td class=\"text-center\" colspan=\"10\">There are no reservations that match your search criteria.</td></tr><tr ng-repeat=\"item in vm.displayedReservations\"><td>{{ ::item.company.name }}</td><td>{{ vm.parseDate(item.expected_on_rent) }}</td><td>{{ vm.parseDate(item.expected_off_rent) }}</td><td>{{ ::item.site_address }}</td><td>{{ ::item.site_city }}</td><td>{{ ::item.site_state }}</td><td>{{ ::item.site_postal }}</td><td>{{ ::item.contact.name }}</td><td>{{ ::item.contact.office_phone }}</td><td>{{ ::item.updated_by }}</td><td class=\"center\"><div class=\"visible-md visible-lg hidden-sm hidden-xs\"><a ng-click=\"vm.showUpdateReservation(item)\" class=\"btn btn-transparent btn-xs\" tooltip-placement=\"top\" uib-tooltip=\"Edit\"><i class=\"fa fa-pencil\"></i></a></div><div class=\"visible-xs visible-sm hidden-md hidden-lg\"><div class=\"btn-group dropdown\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-o btn-sm dropdown-toggle\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i>&nbsp;<span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right dropdown-light\" role=\"menu\"><li><a>Edit</a></li></ul></div></div></td></tr></tbody><tfoot ng-show=\"vm.displayedReservations.length > 9\"><tr><td colspan=\"10\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div></div></form></div><script type=\"text/ng-template\" id=\"asideComments.html\"><div class=\"modal-header\"> <h3 class=\"modal-title\">Comments <a ng-click=\"cancel($event)\" class=\"pull-right\"><span class=\"fa fa-close\"></span></a></h3> </div> <div class=\"modal-body padding-0\"> <form class=\"commentForm\" novalidate> <textarea class=\"form-control height-max clear-style\" ng-model=\"comments\" autofocus placeholder=\"Enter comments here\"></textarea> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Save</button> </div></script><ng-include src=\"\'/app/inventory/inventory-reservation.aside.html\'\"></ng-include>");
$templateCache.put("/app/inventory/inventory-search.html","<div ui-view=\"\"><div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"inventory.search.title\">Primary Status Search</h4><span class=\"mainDescription\" translate=\"inventory.search.description\">Quickly search and find inventory items.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div insight-placeholder=\"vm.placeholder\"></div><div inventory-aside=\"vm.items\" visible=\"vm.asideInventory\"></div><div class=\"container-fluid\" ng-show=\"vm.items.length > 0\"><div class=\"row margin-bottom-15\"><div class=\"col-md-2\"><label class=\"control-label\">Fixed Asset #</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.filter.asset\" ng-keyup=\"vm.filterItems()\" placeholder=\"Search asset #\"></div><div class=\"col-md-2\"><label class=\"control-label\">Inventory Location</label><select class=\"form-control\" chosen=\"\" multiple=\"\" data-placeholder=\"Select a location\" ng-change=\"vm.filterItems()\" ng-model=\"vm.filter.locations\" no-results-text=\"\'There are no locations.\'\" ng-options=\"location.identity as location.name for location in vm.locations\"></select></div><div class=\"col-md-2\"><label class=\"control-label\">Status(es)</label><select class=\"form-control\" chosen=\"\" multiple=\"\" data-placeholder=\"Select statuses\" ng-change=\"vm.filterItems()\" ng-model=\"vm.filter.statuses\" no-results-text=\"\'There are no statuses.\'\" ng-options=\"status.original as status.name for status in vm.statuses\"></select></div><div class=\"col-md-2\"><label class=\"control-label\">2<sup>nd</sup> Status(es)</label><select class=\"form-control\" chosen=\"\" multiple=\"\" data-placeholder=\"Select statuses\" ng-change=\"vm.filterItems()\" ng-model=\"vm.filter.secondStatuses\" no-results-text=\"\'No available second statuses.\'\" ng-options=\"status.original as status.name for status in vm.secondStatuses\"></select></div><div class=\"col-md-4 text-right padding-top-15\"><a class=\"btn btn-wide btn-blue\" ng-click=\"vm.reservation()\">Reservation</a> <a class=\"btn btn-wide btn-success\" ng-click=\"vm.confirmation()\">Confirmation</a> <a class=\"btn btn-wide btn-warning\" ng-click=\"vm.service()\">Service</a></div></div><div class=\"panel panel-white\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div st-table=\"vm.displayedItems\" st-safe-src=\"vm.items\" st-pipe=\"vm.filterPipe\"><table class=\"table no-margin table-hover\"><tbody><tr ng-repeat=\"item in vm.displayedItems\"><td><div class=\"checkbox clip-check check-primary check-md checkbox-inline\"><input type=\"checkbox\" id=\"{{ ::item.identity }}\" value=\"{{ ::item.identity }}\" ng-click=\"vm.selectRow(item.identity)\" ng-checked=\"vm.form.selectedItem == item.identity\"> <label for=\"{{ ::item.identity }}\"></label></div></td><td><div class=\"padding-10\"><div class=\"block\"><span class=\"text-muted\">Fixed Asset #</span><strong>{{ ::item.asset }}</strong></div><span class=\"text-small text-muted\">{{ ::item.description }}</span><div class=\"block margin-top-10\"><span class=\"label\" ng-style=\"{ \'color\' : item.status.primary_color, \'background\' : item.status.background_color }\">{{ ::item.status.name }}</span> <span class=\"label\" ng-style=\"{ \'color\' : item.secondStatus.primary_color, \'background\' : item.secondStatus.background_color }\">{{ ::item.secondStatus.name }}</span></div></div></td><td><div class=\"padding-10\"><span class=\"text-muted\">Current Customer</span><div class=\"block\"><em ng-if=\"vm.getRecord(item) == \'None\'\">None</em> <strong ng-if=\"vm.getRecord(item) !== \'None\'\">{{ vm.getRecord(item).company.name }}</strong></div></div></td><td><div class=\"col-xs-2 no-padding text-center\"><div class=\"border-right border-dark padding-5\"><small class=\"text-muted\">On Rent Date<br><strong>{{ vm.getRecord(item).expected_on_rent | date : \'MM/dd/yyyy\' }}</strong></small></div></div><div class=\"col-xs-2 no-padding text-center\"><div class=\"padding-5\"><small class=\"text-muted\">Off Rent Date<br><strong>{{ vm.getRecord(item).expected_off_rent | date : \'MM/dd/yyyy\' }}</strong></small></div></div><div class=\"col-xs-3 no-padding text-center\"><div class=\"border-right border-dark padding-5\"><small class=\"text-muted\">Expected From Workshop<br><strong></strong></small></div></div><div class=\"col-xs-4 no-padding text-center\"><div class=\"border-right border-dark padding-5\"><small class=\"text-muted\">Next Reservation Date<br><strong></strong></small></div></div><div class=\"col-xs-1 no-padding text-center\"><a ng-click=\"vm.showUpdateItem(item)\" class=\"btn btn-transparent btn-xs tooltips\" tooltip-placement=\"top\" uib-tooltip=\"Edit\"><i class=\"fa fa-pencil fa fa-white\"></i></a></div></td></tr></tbody><tfoot ng-show=\"vm.displayedItems.length > 9\"><tr><td colspan=\"4\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div></div><ng-include src=\"\'/app/inventory/inventory-item.aside.html\'\"></ng-include></div>");
$templateCache.put("/app/inventory/inventory-service.aside.html","<script type=\"text/ng-template\" id=\"asideService.html\"><div class=\"modal-header\"> <h3 class=\"modal-title\">Mechanic Form <a ng-click=\"cancel($event)\" class=\"pull-right\"><span class=\"fa fa-close\"></span></a></h3> </div> <div class=\"modal-body\"> <div class=\"row margin-bottom-15\"> <div class=\"col-md-12 text-right\"> <button class=\"btn btn-primary\" ng-click=\"startService()\" ng-hide=\"form.start_time\">Start Service</button> <button class=\"btn btn-primary ng-hide\" ng-click=\"endService()\" ng-show=\"form.start_time\">End Service</button> </div> </div> <div class=\"row\"> <div class=\"col-md-10\"> </div> <div class=\"col-md-2 ng-hide\" ng-show=\"form.start_time\"> My new status is: <!-- <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Ready Line</button> <button class=\"btn btn-success\" ng-click=\"ok($event)\">Repair</button> <button class=\"btn btn-warning\" ng-click=\"ok($event)\">Hard Down</button> <button class=\"btn btn-danger\" ng-click=\"ok($event)\">Annual Insp.</button> --> <select class=\"form-control\" chosen data-placeholder=\"Select a status\" ng-model=\"form.serviceStatus\" no-results-text=\"\'There are no statuses.\'\" ng-options=\"status.value as status.text for status in serviceStatus\"> </select> </div> </div> <form class=\"contactForm\" novalidate> <div class=\"row\"> <div class=\"col-md-4 col-xs-12\"> <div class=\"form-group\"> <label class=\"control-label\">Serial Number</label> <input type=\"text\" class=\"form-control\" name=\"serial\" ng-model=\"form.serial\" readonly disabled /> </div> </div> <div class=\"col-md-4 col-xs-12\"> <div class=\"form-group\"> <label class=\"control-label\">Fixed Asset #</label> <input type=\"text\" class=\"form-control\" name=\"asset\" ng-model=\"form.asset\" readonly disabled /> </div> </div> <div class=\"col-md-4 col-xs-12\"> <div class=\"form-group\"> <label class=\"control-label\">Item Description</label> <input type=\"text\" class=\"form-control\" name=\"description\" ng-model=\"form.description\" readonly disabled /> </div> </div> </div> <div class=\"row\"> <div class=\"col-md-4 col-xs-12\"> <div class=\"form-group\"> <label class=\"control-label\">Inspection Date</label> <div class=\"input-group\"> <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{inspection_date.format}}\" ng-model=\"form.inspection_date\" is-open=\"inspection_date.opened\" datepicker-options=\"inspection_date.options\" close-text=\"Close\" /> <span class=\"input-group-btn\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"inspection_date.open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button> </span> </div> </div> </div> <div class=\"col-md-4 col-xs-12\"> <div class=\"form-group\"> <label class=\"control-label\">2<sup>nd</sup> Status</label> <select class=\"form-control\" chosen data-placeholder=\"Select a status\" ng-model=\"form.sec_status\" no-results-text=\"\'There are no statuses.\'\" ng-options=\"sec_status.identity as sec_status.name for sec_status in secondStatuses\"> </select> </div> </div> <div class=\"col-md-4 col-xs-12\"> <div class=\"form-group\"> <label class=\"control-label\">Machine Hours</label> <input type=\"text\" class=\"form-control\" name=\"machineHours\" ng-model=\"form.machine_hours\" placeholder=\"Machine Hours\" /> </div> </div> </div> <div class=\"row\"> <div class=\"col-md-4 col-xs-12\"> <div class=\"form-group\"> <label class=\"control-label\">Expected From Workshop</label> <div class=\"input-group\"> <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{expected_workshop.format}}\" ng-model=\"form.expected_workshop\" is-open=\"expected_workshop.opened\" datepicker-options=\"expected_workshop.options\" close-text=\"Close\" /> <span class=\"input-group-btn\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"expected_workshop.open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button> </span> </div> </div> </div> <div class=\"col-md-4 col-xs-12\"> <div class=\"form-group\"> <label class=\"control-label\">Reason Code</label> <input type=\"text\" class=\"form-control\" name=\"reasonCode\" ng-model=\"form.reason_code\" placeholder=\"Reason Code\" /> </div> </div> <div class=\"col-md-4 col-xs-12\"> <div class=\"form-group\"> <label class=\"control-label\">Customer Damage / Warranty</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.warranty\" /> </div> </div> </div> <div class=\"row\"> <div class=\"col-md-12\"> <div class=\"form-group\"> <label class=\"control-label\">Problem Description</label> <textarea class=\"form-control\" rows=\"4\" ng-model=\"form.problem_description\" placeholder=\"Describe the problem...\"></textarea> </div> </div> </div> <div class=\"row\"> <div class=\"col-md-12\"> <div class=\"form-group\"> <label class=\"control-label\">Damage / Warranty Notes</label> <textarea class=\"form-control\" rows=\"4\" ng-model=\"form.warranty_notes\" placeholder=\"Damage/Warranty notes...\"></textarea> </div> </div> </div> <div class=\"row\"> <div class=\"col-md-12\"> <div class=\"form-group\"> <label class=\"control-label\">Notes</label> <textarea class=\"form-control\" rows=\"4\" ng-model=\"form.notes\" placeholder=\"Notes...\"></textarea> </div> </div> </div> </form> <table class=\"table table-hover\"> <thead> <tr> <th>Service Date</th> <th>Machine Hours</th> <th>Reason Code</th> <th>Problem Description</th> <th>Customer Damage/Warranty</th> <th>Damage Warranty Note</th> <th>Service Performed by</th> </tr> </thead> <tbody> <tr ng-repeat=\"service in item.service\"> <td>{{ formatDate(service.start_time) | date : \'MM/dd/yyyy\' }}</td> <td>{{ ::service.machine_hours }}</td> <td>{{ ::service.reason_code }}</td> <td>{{ ::service.problem_description }}</td> <td>{{ ::service.warranty }}</td> <td>{{ ::service.warranty_notes }}</td> <td>{{ ::service.created_by.name }}</td> </tr> </tbody> </table> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> </div></script>");
$templateCache.put("/app/inventory/inventory-service.html","<div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"inventory.service.title\">Mechanic Asset View</h4><span class=\"mainDescription\" translate=\"inventory.service.description\">View the history of a machine.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div class=\"container-fluid container-fullw\"><div class=\"row margin-bottom-15\"><div class=\"col-md-4 text-left\"><h4>Equipment Status: <span class=\"label label-success\">Excellent</span></h4></div><div class=\"col-md-8 text-right\"><button type=\"button\" ng-click=\"main.goBack()\" class=\"btn btn-default\">Return</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.showServiceAsset()\">Service Asset</button></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"panel panel-white\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Serial Number</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.item.serial\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Fixed Asset #</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.item.asset\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Item Description</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.item.description\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Current Status</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.item.status.name\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-1 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">% Available</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.availablePercent\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-1 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">% On Rent</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.rentPercent\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Avg. Rental</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.rentAverage\" readonly=\"\" disabled=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Postpone Maintenance</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.postPoneMaintenance\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Next Insp. Date</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.inspectionDate\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-1 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Current Hours</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.currentHours\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-1 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Hour Last Insp</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.lastInspHours\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-1 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Date In Fleet</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.dateFleet\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-1 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Orders YTD</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.ordersYTD\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-1 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Labor Hours YTD</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.laborHrsYTD\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-1 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Days in Repair YTD</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.daysRepairYTD\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Hours / Rental</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.rentHours\" readonly=\"\" disabled=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Days Rented YTD</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.rentedDaysYTD\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Days Unavail. YTD</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.unavailDays\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Day Hours / Day</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.dayHoursDay\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Next Reservation</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.nextReservation\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Expected On Rent Date</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.expected_on_rent\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Expeced Off Rent Date</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.form.expected_off_rent\" readonly=\"\" disabled=\"\"></div></div></div><hr><table class=\"table table-hover\" st-table=\"vm.displayedOrders\" st-safe-src=\"vm.orders\"><thead><tr><th>Order #</th><th>Fixed Asset #</th><th>Item Description</th><th>Depot</th><th># of Rental Days</th><th>On Rent Date</th><th>Customer</th><th>Hours</th><th>Off Rent Date</th><th>Service Performed After Rental</th></tr></thead><tbody><tr ng-if=\"vm.displayedOrders.length == 0 && vm.orders.length == 0\"><td colspan=\"11\" class=\"text-center\">There are no orders for this item.</td></tr><tr ng-if=\"vm.displayedOrders.length == 0 && vm.orders.length > 0\"><td colspan=\"11\" class=\"text-center\">There are no orders that match your search criteria.</td></tr><tr ng-repeat=\"confirmation in vm.displayedOrders\"><td>#{{ ::confirmation.item_number }}</td><td>{{ ::confirmation.item.asset }}</td><td>{{ ::confirmation.item.description }}</td><td></td><td>{{ ::confirmation.rental_days }}</td><td>{{ ::confirmation.order.expected_on_rent | date : \'MM/dd/yyyy\'}}</td><td>{{ ::confirmation.company.name }}</td><td></td><td>{{ ::confirmation.order.expected_off_rent | date : \'MM/dd/yyyy\' }}</td><td></td></tr></tbody></table></div></div></div></div></div><ng-include src=\"\'/app/inventory/inventory-service.aside.html\'\"></ng-include>");
$templateCache.put("/app/inventory/inventory-statuses.html","<div ui-view=\"\"><div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"inventory.status.title\">Primary Status Search</h4><span class=\"mainDescription\" translate=\"inventory.status.description\">Quickly search and find inventory items.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div class=\"container-fluid container-fullw\"><div class=\"row margin-bottom-15\"><div class=\"col-md-12 text-right\"><a type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.showCreateStatus()\">Create Status</a></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"panel panel-white\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div st-table=\"vm.displayedStatuses\" st-safe-src=\"vm.statuses\"><table class=\"table table-hover\"><thead ng-if=\"vm.statuses.length > 0\"><tr><th st-sort-default=\"true\" st-skip-natural=\"true\" st-sort=\"name\">Name</th><th st-skip-natural=\"true\" st-sort=\"\">Preview</th><th st-skip-natural=\"true\" st-sort=\"\">2<sup>nd</sup> Status</th><th></th></tr><tr><td><input type=\"search\" st-search=\"name\" class=\"form-control\" placeholder=\"Search Name...\"></td><td></td><td></td><td></td><td></td></tr></thead><div class=\"jumbotron text-center\" ng-if=\"vm.displayedStatuses.length == 0 && vm.statuses.length == 0\"><h1 class=\"display-3\">Nothing!</h1><p class=\"lead\">There are currently no inventory statuses within your organization!</p><hr class=\"m-y-2\"><p class=\"lead\"></p></div><tbody><tr ng-if=\"vm.displayedStatuses.length == 0 && vm.statuses.length > 0\"><td colspan=\"5\" class=\"text-center\">There are no inventory statuses that match your search criteria.</td></tr><tr ng-repeat=\"status in vm.displayedStatuses\"><td>{{ ::status.name }}</td><td><span class=\"label\" ng-style=\"{ \'color\': status.primary_color, \'background\' : status.background_color }\">{{ ::status.name }}</span></td><td><span class=\"fa fa-check\" ng-if=\"status.primary == 0\"></span></td><td class=\"center\"><div class=\"visible-md visible-lg hidden-sm hidden-xs\"><a ng-click=\"vm.showEditStatus(status)\" class=\"btn btn-transparent btn-xs tooltips\" tooltip-placement=\"top\" uib-tooltip=\"Edit\"><i class=\"fa fa-pencil fa fa-white\"></i></a></div><div class=\"visible-xs visible-sm hidden-md hidden-lg\"><div class=\"btn-group dropdown\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-o btn-sm dropdown-toggle\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i>&nbsp;<span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right dropdown-light\" role=\"menu\"><li><a>Edit</a></li></ul></div></div></td></tr></tbody><tfoot ng-show=\"vm.displayedStatuses.length > 9\"><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div></div></div></div><script type=\"text/ng-template\" id=\"asideStatus.html\"><div class=\"modal-header\"> <h3 class=\"modal-title\">Status Details</h3> </div> <div class=\"modal-body\"> <form name=\"statusForm\" novalidate> <div class=\"row\"> <div class=\"col-xs-12\"> <div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && statusForm.name.$invalid }\"> <label class=\"control-label\">Status Name</label> <input type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"form.name\" required placeholder=\"Status Name\" /> <span class=\"help-block text-danger\" ng-show=\"submitted && statusForm.name.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Status name is required.</span> </div> </div> </div> <div class=\"row\"> <div class=\"col-md-6 col-xs-12\"> <div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && statusForm.foreground.$invalid }\"> <label class=\"control-label\">Foreground Color</label> <input type=\"text\" class=\"form-control\" name\"foreground\" ng-model=\"form.foreground\" required minicolors /> <span class=\"help-block text-danger\" ng-show=\"submitted && statusForm.foreground.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Foreground is required.</span> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && statusForm.background.$invalid }\"> <label class=\"control-label\">Background Color</label> <input type=\"text\" class=\"form-control\" name=\"background\" ng-model=\"form.background\" required minicolors /> <span class=\"help-block text-danger\" ng-show=\"submitted && statusForm.background.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Background is required.</span> </div> </div> </div> <div class=\"row\"> <div class=\"col-md-12\"> <label class=\"control-label\">Status Type:</label> <btn-toggle options=\"statusTypes\" justified=\"true\"></btn-toggle> </div> </div> <div class=\"row padding-top-10\"> <div class=\"col-md-12\"> <div class=\"form-group preview\"> <label class=\"control-label\">Preview</label> <div> <span class=\"label\" ng-style=\"{\'background\' : form.background, \'color\' : form.foreground}\">{{form.name.length > 0 ? form.name : \'Example Status\'}}</span> </div> </div> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Save</button> </div></script></div>");
$templateCache.put("/app/main/footer.html","<div class=\"footer-inner\"><div class=\"pull-left\">&copy; {{app.year}} <span class=\"text-bold text-uppercase\">{{ app.author }}</span>. <span translate=\"footer.copyright.MESSAGE\">All rights reserved.</span> Version {{ app.version }}</div><div class=\"pull-right\"><a class=\"go-top\" ng-click=\"toTheTop()\"><i class=\"ti-angle-up\"></i></a></div></div>");
$templateCache.put("/app/main/horizontal-menu.html","<div class=\"horizontal-menu-wrapper\"><div class=\"horizontal-nav-container\" ct-fullheight=\"window\" data-ct-fullheight-exclusion=\"header\" data-ct-fullheight-if=\"isSmallDevice\"><ul class=\"nav navbar-nav no-border\"><li ui-sref-active=\"active\" ng-if=\"hasAccess(\'app.dashboard\')\"><a ui-sref=\"app.dashboard\"><letter-icon data=\"{{ \'sidebar.nav.dashboard.MAIN\' | translate }}\" color=\"auto\" char-count=\"2\" size=\"sm\"></letter-icon><span translate=\"sidebar.nav.dashboard.MAIN\">Dashboard</span></a></li><li ng-class=\"{\'active\':$state.includes(\'app.company.search\')}\" ng-if=\"hasAccess(\'app.company.search\')\"><a ui-sref=\"app.company.search\"><letter-icon data=\"{{ \'sidebar.nav.company.SEARCH\' | translate }}\" color=\"auto\" char-count=\"2\" size=\"sm\"></letter-icon><span translate=\"sidebar.nav.company.SEARCH\">Customer Search</span></a></li><li ng-class=\"{\'active\':$state.includes(\'app.inventory.search\')}\" ng-if=\"hasAccess(\'app.inventory.search\')\"><a ui-sref=\"app.inventory.search\" ui-sref-opts=\"{reload: true}\"><letter-icon data=\"{{ \'sidebar.nav.inventory.SEARCH\' | translate }}\" color=\"auto\" char-count=\"2\" size=\"sm\"></letter-icon><span translate=\"sidebar.nav.inventory.SEARCH\">Primary Status Search</span></a></li><li ng-class=\"{\'active\':$state.includes(\'app.mechanic\')}\" ng-if=\"hasAccess(\'app.mechanic\')\"><a ui-sref=\"app.mechanic\" ui-sref-opts=\"{reload: true}\"><letter-icon data=\"{{ \'sidebar.nav.mechanic.VIEW\' | translate }}\" color=\"auto\" char-count=\"1\" size=\"sm\"></letter-icon><span translate=\"sidebar.nav.mechanic.VIEW\">Mechanic View</span></a></li><li ng-class=\"{\'active\':$state.includes(\'app.yardman\')}\" ng-if=\"hasAccess(\'app.yardman\')\"><a ui-sref=\"app.yardman\" ui-sref-opts=\"{reload: true}\"><letter-icon data=\"{{ \'sidebar.nav.yardman.VIEW\' | translate }}\" color=\"auto\" char-count=\"2\" size=\"sm\"></letter-icon><span translate=\"sidebar.nav.yardman.VIEW\">Yardman</span></a></li><li ng-class=\"{\'active\':$state.includes(\'app.planning\')}\" ng-if=\"hasAccess(\'app.planning\')\"><a ui-sref=\"app.planning\" ui-sref-opts=\"{reload: true}\"><letter-icon data=\"{{ \'sidebar.nav.planning.VIEW\' | translate }}\" color=\"auto\" char-count=\"2\" size=\"sm\"></letter-icon><span translate=\"sidebar.nav.planning.VIEW\">Planning</span></a></li><li ng-class=\"{\'active\':$state.includes(\'app.rental\')}\" ng-if=\"hasAccess(\'app.rental\')\"><a ui-sref=\"app.rental\" ui-sref-opts=\"{reload: true}\"><letter-icon data=\"{{ \'sidebar.nav.rental.VIEW\' | translate }}\" color=\"auto\" char-count=\"2\" size=\"sm\"></letter-icon><span translate=\"sidebar.nav.rental.VIEW\">Rental Desk</span></a></li><li class=\"mega-menu\" uib-dropdown=\"\" auto-close=\"outsideClick\" ng-class=\"{\'active\':$state.includes(\'app.settings\')}\" ng-if=\"hasAccess(\'app.settings.*\')\"><a href=\"javascript:void(0)\" uib-dropdown-toggle=\"\"><letter-icon data=\"Settings\" color=\"auto\" char-count=\"2\" size=\"sm\"></letter-icon><span translate=\"sidebar.nav.settings.MAIN\">Settings</span> <span class=\"caret\"></span></a><ul uib-dropdown-menu=\"\"><li><div class=\"mega-menu-content\"><div class=\"col-md-3\"><ul class=\"mega-sub-menu padding-top-0\"><li><span class=\"mega-menu-sub-title text-uppercase text-light text-bold text-extra-small padding-top-25 padding-bottom-10\" translate=\"sidebar.nav.manage.MAIN\">Manage</span><ul><li ui-sref-active=\"active\"><a ui-sref=\"app.settings.companies\"><span translate=\"sidebar.nav.manage.COMPANIES\">Companies</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.settings.contacts\"><span translate=\"sidebar.nav.manage.CONTACTS\">Contacts</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.settings.employees\"><span translate=\"sidebar.nav.manage.EMPLOYEES\">Employees</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.settings.inventory\"><span translate=\"sidebar.nav.manage.INVENTORY\">Inventory</span></a></li></ul></li></ul></div><div class=\"col-md-3\"><ul class=\"mega-sub-menu padding-top-0\"><li><span class=\"mega-menu-sub-title text-uppercase text-light text-bold text-extra-small padding-top-25 padding-bottom-10\" translate=\"sidebar.nav.setup.MAIN\">Setup</span><ul><li ui-sref-active=\"active\"><a ui-sref=\"app.settings.status-options\"><span translate=\"sidebar.nav.setup.STATUSES\">Status Options</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.settings.inventory-locations\"><span translate=\"sidebar.nav.setup.INVENTORY_LOCATIONS\">Inventory Locations</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.settings.inventory-categories\"><span translate=\"sidebar.nav.setup.INVENTORY_CATEGORIES\">Inventory Categories</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.settings.company-classifications\"><span translate=\"sidebar.nav.setup.CLASSIFICATIONS\">Company Classifications</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.settings.employee-departments\"><span translate=\"sidebar.nav.setup.EMPLOYEE_DEPARTMENTS\">Employee Departments</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.settings.employee-positions\"><span translate=\"sidebar.nav.setup.EMPLOYEE_POSITIONS\">Employee Positions</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.settings.roles\"><span translate=\"sidebar.nav.setup.ACCESS_ROLES\">Access Roles/span></span></a></li></ul></li></ul></div><div class=\"col-md-3\"></div><div class=\"col-md-3\"></div></div></li></ul></li></ul><ul class=\"nav navbar-nav navbar-right\"><li class=\"dropdown\" uib-dropdown=\"\"><a href=\"#\" class=\"dropdown-toggle nav-user-wrapper\" data-toggle=\"dropdown\" uib-dropdown-toggle=\"\"><img alt=\"\" src=\"assets/images/default-user.png\" width=\"50px\" height=\"50px\"> <span ng-bind=\"user.name\"></span> <span class=\"caret\"></span></a><ul class=\"dropdown-menu pull-right\"><li><a ui-sref=\"app.pages.user\" translate=\"topbar.user.PROFILE\">My Profile</a></li><li><a ui-sref=\"app.pages.calendar\" translate=\"topbar.user.CALENDAR\">My Calendar</a></li><li><a ui-sref=\"app.pages.messages\" translate=\"topbar.user.MESSAGES\">My Messages (3)</a></li><li><a ui-sref=\"login.lockscreen\" translate=\"topbar.user.LOCKSCREEN\">Lock Screen</a></li><li class=\"divider\"></li><li><a ui-sref=\"auth.logout\" translate=\"topbar.user.LOGOUT\">Log Out</a></li></ul></li></ul></div><div class=\"close-handle visible-xs-block visible-sm-block menu-toggler\" ng-click=\"menuInit(true)\" ng-swipe-up=\"menuInit(true)\"><div class=\"arrow-left\"></div><div class=\"arrow-right\"></div></div></div>");
$templateCache.put("/app/main/main-content.html","<div ui-view=\"\" class=\"wrap-content container fade-in-up\" id=\"container\"></div>");
$templateCache.put("/app/main/main.html","<toaster-container toaster-options=\"{\'position-class\': \'toast-top-right\', \'close-button\':true}\"></toaster-container><div class=\"sidebar app-aside hidden-print\" id=\"sidebar\" toggleable=\"\" parent-active-class=\"app-slide-off\"><div perfect-scrollbar=\"\" wheel-propagation=\"false\" suppress-scroll-x=\"true\" class=\"sidebar-container\"><div ng-include=\"\'/app/main/sidebar.html\'\"></div></div></div><div class=\"app-content\" ng-class=\"{loading: loading}\" ng-swipe-right=\"toggle(\'off-sidebar\', \'off\')\"><ng-include src=\"\'/app/main/top-navbar.html\'\"></ng-include><div ng-include=\"\'/app/main/main-content.html\'\" class=\"main-content\"></div></div><footer ng-include=\"\'/app/main/footer.html\'\" class=\"hidden-print\"></footer>");
$templateCache.put("/app/main/nav.html","<div class=\"navbar-title\"><span translate=\"sidebar.heading.NAVIGATION\">Main Navigation</span></div><ul class=\"main-navigation-menu\"><li ui-sref-active=\"active\"><a ui-sref=\"app.dashboard\"><div class=\"item-content\"><div class=\"item-media\"><letter-icon data=\"{{ \'sidebar.nav.dashboard.MAIN\' | translate }}\" char-count=\"2\" size=\"sm\"></letter-icon></div><div class=\"item-inner\"><span class=\"title\" translate=\"sidebar.nav.dashboard.MAIN\">Dashboard</span></div></div></a></li><li ng-class=\"{\'active open\':$state.includes(\'app.pagelayouts\')}\"><a href=\"javascript:void(0)\"><div class=\"item-content\"><div class=\"item-media\"><letter-icon data=\"{{ \'sidebar.nav.pagelayouts.MAIN\' | translate }}\" char-count=\"2\" size=\"sm\"></letter-icon></div><div class=\"item-inner\"><span class=\"title\" translate=\"sidebar.nav.pagelayouts.MAIN\">Page Layout</span><i class=\"icon-arrow\"></i></div></div></a><ul class=\"sub-menu\"><li ui-sref-active=\"active\"><a ui-sref=\"app.pagelayouts.fixedheader\"><span class=\"title\" translate=\"sidebar.nav.pagelayouts.FIXEDHEADER\">Fixed Header</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.pagelayouts.fixedsidebar\"><span class=\"title\" translate=\"sidebar.nav.pagelayouts.FIXEDSIDEBAR\">Fixed Sidebar</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.pagelayouts.fixedheadersidebar\"><span class=\"title\" translate=\"sidebar.nav.pagelayouts.FIXEDHEADERSIDEBAR\">Fixed Header and Sidebar</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.pagelayouts.fixedfooter\"><span class=\"title\" translate=\"sidebar.nav.pagelayouts.FIXEDFOOTER\">Fixed Footer</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.pagelayouts.boxedpage\"><span class=\"title\" translate=\"sidebar.nav.pagelayouts.BOXEDPAGE\">Boxed Page</span></a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"app.layouts\"><div class=\"item-content\"><div class=\"item-media\"><letter-icon data=\"{{ \'sidebar.nav.layouts.MAIN\' | translate }}\" char-count=\"2\" size=\"sm\"></letter-icon></div><div class=\"item-inner\"><span class=\"title\" translate=\"sidebar.nav.layouts.MAIN\">Layouts</span></div></div></a></li><li ng-class=\"{\'active open\':$state.includes(\'app.ui\')}\"><a href=\"javascript:void(0)\"><div class=\"item-content\"><div class=\"item-media\"><letter-icon data=\"{{ \'sidebar.nav.element.MAIN\' | translate }}\" char-count=\"2\" size=\"sm\"></letter-icon></div><div class=\"item-inner\"><span class=\"title\" translate=\"sidebar.nav.element.MAIN\">UI Elements</span><i class=\"icon-arrow\"></i></div></div></a><ul class=\"sub-menu\"><li ui-sref-active=\"active\"><a ui-sref=\"app.ui.elements\"><span class=\"title\" translate=\"sidebar.nav.element.ELEMENTS\">Elements</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.ui.buttons\"><span class=\"title\" translate=\"sidebar.nav.element.BUTTONS\">Buttons</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.ui.links\"><span class=\"title\" translate=\"sidebar.nav.element.LINKS\">Links</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.ui.icons\"><span class=\"title\" translate=\"sidebar.nav.element.FONTAWESOME\">Font Awesome Icons</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.ui.lineicons\"><span class=\"title\" translate=\"sidebar.nav.element.LINEARICONS\">Linear Icons</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.ui.lettericons\"><span class=\"title\" translate=\"sidebar.nav.element.LETTERICONS\">Letter Icons</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.ui.modals\"><span class=\"title\" translate=\"sidebar.nav.element.MODALS\">Modals</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.ui.toggle\"><span class=\"title\" translate=\"sidebar.nav.element.TOGGLE\">Toggle</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.ui.tabs_accordions\"><span class=\"title\" translate=\"sidebar.nav.element.TABS\">Tabs &amp; Accordions</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.ui.panels\"><span class=\"title\" translate=\"sidebar.nav.element.PANELS\">Panels</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.ui.notifications\"><span class=\"title\" translate=\"sidebar.nav.element.NOTIFICATIONS\">Notifications</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.ui.sliders\"><span class=\"title\" translate=\"sidebar.nav.element.SLIDERS\">Sliders</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.ui.knob\"><span class=\"title\" translate=\"sidebar.nav.element.KNOB\">Knob component</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.ui.treeview\"><span class=\"title\" translate=\"sidebar.nav.element.TREEVIEW\">Treeview</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.ui.media\"><span class=\"title\" translate=\"sidebar.nav.element.MEDIA\">Media Object</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.ui.nestable\"><span class=\"title\" translate=\"sidebar.nav.element.NESTABLE\">Nestable List</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.ui.typography\"><span class=\"title\" translate=\"sidebar.nav.element.TYPOGRAPHY\">Typography</span></a></li></ul></li><li ng-class=\"{\'active open\':$state.includes(\'app.table\')}\"><a href=\"javascript:void(0)\"><div class=\"item-content\"><div class=\"item-media\"><letter-icon data=\"{{ \'sidebar.nav.tables.MAIN\' | translate }}\" char-count=\"2\" size=\"sm\"></letter-icon></div><div class=\"item-inner\"><span class=\"title\" translate=\"sidebar.nav.tables.MAIN\">Tables</span><i class=\"icon-arrow\"></i></div></div></a><ul class=\"sub-menu\"><li ui-sref-active=\"active\"><a ui-sref=\"app.table.basic\"><span class=\"title\" translate=\"sidebar.nav.tables.BASIC\">Basic Tables</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.table.responsive\"><span class=\"title\" translate=\"sidebar.nav.tables.RESPONSIVE\">Responsive Tables</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.table.dynamic\"><span class=\"title\" translate=\"sidebar.nav.tables.DYNAMIC\">Dynamic Tables</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.table.data\"><span class=\"title\" translate=\"sidebar.nav.tables.DATA\">Advanced Data Tables</span></a></li></ul></li><li ng-class=\"{\'active open\':$state.includes(\'app.form\')}\"><a href=\"javascript:void(0)\"><div class=\"item-content\"><div class=\"item-media\"><letter-icon data=\"{{ \'sidebar.nav.forms.MAIN\' | translate }}\" char-count=\"2\" size=\"sm\"></letter-icon></div><div class=\"item-inner\"><span class=\"title\" translate=\"sidebar.nav.forms.MAIN\">Forms</span><i class=\"icon-arrow\"></i></div></div></a><ul class=\"sub-menu\"><li ui-sref-active=\"active\"><a ui-sref=\"app.form.elements\"><span class=\"title\" translate=\"sidebar.nav.forms.ELEMENTS\">Form Elements</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.form.pickers\"><span class=\"title\" translate=\"sidebar.nav.forms.PICKERS\">Pickers</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.form.xeditable\"><span class=\"title\" translate=\"sidebar.nav.forms.XEDITABLE\">X-Editable</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.form.texteditor\"><span class=\"title\" translate=\"sidebar.nav.forms.TEXTEDITOR\">Text Editor</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.form.wizard\"><span class=\"title\" translate=\"sidebar.nav.forms.WIZARD\">Form Wizard</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.form.validation\"><span class=\"title\" translate=\"sidebar.nav.forms.VALIDATION\">Form Validation</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.form.cropping\"><span class=\"title\" translate=\"sidebar.nav.forms.CROPPING\">Image Cropping</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.form.upload\"><span class=\"title\" translate=\"sidebar.nav.forms.UPLOAD\">Multiple File Upload</span></a></li></ul></li><li ng-class=\"{\'active open\':$state.includes(\'login\')}\"><a href=\"javascript:void(0)\"><div class=\"item-content\"><div class=\"item-media\"><letter-icon data=\"{{ \'sidebar.nav.login.MAIN\' | translate }}\" char-count=\"2\" size=\"sm\"></letter-icon></div><div class=\"item-inner\"><span class=\"title\" translate=\"sidebar.nav.login.MAIN\">Login</span><i class=\"icon-arrow\"></i></div></div></a><ul class=\"sub-menu\"><li ui-sref-active=\"active\"><a ui-sref=\"login.signin\"><span class=\"title\" translate=\"sidebar.nav.login.LOGIN\">Login Form</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"login.registration\"><span class=\"title\" translate=\"sidebar.nav.login.REGISTRATION\">Registration Form</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"login.forgot\" translate=\"sidebar.nav.login.FORGOT\"><span class=\"title\">Forgot Password Form</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"login.lockscreen\" translate=\"sidebar.nav.login.LOCKSCREEN\"><span class=\"title\">Lock Screen</span></a></li></ul></li><li ng-class=\"{\'active open\':$state.includes(\'app.pages\')}\"><a href=\"javascript:void(0)\"><div class=\"item-content\"><div class=\"item-media\"><letter-icon data=\"{{ \'sidebar.nav.pages.MAIN\' | translate }}\" char-count=\"2\" size=\"sm\"></letter-icon></div><div class=\"item-inner\"><span class=\"title\" translate=\"sidebar.nav.pages.MAIN\">Pages</span><i class=\"icon-arrow\"></i></div></div></a><ul class=\"sub-menu\"><li ui-sref-active=\"active\"><a ui-sref=\"app.pages.user\"><span class=\"title\" translate=\"sidebar.nav.pages.USERPROFILE\">User Profile</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.pages.invoice\"><span class=\"title\" translate=\"sidebar.nav.pages.INVOICE\">Invoice</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.pages.timeline\"><span class=\"title\" translate=\"sidebar.nav.pages.TIMELINE\">Timeline</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.pages.calendar\"><span class=\"title\" translate=\"sidebar.nav.pages.CALENDAR\">Calendar</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.pages.messages\"><span class=\"title\" translate=\"sidebar.nav.pages.MESSAGES\">Messages</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.pages.blank\"><span class=\"title\" translate=\"sidebar.nav.pages.BLANKPAGE\">Blank Page</span></a></li></ul></li><li ng-class=\"{\'active open\':$state.includes(\'app.utilities\')}\"><a href=\"javascript:void(0)\"><div class=\"item-content\"><div class=\"item-media\"><letter-icon data=\"{{ \'sidebar.nav.utilities.MAIN\' | translate }}\" char-count=\"2\" size=\"sm\"></letter-icon></div><div class=\"item-inner\"><span class=\"title\" translate=\"sidebar.nav.utilities.MAIN\">Utilities</span><i class=\"icon-arrow\"></i></div></div></a><ul class=\"sub-menu\"><li ui-sref-active=\"active\"><a ui-sref=\"app.utilities.search\"><span class=\"title\" translate=\"sidebar.nav.utilities.SEARCHRESULT\">Search Results</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"error.404\"><span class=\"title\" translate=\"sidebar.nav.utilities.ERROR404\">Error 404</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"error.500\"><span class=\"title\" translate=\"sidebar.nav.utilities.ERROR500\">Error 500</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.utilities.pricing\"><span class=\"title\" translate=\"sidebar.nav.utilities.PRICING\">Pricing Table</span></a></li></ul></li><li><a href=\"javascript:void(0)\"><div class=\"item-content\"><div class=\"item-media\"><letter-icon data=\"{{ \'sidebar.nav.4level.MAIN\' | translate }}\" char-count=\"2\" size=\"sm\"></letter-icon></div><div class=\"item-inner\"><span class=\"title\" translate=\"sidebar.nav.4level.MAIN\">Menu Levels</span><i class=\"icon-arrow\"></i></div></div></a><ul class=\"sub-menu\"><li><a href=\"javascript:;\"><span translate=\"sidebar.nav.4level.Item1.MAIN\">Item 1</span> <i class=\"icon-arrow\"></i></a><ul class=\"sub-menu\"><li><a href=\"javascript:;\"><span translate=\"sidebar.nav.4level.Item1.link1.MAIN\">Sample Link 1</span> <i class=\"icon-arrow\"></i></a><ul class=\"sub-menu\"><li><a href=\"#\" translate=\"sidebar.nav.4level.Item1.link1.LINK1\">Sample Link 1</a></li><li><a href=\"#\" translate=\"sidebar.nav.4level.Item1.link1.LINK2\">Sample Link 2</a></li><li><a href=\"#\" translate=\"sidebar.nav.4level.Item1.link1.LINK3\">Sample Link 3</a></li></ul></li><li><a href=\"javascript:;\"><span translate=\"sidebar.nav.4level.Item1.link2.MAIN\">Sample Link 2</span> <i class=\"icon-arrow\"></i></a><ul class=\"sub-menu\"><li><a href=\"#\" translate=\"sidebar.nav.4level.Item1.link2.LINK1\">Sample Link 1</a></li><li><a href=\"#\" translate=\"sidebar.nav.4level.Item1.link2.LINK2\">Sample Link 2</a></li><li><a href=\"#\" translate=\"sidebar.nav.4level.Item1.link2.LINK3\">Sample Link 3</a></li></ul></li><li><a href=\"javascript:;\"><span translate=\"sidebar.nav.4level.Item1.link3.MAIN\">Sample Link 3</span> <i class=\"icon-arrow\"></i></a><ul class=\"sub-menu\"><li><a href=\"#\" translate=\"sidebar.nav.4level.Item1.link3.LINK1\">Sample Link 1</a></li><li><a href=\"#\" translate=\"sidebar.nav.4level.Item1.link3.LINK2\">Sample Link 2</a></li><li><a href=\"#\" translate=\"sidebar.nav.4level.Item1.link3.LINK3\">Sample Link 3</a></li></ul></li></ul></li><li><a href=\"javascript:;\"><span translate=\"sidebar.nav.4level.Item2.MAIN\">Item 2</span> <i class=\"icon-arrow\"></i></a><ul class=\"sub-menu\"><li><a href=\"javascript:;\"><span translate=\"sidebar.nav.4level.Item2.link1.MAIN\">Sample Link 1</span> <i class=\"icon-arrow\"></i></a><ul class=\"sub-menu\"><li><a href=\"#\" translate=\"sidebar.nav.4level.Item2.link1.LINK1\">Sample Link 1</a></li><li><a href=\"#\" translate=\"sidebar.nav.4level.Item2.link1.LINK2\">Sample Link 2</a></li><li><a href=\"#\" translate=\"sidebar.nav.4level.Item2.link1.LINK3\">Sample Link 3</a></li></ul></li><li><a href=\"javascript:;\"><span translate=\"sidebar.nav.4level.Item2.link2.MAIN\">Sample Link 2</span> <i class=\"icon-arrow\"></i></a><ul class=\"sub-menu\"><li><a href=\"#\" translate=\"sidebar.nav.4level.Item2.link2.LINK1\">Sample Link 1</a></li><li><a href=\"#\" translate=\"sidebar.nav.4level.Item2.link2.LINK2\">Sample Link 2</a></li><li><a href=\"#\" translate=\"sidebar.nav.4level.Item2.link2.LINK3\">Sample Link 3</a></li></ul></li><li><a href=\"javascript:;\"><span translate=\"sidebar.nav.4level.Item2.link3.MAIN\">Sample Link 3</span> <i class=\"icon-arrow\"></i></a><ul class=\"sub-menu\"><li><a href=\"#\" translate=\"sidebar.nav.4level.Item2.link3.LINK1\">Sample Link 1</a></li><li><a href=\"#\" translate=\"sidebar.nav.4level.Item2.link3.LINK2\">Sample Link 2</a></li><li><a href=\"#\" translate=\"sidebar.nav.4level.Item2.link3.LINK3\">Sample Link 3</a></li></ul></li></ul></li><li><a href=\"javascript:;\"><span translate=\"sidebar.nav.4level.Item3.MAIN\">Item 3</span> <i class=\"icon-arrow\"></i></a><ul class=\"sub-menu\"><li><a href=\"javascript:;\"><span translate=\"sidebar.nav.4level.Item3.link1.MAIN\">Sample Link 1</span> <i class=\"icon-arrow\"></i></a><ul class=\"sub-menu\"><li><a href=\"#\" translate=\"sidebar.nav.4level.Item3.link1.LINK1\">Sample Link 1</a></li><li><a href=\"#\" translate=\"sidebar.nav.4level.Item3.link1.LINK2\">Sample Link 2</a></li><li><a href=\"#\" translate=\"sidebar.nav.4level.Item3.link1.LINK3\">Sample Link 3</a></li></ul></li><li><a href=\"javascript:;\"><span translate=\"sidebar.nav.4level.Item3.link2.MAIN\">Sample Link 2</span> <i class=\"icon-arrow\"></i></a><ul class=\"sub-menu\"><li><a href=\"#\" translate=\"sidebar.nav.4level.Item3.link2.LINK1\">Sample Link 1</a></li><li><a href=\"#\" translate=\"sidebar.nav.4level.Item3.link2.LINK2\">Sample Link 2</a></li><li><a href=\"#\" translate=\"sidebar.nav.4level.Item3.link2.LINK3\">Sample Link 3</a></li></ul></li><li><a href=\"javascript:;\"><span translate=\"sidebar.nav.4level.Item3.link3.MAIN\">Sample Link 3</span> <i class=\"icon-arrow\"></i></a><ul class=\"sub-menu\"><li><a href=\"#\" translate=\"sidebar.nav.4level.Item3.link3.LINK1\">Sample Link 1</a></li><li><a href=\"#\" translate=\"sidebar.nav.4level.Item3.link3.LINK2\">Sample Link 2</a></li><li><a href=\"#\" translate=\"sidebar.nav.4level.Item3.link3.LINK3\">Sample Link 3</a></li></ul></li></ul></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"app.maps\"><div class=\"item-content\"><div class=\"item-media\"><letter-icon data=\"{{ \'sidebar.nav.maps.MAIN\' | translate }}\" char-count=\"2\" size=\"sm\"></letter-icon></div><div class=\"item-inner\"><span class=\"title\" translate=\"sidebar.nav.maps.MAIN\">Maps</span></div></div></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.charts\"><div class=\"item-content\"><div class=\"item-media\"><letter-icon data=\"{{ \'sidebar.nav.charts.MAIN\' | translate }}\" char-count=\"2\" size=\"sm\"></letter-icon></div><div class=\"item-inner\"><span class=\"title\" translate=\"sidebar.nav.charts.MAIN\">Charts</span></div></div></a></li></ul><div class=\"navbar-title\"><span translate=\"sidebar.heading.FEATURES\">Core Features</span></div><ul class=\"folders\"><li><a ui-sref=\"landing.welcome\"><div class=\"item-content\"><div class=\"item-media\"><letter-icon data=\"{{ \'sidebar.nav.landing.MAIN\' | translate }}\" char-count=\"2\" size=\"sm\"></letter-icon></div><div class=\"item-inner\"><span class=\"title\" translate=\"sidebar.nav.landing.MAIN\">Landing Page</span></div></div></a></li><li><a href=\"http://www.cliptheme.com/demo/packet/LAYOUT-RTL-4/\" target=\"_blank\"><div class=\"item-content\"><div class=\"item-media\"><letter-icon data=\"{{ \'sidebar.nav.rtl.MAIN\' | translate }}\" char-count=\"2\" size=\"sm\"></letter-icon></div><div class=\"item-inner\"><span class=\"title\" translate=\"sidebar.nav.rtl.MAIN\">RTL Version</span></div></div></a></li></ul>");
$templateCache.put("/app/main/settings.html","<button ct-toggle=\"toggle\" target=\"settings\" parent-active-class=\"active\" class=\"btn btn-default\"><i class=\"fa fa-spin fa-gear\"></i></button><div class=\"panel-heading ng-scope\" translate=\"setting.MAIN\">Style Selector</div><div class=\"panel-body ng-scope\"><div class=\"setting-box clearfix\"><span class=\"setting-title pull-left\" translate=\"setting.FIXEDHEADER\">Fixed header</span> <span class=\"setting-switch pull-right\"><switch ng-model=\"app.layout.isNavbarFixed\" class=\"green\"></switch></span></div><div class=\"setting-box clearfix hidden-md hidden-lg\" ng-hide=\"app.layout.isBoxedPage\"><span class=\"setting-title pull-left\" translate=\"setting.FIXEDSIDEBAR\">Fixed sidebar</span> <span class=\"setting-switch pull-right\"><switch ng-model=\"app.layout.isSidebarFixed\" class=\"green\"></switch></span></div><div class=\"setting-box clearfix hidden-md hidden-lg\"><span class=\"setting-title pull-left\" translate=\"setting.CLOSEDSIDEBAR\">Closed sidebar</span> <span class=\"setting-switch pull-right\"><switch ng-model=\"app.layout.isSidebarClosed\" class=\"green\"></switch></span></div><div class=\"setting-box clearfix\"><span class=\"setting-title pull-left\" translate=\"setting.FIXEDFOOTER\">Fixed footer</span> <span class=\"setting-switch pull-right\"><switch ng-model=\"app.layout.isFooterFixed\" class=\"green\"></switch></span></div><div class=\"colors-row setting-box\"><div class=\"color-theme lyt4-theme-1\"><div class=\"color-layout\"><label ng-click=\"app.layout.theme=\'lyt4-theme-1\'; app.layout.logo=\'assets/images/logo2.png\';\"><input type=\"radio\" name=\"setting-theme\" ng-model=\"app.layout.theme\" value=\"lyt4-theme-1\"> <span class=\"fa fa-check-circle lyt-check text-extra-large\"></span> <span class=\"split header\"><span class=\"color th-header\"></span> <span class=\"color th-collapse\"><i class=\"color-button\"></i></span></span> <span class=\"split\"><span class=\"color th-sidebar\"><i class=\"element\"></i></span> <span class=\"color th-body\"></span></span></label></div></div><div class=\"color-theme lyt4-theme-2\"><div class=\"color-layout\"><label ng-click=\"app.layout.theme=\'lyt4-theme-2\'; app.layout.logo=\'assets/images/logo.png\';\"><input type=\"radio\" name=\"setting-theme\" ng-model=\"app.layout.theme\" value=\"lyt4-theme-2\"> <span class=\"fa fa-check-circle lyt-check text-extra-large\"></span> <span class=\"split header\"><span class=\"color th-header\"></span> <span class=\"color th-collapse\"><i class=\"color-button\"></i></span></span> <span class=\"split\"><span class=\"color th-sidebar\"><i class=\"element\"></i></span> <span class=\"color th-body\"></span></span></label></div></div></div><div class=\"colors-row setting-box\"><div class=\"color-theme lyt4-theme-3\"><div class=\"color-layout\"><label ng-click=\"app.layout.theme=\'lyt4-theme-3\'; app.layout.logo=\'assets/images/logo.png\';\"><input type=\"radio\" name=\"setting-theme\" ng-model=\"app.layout.theme\" value=\"lyt4-theme-3\"> <span class=\"fa fa-check-circle lyt-check text-extra-large\"></span> <span class=\"split header\"><span class=\"color th-header\"></span> <span class=\"color th-collapse\"><i class=\"color-button\"></i></span></span> <span class=\"split\"><span class=\"color th-sidebar\"><i class=\"element\"></i></span> <span class=\"color th-body\"></span></span></label></div></div><div class=\"color-theme lyt4-theme-4\"><div class=\"color-layout\"><label ng-click=\"app.layout.theme=\'lyt4-theme-4\'; app.layout.logo=\'assets/images/logo.png\';\"><input type=\"radio\" name=\"setting-theme\" ng-model=\"app.layout.theme\" value=\"lyt4-theme-4\"> <span class=\"fa fa-check-circle lyt-check text-extra-large\"></span> <span class=\"split header\"><span class=\"color th-header\"></span> <span class=\"color th-collapse\"><i class=\"color-button\"></i></span></span> <span class=\"split\"><span class=\"color th-sidebar\"><i class=\"element\"></i></span> <span class=\"color th-body\"></span></span></label></div></div></div><div class=\"colors-row setting-box\"><div class=\"color-theme lyt4-theme-5\"><div class=\"color-layout\"><label ng-click=\"app.layout.theme=\'lyt4-theme-5\'; app.layout.logo=\'assets/images/logo.png\';\"><input type=\"radio\" name=\"setting-theme\" ng-model=\"app.layout.theme\" value=\"lyt4-theme-5\"> <span class=\"fa fa-check-circle lyt-check text-extra-large\"></span> <span class=\"split header\"><span class=\"color th-header\"></span> <span class=\"color th-collapse\"><i class=\"color-button\"></i></span></span> <span class=\"split\"><span class=\"color th-sidebar\"><i class=\"element\"></i></span> <span class=\"color th-body\"></span></span></label></div></div><div class=\"color-theme lyt4-theme-6\"><div class=\"color-layout\"><label ng-click=\"app.layout.theme=\'lyt4-theme-6\'; app.layout.logo=\'assets/images/logo2.png\';\"><input type=\"radio\" name=\"setting-theme\" ng-model=\"app.layout.theme\" value=\"lyt4-theme-6\"> <span class=\"fa fa-check-circle lyt-check text-extra-large\"></span> <span class=\"split header\"><span class=\"color th-header\"></span> <span class=\"color th-collapse\"><i class=\"color-button\"></i></span></span> <span class=\"split\"><span class=\"color th-sidebar\"><i class=\"element\"></i></span> <span class=\"color th-body\"></span></span></label></div></div></div></div><div class=\"panel-footer\"><button class=\"btn btn-primary ladda-button btn-squared btn-sm btn-o\" ng-click=\"resetLayout()\" ladda=\"loading_reset\" data-style=\"slide-up\" ng-init=\"!loading_reset\" data-spinner-size=\"10\" data-spinner-color=\"#999999\">Reset</button> <button class=\"btn btn-primary ladda-button pull-right btn-squared btn-sm btn-wide\" ng-click=\"saveLayout()\" ladda=\"loading_save\" data-style=\"slide-up\" ng-init=\"!loading_save\" data-spinner-size=\"10\">Save</button></div>");
$templateCache.put("/app/main/sidebar.html","<div class=\"search-form hidden-md hidden-lg\"><form class=\"navbar-form\" role=\"search\"><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"{{ \'search.PLACEHOLDER\' | translate }}\"> <button class=\"btn search-button\" type=\"submit\"><i class=\"ti-search\"></i></button></div></form></div><div class=\"nav-user-wrapper\"><div class=\"media\"><div class=\"media-left\"><a class=\"profile-card-photo\" href=\"#\"><img alt=\"\" src=\"assets/images/avatar-1.jpg\"></a></div><div class=\"media-body\"><span class=\"media-heading text-white\">Peter Clark</span><div class=\"text-small text-white-transparent\">UI Designer</div></div><div class=\"media-right media-middle\"><div uib-dropdown=\"\" is-open=\"status.isopen\"><a href=\"\" class=\"dropdown-toggle btn btn-transparent text-white\" uib-dropdown-toggle=\"\"><i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu pull-right animated fadeInRight\"><li><a ui-sref=\"app.pages.user\" translate=\"topbar.user.PROFILE\">My Profile</a></li><li><a ui-sref=\"app.pages.calendar\" translate=\"topbar.user.CALENDAR\">My Calendar</a></li><li><a ui-sref=\"app.pages.messages\" translate=\"topbar.user.MESSAGES\">My Messages (3)</a></li><li><a ui-sref=\"login.lockscreen\" translate=\"topbar.user.LOCKSCREEN\">Lock Screen</a></li><li class=\"divider\"></li><li><a ui-sref=\"login.signin\" translate=\"topbar.user.LOGOUT\">Log Out</a></li></ul></div></div></div></div><nav data-ng-include=\"\'/app/main/nav.html\'\"></nav>");
$templateCache.put("/app/main/top-navbar.html","<header class=\"navbar navbar-default navbar-static-top hidden-print\"><div class=\"navbar-header\"><button href=\"javascript:void(0)\" class=\"mobile-alternative btn no-radius pull-left hidden-md hidden-lg\" id=\"horizontal-menu-toggler\" ng-click=\"menuToggle()\" v-pressable=\"\"><i class=\"fa fa-bars\"></i></button> <button href=\"javascript:void(0)\" class=\"sidebar-mobile-toggler btn no-radius pull-left hidden-md hidden-lg\" id=\"sidebar-toggler\" ng-click=\"toggle(\'sidebar\')\" v-pressable=\"\"><i class=\"fa fa-bars\"></i></button> <a class=\"navbar-brand\" ui-sref=\"app.dashboard\"><img ng-src=\"{{app.layout.logo}}\" alt=\"{{app.name}}\" width=\"148px\"></a> <a class=\"navbar-brand navbar-brand-collapsed\" ui-sref=\"app.dashboard\"><img ng-src=\"{{app.layout.logoCollapsed}}\" alt=\"\"></a></div><div class=\"navbar-collapse collapse\" uib-collapse=\"navbarCollapsed\" ng-init=\"navbarCollapsed = true\" off-click=\"navbarCollapsed = true\" off-click-if=\"!navbarCollapsed\" off-click-filter=\"\'#menu-toggler\'\"><ul class=\"nav navbar-left hidden-sm hidden-xs\"><li class=\"sidebar-toggler-wrapper\"><div><button href=\"javascript:void(0)\" class=\"btn sidebar-toggler visible-md visible-lg\" ng-click=\"app.layout.isSidebarClosed = !app.layout.isSidebarClosed\" v-pressable=\"\"><i class=\"fa fa-bars\"></i></button></div></li><li><a ng-click=\"goFullscreen()\"><i class=\"fa fa-expand\" ng-show=\"!isFullscreen\"></i> <i class=\"fa fa-compress\" ng-show=\"isFullscreen\"></i></a></li><li><form role=\"search\" class=\"navbar-form main-search\"><div class=\"form-group\"><input type=\"text\" placeholder=\"{{ \'search.PLACEHOLDER\' | translate }}\" class=\"form-control\"> <button class=\"btn search-button\" type=\"submit\"><i class=\"fa fa-search\"></i></button></div></form></li></ul><ul class=\"nav navbar-right\" ct-fullheight=\"window\" data-ct-fullheight-exclusion=\"header\" data-ct-fullheight-if=\"isSmallDevice\"><li class=\"dropdown\" uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a href=\"\" class=\"dropdown-toggle\" uib-dropdown-toggle=\"\"><notification-icon count=\"scopeVariable\"><i class=\"fa fa-envelope\"></i></notification-icon></a><ul class=\"dropdown-menu dropdown-light dropdown-messages dropdown-large animated fadeInUpShort\"><li><span class=\"dropdown-header\" translate=\"topbar.messages.HEADER\">Unread messages</span></li><li><div class=\"drop-down-wrapper ps-container\"><ul></ul></div></li><li class=\"view-all\"><a href=\"javascript:void(0)\" translate=\"topbar.messages.SEEALL\">See All</a></li></ul></li><li class=\"dropdown\" uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a href=\"\" class=\"dropdown-toggle\" uib-dropdown-toggle=\"\"><i class=\"fa fa-bell\"></i></a><ul class=\"dropdown-menu dropdown-light dropdown-messages dropdown-large animated fadeInUpShort\"><li><span class=\"dropdown-header\" translate=\"topbar.activities.HEADER\">You have new notifications</span></li><li></li><li class=\"view-all\"><a href=\"javascript:void(0)\" translate=\"topbar.activities.SEEALL\">See All</a></li></ul></li><li class=\"dropdown\" uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a href=\"\" class=\"dropdown-toggle\" uib-dropdown-toggle=\"\"><i class=\"flag-icon\" ng-class=\"\'flagstyle\'| translate\"></i><span>&nbsp;{{language.selected}}</span></a><ul role=\"menu\" class=\"dropdown-menu dropdown-light animated fadeInUpShort\"><li ng-repeat=\"(localeId, langName) in language.available\"><a ng-click=\"language.set(localeId, $event)\" href=\"javascript:void(0)\" class=\"menu-toggler\">{{langName}}</a></li></ul></li></ul><div class=\"close-handle visible-xs-block menu-toggler\" ng-click=\"navbarCollapsed = true\" ng-swipe-up=\"navbarCollapsed = true\"><div class=\"arrow-left\"></div><div class=\"arrow-right\"></div></div></div></header><div ng-include=\"\'/app/main/horizontal-menu.html\'\" class=\"navbar navbar-default horizontal-menu collapse\" uib-collapse=\"horizontalNavbarCollapsed\" off-click=\"menuInit(true)\" off-click-if=\"!horizontalNavbarCollapsed\" off-click-filter=\"\'#horizontal-menu-toggler\'\"></div>");
$templateCache.put("/app/mechanic/mechanic-view.html","<div ui-view=\"\"><div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"mechanic.view.title\">Mechanic View</h4><span class=\"mainDescription\" translate=\"mechanic.view.description\">Quickly service inventory items.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div insight-placeholder=\"vm.placeholder\"></div><div inventory-aside=\"vm.items\" visible=\"vm.asideInventory\"></div><div class=\"container-fluid\" ng-show=\"vm.items.length > 0\"><div class=\"row margin-bottom-15\"><div class=\"col-md-1\"><label class=\"control-label\">Fixed Asset #</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.filter.asset\" ng-keyup=\"vm.filterItems()\" placeholder=\"Asset #\"></div><div class=\"col-md-2\"><label class=\"control-label\">Inventory Location</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select a location\" ng-model=\"vm.filter.location\" no-results-text=\"\'There are no locations.\'\" ng-options=\"location.identity as location.name for location in vm.locations\"></select></div><div class=\"col-md-2\"><label class=\"control-label\">Status(es)</label><select class=\"form-control\" chosen=\"\" multiple=\"\" data-placeholder=\"Select statuses\" ng-change=\"vm.filterItems()\" ng-model=\"vm.filter.statuses\" no-results-text=\"\'There are no statuses.\'\" ng-options=\"status.original as status.name for status in vm.statuses\"></select></div><div class=\"col-md-2\"><label class=\"control-label\">2<sup>nd</sup> Status(es)</label><select class=\"form-control\" chosen=\"\" multiple=\"\" data-placeholder=\"Select statuses\" ng-change=\"vm.filterItems()\" ng-model=\"vm.filter.secondStatuses\" no-results-text=\"\'No available second statuses.\'\" ng-options=\"status.original as status.name for status in vm.secondStatuses\"></select></div><div class=\"col-md-2\"><label class=\"control-label\">Next Inspection Date</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.filter.inspection\" ng-keyup=\"vm.filterItems()\" placeholder=\"Inspection\"></div><div class=\"col-md-1\"><label class=\"control-label\">Expected From WS</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.filter.workshop\" ng-keyup=\"vm.filterItems()\" placeholder=\"Workshop\"></div><div class=\"col-md-2\"><label class=\"control-label\">Next Reservation Date</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.filter.reservation\" ng-keyup=\"vm.filterItems()\" placeholder=\"Reservation\"></div></div><div class=\"panel panel-white\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div st-table=\"vm.displayedItems\" st-safe-src=\"vm.items\" st-pipe=\"vm.filterPipe\"><table class=\"table table-hover\"><thead><th>Inventory Item</th><th>Expected from Workshop</th><th>Next Reservation Date</th><th>Next Inspection Date</th><th></th></thead><tbody><tr ng-show=\"vm.displayedItems.length === 0 && vm.items.length > 0\"><td colspan=\"4\" class=\"text-center\">There are no service records that match your search criteria.</td></tr><tr ng-repeat=\"item in vm.displayedItems\"><td><div class=\"padding-10\"><div class=\"block\"><span class=\"text-muted\">Fixed Asset #</span><strong>{{ ::item.asset }}</strong></div><span class=\"text-small text-muted\">{{ ::item.description }}</span><div class=\"block margin-top-10\"><span class=\"label\" ng-style=\"{ \'color\' : item.status.primary_color, \'background\' : item.status.background_color }\">{{ ::item.status.name }}</span> <span class=\"label\" ng-style=\"{ \'color\' : secondStatus.primary_color, \'background\' : secondStatus.background_color }\">{{ ::secondStatus.name }}</span></div></div></td><td>{{ vm.parseDate(item.next_expected_workshop_date) }}</td><td>{{ vm.parseDate(item.next_reservation_date) }}</td><td>{{ vm.parseDate(item.next_inspection_date) }}</td><td class=\"text-center\"><a ui-sref=\"app.inventory.service({identity:item.identity})\" class=\"btn btn-transparent btn-xs tooltips\" tooltip-placement=\"top\" uib-tooltip=\"Edit\"><i class=\"fa fa-pencil fa fa-white\"></i></a></td></tr></tbody><tfoot ng-show=\"vm.displayedItems.length > 9\"><tr><td colspan=\"4\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div></div></div>");
$templateCache.put("/app/planning/planning.html","<div ui-view=\"\"><div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"planning.index.title\">Planning</h4><span class=\"mainDescription\" translate=\"planning.index.description\">Quickly confirm inventory items.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div insight-placeholder=\"vm.placeholder\"></div><div class=\"container-fluid\" ng-show=\"vm.reservations.length > 0\"><div class=\"row\"><div class=\"col-md-4 col-xs-6\"><label class=\"control-label\">Filter By</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select a filter\" ng-model=\"vm.activeFilter\" no-results-text=\"\'There are no locations.\'\" ng-options=\"filter as filter for filter in vm.availableFilters\"><option value=\"\"></option></select></div><div class=\"col-md-3 col-xs-6\"><div class=\"form-group\" ng-if=\"[\'Customer\', \'Inventory Location\', \'Status\'].indexOf(vm.activeFilter) === -1\"><label class=\"control-label\">&nbsp;</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.newFilter\" ng-enter=\"vm.applyFilter()\"></div><div class=\"form-group\" ng-if=\"vm.activeFilter === \'Inventory Location\'\"><label class=\"control-label\">Inventory Location</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select a location\" ng-model=\"vm.newFilter\" no-results-text=\"\'There are no locations.\'\" ng-options=\"location.identity as location.name for location in vm.locations\"><option value=\"\"></option></select></div><div class=\"form-group\" ng-if=\"vm.activeFilter === \'Status\'\"><label class=\"control-label\">Status(es)</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select statuses\" ng-model=\"vm.newFilter\" no-results-text=\"\'There are no statuses.\'\" ng-options=\"status.identity as status.name for status in vm.statuses\"><option value=\"\"></option></select></div><div class=\"form-group\" ng-if=\"vm.activeFilter === \'Customer\'\"><label class=\"control-label\">Customer</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select customer\" ng-model=\"vm.newFilter\" no-results-text=\"\'There are no companies.\'\" ng-options=\"company.identity as company.name for company in vm.companies\"><option value=\"\"></option></select></div></div><div class=\"col-md-1 col-xs-12\"><button type=\"button\" class=\"btn btn-primary top-spacer-1\" ng-click=\"vm.applyFilter()\">Apply</button></div><div class=\"col-md-2 col-xs-10\"><label class=\"control-label\">Driver</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select driver\" ng-model=\"vm.driver\" no-results-text=\"\'There are no drivers.\'\" ng-options=\"driver.identity as driver.name for driver in vm.drivers\"></select></div><div class=\"col-md-2 col-xs-2\"><button type=\"button\" class=\"btn btn-primary top-spacer-1\" ng-click=\"vm.assignDriver()\">Assign Driver</button></div></div><div class=\"row\" ng-show=\"vm.filters.length > 0\"><div class=\"col-md-6\"><p><em>Active Filters</em></p><ul ng-repeat=\"filter in vm.filters\"><li><span><em>{{ filter.type}}</em> [{{ filter.text}}] <a ng-click=\"vm.removeFilter(filter)\">x</a></span></li></ul></div></div><hr><div class=\"panel panel-white\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div st-table=\"vm.filteredItems\" st-safe-src=\"vm.items\" st-pipe=\"vm.filterPipe\"><table class=\"table no-margin table-hover\"><tbody><tr ng-if=\"vm.filteredItems.length === 0\"><td colspan=\"7\" class=\"text-center\">There are no items that match your filter criteria.</td></tr><tr ng-repeat=\"item in vm.filteredItems\"><td><div class=\"checkbox clip-check check-primary check-md checkbox-inline\"><input type=\"checkbox\" id=\"{{ ::item.next_reservation.identity }}\" value=\"{{ ::item.next_reservation.identity }}\" ng-click=\"vm.selectRow(item.next_reservation.identity)\"> <label for=\"{{ ::item.next_reservation.identity }}\"></label></div></td><td><div class=\"padding-10\"><div class=\"block\"><span class=\"text-muted\">Fixed Asset #</span><strong>{{ ::item.asset }}</strong></div><span class=\"text-small text-muted\">{{ ::item.description }}</span><div class=\"block margin-top-10\"><span class=\"label\" ng-style=\"{ \'color\' : item.status.primary_color, \'background\' : item.status.background_color }\">{{ ::item.status.name }}</span> <span class=\"label\" ng-style=\"{ \'color\' : item.secondStatus.primary_color, \'background\' : item.secondStatus.background_color }\">{{ ::item.secondStatus.name }}</span></div></div></td><td><div class=\"padding-10\"><span class=\"text-muted\">Current Customer</span><div class=\"block\"><strong>{{ item.next_reservation.company.name }}</strong> <span ng-if=\"item.next_reservation === null\"><em>None</em></span></div></div></td><td><div class=\"padding-10\"><div class=\"block\"><span>{{ item.next_reservation.site_address }}</span><br><span>{{ item.next_reservation.site_city }}</span></div></div></td><td><div class=\"padding-10\"><div class=\"block\"><span>Expected On Rent Date</span><p>{{ vm.toDate(item.next_reservation.expected_on_rent) | date: \'MM/dd/yyyy\' }}</p></div></div></td><td><div class=\"padding-10\"><div class=\"block\"><p>Expected from Workshop</p></div></div></td><td><div class=\"padding-10\"><div class=\"block\"><span>Actual Off Rent Date</span><p ng-if=\"vm.toDate(item.next_reservation.expected_off_rent)\">{{ vm.toDate(item.next_reservation.expected_off_rent) | date: \'MM/dd/yyyy\' }}</p><p ng-if=\"!vm.toDate(item.next_reservation.expected_off_rent)\"><em>N/A</em></p></div></div></td><td><div class=\"col-xs-1 no-padding text-center\"><a yardman-status-aside=\"vm.items\" identity=\"{{ item.identity }}\" class=\"btn btn-transparent btn-xs tooltips\" tooltip-placement=\"top\" uib-tooltip=\"Edit\"><i class=\"fa fa-pencil fa fa-white\"></i></a></div></td></tr></tbody><tfoot ng-show=\"vm.displayedReservations.length > 9\"><tr><td colspan=\"7\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div></div></div>");
$templateCache.put("/app/rental/rental.html","<div ui-view=\"\"><div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"rental.index.title\">Rental Desk</h4><span class=\"mainDescription\" translate=\"rental.index.description\">Quickly confirm inventory items.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div insight-placeholder=\"vm.placeholder\"></div><div class=\"container-fluid\" ng-show=\"vm.items.length > 0\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-4 col-xs-6 col-md-offset-2\"><label class=\"control-label\">Filter By</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select a filter\" ng-model=\"vm.activeFilter\" no-results-text=\"\'There are no locations.\'\" ng-options=\"filter as filter for filter in vm.availableFilters\"><option value=\"\"></option></select></div><div class=\"col-md-3 col-xs-6\"><div class=\"form-group\" ng-if=\"[\'Customer\', \'Inventory Location\', \'Status\', \'Secondary Status\'].indexOf(vm.activeFilter) === -1\"><label class=\"control-label\">&nbsp;</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.newFilter\" ng-enter=\"vm.applyFilter()\" autofocus=\"\"></div><div class=\"form-group\" ng-if=\"vm.activeFilter === \'Inventory Location\'\"><label class=\"control-label\">Inventory Location</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select a location\" ng-model=\"vm.newFilter\" no-results-text=\"\'There are no locations.\'\" ng-options=\"location.identity as location.name for location in vm.locations\"><option value=\"\"></option></select></div><div class=\"form-group\" ng-if=\"vm.activeFilter === \'Status\'\"><label class=\"control-label\">Status(es)</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select statuses\" ng-model=\"vm.newFilter\" no-results-text=\"\'There are no statuses.\'\" ng-options=\"status.identity as status.name for status in vm.statuses\"><option value=\"\"></option></select></div><div class=\"form-group\" ng-if=\"vm.activeFilter === \'Secondary Status\'\"><label class=\"control-label\">Status(es)</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select statuses\" ng-model=\"vm.newFilter\" no-results-text=\"\'There are no statuses.\'\" ng-options=\"status.identity as status.name for status in vm.secondStatuses\"><option value=\"\"></option></select></div><div class=\"form-group\" ng-if=\"vm.activeFilter === \'Customer\'\"><label class=\"control-label\">Customer</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select customer\" ng-model=\"vm.newFilter\" no-results-text=\"\'There are no companies.\'\" ng-options=\"company.identity as company.name for company in vm.companies\"><option value=\"\"></option></select></div></div><div class=\"col-md-1 col-xs-12\"><button type=\"button\" class=\"btn btn-primary top-spacer-1\" ng-click=\"vm.applyFilter()\">Apply</button></div></div><div class=\"row\" ng-show=\"vm.filters.length > 0\"><div class=\"col-md-8 col-md-offset-2\"><p><em>Active Filters</em></p><ul ng-repeat=\"filter in vm.filters\"><li><span><em>{{ filter.type}}</em> [{{ filter.text}}] <a ng-click=\"vm.removeFilter(filter)\">x</a></span></li></ul></div></div><hr><div class=\"panel panel-white\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div st-table=\"vm.displayedItems\" st-safe-src=\"vm.items\" st-pipe=\"vm.filterPipe\"><table class=\"table no-margin table-hover\"><tbody><tr ng-if=\"vm.displayedItems.length === 0 && vm.items.length > 0\"><td class=\"text-center\" colspan=\"7\">There are no items that match your search filters.</td></tr><tr ng-repeat=\"item in vm.displayedItems\"><td><div class=\"padding-10\"><div class=\"block\"><span class=\"text-muted\">Fixed Asset #</span><strong>{{ ::item.asset }}</strong></div><span class=\"text-small text-muted\">{{ ::item.description }}</span><div class=\"block margin-top-10\"><span class=\"label\" ng-style=\"{ \'color\' : item.status.primary_color, \'background\' : item.status.background_color }\">{{ ::item.status.name }}</span> <span class=\"label\" ng-style=\"{ \'color\' : item.second_status.primary_color, \'background\' : item.second_status.background_color }\">{{ ::item.second_status.name }}</span></div></div></td><td><div class=\"padding-10\"><span class=\"text-muted\">Current Customer</span><div class=\"block\"><strong>{{ item.next_reservation.company.name }}</strong> <span ng-if=\"item.next_reservation === null\"><em>None</em></span></div></div></td><td><div class=\"padding-10\"><div class=\"block\"><span>{{ item.next_reservation.site_address }}</span><br><span>{{ item.next_reservation.site_city }}</span></div></div></td><td><div class=\"padding-10\"><div class=\"block\"><span>Expected On Rent Date</span><p>{{ vm.toDate(item.next_reservation.expected_on_rent) | date: \'MM/dd/yyyy\' }}</p></div></div></td><td><div class=\"padding-10\"><div class=\"block\"><p>Expected from Workshop</p></div></div></td><td><div class=\"padding-10\"><div class=\"block\"><span>Actual Off Rent Date</span><p ng-if=\"vm.toDate(item.next_reservation.expected_off_rent)\">{{ vm.toDate(item.next_reservation.expected_off_rent) | date: \'MM/dd/yyyy\' }}</p><p ng-if=\"!vm.toDate(item.next_reservation.expected_off_rent)\"><em>N/A</em></p></div></div></td><td><div class=\"no-padding text-center\"><a reservation-aside=\"vm.items\" identity=\"{{ item.identity }}\" class=\"btn btn-transparent btn-xs tooltips\">Reservation</a> <a confirmation-aside=\"vm.items\" identity=\"{{ item.identity }}\" class=\"btn btn-transparent btn-xs tooltips\">Confirmation</a></div></td></tr></tbody><tfoot ng-show=\"vm.displayedItems.length > 9\"><tr><td colspan=\"7\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div><div></div></div></div></div></div></div></div></div>");
$templateCache.put("/app/settings/company-classification-settings.html","<div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"companies.classification.title\">Company Classifications</h4><span class=\"mainDescription\" translate=\"companies.classification.description\">Manage company classifications.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div insight-placeholder=\"vm.placeholder\"></div><div class=\"container-fluid\" ng-show=\"vm.classifications.length > 0\"><div class=\"row margin-bottom-15\"><div class=\"col-md-12 text-right\"><a type=\"button\" class=\"btn btn-primary\" company-classification-aside=\"vm.classifications\" visible=\"vm.asideClassification\">Create Classification</a></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"panel panel-white\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div st-table=\"vm.displayedClassifications\" st-safe-src=\"vm.classifications\"><table class=\"table table-hover\"><thead><tr><th st-sort-default=\"true\" st-skip-natural=\"true\" st-sort=\"name\">Name</th><th st-skip-natural=\"true\" st-sort=\"created_at\">Created</th><th></th></tr><tr><td><input type=\"search\" st-search=\"name\" class=\"form-control\" placeholder=\"Search Name\"></td><td><input type=\"search\" st-search=\"created_at\" class=\"form-control\" placeholder=\"Search...\"></td><td></td></tr></thead><tbody><tr ng-if=\"vm.displayedClassifications.length == 0 && vm.classifications.length > 0\"><td class=\"text-center\" colspan=\"3\">There are no classifications that match your search criteria.</td></tr><tr ng-repeat=\"classification in vm.displayedClassifications\"><td>{{ ::classification.name }}</td><td>{{ ::classification.created_at | date : \'MMMM dd, yyyy\' }}</td><td class=\"center\"><div class=\"visible-md visible-lg hidden-sm hidden-xs\"><a company-classification-aside=\"vm.classifications\" identity=\"{{ ::classification.identity }}\" class=\"btn btn-transparent btn-xs tooltips\" tooltip-placement=\"top\" uib-tooltip=\"Edit\"><i class=\"fa fa-pencil fa fa-white\"></i></a></div><div class=\"visible-xs visible-sm hidden-md hidden-lg\"><div class=\"btn-group dropdown\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-o btn-sm dropdown-toggle\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i>&nbsp;<span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right dropdown-light\" role=\"menu\"><li><a company-classification-aside=\"vm.classifications\" identity=\"{{ ::classification.identity }}\">Edit</a></li></ul></div></div></td></tr></tbody><tfoot ng-show=\"vm.classifications.length > 9\"><tr><td colspan=\"3\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div></div></div></div>");
$templateCache.put("/app/settings/company-settings.html","<div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"companies.index.title\">Companies</h4><span class=\"mainDescription\" translate=\"companies.index.description\">All of the existing customers that have been entered into the system.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div insight-placeholder=\"vm.placeholder\"></div><div class=\"container-fluid\" ng-show=\"vm.companies.length > 0\"><div class=\"row\"><div class=\"col-md-12\"><uib-tabset class=\"tabbable\"><uib-tab heading=\"Companies\"><div class=\"panel panel-white\"><div class=\"panel-body\"><div class=\"text-right\"><a company-aside=\"vm.companies\" class=\"btn btn-primary\">Create Company</a></div><div st-table=\"vm.displayedCompanies\" st-safe-src=\"vm.companies\" st-set-filter=\"smartTableFilter\"><table class=\"table table-hover table-responsive\"><thead><tr><th st-skip-natural=\"true\" st-sort=\"name\" st-sort-default=\"true\">Name</th><th st-skip-natural=\"true\" st-sort=\"customer_number\">Customer #</th><th st-skip-natural=\"true\" st-sort=\"billing_address\">Billing Address</th><th st-skip-natural=\"true\" st-sort=\"billing_city\">City</th><th st-skip-natural=\"true\" st-sort=\"billing_state\">State</th><th st-skip-natural=\"true\" st-sort=\"created_at\">Customer Since</th><th></th></tr><tr><td><input st-search=\"name\" class=\"form-control\" placeholder=\"Search by name\"></td><td><input st-search=\"customer_number\" class=\"form-control\" placeholder=\"Search by customer number\"></td><td><input st-search=\"billing_address\" class=\"form-control\" placeholder=\"Search by billing address\"></td><td><input st-search=\"billing_city\" class=\"form-control\" placeholder=\"Search by city\"></td><td><input st-search=\"billing_state\" class=\"form-control\" placeholder=\"Search by state\"></td><td><input st-search=\"created_at\" class=\"form-control\" placeholder=\"Customer since\"></td><td></td></tr></thead><tbody><tr ng-repeat=\"company in vm.displayedCompanies\"><td>{{ company.name }}</td><td>{{ company.customer_number }}</td><td>{{ company.billing_address }}</td><td>{{ company.billing_city }}</td><td>{{ company.billing_state }}</td><td>{{ company.created_at | date : \'MMMM dd, yyyy\' }}</td><td class=\"center\"><a company-aside=\"vm.companies\" identity=\"{{ ::company.identity }}\" class=\"btn btn-transparent btn-xs\" tooltip-placement=\"top\" uib-tooltip=\"Edit\"><i class=\"fa fa-pencil fa fa-white\"></i></a></td></tr><tfoot ng-show=\"vm.displayedCompanies.length > 9\"><tr><td colspan=\"7\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></tbody></table></div></div></div></uib-tab><uib-tab heading=\"Trash Bin\"><div class=\"panel panel-white\"><div class=\"panel-body\"><div st-table=\"vm.displayedDeleted\" st-safe-src=\"vm.deletedCompanies\"><table class=\"table table-hover\"><thead><tr><th st-sort=\"name\" st-sort-default=\"true\">Name</th><th st-sort=\"customer_number\">Customer Number</th><th st-sort=\"billing_state\">Location</th><th st-sort=\"deleted_at\">Deleted On</th><th></th></tr><tr><td><input st-search=\"name\" class=\"form-control\" placeholder=\"Search by name\"></td><td><input st-search=\"customer_number\" class=\"form-control\" placeholder=\"Search by customer number\"></td><td><input st-search=\"\" class=\"form-control\" placeholder=\"Search by location\"></td><td><input st-search=\"\" class=\"form-control\" placeholder=\"Deleted at\"></td><td></td></tr></thead><tbody><tr><td colspan=\"5\" class=\"text-center\">There are no deleted companies that match your search criteria.</td></tr><tr ng-repeat=\"company in vm.displayedDeleted\"><td>{{ ::company.name }}</td><td>{{ ::company.customer_number }}</td><td>{{ ::company.billing_city }}, {{ ::company.billing_state }}</td><td>{{ company.deleted_at * 1000 | date : \'MMMM dd, yyyy\' }}</td><td class=\"center\"><div class=\"visible-md visible-lg hidden-sm hidden-xs\"><a ng-click=\"vm.deleteCompanyPrompt(company);\" class=\"btn btn-transparent btn-xs tooltips\" tooltip-placement=\"top\" uib-tooltip=\"Recover\"><i class=\"fa fa-reply fa fa-white\"></i></a></div><div class=\"visible-xs visible-sm hidden-md hidden-lg\"><div class=\"btn-group dropdown\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-o btn-sm dropdown-toggle\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i>&nbsp;<span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right dropdown-light\" role=\"menu\"><li><a ng-click=\"vm.deleteCompanyPrompt(company);\">Recover</a></li></ul></div></div></td></tr><tfoot ng-show=\"vm.displayedDeleted.length > 9\"><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></tbody></table></div></div></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("/app/settings/contact-settings.html","<div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"contacts.index.title\">Contacts</h4><span class=\"mainDescription\" translate=\"contacts.index.description\">All of the existing customers that have been entered into the system.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div insight-placeholder=\"vm.placeholder\"></div><div class=\"container-fluid\" ng-show=\"vm.contacts.length > 0\"><div class=\"row margin-bottom-15\"><div class=\"col-md-12 text-right\"><a type=\"button\" contact-aside=\"vm.contacts\" visible=\"vm.asideContact\" class=\"btn btn-primary\">Create Contact</a></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"panel panel-white\"><div class=\"panel-body\"><div st-table=\"vm.displayedContacts\" st-safe-src=\"vm.contacts\"><table class=\"table table-hover table-responsive\"><thead><tr><th st-sort-default=\"true\" st-skip-natural=\"true\" st-sort=\"name\">Name</th><th st-skip-natural=\"true\" st-sort=\"email\">Email</th><th st-skip-natural=\"true\" st-sort=\"office_phone\">Phone</th><th st-skip-natural=\"true\" st-sort=\"position\">Position</th><th st-skip-natural=\"true\" st-sort=\"company.name\">Company</th><th></th></tr><tr><td><input type=\"search\" st-search=\"name\" class=\"form-control\" placeholder=\"Search Name\"></td><td><input type=\"search\" st-search=\"email\" class=\"form-control\" placeholder=\"Search Email\"></td><td><input type=\"search\" st-search=\"office_phone\" class=\"form-control\" placeholder=\"Search Phone\"></td><td><input type=\"search\" st-search=\"position\" class=\"form-control\" placeholder=\"Search Position\"></td><td><input type=\"search\" st-search=\"company.name\" class=\"form-control\" placeholder=\"Search Company\"></td><td></td></tr></thead><tbody><tr ng-if=\"vm.displayedContacts.length == 0 && vm.contacts.length > 0\"><td class=\"text-center\" colspan=\"6\">There are no contacts that match your search criteria.</td></tr><tr ng-repeat=\"contact in vm.displayedContacts\"><td>{{ ::contact.name }}</td><td>{{ ::contact.email }}</td><td>{{ ::contact.office_phone }}</td><td>{{ ::contact.position }}</td><td><a company-aside=\"\" identity=\"{{ ::contact.company.identity }}\">{{ ::contact.company.name }}</a></td><td class=\"center\"><div class=\"visible-md visible-lg hidden-sm hidden-xs\"><a contact-aside=\"vm.contacts\" identity=\"{{ ::contact.identity }}\" class=\"btn btn-transparent btn-xs tooltips\" tooltip-placement=\"top\" uib-tooltip=\"Edit\"><i class=\"fa fa-pencil fa fa-white\"></i></a></div><div class=\"visible-xs visible-sm hidden-md hidden-lg\"><div class=\"btn-group dropdown\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-o btn-sm dropdown-toggle\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i>&nbsp;<span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right dropdown-light\" role=\"menu\"><li><a contact-aside=\"vm.contacts\" identity=\"{{ ::contact.identity }}\">Edit</a></li></ul></div></div></td></tr></tbody><tfoot ng-show=\"vm.displayedContacts.length > 9\"><tr><td colspan=\"6\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div></div>");
$templateCache.put("/app/settings/employee-department-settings.html","<div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"employee_departments.index.title\">Manage Employee Departments</h4><span class=\"mainDescription\" translate=\"employee_departments.index.description\">Create a new employee department for your organization or update an existing record.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div insight-placeholder=\"vm.placeholder\" collection=\"vm.departments\"></div><div class=\"container-fluid\" ng-show=\"vm.departments.length > 0\"><div class=\"row margin-bottom-15\"><div class=\"col-md-12 text-right\"><a class=\"btn btn-primary\" employee-department-aside=\"vm.departments\" visible=\"vm.departmentAside\">Create Department</a></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"panel panel-white\"><div class=\"panel-body\"><table class=\"table table-hover\" st-table=\"vm.displayedDepartments\" st-safe-src=\"vm.departments\"><thead><tr><th st-sort-default=\"true\" st-skip-natural=\"true\" st-sort=\"name\">Name</th><th st-skip-natural=\"true\" st-sort=\"created_by.name\">Created By</th><th st-skip-natural=\"true\" st-sort=\"created_at\">Created At</th><th st-skip-natural=\"true\" st-sort=\"last_modified_by.name\">Lasted Modified By</th><th st-skip-natural=\"true\" st-sort=\"last_modified_at\">Last Modified At</th><th></th></tr><tr><th><input st-search=\"name\" class=\"form-control\" placeholder=\"Search by name\"></th><th><input st-search=\"created_by.name\" class=\"form-control\" placeholder=\"Search by created by\"></th><th><input st-search=\"created_at\" class=\"form-control\" placeholder=\"Search by created at\"></th><th><input st-search=\"last_modified_by.name\" class=\"form-control\" placeholder=\"Search by last modified by\"></th><th><input st-search=\"last_modified_at\" class=\"form-control\" placeholder=\"Search by last modified at\"></th><th></th></tr></thead><tbody><tr ng-if=\"vm.displayedDepartments.length == 0 && vm.departments.length > 0\"><td colspan=\"6\" class=\"text-center\">There are no employee departments that match your search criteria.</td></tr><tr ng-repeat=\"department in vm.displayedDepartments\"><td>{{ ::department.name }}</td><td>{{ ::department.created_by.name }}</td><td>{{ ::department.created_at | date: \'MMMM dd, yyyy\' }}</td><td>{{ ::department.last_modified_by.name }}</td><td>{{ ::department.last_modified_at | date: \'MMMM dd, yyyy\' }}</td><td class=\"center\"><div class=\"visible-md visible-lg hidden-sm hidden-xs\"><a employee-department-aside=\"vm.departments\" identity=\"{{ ::department.identity }}\" class=\"btn btn-transparent btn-xs\" tooltip-placement=\"top\" uib-tooltip=\"Edit\"><i class=\"fa fa-pencil\"></i></a></div><div class=\"visible-xs visible-sm hidden-md hidden-lg\"><div class=\"btn-group dropdown\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-o btn-sm dropdown-toggle\" uib-dropdown-toggle=\"\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-cog\"></i>&nbsp;<span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right dropdown-light\" role=\"menu\"><li><a employee-department-aside=\"vm.departments\" identity=\"{{ ::department.identity }}\">Edit</a></li></ul></div></div></td></tr></tbody><tfoot ng-show=\"vm.displayedDepartments.length > 9\"><tr><td colspan=\"6\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("/app/settings/employee-position-settings.html","<div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"employee_positions.index.title\">Manage Employee Positions</h4><span class=\"mainDescription\" translate=\"employee_positions.index.description\">Create a new employee position for your organization or update an existing record.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div insight-placeholder=\"vm.placeholder\" collection=\"vm.positions\"></div><div class=\"container-fluid\" ng-show=\"vm.positions.length > 0\"><div class=\"row margin-bottom-15\"><div class=\"col-md-12 text-right\"><a class=\"btn btn-primary\" employee-position-aside=\"vm.positions\" visible=\"vm.positionAside\">Create Position</a></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"panel panel-white\"><div class=\"panel-body\"><table class=\"table table-hover\" st-table=\"vm.displayedPositions\" st-safe-src=\"vm.positions\"><thead><tr><th st-sort-default=\"true\" st-skip-natural=\"true\" st-sort=\"name\">Name</th><th st-skip-natural=\"true\" st-sort=\"created_by.name\">Created By</th><th st-skip-natural=\"true\" st-sort=\"created_at\">Created At</th><th st-skip-natural=\"true\" st-sort=\"last_modified_by.name\">Lasted Modified By</th><th st-skip-natural=\"true\" st-sort=\"last_modified_at\">Last Modified At</th><th></th></tr><tr><th><input st-search=\"name\" class=\"form-control\" placeholder=\"Search by name\"></th><th><input st-search=\"created_by.name\" class=\"form-control\" placeholder=\"Search by created by\"></th><th><input st-search=\"created_at\" class=\"form-control\" placeholder=\"Search by created at\"></th><th><input st-search=\"last_modified_by.name\" class=\"form-control\" placeholder=\"Search by last modified by\"></th><th><input st-search=\"last_modified_at\" class=\"form-control\" placeholder=\"Search by last modified at\"></th><th></th></tr></thead><tbody><tr ng-if=\"vm.displayedPositions.length == 0 && vm.positions.length > 0\"><td colspan=\"6\" class=\"text-center\">There are no employee positions that match your search criteria.</td></tr><tr ng-repeat=\"position in vm.displayedPositions\"><td>{{ ::position.name }}</td><td>{{ ::position.created_by.name }}</td><td>{{ ::position.created_at | date: \'MMMM dd, yyyy\' }}</td><td>{{ ::position.last_modified_by.name }}</td><td>{{ ::position.last_modified_at | date: \'MMMM dd, yyyy\' }}</td><td class=\"center\"><div class=\"visible-md visible-lg hidden-sm hidden-xs\"><a employee-position-aside=\"vm.positions\" identity=\"{{ ::position.identity }}\" class=\"btn btn-transparent btn-xs\" tooltip-placement=\"top\" uib-tooltip=\"Edit\"><i class=\"fa fa-pencil\"></i></a></div><div class=\"visible-xs visible-sm hidden-md hidden-lg\"><div class=\"btn-group dropdown\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-o btn-sm dropdown-toggle\" uib-dropdown-toggle=\"\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-cog\"></i>&nbsp;<span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right dropdown-light\" role=\"menu\"><li><a employee-position-aside=\"vm.positions\" identity=\"{{ ::position.identity }}\">Edit</a></li></ul></div></div></td></tr></tbody><tfoot ng-show=\"vm.displayedPositions.length > 9\"><tr><td colspan=\"6\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("/app/settings/employee-settings.html","<div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"settings.employees.MAIN\">Manage Employees</h4><span class=\"mainDescription\">Create a new employee for your organization or update an existing record.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div insight-placeholder=\"vm.placeholder\"></div><div class=\"container-fluid\" ng-show=\"vm.employees.length > 0\"><div class=\"row margin-bottom-15\"><div class=\"col-md-12 text-right\"><a class=\"btn btn-primary\" employee-aside=\"vm.employees\" visible=\"vm.asideEmployee\">Create Employee</a></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"panel panel-white\"><div class=\"panel-body\"><table class=\"table table-hover\" st-table=\"vm.displayedEmployees\" st-safe-src=\"vm.employees\"><thead><tr><th st-sort-default=\"true\" st-skip-natural=\"true\" st-sort=\"name\">Name</th><th st-skip-natural=\"true\" st-sort=\"position\">Position</th><th st-skip-natural=\"true\" st-sort=\"email\">Email</th><th st-skip-natural=\"true\" st-sort=\"external\">Location</th><th></th></tr><tr><th><input st-search=\"name\" class=\"form-control\" placeholder=\"Search by name\"></th><th><input st-search=\"position\" class=\"form-control\" placeholder=\"Search by position\"></th><th><input st-search=\"email\" class=\"form-control\" placeholder=\"Search by email\"></th><th><input st-search=\"location\" class=\"form-control\" placeholder=\"Search by location\"></th><th></th></tr></thead><tbody><tr ng-if=\"vm.displayedEmployees.length == 0 && vm.employees.length > 0\"><td colspan=\"5\" class=\"text-center\">There are no employees that match your search criteria.</td></tr><tr ng-repeat=\"employee in vm.displayedEmployees\"><td>{{ ::employee.name }}</td><td>{{ ::employee.position.name }}</td><td>{{ ::employee.email }}</td><td>{{ ::employee.location.name }}</td><td class=\"center\"><div class=\"visible-md visible-lg hidden-sm hidden-xs\"><a employee-aside=\"vm.employees\" identity=\"{{ ::employee.identity }}\" class=\"btn btn-transparent btn-xs\" tooltip-placement=\"top\" uib-tooltip=\"Edit\"><i class=\"fa fa-pencil\"></i></a></div><div class=\"visible-xs visible-sm hidden-md hidden-lg\"><div class=\"btn-group dropdown\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-o btn-sm dropdown-toggle\" uib-dropdown-toggle=\"\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"fa fa-cog\"></i>&nbsp;<span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right dropdown-light\" role=\"menu\"><li><a employee-aside=\"vm.employees\" identity=\"{{ ::employee.identity }}\">Edit</a></li></ul></div></div></td></tr></tbody><tfoot ng-show=\"vm.employees.length > 9\"><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("/app/settings/inventory-category-settings.html","<div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"inventory.category.title\">Inventory Category</h4><span class=\"mainDescription\" translate=\"inventory.category.description\">All of the existing inventory categories within the system.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div insight-placeholder=\"vm.placeholder\"></div><div class=\"container-fluid\" ng-show=\"vm.categories.length > 0\"><div class=\"row margin-bottom-15\"><div class=\"col-md-12 text-right\"><a type=\"button\" class=\"btn btn-primary\" inventory-category-aside=\"vm.categories\" visible=\"vm.asideCategory\">Create Category</a></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"panel panel-white\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div st-table=\"vm.displayedCategories\" st-safe-src=\"vm.categories\"><table class=\"table table-hover\"><thead><tr><th st-sort-default=\"true\" st-skip-natural=\"true\" st-sort=\"name\">Name</th><th st-skip-natural=\"true\" st-sort=\"description\">Description</th><th st-skip-natural=\"true\" st-sort=\"created_at\">Created At</th><th></th></tr><tr><td><input st-search=\"name\" type=\"search\" class=\"form-control\" placeholder=\"Search Name...\"></td><td><input st-search=\"description\" type=\"search\" class=\"form-control\" placeholder=\"Search Description...\"></td><td><input st-search=\"created_at\" type=\"search\" class=\"form-control\" placeholder=\"Search Created At...\"></td><td></td></tr></thead><tbody><tr ng-if=\"vm.displayedCategories.length == 0 && vm.categories.length > 0\"><td colspan=\"4\" class=\"text-center\">There are no inventory categories that match your search criteria.</td></tr><tr ng-repeat=\"category in vm.displayedCategories\"><td>{{ ::category.name }}</td><td>{{ ::category.description }}</td><td>{{ ::category.created_at | date: \'MMMM dd, yyyy\' }}</td><td class=\"center\"><div class=\"visible-md visible-lg hidden-sm hidden-xs\"><a inventory-category-aside=\"vm.categories\" identity=\"{{ category.identity }}\" class=\"btn btn-transparent btn-xs tooltips\" tooltip-placement=\"top\" uib-tooltip=\"Edit\"><i class=\"fa fa-pencil fa fa-white\"></i></a></div><div class=\"visible-xs visible-sm hidden-md hidden-lg\"><div class=\"btn-group dropdown\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-o btn-sm dropdown-toggle\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i>&nbsp;<span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right dropdown-light\" role=\"menu\"><li><a inventory-category-aside=\"vm.categories\" identity=\"{{ category.identity }}\">Edit</a></li></ul></div></div></td></tr></tbody><tfoot ng-show=\"vm.displayedCategories.length > 9\"><tr><td colspan=\"4\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div></div></div></div>");
$templateCache.put("/app/settings/inventory-location-settings.html","<div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"inventory.location.title\">Inventory Locations</h4><span class=\"mainDescription\" translate=\"inventory.location.description\">All of the existing inventory locations within the system.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div insight-placeholder=\"vm.placeholder\"></div><div class=\"container-fluid\" ng-show=\"vm.locations.length > 0\"><div class=\"row margin-bottom-15\"><div class=\"col-md-12 text-right\"><a type=\"button\" class=\"btn btn-primary\" inventory-location-aside=\"vm.locations\" visible=\"vm.asideLocation\">Create Location</a></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"panel panel-white\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div st-table=\"vm.displayedLocations\" st-safe-src=\"vm.locations\"><table class=\"table table-hover\"><thead><tr><th st-sort-default=\"true\" st-skip-natural=\"true\" st-sort=\"name\">Name</th><th st-skip-natural=\"true\" st-sort=\"code\">Code</th><th st-skip-natural=\"true\" st-sort=\"description\">Description</th><th></th></tr><tr><td><input st-search=\"name\" type=\"search\" class=\"form-control\" placeholder=\"Search Name...\"></td><td><input st-search=\"code\" type=\"search\" class=\"form-control\" placeholder=\"Search Code...\"></td><td><input st-search=\"description\" type=\"search\" class=\"form-control\" placeholder=\"Search Description...\"></td><td></td></tr></thead><tbody><tr ng-if=\"vm.displayedLocations.length == 0 && vm.locations.length > 0\"><td colspan=\"4\" class=\"text-center\">There are no inventory locations that match your search criteria.</td></tr><tr ng-repeat=\"location in vm.displayedLocations\"><td>{{ ::location.name }}</td><td>{{ ::location.code }}</td><td>{{ ::location.description }}</td><td class=\"center\"><div class=\"visible-md visible-lg hidden-sm hidden-xs\"><a inventory-location-aside=\"vm.locations\" identity=\"{{ location.identity }}\" class=\"btn btn-transparent btn-xs tooltips\" tooltip-placement=\"top\" uib-tooltip=\"Edit\"><i class=\"fa fa-pencil fa fa-white\"></i></a></div><div class=\"visible-xs visible-sm hidden-md hidden-lg\"><div class=\"btn-group dropdown\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-o btn-sm dropdown-toggle\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i>&nbsp;<span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right dropdown-light\" role=\"menu\"><li><a inventory-location-aside=\"vm.locations\" identity=\"{{ location.identity }}\">Edit</a></li></ul></div></div></td></tr></tbody><tfoot ng-show=\"vm.displayedLocations.length > 9\"><tr><td colspan=\"4\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div></div></div></div>");
$templateCache.put("/app/settings/inventory-settings.html","<div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"inventory.index.title\">Inventory</h4><span class=\"mainDescription\" translate=\"inventory.index.description\">All of the existing inventory items that have been entered into the system.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div insight-placeholder=\"vm.placeholder\" ng-show=\"vm.items.length === 0\"></div><div class=\"container-fluid top-spacer-1\" ng-show=\"vm.items.length > 0\"><div class=\"row\"><div class=\"col-md-12\"><uib-tabset class=\"tabbable\"><uib-tab heading=\"Inventory Items\"><div class=\"panel panel-white\"><div class=\"panel-body\"><div class=\"text-right\"><a inventory-aside=\"vm.items\" visible=\"vm.asideInventory\" class=\"btn btn-primary\">Create Item</a></div><div st-table=\"vm.displayedItems\" st-safe-src=\"vm.items\" st-pipe=\"vm.filterPipe()\"><table class=\"table table-hover\"><thead><tr><th st-skip-natural=\"true\" st-sort=\"asset\" st-sort-default=\"true\">Fixed Asset #</th><th st-skip-natural=\"true\" st-sort=\"category.name\">Category</th><th st-skip-natural=\"true\" st-sort=\"description\">Description</th><th st-skip-natural=\"true\" st-sort=\"status.name\">Status</th><th st-skip-natural=\"true\" st-sort=\"second_status.name\">2<sup>nd</sup> Status</th><th st-skip-natural=\"true\" st-sort=\"location.name\">Location</th><th></th></tr><tr><th><input type=\"text\" class=\"form-control\" ng-model=\"vm.filter.asset\" ng-keyup=\"vm.filterItems()\" placeholder=\"Search by asset\"></th><th><input type=\"text\" class=\"form-control\" ng-model=\"vm.filter.category\" ng-keyup=\"vm.filterItems()\" placeholder=\"Search by category\"></th><th><input type=\"text\" class=\"form-control\" ng-model=\"vm.filter.description\" ng-keyup=\"vm.filterItems()\" placeholder=\"Search by description\"></th><th class=\"max-width-200\"><select class=\"form-control\" chosen=\"\" multiple=\"\" data-placeholder=\"Select statuses\" ng-change=\"vm.filterItems()\" ng-model=\"vm.filter.statuses\" no-results-text=\"\'There are no statuses.\'\" ng-options=\"status.original as status.name for status in vm.statuses\"></select></th><th class=\"max-width-200\"><select class=\"form-control\" chosen=\"\" multiple=\"\" data-placeholder=\"Select statuses\" ng-change=\"vm.filterItems()\" ng-model=\"vm.filter.secondStatuses\" no-results-text=\"\'No available second statuses.\'\" ng-options=\"status.original as status.name for status in vm.secondStatuses\"></select></th><th class=\"max-width-200\"><select class=\"form-control\" chosen=\"\" multiple=\"\" data-placeholder=\"Select locations\" ng-change=\"vm.filterItems()\" ng-model=\"vm.filter.locations\" no-results-text=\"\'No available locations.\'\" ng-options=\"location.identity as location.name for location in vm.locations\"></select></th><th></th></tr></thead><tbody><tr ng-if=\"vm.displayedItems.length == 0 && vm.items.length > 0\"><td colspan=\"7\" class=\"text-center\">There are no inventory items that match your search criteria.</td></tr><tr ng-repeat=\"item in vm.displayedItems\"><td>{{ ::item.asset }}</td><td>{{ ::item.category.name }}</td><td>{{ ::item.description }}</td><td><span class=\"label\" ng-style=\"{ \'color\' : item.status.primary_color, \'background\' : item.status.background_color }\">{{ ::item.status.name }}</span></td><td><span class=\"label\" ng-style=\"{ \'color\' : item.second_status.primary_color, \'background\' : item.second_status.background_color }\">{{ ::item.second_status.name }}</span></td><td>{{ ::item.location.name }}</td><td class=\"center\"><div class=\"visible-md visible-lg hidden-sm hidden-xs\"><a inventory-aside=\"vm.items\" identity=\"{{ ::item.identity }}\" class=\"btn btn-transparent btn-xs\" tooltip-placement=\"top\" uib-tooltip=\"Edit\"><i class=\"fa fa-pencil\"></i></a></div><div class=\"visible-xs visible-sm hidden-md hidden-lg\"><div class=\"btn-group dropdown\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-o btn-sm dropdown-toggle\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i>&nbsp;<span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right dropdown-light\" role=\"menu\"><li><a inventory-aside=\"vm.items\" identity=\"{{ item.identity }}\">Edit</a></li></ul></div></div></td></tr></tbody><tfoot ng-show=\"vm.items.length > 9\"><tr><td colspan=\"7\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></uib-tab><uib-tab heading=\"Trash Bin\"><div class=\"panel panel-white\"><div class=\"panel-body\"><div st-table=\"vm.displayedDeleted\" st-safe-src=\"vm.deletedItems\"><table class=\"table table-hover\"><thead ng-if=\"vm.deletedItems.length > 0\"><tr><th class=\"hide\" st-sort=\"updated_at\" st-sort-default=\"reverse\"></th><th st-skip-natural=\"true\" st-sort=\"asset\">Fixed Asset #</th><th st-skip-natural=\"true\" st-sort=\"serial\">Serial</th><th st-skip-natural=\"true\" st-sort=\"\">Category</th><th st-skip-natural=\"true\" st-sort=\"\">Location</th><th st-skip-natural=\"true\" st-sort=\"description\">Description</th><th></th></tr></thead><div class=\"jumbotron text-center\" ng-if=\"vm.displayedDeleted.length == 0 && vm.deletedItems.length == 0\"><h1 class=\"display-3\">Nothing!</h1><p class=\"lead\">There are currently no deleted inventory items within your organization!</p><hr class=\"m-y-2\"><p class=\"lead\"></p></div><tbody><tr ng-if=\"vm.displayedDeleted.length == 0 && vm.deletedItems.length > 0\"><td colspan=\"6\" class=\"text-center\">There are no deleted inventory items that match your search criteria.</td></tr><tr ng-repeat=\"item in vm.displayedDeleted\"><td class=\"hide\">{{ ::item.updated_at }}</td><td>{{ ::item.asset }}</td><td>{{ ::item.serial }}</td><td></td><td></td><td>{{ ::item.description }}</td><td class=\"center\"><div class=\"visible-md visible-lg hidden-sm hidden-xs\"><a ng-click=\"vm.restoreItemPrompt(item);\" class=\"btn btn-transparent btn-xs tooltips\" tooltip-placement=\"top\" uib-tooltip=\"Restore\"><i class=\"fa fa-reply fa fa-white\"></i></a></div><div class=\"visible-xs visible-sm hidden-md hidden-lg\"><div class=\"btn-group dropdown\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-o btn-sm dropdown-toggle\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i>&nbsp;<span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right dropdown-light\" role=\"menu\"><li><a>Edit</a></li><li><a ng-click=\"vm.deleteCompanyPrompt(company);\">Remove</a></li></ul></div></div></td></tr></tbody><tfoot ng-show=\"vm.displayedDeleted.length > 9\"><tr><td colspan=\"6\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("/app/settings/status-option-settings.html","<div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"inventory.status.title\">Status Options</h4><span class=\"mainDescription\" translate=\"inventory.status.description\">All of the existing status options within the system.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div insight-placeholder=\"vm.placeholder\"></div><div class=\"container-fluid\" ng-show=\"vm.statuses.length > 0\"><div class=\"row margin-bottom-15\"><div class=\"col-md-12 text-right\"><a type=\"button\" status-aside=\"vm.statuses\" visible=\"vm.asideStatus\" class=\"btn btn-primary\">Create Status</a></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"panel panel-white\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div st-table=\"vm.displayedStatuses\" st-safe-src=\"vm.statuses\"><table class=\"table table-hover\"><thead><tr><th st-sort-default=\"true\" st-skip-natural=\"true\" st-sort=\"name\">Name</th><th st-skip-natural=\"true\" st-sort=\"\">Preview</th><th st-skip-natural=\"true\" st-sort=\"\">2<sup>nd</sup> Status</th><th></th></tr><tr><td><input type=\"search\" st-search=\"name\" class=\"form-control\" placeholder=\"Search Name...\"></td><td></td><td></td><td></td><td></td></tr></thead><tbody><tr ng-if=\"vm.displayedStatuses.length == 0 && vm.statuses.length > 0\"><td colspan=\"5\" class=\"text-center\">There are no inventory statuses that match your search criteria.</td></tr><tr ng-repeat=\"status in vm.displayedStatuses\"><td>{{ ::status.name }}</td><td><span class=\"label\" ng-style=\"{ \'color\': status.primary_color, \'background\' : status.background_color }\">{{ ::status.name }}</span></td><td><span class=\"fa fa-check\" ng-if=\"status.primary === false\"></span></td><td class=\"center\"><div class=\"visible-md visible-lg hidden-sm hidden-xs\"><a class=\"btn btn-transparent btn-xs tooltips\" tooltip-placement=\"top\" uib-tooltip=\"Edit\" status-aside=\"vm.statuses\" identity=\"{{ ::status.identity }}\"><i class=\"fa fa-pencil fa fa-white\"></i></a></div><div class=\"visible-xs visible-sm hidden-md hidden-lg\"><div class=\"btn-group dropdown\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-o btn-sm dropdown-toggle\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i>&nbsp;<span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right dropdown-light\" role=\"menu\"><li><a status-aside=\"vm.statuses\" identity=\"{{ ::status.identity }}\">Edit</a></li></ul></div></div></td></tr></tbody><tfoot ng-show=\"vm.displayedStatuses.length > 9\"><tr><td colspan=\"5\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div></div></div></div>");
$templateCache.put("/app/settings/user-role-settings.html","<div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"settings.roles.title\">Roles</h4><span class=\"mainDescription\" translate=\"settings.roles.description\">Restrict users\' access to pages and functionality inside of InsightFlow.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div insight-placeholder=\"vm.placeholder\"></div><div class=\"container-fluid\" ng-show=\"vm.roles.length > 0\"><div class=\"row margin-bottom-15\"><div class=\"col-md-12 text-right\"><a type=\"button\" role-aside=\"vm.roles\" visible=\"vm.asideRole\" class=\"btn btn-primary\">Create Role</a></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"panel panel-white\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div st-table=\"vm.displayedRoles\" st-safe-src=\"vm.roles\"><table class=\"table table-hover\"><thead><tr><th st-sort-default=\"true\" st-skip-natural=\"true\" st-sort=\"name\">Name</th><th st-skip-natural=\"true\" st-sort=\"user_count\">User Count</th><th></th></tr><tr><td><input type=\"search\" st-search=\"name\" class=\"form-control\" placeholder=\"Search Name...\"></td><td><input type=\"search\" st-search=\"user_count\" class=\"form-control\" placeholder=\"Search User Count...\"></td><td></td></tr></thead><tbody><tr ng-if=\"vm.displayedRoles.length == 0 && vm.roles.length > 0\"><td colspan=\"5\" class=\"text-center\">There are no roles that match your search criteria.</td></tr><tr ng-repeat=\"role in vm.displayedRoles\"><td>{{ ::role.name }}</td><td>{{ ::role.user_count }}</td><td class=\"center\"><div class=\"visible-md visible-lg hidden-sm hidden-xs\"><a class=\"btn btn-transparent btn-xs tooltips\" tooltip-placement=\"top\" uib-tooltip=\"Edit\" role-aside=\"vm.roles\" identity=\"{{ ::role.identity }}\"><i class=\"fa fa-pencil fa fa-white\"></i></a></div><div class=\"visible-xs visible-sm hidden-md hidden-lg\"><div class=\"btn-group dropdown\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-o btn-sm dropdown-toggle\" uib-dropdown-toggle=\"\"><i class=\"fa fa-cog\"></i>&nbsp;<span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right dropdown-light\" role=\"menu\"><li><a role-aside=\"vm.roles\" identity=\"{{ ::role.identity }}\">Edit</a></li></ul></div></div></td></tr></tbody><tfoot ng-show=\"vm.displayedRoles.length > 9\"><tr><td colspan=\"3\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div></div></div></div>");
$templateCache.put("/app/yardman/yardman.html","<div ui-view=\"\"><div class=\"breadcrumb-wrapper\"><h4 class=\"mainTitle no-margin\" translate=\"yardman.index.title\">Yardman</h4><span class=\"mainDescription\" translate=\"yardman.index.description\">Quickly confirm inventory items.</span><div ncy-breadcrumb=\"\" class=\"pull-right\"></div></div><div insight-placeholder=\"vm.placeholder\"></div><div class=\"container-fluid\" ng-show=\"vm.items.length > 0\"><div class=\"row margin-bottom-15\"><div class=\"col-md-2\"><label class=\"control-label\">Fixed Asset #</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.filter.asset\" ng-keyup=\"vm.filterItems()\" placeholder=\"Search asset #\"></div><div class=\"col-md-2\"><label class=\"control-label\">Inventory Location</label><select class=\"form-control\" chosen=\"\" multiple=\"\" data-placeholder=\"Select a location\" ng-change=\"vm.filterItems()\" ng-model=\"vm.filter.locations\" no-results-text=\"\'There are no locations.\'\" ng-options=\"location.identity as location.name for location in vm.locations\"></select></div><div class=\"col-md-2\"><label class=\"control-label\">Status(es)</label><select class=\"form-control\" chosen=\"\" multiple=\"\" data-placeholder=\"Select statuses\" ng-change=\"vm.filterItems()\" ng-model=\"vm.filter.statuses\" no-results-text=\"\'There are no statuses.\'\" ng-options=\"status.original as status.name for status in vm.statuses\"></select></div><div class=\"col-md-2\"><label class=\"control-label\">Driver</label></div></div><div class=\"panel panel-white\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div st-table=\"vm.displayedItems\" st-safe-src=\"vm.items\" st-pipe=\"vm.filterPipe\"><table class=\"table no-margin table-hover\"><tbody><tr ng-repeat=\"item in vm.displayedItems\"><td><div class=\"padding-10\"><div class=\"block\"><span class=\"text-muted\">Fixed Asset #</span><strong>{{ ::item.asset }}</strong></div><span class=\"text-small text-muted\">{{ ::item.description }}</span><div class=\"block margin-top-10\"><span class=\"label\" ng-style=\"{ \'color\' : item.status.primary_color, \'background\' : item.status.background_color }\">{{ ::item.status.name }}</span> <span class=\"label\" ng-style=\"{ \'color\' : item.secondStatus.primary_color, \'background\' : item.secondStatus.background_color }\">{{ ::item.secondStatus.name }}</span></div></div></td><td><div class=\"padding-10\"><span class=\"text-muted\">Current Customer</span><div class=\"block\"><em>None (Placeholder Text)</em></div></div></td><td><div class=\"padding-10\"><span class=\"text-muted\">Driver</span><div class=\"block\"><em>None</em></div></div></td><td><div class=\"col-xs-1 no-padding text-center\"><a yardman-status-aside=\"vm.items\" identity=\"{{ item.identity }}\" class=\"btn btn-transparent btn-xs tooltips\" tooltip-placement=\"top\" uib-tooltip=\"Edit\"><i class=\"fa fa-pencil fa fa-white\"></i></a></div></td></tr></tbody><tfoot ng-show=\"vm.displayedItems.length > 9\"><tr><td colspan=\"4\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div></div></div>");
$templateCache.put("/app/components/btnToggle/btnToggle.html","<div class=\"btn-group\" ng-class=\"{\'btn-group-justified\':justified}\"><a class=\"btn\" ng-class=\"{\'{{selectedClass}}\' : isSelected(option), \'btn-default\' : !isSelected(option)}\" ng-click=\"selectItem(option)\" ng-disabled=\"option.disabled === true\" ng-repeat=\"option in options\"><span ng-bind-html=\"option.text\"></span></a></div>");
$templateCache.put("/app/components/companyAside/companyAside.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Company Details <a ng-click=\"cancel($event)\" class=\"pull-right\"><span class=\"fa fa-close\"></span></a></h3></div><div class=\"modal-body\"><form name=\"asideForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-3 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.name.$invalid}\"><label class=\"control-label\">Company Name</label> <input type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"form.name\" required=\"\" placeholder=\"Company Name\"><div class=\"help-block\" ng-if=\"submitted && asideForm.name.$invalid\"><p class=\"text-danger\">Company name is a required field.</p></div></div></div><div class=\"col-md-1 col-xs-1\"><div class=\"checkbox clip-check check-primary check-md padding-top-20 pull-right\"><input type=\"checkbox\" id=\"number_check\" ng-model=\"form.number_check\" ng-checked=\"true\"> <label for=\"number_check\" tooltip-placement=\"top\" uib-tooltip=\"Uncheck to enter a custom number. Note: The system auto generates numbers.\"></label></div></div><div class=\"col-md-2 col-xs-11\"><div class=\"form-group\"><label class=\"control-label\">Customer Number</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.customer_number\" placeholder=\"Customer Number\" ng-disabled=\"form.number_check == true\"></div></div><div class=\"col-md-3 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Assigned User</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select an assigned user\" ng-model=\"form.assigned_user\" no-results-text=\"\'There are no users.\'\" ng-options=\"user.identity as user.name for user in users\"></select></div></div><div class=\"col-md-3 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Classification</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select a classification\" ng-model=\"form.classification\" no-results-text=\"\'There are no classifications.\'\" ng-options=\"classification.identity as classification.name for classification in classifications\"></select></div></div></div><hr><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.billing_address.$invalid}\"><label class=\"control-label\">Billing Street Address</label> <input type=\"text\" class=\"form-control\" name=\"billing_address\" ng-model=\"form.billing_address\" placeholder=\"Street Address\" required=\"\"><div class=\"help-block\" ng-if=\"submitted && asideForm.billing_address.$invalid\"><p class=\"text-danger\">Billing address is a required field.</p></div></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.billing_city.$invalid}\"><label class=\"control-label\">City</label> <input type=\"text\" class=\"form-control\" name=\"billing_city\" ng-model=\"form.billing_city\" placeholder=\"City\" required=\"\"><div class=\"help-block\" ng-if=\"submitted && asideForm.billing_city.$invalid\"><p class=\"text-danger\">City is a required field.</p></div></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.billing_state.$invalid}\"><label class=\"control-label\">State</label> <input type=\"text\" class=\"form-control\" name=\"billing_state\" ng-model=\"form.billing_state\" placeholder=\"State\" required=\"\"><div class=\"help-block\" ng-if=\"submitted && asideForm.billing_state.$invalid\"><p class=\"text-danger\">State is a required field.</p></div></div></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.billing_postal.$invalid}\"><label class=\"control-label\">Postal Code</label> <input type=\"text\" class=\"form-control\" name=\"billing_postal\" ng-model=\"form.billing_postal\" placeholder=\"Postal Code\" required=\"\"><div class=\"help-block\" ng-if=\"submitted && asideForm.billing_postal.$invalid\"><p class=\"text-danger\">Postal code is a required field.</p></div></div></div><div class=\"col-md-1 col-xs-1\"><div class=\"checkbox clip-check check-primary check-md padding-top-20 pull-right\"><input type=\"checkbox\" id=\"country_check\" ng-model=\"form.country_check\" ng-checked=\"true\"> <label for=\"country_check\" tooltip-placement=\"top\" uib-tooltip=\"Uncheck to enter a different country.\"></label></div></div><div class=\"col-md-3 col-xs-11\"><div class=\"form-group\"><label class=\"control-label\">Country</label> <input type=\"text\" class=\"form-control\" name=\"billing_country\" ng-model=\"form.billing_country\" ng-disabled=\"form.country_check == true\" placeholder=\"Country\"></div></div><div class=\"col-md-3 col-xs-8\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.phone.$invalid}\"><label class=\"control-label\">Office Phone</label> <input type=\"text\" class=\"form-control\" name=\"phone\" ng-model=\"form.phone\" placeholder=\"Office Phone\" required=\"\"><div class=\"help-block\" ng-if=\"submitted && asideForm.phone.$invalid\"><p class=\"text-danger\">Office phone is a required field.</p></div></div></div><div class=\"col-md-1 col-xs-4\"><div class=\"form-group\"><label class=\"control-label\">Ext.</label> <input type=\"text\" class=\"form-control\" name=\"extension\" ng-model=\"form.extension\" placeholder=\"Ext\"></div></div></div><hr><div class=\"row\"><div class=\"col-md-3 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Website</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.website\" ng-blur=\"validateWebsite()\" placeholder=\"www.example.com\"></div></div><div class=\"col-md-3 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Industry</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select an industry\" ng-model=\"form.industry\" no-results-text=\"\'There are no industries.\'\" ng-options=\"industry.identity as industry.name for industry in industries\"></select></div></div><div class=\"col-md-1 col-xs-1\"><div class=\"checkbox clip-check check-primary check-md padding-top-20 pull-right\"><input type=\"checkbox\" id=\"parent_check\" ng-model=\"form.parent_check\" ng-checked=\"true\"> <label for=\"parent_check\" tooltip-placement=\"top\" uib-tooltip=\"Uncheck to select a parent company.\"></label></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Parent Company</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select a parent company\" ng-model=\"form.parent_company\" ng-disabled=\"form.parent_check == true\" no-results-text=\"\'There are no companies.\'\" ng-options=\"company.identity as company.name for company in companies\"></select></div></div><div class=\"col-md-3 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Description</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.description\" placeholder=\"Additional Information\" ng-focus=\"form.desc_expand = true\"></div></div></div><div class=\"row\" ng-show=\"form.desc_expand == true\"><div class=\"col-md-12\"><textarea class=\"form-control\" rows=\"3\" ng-model=\"form.description\" placeholder=\"Additonal information\" ng-blur=\"form.desc_expand = false\"></textarea></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> <button class=\"btn btn-danger\" ng-click=\"delete($event)\" ng-if=\"form.identity\">Delete</button> <button class=\"btn btn-primary\" ng-click=\"ok($event, \'ADD_NEW\')\">Save and Add New Company</button> <button class=\"btn btn-primary\" ng-click=\"ok($event, \'SELECT_ASSET\')\">Save and Select Asset</button> <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Save and Return</button></div>");
$templateCache.put("/app/components/companyClassificationAside/companyClassificationAside.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Classification Details</h3></div><div class=\"modal-body\"><form name=\"asideForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.name.$invalid }\"><label class=\"control-label\">Name</label> <input type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"form.name\" placeholder=\"Classification Name\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.name.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Classification name is required.</span></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> <button class=\"btn btn-danger\" ng-click=\"delete($event)\" ng-if=\"form.identity\">Delete</button> <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Save</button></div>");
$templateCache.put("/app/components/confirmationAside/confirmationAside.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Confirmation Details <a ng-click=\"cancel($event)\" class=\"pull-right\"><span class=\"fa fa-close\"></span></a></h3></div><div class=\"modal-body\"><form name=\"asideForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Fixed Asset #</label> <input type=\"text\" class=\"form-control\" value=\"{{ ::form.asset }}\" placeholder=\"Fixed Asset #\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && confirmationForm.company.$invalid}\"><label class=\"control-label\">Customer<span class=\"req\">*</span></label><select class=\"form-control\" chosen=\"\" ng-change=\"loadCompany(this)\" data-placeholder=\"Select a customer\" ng-model=\"form.company\" no-results-text=\"\'There are no companies.\'\" ng-options=\"company.identity as company.name for company in companies\" name=\"company\" required=\"\"><option value=\"\"></option></select><span class=\"help-block text-danger\" ng-show=\"submitted && confirmationForm.company.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> You must select a company to create a reservation.</span></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && confirmationForm.expected_on_rent.$invalid}\"><label class=\"control-label\">Expected On Rent Date</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"expected_on_rent\" uib-datepicker-popup=\"{{on_rent.format}}\" ng-model=\"form.expected_on_rent\" is-open=\"on_rent.opened\" datepicker-options=\"on_rent.options\" close-text=\"Close\" required=\"\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"on_rent.open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><span class=\"help-block text-danger\" ng-show=\"submitted && confirmationForm.expected_on_rent.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> You must enter an expected on rent date for a reservation.</span></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Expected Off Rent Date</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{off_rent.format}}\" ng-model=\"form.expected_off_rent\" is-open=\"off_rent.opened\" datepicker-options=\"off_rent.options\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"off_rent.open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && confirmationForm.contact.$invalid}\"><label class=\"control-label\">Contact Name<span class=\"req\">*</span></label><select class=\"form-control\" chosen=\"\" ng-change=\"loadContact(this)\" data-placeholder=\"Select a contact\" ng-model=\"form.contact\" no-results-text=\"\'There are no contacts.\'\" ng-options=\"contact.identity as contact.name for contact in contacts\" name=\"contact\" required=\"\"><option value=\"\"></option></select><span class=\"help-block text-danger\" ng-show=\"submitted && confirmationForm.contact.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> You must select a contact to create a reservation.</span></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Contact Number</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.phone\" placeholder=\"Contact #\"></div></div></div><div class=\"row\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Item Description</label> <input type=\"text\" class=\"form-control\" value=\"{{ ::form.description }}\" placeholder=\"Item Description\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Location</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.site_address\" placeholder=\"Street Address\"></div></div><div class=\"col-md-1 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">City</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.site_city\" placeholder=\"City\"></div></div><div class=\"col-md-1 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">State</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.site_state\" placeholder=\"State\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Zip Code</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.site_postal\" placeholder=\"Zip Code\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Delivery Time</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.delivery_request_time\" name=\"deliveryTime\" bs-timepicker=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Comments</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.comments\" ng-click=\"expandComments();\" placeholder=\"Comments\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\">Choose an existing address:</label><select class=\"form-control\" chosen=\"\" ng-change=\"loadAddress()\" data-placeholder=\"Select an existing site address...\" ng-model=\"form.address\" no-results-text=\"\'There are no existing site addresses.\'\" ng-options=\"address as address.site_address+\' \'+address.site_city+\', \'+address.site_state+\' \'+address.site_postal for address in addresses\"><option value=\"\" <=\"\" option=\"\"></option></select></div></div></div><div class=\"row\"><div class=\"col-md-12\" st-table=\"form.reservations\"><h4>Existing Confirmations</h4><table class=\"table table-hover\"><thead><tr><th>Customer Name</th><th>Expected On-Rent</th><th>Expected Off-Rent</th><th>Location</th><th>City</th><th>State</th><th>Zip Code</th><th>Contact Name</th><th>Contact #</th></tr></thead><tbody><tr ng-if=\"form.reservations.length === 0\"><td class=\"text-center\" colspan=\"9\">There are no past confirmations for this item.</td></tr><tr ng-repeat=\"reservation in form.reservations\" ng-if=\"reservation.confirmation !== null\"><td>{{ ::reservation.company.name }}</td><td>{{ parseDate(reservation.expected_on_rent) }}</td><td>{{ parseDate(reservation.expected_off_rent) }}</td><td>{{ ::reservation.site_address }}</td><td>{{ ::reservation.site_city }}</td><td>{{ ::reservation.site_state }}</td><td>{{ ::reservation.site_postal }}</td><td>{{ ::reservation.contact.name }}</td><td>{{ ::reservation.contact.office_phone }}</td></tr></tbody><tfoot ng-show=\"form.reservations.length > 9\"><tr><td colspan=\"9\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Save</button></div>");
$templateCache.put("/app/components/contactAside/contactAside.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Contact Details <a ng-click=\"cancel($event)\" class=\"pull-right\"><span class=\"fa fa-close\"></span></a></h3></div><div class=\"modal-body\"><form name=\"asideForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.firstName.$invalid }\"><label class=\"control-label\">First Name</label> <input type=\"text\" class=\"form-control\" name=\"firstName\" ng-model=\"form.first_name\" placeholder=\"First Name\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.firstName.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> First name is required.</span></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.lastName.$invalid }\"><label class=\"control-label\">Last Name</label> <input type=\"text\" class=\"form-control\" name=\"lastName\" ng-model=\"form.last_name\" placeholder=\"Last Name\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.firstName.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Last name is required.</span></div></div></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && (asideForm.company.$invalid || !form.company) }\"><label class=\"control-label\">Company<span class=\"req\">*</span></label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select a company\" ng-model=\"form.company\" required=\"\" no-results-text=\"\'There are no companies.\'\" ng-options=\"company.identity as company.name for company in companies\"></select><span class=\"help-block text-danger\" ng-show=\"submitted && (asideForm.company.$invalid || !form.company)\"><i class=\"fa fa-exclamation-circle\"></i> Company is required.</span></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.phone.$invalid }\"><label class=\"control-label\">Phone</label> <input type=\"text\" class=\"form-control\" name=\"phone\" ng-model=\"form.office_phone\" placeholder=\"Phone\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.phone.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Phone is required.</span></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Ext.</label> <input type=\"text\" class=\"form-control\" name=\"extension\" ng-model=\"form.extension\" placeholder=\"Ext\"></div></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Position</label> <input type=\"text\" class=\"form-control\" name=\"position\" ng-model=\"form.position\" placeholder=\"Position\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Email</label> <input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"form.email\" placeholder=\"Email Address\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Division</label> <input type=\"text\" class=\"form-control\" name=\"division\" ng-model=\"form.division\" placeholder=\"Division\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\">Notes (description)</label> <textarea class=\"form-control\" rows=\"3\" name=\"description\" ng-model=\"form.notes\" placeholder=\"Contact Notes...\"></textarea></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Save</button></div>");
$templateCache.put("/app/components/employeeAside/employeeAside.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Employee Details <a ng-click=\"cancel($event)\" class=\"pull-right\"><span class=\"fa fa-close\"></span></a></h3></div><div class=\"modal-body\"><form name=\"asideForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.firstName.$invalid }\"><label class=\"control-label\">First Name</label> <input type=\"text\" class=\"form-control\" name=\"firstName\" ng-model=\"form.first_name\" placeholder=\"First Name\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.firstName.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> First name is required.</span></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Middle Name</label> <input type=\"text\" class=\"form-control\" name=\"middleName\" ng-model=\"form.middle_name\" placeholder=\"Middle Name\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.lastName.$invalid }\"><label class=\"control-label\">Last Name</label> <input type=\"text\" class=\"form-control\" name=\"lastName\" ng-model=\"form.last_name\" placeholder=\"Last Name\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.lastName.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Last name is required.</span></div></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><label class=\"control-label\" tooltip-placement=\"top\" uib-tooltip=\"Uncheck to enter a company ID number. Note: The system auto generates numbers.\">Company ID Number <span class=\"fa fa-info-circle\"></span></label><div class=\"row\"><div class=\"col-md-2\"><div class=\"checkbox clip-check check-primary check-md\"><input type=\"checkbox\" id=\"number_check\" ng-model=\"form.number_check\" ng-checked=\"true\"> <label for=\"number_check\"></label></div></div><div class=\"col-md-10\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.employee_id.$invalid }\"><input type=\"text\" class=\"form-control\" name=\"employee_id\" ng-model=\"form.employee_id\" placeholder=\"Company ID Number\" ng-disabled=\"form.number_check\" ng-required=\"!form.number_check\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.employee_id.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Company ID is required.</span></div></div></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.email.$invalid }\"><label class=\"control-label\">Email</label> <input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"form.email\" placeholder=\"Email Address\" autocomplete=\"off\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.email.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Email address is required.</span></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.password.$invalid }\"><label class=\"control-label\">Password</label> <input type=\"password\" class=\"form-control\" name=\"password\" ng-model=\"form.password\" placeholder=\"Password\" autocomplete=\"off\" ng-required=\"!form.identity\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.password.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Password is required.</span></div></div></div><div class=\"row top-spacer-1\"><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.phone.$invalid }\"><label class=\"control-label\">Cell Phone</label> <input type=\"text\" class=\"form-control\" name=\"phone\" ng-model=\"form.cell_phone\" placeholder=\"Phone\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.phone.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Phone is required.</span></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.location.$invalid }\"><label class=\"control-label\">Phone</label> <input type=\"text\" class=\"form-control\" name=\"phone\" ng-model=\"form.phone\" placeholder=\"Phone\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.location.$invalid }\"><label class=\"control-label\">Extension</label> <input type=\"text\" class=\"form-control\" name=\"extension\" ng-model=\"form.extension\" placeholder=\"Extension\"></div></div></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.hireDate.$invalid }\"><label class=\"control-label\">Street</label> <input type=\"text\" class=\"form-control\" name=\"street\" ng-model=\"form.street\" placeholder=\"Street\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.location.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Street is required.</span></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.location.$invalid }\"><label class=\"control-label\">City</label> <input type=\"text\" class=\"form-control\" name=\"city\" ng-model=\"form.city\" placeholder=\"City\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.location.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> City is required.</span></div></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.location.$invalid }\"><label class=\"control-label\">State</label> <input type=\"text\" class=\"form-control\" name=\"state\" ng-model=\"form.state\" placeholder=\"State\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.location.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> State is required.</span></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.password.$invalid }\"><label class=\"control-label\">Country</label> <input type=\"text\" class=\"form-control\" name=\"country\" ng-model=\"form.country\" placeholder=\"Country\" ng-required=\"!form.identity\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.password.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Country is required.</span></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.password.$invalid }\"><label class=\"control-label\">Zip Code</label> <input type=\"text\" class=\"form-control\" name=\"postal_code\" ng-model=\"form.postal_code\" placeholder=\"Zip Code\" ng-required=\"!form.identity\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.password.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Zip Code is required.</span></div></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Position</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select a Position\" ng-model=\"form.position\" no-results-text=\"\'There are no positions.\'\" ng-options=\"position.identity as position.name for position in positions\"></select></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Department</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select a Department\" ng-model=\"form.department\" no-results-text=\"\'There are no Departments.\'\" ng-options=\"department.identity as department.name for department in departments\"></select></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.hireDate.$invalid }\"><label class=\"control-label\">Hire Date</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"hireDate\" uib-datepicker-popup=\"{{hire_date.format}}\" ng-model=\"form.hire_date\" is-open=\"hire_date.opened\" datepicker-options=\"hire_date.options\" close-text=\"Close\" required=\"\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"hire_date.open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.hireDate.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Hire date is required.</span></div></div></div><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Facility Location</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select a location\" ng-model=\"form.facility\" no-results-text=\"\'There are no locations.\'\" ng-options=\"location.identity as location.name for location in locations\"></select></div></div></div><div class=\"row\"><div class=\"col-md-9 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Employee Shift</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select a shift\" ng-model=\"form.shift\" no-results-text=\"\'There are no shifts.\'\" ng-options=\"shift.identity as shift.name for shift in shifts\" ng-disabled=\"createShiftVar === true\"></select></div></div><div class=\"col-md-3 col-xs-12\"><div class=\"form-group\"><button type=\"button\" class=\"margin-top-20 btn btn-primary\" ng-click=\"createShiftVar=!createShiftVar; shiftToggle = !shiftToggle\">{{shiftText}}</button></div></div></div><div class=\"row\" ng-show=\"createRoleVar\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.roleName.$invalid }\"><label class=\"control-label\">Role Name</label> <input type=\"text\" class=\"form-control\" name=\"roleName\" ng-model=\"form.role.name\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.roleCode.$invalid }\"><label class=\"control-label\">Role Code</label> <input type=\"text\" class=\"form-control\" name=\"roleCode\" ng-model=\"form.role.code\"></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.roleDescription.$invalid }\"><label class=\"control-label\">Role Description</label> <input type=\"text\" class=\"form-control\" name=\"roleDescription\" ng-model=\"form.role.description\"></div></div></div><div class=\"row\" ng-show=\"createShiftVar\"><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.start_time.$invalid }\"><label class=\"control-label\">Shift Start</label> <input type=\"text\" class=\"form-control\" name=\"start_time\" ng-model=\"form.newShift.start_time\" bs-timepicker=\"\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.end_time.$invalid }\"><label class=\"control-label\">Shift End</label> <input type=\"text\" class=\"form-control\" name=\"end_time\" ng-model=\"form.newShift.end_time\" bs-timepicker=\"\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.shift_name.$invalid }\"><label class=\"control-label\">Shift Name</label> <input type=\"text\" class=\"form-control\" name=\"shift_name\" ng-model=\"form.newShift.name\"></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Save</button></div>");
$templateCache.put("/app/components/employeeDepartmentAside/employeeDepartmentAside.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Employee Department Details</h3></div><div class=\"modal-body\"><form name=\"asideForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.name.$invalid }\"><label class=\"control-label\">Department Name</label> <input type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"form.name\" required=\"\" placeholder=\"Department Name\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.name.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Department name is required.</span></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> <button class=\"btn btn-danger\" ng-click=\"delete($event)\" ng-if=\"form.identity\">Delete</button> <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Save</button></div>");
$templateCache.put("/app/components/employeePositionAside/employeePositionAside.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Employee Position Details</h3></div><div class=\"modal-body\"><form name=\"asideForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.name.$invalid }\"><label class=\"control-label\">Position Name</label> <input type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"form.name\" required=\"\" placeholder=\"Position Name\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.name.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Position name is required.</span></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> <button class=\"btn btn-danger\" ng-click=\"delete($event)\" ng-if=\"form.identity\">Delete</button> <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Save</button></div>");
$templateCache.put("/app/components/insightPlaceholder/insightPlaceholder.html","<div class=\"container top-spacer-1\"><div class=\"jumbotron text-center\" ng-show=\"vm.isVisible()\"><h1 ng-bind-html=\"vm.options.title\"></h1><p class=\"lead\" ng-bind-html=\"vm.options.message\"></p><hr class=\"m-y-2\"><button class=\"btn btn-primary btn-lg\" type=\"button\" ng-if=\"vm.options.button_text\" ng-bind-html=\"vm.options.button_text\" ng-click=\"vm.clickButton()\"></button></div></div>");
$templateCache.put("/app/components/inventoryCategoryAside/inventoryCategoryAside.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Inventory Category Details</h3></div><div class=\"modal-body\"><form name=\"asideForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.name.$invalid }\"><label class=\"control-label\">Name</label> <input type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"form.name\" placeholder=\"Category Name\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.name.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Category name is required.</span></div></div><div class=\"col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Description</label> <textarea class=\"form-control\" name=\"description\" ng-model=\"form.description\" placeholder=\"Description\" rows=\"3\"></textarea></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> <button class=\"btn btn-danger\" ng-click=\"delete($event)\" ng-if=\"form.identity\">Delete</button> <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Save</button></div>");
$templateCache.put("/app/components/inventoryAside/inventoryAside.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Inventory Data Input</h3></div><div class=\"modal-body\"><form name=\"asideForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Serial Number</label> <input type=\"text\" class=\"form-control\" name=\"serial\" ng-model=\"form.serial\" placeholder=\"Serial Number\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.asset.$invalid }\"><label class=\"control-label\">Fixed Asset #</label> <input type=\"text\" class=\"form-control\" name=\"asset\" ng-model=\"form.asset\" required=\"\" placeholder=\"Fixed Asset #\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.asset.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Fixed asset # is required.</span></div></div></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Current Status</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select a status\" ng-model=\"form.status\" no-results-text=\"\'There are no statuses.\'\" ng-options=\"status.identity as status.name for status in statuses\"></select></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">2<sup>nd</sup> Status</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select a status\" ng-model=\"form.sec_status\" no-results-text=\"\'There are no second statuses.\'\" ng-options=\"status.identity as status.name for status in secondStatuses\"></select></div></div></div><div class=\"form-group\"><label class=\"control-label\">Item Description</label> <textarea class=\"form-control autosize area-animated msd-elastic: \\n;\" name=\"description\" ng-model=\"form.description\" placeholder=\"Item Description\" rows=\"2\"></textarea></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Height</label> <input type=\"text\" class=\"form-control\" name=\"height\" ng-model=\"form.height\" placeholder=\"Height\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Category</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select a category\" ng-model=\"form.category\" no-results-text=\"\'There are no inventory categories.\'\" ng-options=\"category.identity as category.name for category in categories\"></select></div></div></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.manuYear.$invalid }\"><label class=\"control-label\">Year Manufactured</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"manuYear\" uib-datepicker-popup=\"{{manu_year.format}}\" ng-model=\"form.manuYear\" is-open=\"manu_year.opened\" datepicker-options=\"manu_year.options\" close-text=\"Close\" required=\"\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"manu_year.open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.manuYear.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Year manufactured is required.</span></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.date_fleet.$invalid }\"><label class=\"control-label\">Date in Fleet</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"date_fleet\" uib-datepicker-popup=\"{{date_fleet.format}}\" ng-model=\"form.fleet\" is-open=\"date_fleet.opened\" datepicker-options=\"date_fleet.options\" close-text=\"Close\" required=\"\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"date_fleet.open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.date_fleet.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Date in fleet is required.</span></div></div></div><div class=\"form-group\"><label class=\"control-label\">Item Location (<a ng-click=\"displayLocationAside()\">Create New Location</a>)</label><div inventory-location-aside=\"\" visible=\"asideLocation\"></div><select class=\"form-control\" chosen=\"\" data-placeholder=\"Select a location\" ng-model=\"form.location\" no-results-text=\"\'There are no inventory locations.\'\" ng-options=\"location.identity as location.name for location in locations\"></select></div><div ng-show=\"showLocationFields\"><div class=\"form-group\"><label class=\"control-label\">New Facility Location</label> <input type=\"text\" class=\"form-control\" name=\"itemLocation\" ng-model=\"form.location.name\" placeholder=\"Location Name\"></div><div class=\"form-group\"><label class=\"control-label\">New Facility Code</label> <input type=\"text\" class=\"form-control\" name=\"itemCode\" ng-model=\"form.location.code\" placeholder=\"Code\"></div><div class=\"form-group\"><label class=\"control-label\">New Facility Description</label> <input type=\"text\" class=\"form-control\" name=\"itemDescription\" ng-model=\"form.location.description\" placeholder=\"Description\"></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Save</button></div>");
$templateCache.put("/app/components/inventoryLocationAside/inventoryLocationAside.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Inventory Location Details</h3></div><div class=\"modal-body\"><form name=\"asideForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.name.$invalid }\"><label class=\"control-label\">Facility Name</label> <input type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"form.name\" required=\"\" placeholder=\"Facility Name\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.name.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Facility name is required.</span></div></div></div><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && facilityError.length > 0 }\"><label class=\"control-label\">Facility Code</label> <input type=\"text\" class=\"form-control\" name=\"code\" ng-model=\"form.code\" placeholder=\"Facility Code\"> <span class=\"help-block text-danger\" ng-show=\"submitted && facilityError.length > 0\"><i class=\"fa fa-exclamation-circle\"></i> {{ facilityError }}</span></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\">Facility Description</label> <textarea class=\"form-control\" ng-model=\"form.description\" placeholder=\"Facility Description\" rows=\"4\"></textarea></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> <button class=\"btn btn-danger\" ng-click=\"delete($event)\" ng-if=\"form.identity\">Delete</button> <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Save</button></div>");
$templateCache.put("/app/components/reservationAside/reservationAside.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Reservation Details <a ng-click=\"cancel($event)\" class=\"pull-right\"><span class=\"fa fa-close\"></span></a></h3></div><div class=\"modal-body\"><form name=\"asideForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Fixed Asset #</label> <input type=\"text\" class=\"form-control\" value=\"{{ ::form.asset }}\" placeholder=\"Fixed Asset #\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && reservationForm.company.$invalid}\"><label class=\"control-label\">Reservation Customer<span class=\"req\">*</span></label><select class=\"form-control\" chosen=\"\" ng-change=\"loadCompany(this)\" data-placeholder=\"Select a customer\" ng-model=\"form.company\" no-results-text=\"\'There are no companies.\'\" ng-options=\"company.identity as company.name for company in companies\" name=\"company\" required=\"\"><option value=\"\"></option></select><span class=\"help-block text-danger\" ng-show=\"submitted && reservationForm.company.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> You must select a company to create a reservation.</span></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && reservationForm.expected_on_rent.$invalid}\"><label class=\"control-label\">Expected On Rent Date</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"expected_on_rent\" uib-datepicker-popup=\"{{on_rent.format}}\" ng-model=\"form.expected_on_rent\" is-open=\"on_rent.opened\" datepicker-options=\"on_rent.options\" close-text=\"Close\" required=\"\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"on_rent.open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><span class=\"help-block text-danger\" ng-show=\"submitted && reservationForm.expected_on_rent.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> You must enter an expected on rent date for a reservation.</span></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Expected Off Rent Date</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{off_rent.format}}\" ng-model=\"form.expected_off_rent\" is-open=\"off_rent.opened\" datepicker-options=\"off_rent.options\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"off_rent.open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && reservationForm.contact.$invalid}\"><label class=\"control-label\">Contact Name<span class=\"req\">*</span></label><select class=\"form-control\" chosen=\"\" ng-change=\"loadContact(this)\" data-placeholder=\"Select a contact\" ng-model=\"form.contact\" no-results-text=\"\'There are no contacts.\'\" ng-options=\"contact.identity as contact.name for contact in contacts\" name=\"contact\" required=\"\"><option value=\"\"></option></select><span class=\"help-block text-danger\" ng-show=\"submitted && reservationForm.contact.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> You must select a contact to create a reservation.</span></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Contact Number</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.phone\" placeholder=\"Contact #\"></div></div></div><div class=\"row\"><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Item Description</label> <input type=\"text\" class=\"form-control\" value=\"{{ ::form.description }}\" placeholder=\"Item Description\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Location</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.site_address\" placeholder=\"Street Address\"></div></div><div class=\"col-md-1 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">City</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.site_city\" placeholder=\"City\"></div></div><div class=\"col-md-1 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">State</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.site_state\" placeholder=\"State\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Zip Code</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.site_postal\" placeholder=\"Zip Code\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Delivery Time</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.delivery_request_time\" name=\"deliveryTime\" bs-timepicker=\"\"></div></div><div class=\"col-md-2 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Comments</label> <input type=\"text\" class=\"form-control\" ng-model=\"form.comments\" ng-click=\"expandComments();\" placeholder=\"Comments\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\">Choose an existing address:</label><select class=\"form-control\" chosen=\"\" ng-change=\"loadAddress()\" data-placeholder=\"Select an existing site address...\" ng-model=\"form.address\" no-results-text=\"\'There are no existing site addresses.\'\" ng-options=\"address as address.site_address+\' \'+address.site_city+\', \'+address.site_state+\' \'+address.site_postal for address in addresses\"><option value=\"\" <=\"\" option=\"\"></option></select></div></div></div><div class=\"row\"><div class=\"col-md-12\" st-table=\"form.reservations\"><h4>Existing Reservations</h4><table class=\"table table-hover\"><thead><tr><th>Customer Name</th><th>Expected On-Rent</th><th>Expected Off-Rent</th><th>Location</th><th>City</th><th>State</th><th>Zip Code</th><th>Contact Name</th><th>Contact #</th></tr></thead><tbody><tr ng-if=\"form.reservations.length === 0\"><td class=\"text-center\" colspan=\"9\">There are no past reservations for this item.</td></tr><tr ng-repeat=\"reservation in form.reservations\"><td>{{ ::reservation.company.name }}</td><td>{{ parseDate(reservation.expected_on_rent) }}</td><td>{{ parseDate(reservation.expected_off_rent) }}</td><td>{{ ::reservation.site_address }}</td><td>{{ ::reservation.site_city }}</td><td>{{ ::reservation.site_state }}</td><td>{{ ::reservation.site_postal }}</td><td>{{ ::reservation.contact.name }}</td><td>{{ ::reservation.contact.office_phone }}</td></tr></tbody><tfoot ng-show=\"form.reservations.length > 9\"><tr><td colspan=\"9\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"10\"></div></td></tr></tfoot></table></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Save</button></div>");
$templateCache.put("/app/components/roleAside/roleAside.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Role Details <a ng-click=\"cancel($event)\" class=\"pull-right\"><span class=\"fa fa-close\"></span></a></h3></div><div class=\"modal-body\"><form name=\"asideForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.roleName.$invalid }\"><label class=\"control-label\">Role Name</label> <input type=\"text\" class=\"form-control\" name=\"roleName\" ng-model=\"form.name\" placeholder=\"Role Name\" required=\"\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.roleName.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Role name is required.</span></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Pages</label><select class=\"form-control\" chosen=\"\" multiple=\"\" data-placeholder=\"Select Pages\" ng-model=\"form.pages\" no-results-text=\"\'There are no pages.\'\" ng-options=\"page.state as page.name for page in pages\"></select></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Users</label><select class=\"form-control\" chosen=\"\" multiple=\"\" data-placeholder=\"Select Users\" ng-model=\"form.users\" no-results-text=\"\'There are no users.\'\" ng-options=\"user.identity as user.name for user in users\"></select></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Save</button></div>");
$templateCache.put("/app/components/statusAside/statusAside.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Status Details</h3></div><div class=\"modal-body\"><form name=\"asideForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.name.$invalid }\"><label class=\"control-label\">Status Name</label> <input type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"form.name\" required=\"\" placeholder=\"Status Name\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.name.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Status name is required.</span></div></div></div><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.foreground.$invalid }\"><label class=\"control-label\">Foreground Color</label> <input type=\"text\" class=\"form-control\" name=\"\" \"foreground\"=\"\" ng-model=\"form.foreground\" required=\"\" minicolors=\"\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.foreground.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Foreground is required.</span></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : submitted && asideForm.background.$invalid }\"><label class=\"control-label\">Background Color</label> <input type=\"text\" class=\"form-control\" name=\"background\" ng-model=\"form.background\" required=\"\" minicolors=\"\"> <span class=\"help-block text-danger\" ng-show=\"submitted && asideForm.background.$invalid\"><i class=\"fa fa-exclamation-circle\"></i> Background is required.</span></div></div></div><div class=\"row\"><div class=\"col-md-12\"><label class=\"control-label\">Status Type:</label><btn-toggle options=\"statusTypes\" justified=\"true\"></btn-toggle></div></div><div class=\"row padding-top-10\"><div class=\"col-md-12\"><div class=\"form-group preview\"><label class=\"control-label\">Preview</label><div><span class=\"label\" ng-style=\"{\'background\' : form.background, \'color\' : form.foreground}\">{{form.name.length > 0 ? form.name : \'Example Status\'}}</span></div></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> <button class=\"btn btn-danger\" ng-click=\"delete($event)\" ng-if=\"form.identity && form.modifiable\">Delete</button> <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Save</button></div>");
$templateCache.put("/app/components/yardmanStatusAside/yardmanStatusAside.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Update Status</h3></div><div class=\"modal-body\"><form name=\"asideForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Fixed Asset #</label> <input type=\"text\" class=\"form-control\" name=\"asset\" ng-model=\"form.asset\" placeholder=\"Fixed Asset\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Item Description</label> <textarea class=\"form-control\" name=\"description\" ng-model=\"form.description\" placeholder=\"Description\" rows=\"3\" readonly=\"\" disabled=\"\"></textarea></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"control-label\">Current Status</label> <input type=\"text\" class=\"form-control\" ng-model=\"inventory.status.name\" placeholder=\"Current Status\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"control-label\">2<sup>nd</sup> Status</label> <input type=\"text\" class=\"form-control\" ng-model=\"inventory.secondStatus.name\" placeholder=\"No second status\" readonly=\"\" disabled=\"\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Machine Hours</label> <input type=\"text\" class=\"form-control\" name=\"machineHours\" ng-model=\"form.machine_hours\" placeholder=\"Machine Hours\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Fuel Required</label> <input type=\"text\" class=\"form-control\" name=\"fuel\" ng-model=\"form.amount\" placeholder=\"Fuel Required\"></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\">Comments</label> <input type=\"text\" class=\"form-control\" name=\"comments\" ng-model=\"form.comments\" placeholder=\"Comments\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">Customer</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Customer\" ng-model=\"form.company\" no-results-text=\"\'There are no customers.\'\" ng-options=\"company.identity as company.name for company in companies\"></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">Update Status</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"Update Status\" ng-model=\"form.status\" no-results-text=\"\'There are no statuses.\'\" ng-options=\"status.identity as status.name for status in statuses\"></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">2<sup>nd</sup> Status</label><select class=\"form-control\" chosen=\"\" data-placeholder=\"2nd Status\" ng-model=\"form.secondStatus\" no-results-text=\"\'There are no statuses.\'\" ng-options=\"status.identity as status.name for status in secondStatuses\"></select></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel($event)\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"ok($event)\">Save</button></div>");}]);